/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 30);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
    * jQuery JavaScript Library v3.3.1
    * https://jquery.com/
    *
    * Includes Sizzle.js
    * https://sizzlejs.com/
    *
    * Copyright JS Foundation and other contributors
    * Released under the MIT license
    * https://jquery.org/license
    *
    * Date: 2018-01-20T17:24Z
    */
   ( function( global, factory ) {
   
       "use strict";
   
       if (  true && typeof module.exports === "object" ) {
   
           // For CommonJS and CommonJS-like environments where a proper `window`
           // is present, execute the factory and get jQuery.
           // For environments that do not have a `window` with a `document`
           // (such as Node.js), expose a factory as module.exports.
           // This accentuates the need for the creation of a real `window`.
           // e.g. var jQuery = require("jquery")(window);
           // See ticket #14549 for more info.
           module.exports = global.document ?
               factory( global, true ) :
               function( w ) {
                   if ( !w.document ) {
                       throw new Error( "jQuery requires a window with a document" );
                   }
                   return factory( w );
               };
       } else {
           factory( global );
       }
   
   // Pass this if window is not defined yet
   } )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
   
   // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
   // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
   // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
   // enough that all such attempts are guarded in a try block.
   "use strict";
   
   var arr = [];
   
   var document = window.document;
   
   var getProto = Object.getPrototypeOf;
   
   var slice = arr.slice;
   
   var concat = arr.concat;
   
   var push = arr.push;
   
   var indexOf = arr.indexOf;
   
   var class2type = {};
   
   var toString = class2type.toString;
   
   var hasOwn = class2type.hasOwnProperty;
   
   var fnToString = hasOwn.toString;
   
   var ObjectFunctionString = fnToString.call( Object );
   
   var support = {};
   
   var isFunction = function isFunction( obj ) {
   
         // Support: Chrome <=57, Firefox <=52
         // In some browsers, typeof returns "function" for HTML <object> elements
         // (i.e., `typeof document.createElement( "object" ) === "function"`).
         // We don't want to classify *any* DOM node as a function.
         return typeof obj === "function" && typeof obj.nodeType !== "number";
     };
   
   
   var isWindow = function isWindow( obj ) {
           return obj != null && obj === obj.window;
       };
   
   
   
   
       var preservedScriptAttributes = {
           type: true,
           src: true,
           noModule: true
       };
   
       function DOMEval( code, doc, node ) {
           doc = doc || document;
   
           var i,
               script = doc.createElement( "script" );
   
           script.text = code;
           if ( node ) {
               for ( i in preservedScriptAttributes ) {
                   if ( node[ i ] ) {
                       script[ i ] = node[ i ];
                   }
               }
           }
           doc.head.appendChild( script ).parentNode.removeChild( script );
       }
   
   
   function toType( obj ) {
       if ( obj == null ) {
           return obj + "";
       }
   
       // Support: Android <=2.3 only (functionish RegExp)
       return typeof obj === "object" || typeof obj === "function" ?
           class2type[ toString.call( obj ) ] || "object" :
           typeof obj;
   }
   /* global Symbol */
   // Defining this global in .eslintrc.json would create a danger of using the global
   // unguarded in another place, it seems safer to define global only for this module
   
   
   
   var
       version = "3.3.1",
   
       // Define a local copy of jQuery
       jQuery = function( selector, context ) {
   
           // The jQuery object is actually just the init constructor 'enhanced'
           // Need init if jQuery is called (just allow error to be thrown if not included)
           return new jQuery.fn.init( selector, context );
       },
   
       // Support: Android <=4.0 only
       // Make sure we trim BOM and NBSP
       rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
   
   jQuery.fn = jQuery.prototype = {
   
       // The current version of jQuery being used
       jquery: version,
   
       constructor: jQuery,
   
       // The default length of a jQuery object is 0
       length: 0,
   
       toArray: function() {
           return slice.call( this );
       },
   
       // Get the Nth element in the matched element set OR
       // Get the whole matched element set as a clean array
       get: function( num ) {
   
           // Return all the elements in a clean array
           if ( num == null ) {
               return slice.call( this );
           }
   
           // Return just the one element from the set
           return num < 0 ? this[ num + this.length ] : this[ num ];
       },
   
       // Take an array of elements and push it onto the stack
       // (returning the new matched element set)
       pushStack: function( elems ) {
   
           // Build a new jQuery matched element set
           var ret = jQuery.merge( this.constructor(), elems );
   
           // Add the old object onto the stack (as a reference)
           ret.prevObject = this;
   
           // Return the newly-formed element set
           return ret;
       },
   
       // Execute a callback for every element in the matched set.
       each: function( callback ) {
           return jQuery.each( this, callback );
       },
   
       map: function( callback ) {
           return this.pushStack( jQuery.map( this, function( elem, i ) {
               return callback.call( elem, i, elem );
           } ) );
       },
   
       slice: function() {
           return this.pushStack( slice.apply( this, arguments ) );
       },
   
       first: function() {
           return this.eq( 0 );
       },
   
       last: function() {
           return this.eq( -1 );
       },
   
       eq: function( i ) {
           var len = this.length,
               j = +i + ( i < 0 ? len : 0 );
           return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
       },
   
       end: function() {
           return this.prevObject || this.constructor();
       },
   
       // For internal use only.
       // Behaves like an Array's method, not like a jQuery method.
       push: push,
       sort: arr.sort,
       splice: arr.splice
   };
   
   jQuery.extend = jQuery.fn.extend = function() {
       var options, name, src, copy, copyIsArray, clone,
           target = arguments[ 0 ] || {},
           i = 1,
           length = arguments.length,
           deep = false;
   
       // Handle a deep copy situation
       if ( typeof target === "boolean" ) {
           deep = target;
   
           // Skip the boolean and the target
           target = arguments[ i ] || {};
           i++;
       }
   
       // Handle case when target is a string or something (possible in deep copy)
       if ( typeof target !== "object" && !isFunction( target ) ) {
           target = {};
       }
   
       // Extend jQuery itself if only one argument is passed
       if ( i === length ) {
           target = this;
           i--;
       }
   
       for ( ; i < length; i++ ) {
   
           // Only deal with non-null/undefined values
           if ( ( options = arguments[ i ] ) != null ) {
   
               // Extend the base object
               for ( name in options ) {
                   src = target[ name ];
                   copy = options[ name ];
   
                   // Prevent never-ending loop
                   if ( target === copy ) {
                       continue;
                   }
   
                   // Recurse if we're merging plain objects or arrays
                   if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
                       ( copyIsArray = Array.isArray( copy ) ) ) ) {
   
                       if ( copyIsArray ) {
                           copyIsArray = false;
                           clone = src && Array.isArray( src ) ? src : [];
   
                       } else {
                           clone = src && jQuery.isPlainObject( src ) ? src : {};
                       }
   
                       // Never move original objects, clone them
                       target[ name ] = jQuery.extend( deep, clone, copy );
   
                   // Don't bring in undefined values
                   } else if ( copy !== undefined ) {
                       target[ name ] = copy;
                   }
               }
           }
       }
   
       // Return the modified object
       return target;
   };
   
   jQuery.extend( {
   
       // Unique for each copy of jQuery on the page
       expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
   
       // Assume jQuery is ready without the ready module
       isReady: true,
   
       error: function( msg ) {
           throw new Error( msg );
       },
   
       noop: function() {},
   
       isPlainObject: function( obj ) {
           var proto, Ctor;
   
           // Detect obvious negatives
           // Use toString instead of jQuery.type to catch host objects
           if ( !obj || toString.call( obj ) !== "[object Object]" ) {
               return false;
           }
   
           proto = getProto( obj );
   
           // Objects with no prototype (e.g., `Object.create( null )`) are plain
           if ( !proto ) {
               return true;
           }
   
           // Objects with prototype are plain iff they were constructed by a global Object function
           Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
           return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
       },
   
       isEmptyObject: function( obj ) {
   
           /* eslint-disable no-unused-vars */
           // See https://github.com/eslint/eslint/issues/6125
           var name;
   
           for ( name in obj ) {
               return false;
           }
           return true;
       },
   
       // Evaluates a script in a global context
       globalEval: function( code ) {
           DOMEval( code );
       },
   
       each: function( obj, callback ) {
           var length, i = 0;
   
           if ( isArrayLike( obj ) ) {
               length = obj.length;
               for ( ; i < length; i++ ) {
                   if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                       break;
                   }
               }
           } else {
               for ( i in obj ) {
                   if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                       break;
                   }
               }
           }
   
           return obj;
       },
   
       // Support: Android <=4.0 only
       trim: function( text ) {
           return text == null ?
               "" :
               ( text + "" ).replace( rtrim, "" );
       },
   
       // results is for internal usage only
       makeArray: function( arr, results ) {
           var ret = results || [];
   
           if ( arr != null ) {
               if ( isArrayLike( Object( arr ) ) ) {
                   jQuery.merge( ret,
                       typeof arr === "string" ?
                       [ arr ] : arr
                   );
               } else {
                   push.call( ret, arr );
               }
           }
   
           return ret;
       },
   
       inArray: function( elem, arr, i ) {
           return arr == null ? -1 : indexOf.call( arr, elem, i );
       },
   
       // Support: Android <=4.0 only, PhantomJS 1 only
       // push.apply(_, arraylike) throws on ancient WebKit
       merge: function( first, second ) {
           var len = +second.length,
               j = 0,
               i = first.length;
   
           for ( ; j < len; j++ ) {
               first[ i++ ] = second[ j ];
           }
   
           first.length = i;
   
           return first;
       },
   
       grep: function( elems, callback, invert ) {
           var callbackInverse,
               matches = [],
               i = 0,
               length = elems.length,
               callbackExpect = !invert;
   
           // Go through the array, only saving the items
           // that pass the validator function
           for ( ; i < length; i++ ) {
               callbackInverse = !callback( elems[ i ], i );
               if ( callbackInverse !== callbackExpect ) {
                   matches.push( elems[ i ] );
               }
           }
   
           return matches;
       },
   
       // arg is for internal usage only
       map: function( elems, callback, arg ) {
           var length, value,
               i = 0,
               ret = [];
   
           // Go through the array, translating each of the items to their new values
           if ( isArrayLike( elems ) ) {
               length = elems.length;
               for ( ; i < length; i++ ) {
                   value = callback( elems[ i ], i, arg );
   
                   if ( value != null ) {
                       ret.push( value );
                   }
               }
   
           // Go through every key on the object,
           } else {
               for ( i in elems ) {
                   value = callback( elems[ i ], i, arg );
   
                   if ( value != null ) {
                       ret.push( value );
                   }
               }
           }
   
           // Flatten any nested arrays
           return concat.apply( [], ret );
       },
   
       // A global GUID counter for objects
       guid: 1,
   
       // jQuery.support is not used in Core but other projects attach their
       // properties to it so it needs to exist.
       support: support
   } );
   
   if ( typeof Symbol === "function" ) {
       jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
   }
   
   // Populate the class2type map
   jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
   function( i, name ) {
       class2type[ "[object " + name + "]" ] = name.toLowerCase();
   } );
   
   function isArrayLike( obj ) {
   
       // Support: real iOS 8.2 only (not reproducible in simulator)
       // `in` check used to prevent JIT error (gh-2145)
       // hasOwn isn't used here due to false negatives
       // regarding Nodelist length in IE
       var length = !!obj && "length" in obj && obj.length,
           type = toType( obj );
   
       if ( isFunction( obj ) || isWindow( obj ) ) {
           return false;
       }
   
       return type === "array" || length === 0 ||
           typeof length === "number" && length > 0 && ( length - 1 ) in obj;
   }
   var Sizzle =
   /*!
    * Sizzle CSS Selector Engine v2.3.3
    * https://sizzlejs.com/
    *
    * Copyright jQuery Foundation and other contributors
    * Released under the MIT license
    * http://jquery.org/license
    *
    * Date: 2016-08-08
    */
   (function( window ) {
   
   var i,
       support,
       Expr,
       getText,
       isXML,
       tokenize,
       compile,
       select,
       outermostContext,
       sortInput,
       hasDuplicate,
   
       // Local document vars
       setDocument,
       document,
       docElem,
       documentIsHTML,
       rbuggyQSA,
       rbuggyMatches,
       matches,
       contains,
   
       // Instance-specific data
       expando = "sizzle" + 1 * new Date(),
       preferredDoc = window.document,
       dirruns = 0,
       done = 0,
       classCache = createCache(),
       tokenCache = createCache(),
       compilerCache = createCache(),
       sortOrder = function( a, b ) {
           if ( a === b ) {
               hasDuplicate = true;
           }
           return 0;
       },
   
       // Instance methods
       hasOwn = ({}).hasOwnProperty,
       arr = [],
       pop = arr.pop,
       push_native = arr.push,
       push = arr.push,
       slice = arr.slice,
       // Use a stripped-down indexOf as it's faster than native
       // https://jsperf.com/thor-indexof-vs-for/5
       indexOf = function( list, elem ) {
           var i = 0,
               len = list.length;
           for ( ; i < len; i++ ) {
               if ( list[i] === elem ) {
                   return i;
               }
           }
           return -1;
       },
   
       booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
   
       // Regular expressions
   
       // http://www.w3.org/TR/css3-selectors/#whitespace
       whitespace = "[\\x20\\t\\r\\n\\f]",
   
       // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
       identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
   
       // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
       attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
           // Operator (capture 2)
           "*([*^$|!~]?=)" + whitespace +
           // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
           "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
           "*\\]",
   
       pseudos = ":(" + identifier + ")(?:\\((" +
           // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
           // 1. quoted (capture 3; capture 4 or capture 5)
           "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
           // 2. simple (capture 6)
           "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
           // 3. anything else (capture 2)
           ".*" +
           ")\\)|)",
   
       // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
       rwhitespace = new RegExp( whitespace + "+", "g" ),
       rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
   
       rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
       rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
   
       rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
   
       rpseudo = new RegExp( pseudos ),
       ridentifier = new RegExp( "^" + identifier + "$" ),
   
       matchExpr = {
           "ID": new RegExp( "^#(" + identifier + ")" ),
           "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
           "TAG": new RegExp( "^(" + identifier + "|[*])" ),
           "ATTR": new RegExp( "^" + attributes ),
           "PSEUDO": new RegExp( "^" + pseudos ),
           "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
               "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
               "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
           "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
           // For use in libraries implementing .is()
           // We use this for POS matching in `select`
           "needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
               whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
       },
   
       rinputs = /^(?:input|select|textarea|button)$/i,
       rheader = /^h\d$/i,
   
       rnative = /^[^{]+\{\s*\[native \w/,
   
       // Easily-parseable/retrievable ID or TAG or CLASS selectors
       rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
   
       rsibling = /[+~]/,
   
       // CSS escapes
       // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
       runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
       funescape = function( _, escaped, escapedWhitespace ) {
           var high = "0x" + escaped - 0x10000;
           // NaN means non-codepoint
           // Support: Firefox<24
           // Workaround erroneous numeric interpretation of +"0x"
           return high !== high || escapedWhitespace ?
               escaped :
               high < 0 ?
                   // BMP codepoint
                   String.fromCharCode( high + 0x10000 ) :
                   // Supplemental Plane codepoint (surrogate pair)
                   String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
       },
   
       // CSS string/identifier serialization
       // https://drafts.csswg.org/cssom/#common-serializing-idioms
       rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
       fcssescape = function( ch, asCodePoint ) {
           if ( asCodePoint ) {
   
               // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
               if ( ch === "\0" ) {
                   return "\uFFFD";
               }
   
               // Control characters and (dependent upon position) numbers get escaped as code points
               return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
           }
   
           // Other potentially-special ASCII characters get backslash-escaped
           return "\\" + ch;
       },
   
       // Used for iframes
       // See setDocument()
       // Removing the function wrapper causes a "Permission Denied"
       // error in IE
       unloadHandler = function() {
           setDocument();
       },
   
       disabledAncestor = addCombinator(
           function( elem ) {
               return elem.disabled === true && ("form" in elem || "label" in elem);
           },
           { dir: "parentNode", next: "legend" }
       );
   
   // Optimize for push.apply( _, NodeList )
   try {
       push.apply(
           (arr = slice.call( preferredDoc.childNodes )),
           preferredDoc.childNodes
       );
       // Support: Android<4.0
       // Detect silently failing push.apply
       arr[ preferredDoc.childNodes.length ].nodeType;
   } catch ( e ) {
       push = { apply: arr.length ?
   
           // Leverage slice if possible
           function( target, els ) {
               push_native.apply( target, slice.call(els) );
           } :
   
           // Support: IE<9
           // Otherwise append directly
           function( target, els ) {
               var j = target.length,
                   i = 0;
               // Can't trust NodeList.length
               while ( (target[j++] = els[i++]) ) {}
               target.length = j - 1;
           }
       };
   }
   
   function Sizzle( selector, context, results, seed ) {
       var m, i, elem, nid, match, groups, newSelector,
           newContext = context && context.ownerDocument,
   
           // nodeType defaults to 9, since context defaults to document
           nodeType = context ? context.nodeType : 9;
   
       results = results || [];
   
       // Return early from calls with invalid selector or context
       if ( typeof selector !== "string" || !selector ||
           nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
   
           return results;
       }
   
       // Try to shortcut find operations (as opposed to filters) in HTML documents
       if ( !seed ) {
   
           if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
               setDocument( context );
           }
           context = context || document;
   
           if ( documentIsHTML ) {
   
               // If the selector is sufficiently simple, try using a "get*By*" DOM method
               // (excepting DocumentFragment context, where the methods don't exist)
               if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
   
                   // ID selector
                   if ( (m = match[1]) ) {
   
                       // Document context
                       if ( nodeType === 9 ) {
                           if ( (elem = context.getElementById( m )) ) {
   
                               // Support: IE, Opera, Webkit
                               // TODO: identify versions
                               // getElementById can match elements by name instead of ID
                               if ( elem.id === m ) {
                                   results.push( elem );
                                   return results;
                               }
                           } else {
                               return results;
                           }
   
                       // Element context
                       } else {
   
                           // Support: IE, Opera, Webkit
                           // TODO: identify versions
                           // getElementById can match elements by name instead of ID
                           if ( newContext && (elem = newContext.getElementById( m )) &&
                               contains( context, elem ) &&
                               elem.id === m ) {
   
                               results.push( elem );
                               return results;
                           }
                       }
   
                   // Type selector
                   } else if ( match[2] ) {
                       push.apply( results, context.getElementsByTagName( selector ) );
                       return results;
   
                   // Class selector
                   } else if ( (m = match[3]) && support.getElementsByClassName &&
                       context.getElementsByClassName ) {
   
                       push.apply( results, context.getElementsByClassName( m ) );
                       return results;
                   }
               }
   
               // Take advantage of querySelectorAll
               if ( support.qsa &&
                   !compilerCache[ selector + " " ] &&
                   (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
   
                   if ( nodeType !== 1 ) {
                       newContext = context;
                       newSelector = selector;
   
                   // qSA looks outside Element context, which is not what we want
                   // Thanks to Andrew Dupont for this workaround technique
                   // Support: IE <=8
                   // Exclude object elements
                   } else if ( context.nodeName.toLowerCase() !== "object" ) {
   
                       // Capture the context ID, setting it first if necessary
                       if ( (nid = context.getAttribute( "id" )) ) {
                           nid = nid.replace( rcssescape, fcssescape );
                       } else {
                           context.setAttribute( "id", (nid = expando) );
                       }
   
                       // Prefix every selector in the list
                       groups = tokenize( selector );
                       i = groups.length;
                       while ( i-- ) {
                           groups[i] = "#" + nid + " " + toSelector( groups[i] );
                       }
                       newSelector = groups.join( "," );
   
                       // Expand context for sibling selectors
                       newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
                           context;
                   }
   
                   if ( newSelector ) {
                       try {
                           push.apply( results,
                               newContext.querySelectorAll( newSelector )
                           );
                           return results;
                       } catch ( qsaError ) {
                       } finally {
                           if ( nid === expando ) {
                               context.removeAttribute( "id" );
                           }
                       }
                   }
               }
           }
       }
   
       // All others
       return select( selector.replace( rtrim, "$1" ), context, results, seed );
   }
   
   /**
    * Create key-value caches of limited size
    * @returns {function(string, object)} Returns the Object data after storing it on itself with
    *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
    *	deleting the oldest entry
    */
   function createCache() {
       var keys = [];
   
       function cache( key, value ) {
           // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
           if ( keys.push( key + " " ) > Expr.cacheLength ) {
               // Only keep the most recent entries
               delete cache[ keys.shift() ];
           }
           return (cache[ key + " " ] = value);
       }
       return cache;
   }
   
   /**
    * Mark a function for special use by Sizzle
    * @param {Function} fn The function to mark
    */
   function markFunction( fn ) {
       fn[ expando ] = true;
       return fn;
   }
   
   /**
    * Support testing using an element
    * @param {Function} fn Passed the created element and returns a boolean result
    */
   function assert( fn ) {
       var el = document.createElement("fieldset");
   
       try {
           return !!fn( el );
       } catch (e) {
           return false;
       } finally {
           // Remove from its parent by default
           if ( el.parentNode ) {
               el.parentNode.removeChild( el );
           }
           // release memory in IE
           el = null;
       }
   }
   
   /**
    * Adds the same handler for all of the specified attrs
    * @param {String} attrs Pipe-separated list of attributes
    * @param {Function} handler The method that will be applied
    */
   function addHandle( attrs, handler ) {
       var arr = attrs.split("|"),
           i = arr.length;
   
       while ( i-- ) {
           Expr.attrHandle[ arr[i] ] = handler;
       }
   }
   
   /**
    * Checks document order of two siblings
    * @param {Element} a
    * @param {Element} b
    * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
    */
   function siblingCheck( a, b ) {
       var cur = b && a,
           diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
               a.sourceIndex - b.sourceIndex;
   
       // Use IE sourceIndex if available on both nodes
       if ( diff ) {
           return diff;
       }
   
       // Check if b follows a
       if ( cur ) {
           while ( (cur = cur.nextSibling) ) {
               if ( cur === b ) {
                   return -1;
               }
           }
       }
   
       return a ? 1 : -1;
   }
   
   /**
    * Returns a function to use in pseudos for input types
    * @param {String} type
    */
   function createInputPseudo( type ) {
       return function( elem ) {
           var name = elem.nodeName.toLowerCase();
           return name === "input" && elem.type === type;
       };
   }
   
   /**
    * Returns a function to use in pseudos for buttons
    * @param {String} type
    */
   function createButtonPseudo( type ) {
       return function( elem ) {
           var name = elem.nodeName.toLowerCase();
           return (name === "input" || name === "button") && elem.type === type;
       };
   }
   
   /**
    * Returns a function to use in pseudos for :enabled/:disabled
    * @param {Boolean} disabled true for :disabled; false for :enabled
    */
   function createDisabledPseudo( disabled ) {
   
       // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
       return function( elem ) {
   
           // Only certain elements can match :enabled or :disabled
           // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
           // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
           if ( "form" in elem ) {
   
               // Check for inherited disabledness on relevant non-disabled elements:
               // * listed form-associated elements in a disabled fieldset
               //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
               //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
               // * option elements in a disabled optgroup
               //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
               // All such elements have a "form" property.
               if ( elem.parentNode && elem.disabled === false ) {
   
                   // Option elements defer to a parent optgroup if present
                   if ( "label" in elem ) {
                       if ( "label" in elem.parentNode ) {
                           return elem.parentNode.disabled === disabled;
                       } else {
                           return elem.disabled === disabled;
                       }
                   }
   
                   // Support: IE 6 - 11
                   // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                   return elem.isDisabled === disabled ||
   
                       // Where there is no isDisabled, check manually
                       /* jshint -W018 */
                       elem.isDisabled !== !disabled &&
                           disabledAncestor( elem ) === disabled;
               }
   
               return elem.disabled === disabled;
   
           // Try to winnow out elements that can't be disabled before trusting the disabled property.
           // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
           // even exist on them, let alone have a boolean value.
           } else if ( "label" in elem ) {
               return elem.disabled === disabled;
           }
   
           // Remaining elements are neither :enabled nor :disabled
           return false;
       };
   }
   
   /**
    * Returns a function to use in pseudos for positionals
    * @param {Function} fn
    */
   function createPositionalPseudo( fn ) {
       return markFunction(function( argument ) {
           argument = +argument;
           return markFunction(function( seed, matches ) {
               var j,
                   matchIndexes = fn( [], seed.length, argument ),
                   i = matchIndexes.length;
   
               // Match elements found at the specified indexes
               while ( i-- ) {
                   if ( seed[ (j = matchIndexes[i]) ] ) {
                       seed[j] = !(matches[j] = seed[j]);
                   }
               }
           });
       });
   }
   
   /**
    * Checks a node for validity as a Sizzle context
    * @param {Element|Object=} context
    * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
    */
   function testContext( context ) {
       return context && typeof context.getElementsByTagName !== "undefined" && context;
   }
   
   // Expose support vars for convenience
   support = Sizzle.support = {};
   
   /**
    * Detects XML nodes
    * @param {Element|Object} elem An element or a document
    * @returns {Boolean} True iff elem is a non-HTML XML node
    */
   isXML = Sizzle.isXML = function( elem ) {
       // documentElement is verified for cases where it doesn't yet exist
       // (such as loading iframes in IE - #4833)
       var documentElement = elem && (elem.ownerDocument || elem).documentElement;
       return documentElement ? documentElement.nodeName !== "HTML" : false;
   };
   
   /**
    * Sets document-related variables once based on the current document
    * @param {Element|Object} [doc] An element or document object to use to set the document
    * @returns {Object} Returns the current document
    */
   setDocument = Sizzle.setDocument = function( node ) {
       var hasCompare, subWindow,
           doc = node ? node.ownerDocument || node : preferredDoc;
   
       // Return early if doc is invalid or already selected
       if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
           return document;
       }
   
       // Update global variables
       document = doc;
       docElem = document.documentElement;
       documentIsHTML = !isXML( document );
   
       // Support: IE 9-11, Edge
       // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
       if ( preferredDoc !== document &&
           (subWindow = document.defaultView) && subWindow.top !== subWindow ) {
   
           // Support: IE 11, Edge
           if ( subWindow.addEventListener ) {
               subWindow.addEventListener( "unload", unloadHandler, false );
   
           // Support: IE 9 - 10 only
           } else if ( subWindow.attachEvent ) {
               subWindow.attachEvent( "onunload", unloadHandler );
           }
       }
   
       /* Attributes
       ---------------------------------------------------------------------- */
   
       // Support: IE<8
       // Verify that getAttribute really returns attributes and not properties
       // (excepting IE8 booleans)
       support.attributes = assert(function( el ) {
           el.className = "i";
           return !el.getAttribute("className");
       });
   
       /* getElement(s)By*
       ---------------------------------------------------------------------- */
   
       // Check if getElementsByTagName("*") returns only elements
       support.getElementsByTagName = assert(function( el ) {
           el.appendChild( document.createComment("") );
           return !el.getElementsByTagName("*").length;
       });
   
       // Support: IE<9
       support.getElementsByClassName = rnative.test( document.getElementsByClassName );
   
       // Support: IE<10
       // Check if getElementById returns elements by name
       // The broken getElementById methods don't pick up programmatically-set names,
       // so use a roundabout getElementsByName test
       support.getById = assert(function( el ) {
           docElem.appendChild( el ).id = expando;
           return !document.getElementsByName || !document.getElementsByName( expando ).length;
       });
   
       // ID filter and find
       if ( support.getById ) {
           Expr.filter["ID"] = function( id ) {
               var attrId = id.replace( runescape, funescape );
               return function( elem ) {
                   return elem.getAttribute("id") === attrId;
               };
           };
           Expr.find["ID"] = function( id, context ) {
               if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                   var elem = context.getElementById( id );
                   return elem ? [ elem ] : [];
               }
           };
       } else {
           Expr.filter["ID"] =  function( id ) {
               var attrId = id.replace( runescape, funescape );
               return function( elem ) {
                   var node = typeof elem.getAttributeNode !== "undefined" &&
                       elem.getAttributeNode("id");
                   return node && node.value === attrId;
               };
           };
   
           // Support: IE 6 - 7 only
           // getElementById is not reliable as a find shortcut
           Expr.find["ID"] = function( id, context ) {
               if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                   var node, i, elems,
                       elem = context.getElementById( id );
   
                   if ( elem ) {
   
                       // Verify the id attribute
                       node = elem.getAttributeNode("id");
                       if ( node && node.value === id ) {
                           return [ elem ];
                       }
   
                       // Fall back on getElementsByName
                       elems = context.getElementsByName( id );
                       i = 0;
                       while ( (elem = elems[i++]) ) {
                           node = elem.getAttributeNode("id");
                           if ( node && node.value === id ) {
                               return [ elem ];
                           }
                       }
                   }
   
                   return [];
               }
           };
       }
   
       // Tag
       Expr.find["TAG"] = support.getElementsByTagName ?
           function( tag, context ) {
               if ( typeof context.getElementsByTagName !== "undefined" ) {
                   return context.getElementsByTagName( tag );
   
               // DocumentFragment nodes don't have gEBTN
               } else if ( support.qsa ) {
                   return context.querySelectorAll( tag );
               }
           } :
   
           function( tag, context ) {
               var elem,
                   tmp = [],
                   i = 0,
                   // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                   results = context.getElementsByTagName( tag );
   
               // Filter out possible comments
               if ( tag === "*" ) {
                   while ( (elem = results[i++]) ) {
                       if ( elem.nodeType === 1 ) {
                           tmp.push( elem );
                       }
                   }
   
                   return tmp;
               }
               return results;
           };
   
       // Class
       Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
           if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
               return context.getElementsByClassName( className );
           }
       };
   
       /* QSA/matchesSelector
       ---------------------------------------------------------------------- */
   
       // QSA and matchesSelector support
   
       // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
       rbuggyMatches = [];
   
       // qSa(:focus) reports false when true (Chrome 21)
       // We allow this because of a bug in IE8/9 that throws an error
       // whenever `document.activeElement` is accessed on an iframe
       // So, we allow :focus to pass through QSA all the time to avoid the IE error
       // See https://bugs.jquery.com/ticket/13378
       rbuggyQSA = [];
   
       if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
           // Build QSA regex
           // Regex strategy adopted from Diego Perini
           assert(function( el ) {
               // Select is set to empty string on purpose
               // This is to test IE's treatment of not explicitly
               // setting a boolean content attribute,
               // since its presence should be enough
               // https://bugs.jquery.com/ticket/12359
               docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
                   "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                   "<option selected=''></option></select>";
   
               // Support: IE8, Opera 11-12.16
               // Nothing should be selected when empty strings follow ^= or $= or *=
               // The test attribute must be unknown in Opera but "safe" for WinRT
               // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
               if ( el.querySelectorAll("[msallowcapture^='']").length ) {
                   rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
               }
   
               // Support: IE8
               // Boolean attributes and "value" are not treated correctly
               if ( !el.querySelectorAll("[selected]").length ) {
                   rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
               }
   
               // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
               if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
                   rbuggyQSA.push("~=");
               }
   
               // Webkit/Opera - :checked should return selected option elements
               // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
               // IE8 throws error here and will not see later tests
               if ( !el.querySelectorAll(":checked").length ) {
                   rbuggyQSA.push(":checked");
               }
   
               // Support: Safari 8+, iOS 8+
               // https://bugs.webkit.org/show_bug.cgi?id=136851
               // In-page `selector#id sibling-combinator selector` fails
               if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
                   rbuggyQSA.push(".#.+[+~]");
               }
           });
   
           assert(function( el ) {
               el.innerHTML = "<a href='' disabled='disabled'></a>" +
                   "<select disabled='disabled'><option/></select>";
   
               // Support: Windows 8 Native Apps
               // The type and name attributes are restricted during .innerHTML assignment
               var input = document.createElement("input");
               input.setAttribute( "type", "hidden" );
               el.appendChild( input ).setAttribute( "name", "D" );
   
               // Support: IE8
               // Enforce case-sensitivity of name attribute
               if ( el.querySelectorAll("[name=d]").length ) {
                   rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
               }
   
               // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
               // IE8 throws error here and will not see later tests
               if ( el.querySelectorAll(":enabled").length !== 2 ) {
                   rbuggyQSA.push( ":enabled", ":disabled" );
               }
   
               // Support: IE9-11+
               // IE's :disabled selector does not pick up the children of disabled fieldsets
               docElem.appendChild( el ).disabled = true;
               if ( el.querySelectorAll(":disabled").length !== 2 ) {
                   rbuggyQSA.push( ":enabled", ":disabled" );
               }
   
               // Opera 10-11 does not throw on post-comma invalid pseudos
               el.querySelectorAll("*,:x");
               rbuggyQSA.push(",.*:");
           });
       }
   
       if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
           docElem.webkitMatchesSelector ||
           docElem.mozMatchesSelector ||
           docElem.oMatchesSelector ||
           docElem.msMatchesSelector) )) ) {
   
           assert(function( el ) {
               // Check to see if it's possible to do matchesSelector
               // on a disconnected node (IE 9)
               support.disconnectedMatch = matches.call( el, "*" );
   
               // This should fail with an exception
               // Gecko does not error, returns false instead
               matches.call( el, "[s!='']:x" );
               rbuggyMatches.push( "!=", pseudos );
           });
       }
   
       rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
       rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
   
       /* Contains
       ---------------------------------------------------------------------- */
       hasCompare = rnative.test( docElem.compareDocumentPosition );
   
       // Element contains another
       // Purposefully self-exclusive
       // As in, an element does not contain itself
       contains = hasCompare || rnative.test( docElem.contains ) ?
           function( a, b ) {
               var adown = a.nodeType === 9 ? a.documentElement : a,
                   bup = b && b.parentNode;
               return a === bup || !!( bup && bup.nodeType === 1 && (
                   adown.contains ?
                       adown.contains( bup ) :
                       a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
               ));
           } :
           function( a, b ) {
               if ( b ) {
                   while ( (b = b.parentNode) ) {
                       if ( b === a ) {
                           return true;
                       }
                   }
               }
               return false;
           };
   
       /* Sorting
       ---------------------------------------------------------------------- */
   
       // Document order sorting
       sortOrder = hasCompare ?
       function( a, b ) {
   
           // Flag for duplicate removal
           if ( a === b ) {
               hasDuplicate = true;
               return 0;
           }
   
           // Sort on method existence if only one input has compareDocumentPosition
           var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
           if ( compare ) {
               return compare;
           }
   
           // Calculate position if both inputs belong to the same document
           compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
               a.compareDocumentPosition( b ) :
   
               // Otherwise we know they are disconnected
               1;
   
           // Disconnected nodes
           if ( compare & 1 ||
               (!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
   
               // Choose the first element that is related to our preferred document
               if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
                   return -1;
               }
               if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
                   return 1;
               }
   
               // Maintain original order
               return sortInput ?
                   ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                   0;
           }
   
           return compare & 4 ? -1 : 1;
       } :
       function( a, b ) {
           // Exit early if the nodes are identical
           if ( a === b ) {
               hasDuplicate = true;
               return 0;
           }
   
           var cur,
               i = 0,
               aup = a.parentNode,
               bup = b.parentNode,
               ap = [ a ],
               bp = [ b ];
   
           // Parentless nodes are either documents or disconnected
           if ( !aup || !bup ) {
               return a === document ? -1 :
                   b === document ? 1 :
                   aup ? -1 :
                   bup ? 1 :
                   sortInput ?
                   ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                   0;
   
           // If the nodes are siblings, we can do a quick check
           } else if ( aup === bup ) {
               return siblingCheck( a, b );
           }
   
           // Otherwise we need full lists of their ancestors for comparison
           cur = a;
           while ( (cur = cur.parentNode) ) {
               ap.unshift( cur );
           }
           cur = b;
           while ( (cur = cur.parentNode) ) {
               bp.unshift( cur );
           }
   
           // Walk down the tree looking for a discrepancy
           while ( ap[i] === bp[i] ) {
               i++;
           }
   
           return i ?
               // Do a sibling check if the nodes have a common ancestor
               siblingCheck( ap[i], bp[i] ) :
   
               // Otherwise nodes in our document sort first
               ap[i] === preferredDoc ? -1 :
               bp[i] === preferredDoc ? 1 :
               0;
       };
   
       return document;
   };
   
   Sizzle.matches = function( expr, elements ) {
       return Sizzle( expr, null, null, elements );
   };
   
   Sizzle.matchesSelector = function( elem, expr ) {
       // Set document vars if needed
       if ( ( elem.ownerDocument || elem ) !== document ) {
           setDocument( elem );
       }
   
       // Make sure that attribute selectors are quoted
       expr = expr.replace( rattributeQuotes, "='$1']" );
   
       if ( support.matchesSelector && documentIsHTML &&
           !compilerCache[ expr + " " ] &&
           ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
           ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
   
           try {
               var ret = matches.call( elem, expr );
   
               // IE 9's matchesSelector returns false on disconnected nodes
               if ( ret || support.disconnectedMatch ||
                       // As well, disconnected nodes are said to be in a document
                       // fragment in IE 9
                       elem.document && elem.document.nodeType !== 11 ) {
                   return ret;
               }
           } catch (e) {}
       }
   
       return Sizzle( expr, document, null, [ elem ] ).length > 0;
   };
   
   Sizzle.contains = function( context, elem ) {
       // Set document vars if needed
       if ( ( context.ownerDocument || context ) !== document ) {
           setDocument( context );
       }
       return contains( context, elem );
   };
   
   Sizzle.attr = function( elem, name ) {
       // Set document vars if needed
       if ( ( elem.ownerDocument || elem ) !== document ) {
           setDocument( elem );
       }
   
       var fn = Expr.attrHandle[ name.toLowerCase() ],
           // Don't get fooled by Object.prototype properties (jQuery #13807)
           val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
               fn( elem, name, !documentIsHTML ) :
               undefined;
   
       return val !== undefined ?
           val :
           support.attributes || !documentIsHTML ?
               elem.getAttribute( name ) :
               (val = elem.getAttributeNode(name)) && val.specified ?
                   val.value :
                   null;
   };
   
   Sizzle.escape = function( sel ) {
       return (sel + "").replace( rcssescape, fcssescape );
   };
   
   Sizzle.error = function( msg ) {
       throw new Error( "Syntax error, unrecognized expression: " + msg );
   };
   
   /**
    * Document sorting and removing duplicates
    * @param {ArrayLike} results
    */
   Sizzle.uniqueSort = function( results ) {
       var elem,
           duplicates = [],
           j = 0,
           i = 0;
   
       // Unless we *know* we can detect duplicates, assume their presence
       hasDuplicate = !support.detectDuplicates;
       sortInput = !support.sortStable && results.slice( 0 );
       results.sort( sortOrder );
   
       if ( hasDuplicate ) {
           while ( (elem = results[i++]) ) {
               if ( elem === results[ i ] ) {
                   j = duplicates.push( i );
               }
           }
           while ( j-- ) {
               results.splice( duplicates[ j ], 1 );
           }
       }
   
       // Clear input after sorting to release objects
       // See https://github.com/jquery/sizzle/pull/225
       sortInput = null;
   
       return results;
   };
   
   /**
    * Utility function for retrieving the text value of an array of DOM nodes
    * @param {Array|Element} elem
    */
   getText = Sizzle.getText = function( elem ) {
       var node,
           ret = "",
           i = 0,
           nodeType = elem.nodeType;
   
       if ( !nodeType ) {
           // If no nodeType, this is expected to be an array
           while ( (node = elem[i++]) ) {
               // Do not traverse comment nodes
               ret += getText( node );
           }
       } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
           // Use textContent for elements
           // innerText usage removed for consistency of new lines (jQuery #11153)
           if ( typeof elem.textContent === "string" ) {
               return elem.textContent;
           } else {
               // Traverse its children
               for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                   ret += getText( elem );
               }
           }
       } else if ( nodeType === 3 || nodeType === 4 ) {
           return elem.nodeValue;
       }
       // Do not include comment or processing instruction nodes
   
       return ret;
   };
   
   Expr = Sizzle.selectors = {
   
       // Can be adjusted by the user
       cacheLength: 50,
   
       createPseudo: markFunction,
   
       match: matchExpr,
   
       attrHandle: {},
   
       find: {},
   
       relative: {
           ">": { dir: "parentNode", first: true },
           " ": { dir: "parentNode" },
           "+": { dir: "previousSibling", first: true },
           "~": { dir: "previousSibling" }
       },
   
       preFilter: {
           "ATTR": function( match ) {
               match[1] = match[1].replace( runescape, funescape );
   
               // Move the given value to match[3] whether quoted or unquoted
               match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
   
               if ( match[2] === "~=" ) {
                   match[3] = " " + match[3] + " ";
               }
   
               return match.slice( 0, 4 );
           },
   
           "CHILD": function( match ) {
               /* matches from matchExpr["CHILD"]
                   1 type (only|nth|...)
                   2 what (child|of-type)
                   3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
                   4 xn-component of xn+y argument ([+-]?\d*n|)
                   5 sign of xn-component
                   6 x of xn-component
                   7 sign of y-component
                   8 y of y-component
               */
               match[1] = match[1].toLowerCase();
   
               if ( match[1].slice( 0, 3 ) === "nth" ) {
                   // nth-* requires argument
                   if ( !match[3] ) {
                       Sizzle.error( match[0] );
                   }
   
                   // numeric x and y parameters for Expr.filter.CHILD
                   // remember that false/true cast respectively to 0/1
                   match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
                   match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
   
               // other types prohibit arguments
               } else if ( match[3] ) {
                   Sizzle.error( match[0] );
               }
   
               return match;
           },
   
           "PSEUDO": function( match ) {
               var excess,
                   unquoted = !match[6] && match[2];
   
               if ( matchExpr["CHILD"].test( match[0] ) ) {
                   return null;
               }
   
               // Accept quoted arguments as-is
               if ( match[3] ) {
                   match[2] = match[4] || match[5] || "";
   
               // Strip excess characters from unquoted arguments
               } else if ( unquoted && rpseudo.test( unquoted ) &&
                   // Get excess from tokenize (recursively)
                   (excess = tokenize( unquoted, true )) &&
                   // advance to the next closing parenthesis
                   (excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
   
                   // excess is a negative index
                   match[0] = match[0].slice( 0, excess );
                   match[2] = unquoted.slice( 0, excess );
               }
   
               // Return only captures needed by the pseudo filter method (type and argument)
               return match.slice( 0, 3 );
           }
       },
   
       filter: {
   
           "TAG": function( nodeNameSelector ) {
               var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
               return nodeNameSelector === "*" ?
                   function() { return true; } :
                   function( elem ) {
                       return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                   };
           },
   
           "CLASS": function( className ) {
               var pattern = classCache[ className + " " ];
   
               return pattern ||
                   (pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
                   classCache( className, function( elem ) {
                       return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
                   });
           },
   
           "ATTR": function( name, operator, check ) {
               return function( elem ) {
                   var result = Sizzle.attr( elem, name );
   
                   if ( result == null ) {
                       return operator === "!=";
                   }
                   if ( !operator ) {
                       return true;
                   }
   
                   result += "";
   
                   return operator === "=" ? result === check :
                       operator === "!=" ? result !== check :
                       operator === "^=" ? check && result.indexOf( check ) === 0 :
                       operator === "*=" ? check && result.indexOf( check ) > -1 :
                       operator === "$=" ? check && result.slice( -check.length ) === check :
                       operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
                       operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
                       false;
               };
           },
   
           "CHILD": function( type, what, argument, first, last ) {
               var simple = type.slice( 0, 3 ) !== "nth",
                   forward = type.slice( -4 ) !== "last",
                   ofType = what === "of-type";
   
               return first === 1 && last === 0 ?
   
                   // Shortcut for :nth-*(n)
                   function( elem ) {
                       return !!elem.parentNode;
                   } :
   
                   function( elem, context, xml ) {
                       var cache, uniqueCache, outerCache, node, nodeIndex, start,
                           dir = simple !== forward ? "nextSibling" : "previousSibling",
                           parent = elem.parentNode,
                           name = ofType && elem.nodeName.toLowerCase(),
                           useCache = !xml && !ofType,
                           diff = false;
   
                       if ( parent ) {
   
                           // :(first|last|only)-(child|of-type)
                           if ( simple ) {
                               while ( dir ) {
                                   node = elem;
                                   while ( (node = node[ dir ]) ) {
                                       if ( ofType ?
                                           node.nodeName.toLowerCase() === name :
                                           node.nodeType === 1 ) {
   
                                           return false;
                                       }
                                   }
                                   // Reverse direction for :only-* (if we haven't yet done so)
                                   start = dir = type === "only" && !start && "nextSibling";
                               }
                               return true;
                           }
   
                           start = [ forward ? parent.firstChild : parent.lastChild ];
   
                           // non-xml :nth-child(...) stores cache data on `parent`
                           if ( forward && useCache ) {
   
                               // Seek `elem` from a previously-cached index
   
                               // ...in a gzip-friendly way
                               node = parent;
                               outerCache = node[ expando ] || (node[ expando ] = {});
   
                               // Support: IE <9 only
                               // Defend against cloned attroperties (jQuery gh-1709)
                               uniqueCache = outerCache[ node.uniqueID ] ||
                                   (outerCache[ node.uniqueID ] = {});
   
                               cache = uniqueCache[ type ] || [];
                               nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                               diff = nodeIndex && cache[ 2 ];
                               node = nodeIndex && parent.childNodes[ nodeIndex ];
   
                               while ( (node = ++nodeIndex && node && node[ dir ] ||
   
                                   // Fallback to seeking `elem` from the start
                                   (diff = nodeIndex = 0) || start.pop()) ) {
   
                                   // When found, cache indexes on `parent` and break
                                   if ( node.nodeType === 1 && ++diff && node === elem ) {
                                       uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
                                       break;
                                   }
                               }
   
                           } else {
                               // Use previously-cached element index if available
                               if ( useCache ) {
                                   // ...in a gzip-friendly way
                                   node = elem;
                                   outerCache = node[ expando ] || (node[ expando ] = {});
   
                                   // Support: IE <9 only
                                   // Defend against cloned attroperties (jQuery gh-1709)
                                   uniqueCache = outerCache[ node.uniqueID ] ||
                                       (outerCache[ node.uniqueID ] = {});
   
                                   cache = uniqueCache[ type ] || [];
                                   nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                   diff = nodeIndex;
                               }
   
                               // xml :nth-child(...)
                               // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                               if ( diff === false ) {
                                   // Use the same loop as above to seek `elem` from the start
                                   while ( (node = ++nodeIndex && node && node[ dir ] ||
                                       (diff = nodeIndex = 0) || start.pop()) ) {
   
                                       if ( ( ofType ?
                                           node.nodeName.toLowerCase() === name :
                                           node.nodeType === 1 ) &&
                                           ++diff ) {
   
                                           // Cache the index of each encountered element
                                           if ( useCache ) {
                                               outerCache = node[ expando ] || (node[ expando ] = {});
   
                                               // Support: IE <9 only
                                               // Defend against cloned attroperties (jQuery gh-1709)
                                               uniqueCache = outerCache[ node.uniqueID ] ||
                                                   (outerCache[ node.uniqueID ] = {});
   
                                               uniqueCache[ type ] = [ dirruns, diff ];
                                           }
   
                                           if ( node === elem ) {
                                               break;
                                           }
                                       }
                                   }
                               }
                           }
   
                           // Incorporate the offset, then check against cycle size
                           diff -= last;
                           return diff === first || ( diff % first === 0 && diff / first >= 0 );
                       }
                   };
           },
   
           "PSEUDO": function( pseudo, argument ) {
               // pseudo-class names are case-insensitive
               // http://www.w3.org/TR/selectors/#pseudo-classes
               // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
               // Remember that setFilters inherits from pseudos
               var args,
                   fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
                       Sizzle.error( "unsupported pseudo: " + pseudo );
   
               // The user may use createPseudo to indicate that
               // arguments are needed to create the filter function
               // just as Sizzle does
               if ( fn[ expando ] ) {
                   return fn( argument );
               }
   
               // But maintain support for old signatures
               if ( fn.length > 1 ) {
                   args = [ pseudo, pseudo, "", argument ];
                   return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
                       markFunction(function( seed, matches ) {
                           var idx,
                               matched = fn( seed, argument ),
                               i = matched.length;
                           while ( i-- ) {
                               idx = indexOf( seed, matched[i] );
                               seed[ idx ] = !( matches[ idx ] = matched[i] );
                           }
                       }) :
                       function( elem ) {
                           return fn( elem, 0, args );
                       };
               }
   
               return fn;
           }
       },
   
       pseudos: {
           // Potentially complex pseudos
           "not": markFunction(function( selector ) {
               // Trim the selector passed to compile
               // to avoid treating leading and trailing
               // spaces as combinators
               var input = [],
                   results = [],
                   matcher = compile( selector.replace( rtrim, "$1" ) );
   
               return matcher[ expando ] ?
                   markFunction(function( seed, matches, context, xml ) {
                       var elem,
                           unmatched = matcher( seed, null, xml, [] ),
                           i = seed.length;
   
                       // Match elements unmatched by `matcher`
                       while ( i-- ) {
                           if ( (elem = unmatched[i]) ) {
                               seed[i] = !(matches[i] = elem);
                           }
                       }
                   }) :
                   function( elem, context, xml ) {
                       input[0] = elem;
                       matcher( input, null, xml, results );
                       // Don't keep the element (issue #299)
                       input[0] = null;
                       return !results.pop();
                   };
           }),
   
           "has": markFunction(function( selector ) {
               return function( elem ) {
                   return Sizzle( selector, elem ).length > 0;
               };
           }),
   
           "contains": markFunction(function( text ) {
               text = text.replace( runescape, funescape );
               return function( elem ) {
                   return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
               };
           }),
   
           // "Whether an element is represented by a :lang() selector
           // is based solely on the element's language value
           // being equal to the identifier C,
           // or beginning with the identifier C immediately followed by "-".
           // The matching of C against the element's language value is performed case-insensitively.
           // The identifier C does not have to be a valid language name."
           // http://www.w3.org/TR/selectors/#lang-pseudo
           "lang": markFunction( function( lang ) {
               // lang value must be a valid identifier
               if ( !ridentifier.test(lang || "") ) {
                   Sizzle.error( "unsupported lang: " + lang );
               }
               lang = lang.replace( runescape, funescape ).toLowerCase();
               return function( elem ) {
                   var elemLang;
                   do {
                       if ( (elemLang = documentIsHTML ?
                           elem.lang :
                           elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
   
                           elemLang = elemLang.toLowerCase();
                           return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
                       }
                   } while ( (elem = elem.parentNode) && elem.nodeType === 1 );
                   return false;
               };
           }),
   
           // Miscellaneous
           "target": function( elem ) {
               var hash = window.location && window.location.hash;
               return hash && hash.slice( 1 ) === elem.id;
           },
   
           "root": function( elem ) {
               return elem === docElem;
           },
   
           "focus": function( elem ) {
               return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
           },
   
           // Boolean properties
           "enabled": createDisabledPseudo( false ),
           "disabled": createDisabledPseudo( true ),
   
           "checked": function( elem ) {
               // In CSS3, :checked should return both checked and selected elements
               // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
               var nodeName = elem.nodeName.toLowerCase();
               return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
           },
   
           "selected": function( elem ) {
               // Accessing this property makes selected-by-default
               // options in Safari work properly
               if ( elem.parentNode ) {
                   elem.parentNode.selectedIndex;
               }
   
               return elem.selected === true;
           },
   
           // Contents
           "empty": function( elem ) {
               // http://www.w3.org/TR/selectors/#empty-pseudo
               // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
               //   but not by others (comment: 8; processing instruction: 7; etc.)
               // nodeType < 6 works because attributes (2) do not appear as children
               for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                   if ( elem.nodeType < 6 ) {
                       return false;
                   }
               }
               return true;
           },
   
           "parent": function( elem ) {
               return !Expr.pseudos["empty"]( elem );
           },
   
           // Element/input types
           "header": function( elem ) {
               return rheader.test( elem.nodeName );
           },
   
           "input": function( elem ) {
               return rinputs.test( elem.nodeName );
           },
   
           "button": function( elem ) {
               var name = elem.nodeName.toLowerCase();
               return name === "input" && elem.type === "button" || name === "button";
           },
   
           "text": function( elem ) {
               var attr;
               return elem.nodeName.toLowerCase() === "input" &&
                   elem.type === "text" &&
   
                   // Support: IE<8
                   // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                   ( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
           },
   
           // Position-in-collection
           "first": createPositionalPseudo(function() {
               return [ 0 ];
           }),
   
           "last": createPositionalPseudo(function( matchIndexes, length ) {
               return [ length - 1 ];
           }),
   
           "eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
               return [ argument < 0 ? argument + length : argument ];
           }),
   
           "even": createPositionalPseudo(function( matchIndexes, length ) {
               var i = 0;
               for ( ; i < length; i += 2 ) {
                   matchIndexes.push( i );
               }
               return matchIndexes;
           }),
   
           "odd": createPositionalPseudo(function( matchIndexes, length ) {
               var i = 1;
               for ( ; i < length; i += 2 ) {
                   matchIndexes.push( i );
               }
               return matchIndexes;
           }),
   
           "lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
               var i = argument < 0 ? argument + length : argument;
               for ( ; --i >= 0; ) {
                   matchIndexes.push( i );
               }
               return matchIndexes;
           }),
   
           "gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
               var i = argument < 0 ? argument + length : argument;
               for ( ; ++i < length; ) {
                   matchIndexes.push( i );
               }
               return matchIndexes;
           })
       }
   };
   
   Expr.pseudos["nth"] = Expr.pseudos["eq"];
   
   // Add button/input type pseudos
   for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
       Expr.pseudos[ i ] = createInputPseudo( i );
   }
   for ( i in { submit: true, reset: true } ) {
       Expr.pseudos[ i ] = createButtonPseudo( i );
   }
   
   // Easy API for creating new setFilters
   function setFilters() {}
   setFilters.prototype = Expr.filters = Expr.pseudos;
   Expr.setFilters = new setFilters();
   
   tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
       var matched, match, tokens, type,
           soFar, groups, preFilters,
           cached = tokenCache[ selector + " " ];
   
       if ( cached ) {
           return parseOnly ? 0 : cached.slice( 0 );
       }
   
       soFar = selector;
       groups = [];
       preFilters = Expr.preFilter;
   
       while ( soFar ) {
   
           // Comma and first run
           if ( !matched || (match = rcomma.exec( soFar )) ) {
               if ( match ) {
                   // Don't consume trailing commas as valid
                   soFar = soFar.slice( match[0].length ) || soFar;
               }
               groups.push( (tokens = []) );
           }
   
           matched = false;
   
           // Combinators
           if ( (match = rcombinators.exec( soFar )) ) {
               matched = match.shift();
               tokens.push({
                   value: matched,
                   // Cast descendant combinators to space
                   type: match[0].replace( rtrim, " " )
               });
               soFar = soFar.slice( matched.length );
           }
   
           // Filters
           for ( type in Expr.filter ) {
               if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
                   (match = preFilters[ type ]( match ))) ) {
                   matched = match.shift();
                   tokens.push({
                       value: matched,
                       type: type,
                       matches: match
                   });
                   soFar = soFar.slice( matched.length );
               }
           }
   
           if ( !matched ) {
               break;
           }
       }
   
       // Return the length of the invalid excess
       // if we're just parsing
       // Otherwise, throw an error or return tokens
       return parseOnly ?
           soFar.length :
           soFar ?
               Sizzle.error( selector ) :
               // Cache the tokens
               tokenCache( selector, groups ).slice( 0 );
   };
   
   function toSelector( tokens ) {
       var i = 0,
           len = tokens.length,
           selector = "";
       for ( ; i < len; i++ ) {
           selector += tokens[i].value;
       }
       return selector;
   }
   
   function addCombinator( matcher, combinator, base ) {
       var dir = combinator.dir,
           skip = combinator.next,
           key = skip || dir,
           checkNonElements = base && key === "parentNode",
           doneName = done++;
   
       return combinator.first ?
           // Check against closest ancestor/preceding element
           function( elem, context, xml ) {
               while ( (elem = elem[ dir ]) ) {
                   if ( elem.nodeType === 1 || checkNonElements ) {
                       return matcher( elem, context, xml );
                   }
               }
               return false;
           } :
   
           // Check against all ancestor/preceding elements
           function( elem, context, xml ) {
               var oldCache, uniqueCache, outerCache,
                   newCache = [ dirruns, doneName ];
   
               // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
               if ( xml ) {
                   while ( (elem = elem[ dir ]) ) {
                       if ( elem.nodeType === 1 || checkNonElements ) {
                           if ( matcher( elem, context, xml ) ) {
                               return true;
                           }
                       }
                   }
               } else {
                   while ( (elem = elem[ dir ]) ) {
                       if ( elem.nodeType === 1 || checkNonElements ) {
                           outerCache = elem[ expando ] || (elem[ expando ] = {});
   
                           // Support: IE <9 only
                           // Defend against cloned attroperties (jQuery gh-1709)
                           uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
   
                           if ( skip && skip === elem.nodeName.toLowerCase() ) {
                               elem = elem[ dir ] || elem;
                           } else if ( (oldCache = uniqueCache[ key ]) &&
                               oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
   
                               // Assign to newCache so results back-propagate to previous elements
                               return (newCache[ 2 ] = oldCache[ 2 ]);
                           } else {
                               // Reuse newcache so results back-propagate to previous elements
                               uniqueCache[ key ] = newCache;
   
                               // A match means we're done; a fail means we have to keep checking
                               if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
                                   return true;
                               }
                           }
                       }
                   }
               }
               return false;
           };
   }
   
   function elementMatcher( matchers ) {
       return matchers.length > 1 ?
           function( elem, context, xml ) {
               var i = matchers.length;
               while ( i-- ) {
                   if ( !matchers[i]( elem, context, xml ) ) {
                       return false;
                   }
               }
               return true;
           } :
           matchers[0];
   }
   
   function multipleContexts( selector, contexts, results ) {
       var i = 0,
           len = contexts.length;
       for ( ; i < len; i++ ) {
           Sizzle( selector, contexts[i], results );
       }
       return results;
   }
   
   function condense( unmatched, map, filter, context, xml ) {
       var elem,
           newUnmatched = [],
           i = 0,
           len = unmatched.length,
           mapped = map != null;
   
       for ( ; i < len; i++ ) {
           if ( (elem = unmatched[i]) ) {
               if ( !filter || filter( elem, context, xml ) ) {
                   newUnmatched.push( elem );
                   if ( mapped ) {
                       map.push( i );
                   }
               }
           }
       }
   
       return newUnmatched;
   }
   
   function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
       if ( postFilter && !postFilter[ expando ] ) {
           postFilter = setMatcher( postFilter );
       }
       if ( postFinder && !postFinder[ expando ] ) {
           postFinder = setMatcher( postFinder, postSelector );
       }
       return markFunction(function( seed, results, context, xml ) {
           var temp, i, elem,
               preMap = [],
               postMap = [],
               preexisting = results.length,
   
               // Get initial elements from seed or context
               elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
   
               // Prefilter to get matcher input, preserving a map for seed-results synchronization
               matcherIn = preFilter && ( seed || !selector ) ?
                   condense( elems, preMap, preFilter, context, xml ) :
                   elems,
   
               matcherOut = matcher ?
                   // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                   postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
   
                       // ...intermediate processing is necessary
                       [] :
   
                       // ...otherwise use results directly
                       results :
                   matcherIn;
   
           // Find primary matches
           if ( matcher ) {
               matcher( matcherIn, matcherOut, context, xml );
           }
   
           // Apply postFilter
           if ( postFilter ) {
               temp = condense( matcherOut, postMap );
               postFilter( temp, [], context, xml );
   
               // Un-match failing elements by moving them back to matcherIn
               i = temp.length;
               while ( i-- ) {
                   if ( (elem = temp[i]) ) {
                       matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
                   }
               }
           }
   
           if ( seed ) {
               if ( postFinder || preFilter ) {
                   if ( postFinder ) {
                       // Get the final matcherOut by condensing this intermediate into postFinder contexts
                       temp = [];
                       i = matcherOut.length;
                       while ( i-- ) {
                           if ( (elem = matcherOut[i]) ) {
                               // Restore matcherIn since elem is not yet a final match
                               temp.push( (matcherIn[i] = elem) );
                           }
                       }
                       postFinder( null, (matcherOut = []), temp, xml );
                   }
   
                   // Move matched elements from seed to results to keep them synchronized
                   i = matcherOut.length;
                   while ( i-- ) {
                       if ( (elem = matcherOut[i]) &&
                           (temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
   
                           seed[temp] = !(results[temp] = elem);
                       }
                   }
               }
   
           // Add elements to results, through postFinder if defined
           } else {
               matcherOut = condense(
                   matcherOut === results ?
                       matcherOut.splice( preexisting, matcherOut.length ) :
                       matcherOut
               );
               if ( postFinder ) {
                   postFinder( null, results, matcherOut, xml );
               } else {
                   push.apply( results, matcherOut );
               }
           }
       });
   }
   
   function matcherFromTokens( tokens ) {
       var checkContext, matcher, j,
           len = tokens.length,
           leadingRelative = Expr.relative[ tokens[0].type ],
           implicitRelative = leadingRelative || Expr.relative[" "],
           i = leadingRelative ? 1 : 0,
   
           // The foundational matcher ensures that elements are reachable from top-level context(s)
           matchContext = addCombinator( function( elem ) {
               return elem === checkContext;
           }, implicitRelative, true ),
           matchAnyContext = addCombinator( function( elem ) {
               return indexOf( checkContext, elem ) > -1;
           }, implicitRelative, true ),
           matchers = [ function( elem, context, xml ) {
               var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
                   (checkContext = context).nodeType ?
                       matchContext( elem, context, xml ) :
                       matchAnyContext( elem, context, xml ) );
               // Avoid hanging onto element (issue #299)
               checkContext = null;
               return ret;
           } ];
   
       for ( ; i < len; i++ ) {
           if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
               matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
           } else {
               matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
   
               // Return special upon seeing a positional matcher
               if ( matcher[ expando ] ) {
                   // Find the next relative operator (if any) for proper handling
                   j = ++i;
                   for ( ; j < len; j++ ) {
                       if ( Expr.relative[ tokens[j].type ] ) {
                           break;
                       }
                   }
                   return setMatcher(
                       i > 1 && elementMatcher( matchers ),
                       i > 1 && toSelector(
                           // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                           tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
                       ).replace( rtrim, "$1" ),
                       matcher,
                       i < j && matcherFromTokens( tokens.slice( i, j ) ),
                       j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
                       j < len && toSelector( tokens )
                   );
               }
               matchers.push( matcher );
           }
       }
   
       return elementMatcher( matchers );
   }
   
   function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
       var bySet = setMatchers.length > 0,
           byElement = elementMatchers.length > 0,
           superMatcher = function( seed, context, xml, results, outermost ) {
               var elem, j, matcher,
                   matchedCount = 0,
                   i = "0",
                   unmatched = seed && [],
                   setMatched = [],
                   contextBackup = outermostContext,
                   // We must always have either seed elements or outermost context
                   elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
                   // Use integer dirruns iff this is the outermost matcher
                   dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                   len = elems.length;
   
               if ( outermost ) {
                   outermostContext = context === document || context || outermost;
               }
   
               // Add elements passing elementMatchers directly to results
               // Support: IE<9, Safari
               // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
               for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
                   if ( byElement && elem ) {
                       j = 0;
                       if ( !context && elem.ownerDocument !== document ) {
                           setDocument( elem );
                           xml = !documentIsHTML;
                       }
                       while ( (matcher = elementMatchers[j++]) ) {
                           if ( matcher( elem, context || document, xml) ) {
                               results.push( elem );
                               break;
                           }
                       }
                       if ( outermost ) {
                           dirruns = dirrunsUnique;
                       }
                   }
   
                   // Track unmatched elements for set filters
                   if ( bySet ) {
                       // They will have gone through all possible matchers
                       if ( (elem = !matcher && elem) ) {
                           matchedCount--;
                       }
   
                       // Lengthen the array for every element, matched or not
                       if ( seed ) {
                           unmatched.push( elem );
                       }
                   }
               }
   
               // `i` is now the count of elements visited above, and adding it to `matchedCount`
               // makes the latter nonnegative.
               matchedCount += i;
   
               // Apply set filters to unmatched elements
               // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
               // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
               // no element matchers and no seed.
               // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
               // case, which will result in a "00" `matchedCount` that differs from `i` but is also
               // numerically zero.
               if ( bySet && i !== matchedCount ) {
                   j = 0;
                   while ( (matcher = setMatchers[j++]) ) {
                       matcher( unmatched, setMatched, context, xml );
                   }
   
                   if ( seed ) {
                       // Reintegrate element matches to eliminate the need for sorting
                       if ( matchedCount > 0 ) {
                           while ( i-- ) {
                               if ( !(unmatched[i] || setMatched[i]) ) {
                                   setMatched[i] = pop.call( results );
                               }
                           }
                       }
   
                       // Discard index placeholder values to get only actual matches
                       setMatched = condense( setMatched );
                   }
   
                   // Add matches to results
                   push.apply( results, setMatched );
   
                   // Seedless set matches succeeding multiple successful matchers stipulate sorting
                   if ( outermost && !seed && setMatched.length > 0 &&
                       ( matchedCount + setMatchers.length ) > 1 ) {
   
                       Sizzle.uniqueSort( results );
                   }
               }
   
               // Override manipulation of globals by nested matchers
               if ( outermost ) {
                   dirruns = dirrunsUnique;
                   outermostContext = contextBackup;
               }
   
               return unmatched;
           };
   
       return bySet ?
           markFunction( superMatcher ) :
           superMatcher;
   }
   
   compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
       var i,
           setMatchers = [],
           elementMatchers = [],
           cached = compilerCache[ selector + " " ];
   
       if ( !cached ) {
           // Generate a function of recursive functions that can be used to check each element
           if ( !match ) {
               match = tokenize( selector );
           }
           i = match.length;
           while ( i-- ) {
               cached = matcherFromTokens( match[i] );
               if ( cached[ expando ] ) {
                   setMatchers.push( cached );
               } else {
                   elementMatchers.push( cached );
               }
           }
   
           // Cache the compiled function
           cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
   
           // Save selector and tokenization
           cached.selector = selector;
       }
       return cached;
   };
   
   /**
    * A low-level selection function that works with Sizzle's compiled
    *  selector functions
    * @param {String|Function} selector A selector or a pre-compiled
    *  selector function built with Sizzle.compile
    * @param {Element} context
    * @param {Array} [results]
    * @param {Array} [seed] A set of elements to match against
    */
   select = Sizzle.select = function( selector, context, results, seed ) {
       var i, tokens, token, type, find,
           compiled = typeof selector === "function" && selector,
           match = !seed && tokenize( (selector = compiled.selector || selector) );
   
       results = results || [];
   
       // Try to minimize operations if there is only one selector in the list and no seed
       // (the latter of which guarantees us context)
       if ( match.length === 1 ) {
   
           // Reduce context if the leading compound selector is an ID
           tokens = match[0] = match[0].slice( 0 );
           if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
                   context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
   
               context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
               if ( !context ) {
                   return results;
   
               // Precompiled matchers will still verify ancestry, so step up a level
               } else if ( compiled ) {
                   context = context.parentNode;
               }
   
               selector = selector.slice( tokens.shift().value.length );
           }
   
           // Fetch a seed set for right-to-left matching
           i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
           while ( i-- ) {
               token = tokens[i];
   
               // Abort if we hit a combinator
               if ( Expr.relative[ (type = token.type) ] ) {
                   break;
               }
               if ( (find = Expr.find[ type ]) ) {
                   // Search, expanding context for leading sibling combinators
                   if ( (seed = find(
                       token.matches[0].replace( runescape, funescape ),
                       rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
                   )) ) {
   
                       // If seed is empty or no tokens remain, we can return early
                       tokens.splice( i, 1 );
                       selector = seed.length && toSelector( tokens );
                       if ( !selector ) {
                           push.apply( results, seed );
                           return results;
                       }
   
                       break;
                   }
               }
           }
       }
   
       // Compile and execute a filtering function if one is not provided
       // Provide `match` to avoid retokenization if we modified the selector above
       ( compiled || compile( selector, match ) )(
           seed,
           context,
           !documentIsHTML,
           results,
           !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
       );
       return results;
   };
   
   // One-time assignments
   
   // Sort stability
   support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
   
   // Support: Chrome 14-35+
   // Always assume duplicates if they aren't passed to the comparison function
   support.detectDuplicates = !!hasDuplicate;
   
   // Initialize against the default document
   setDocument();
   
   // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
   // Detached nodes confoundingly follow *each other*
   support.sortDetached = assert(function( el ) {
       // Should return 1, but returns 4 (following)
       return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
   });
   
   // Support: IE<8
   // Prevent attribute/property "interpolation"
   // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
   if ( !assert(function( el ) {
       el.innerHTML = "<a href='#'></a>";
       return el.firstChild.getAttribute("href") === "#" ;
   }) ) {
       addHandle( "type|href|height|width", function( elem, name, isXML ) {
           if ( !isXML ) {
               return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
           }
       });
   }
   
   // Support: IE<9
   // Use defaultValue in place of getAttribute("value")
   if ( !support.attributes || !assert(function( el ) {
       el.innerHTML = "<input/>";
       el.firstChild.setAttribute( "value", "" );
       return el.firstChild.getAttribute( "value" ) === "";
   }) ) {
       addHandle( "value", function( elem, name, isXML ) {
           if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
               return elem.defaultValue;
           }
       });
   }
   
   // Support: IE<9
   // Use getAttributeNode to fetch booleans when getAttribute lies
   if ( !assert(function( el ) {
       return el.getAttribute("disabled") == null;
   }) ) {
       addHandle( booleans, function( elem, name, isXML ) {
           var val;
           if ( !isXML ) {
               return elem[ name ] === true ? name.toLowerCase() :
                       (val = elem.getAttributeNode( name )) && val.specified ?
                       val.value :
                   null;
           }
       });
   }
   
   return Sizzle;
   
   })( window );
   
   
   
   jQuery.find = Sizzle;
   jQuery.expr = Sizzle.selectors;
   
   // Deprecated
   jQuery.expr[ ":" ] = jQuery.expr.pseudos;
   jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
   jQuery.text = Sizzle.getText;
   jQuery.isXMLDoc = Sizzle.isXML;
   jQuery.contains = Sizzle.contains;
   jQuery.escapeSelector = Sizzle.escape;
   
   
   
   
   var dir = function( elem, dir, until ) {
       var matched = [],
           truncate = until !== undefined;
   
       while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
           if ( elem.nodeType === 1 ) {
               if ( truncate && jQuery( elem ).is( until ) ) {
                   break;
               }
               matched.push( elem );
           }
       }
       return matched;
   };
   
   
   var siblings = function( n, elem ) {
       var matched = [];
   
       for ( ; n; n = n.nextSibling ) {
           if ( n.nodeType === 1 && n !== elem ) {
               matched.push( n );
           }
       }
   
       return matched;
   };
   
   
   var rneedsContext = jQuery.expr.match.needsContext;
   
   
   
   function nodeName( elem, name ) {
   
     return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
   
   };
   var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
   
   
   
   // Implement the identical functionality for filter and not
   function winnow( elements, qualifier, not ) {
       if ( isFunction( qualifier ) ) {
           return jQuery.grep( elements, function( elem, i ) {
               return !!qualifier.call( elem, i, elem ) !== not;
           } );
       }
   
       // Single element
       if ( qualifier.nodeType ) {
           return jQuery.grep( elements, function( elem ) {
               return ( elem === qualifier ) !== not;
           } );
       }
   
       // Arraylike of elements (jQuery, arguments, Array)
       if ( typeof qualifier !== "string" ) {
           return jQuery.grep( elements, function( elem ) {
               return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
           } );
       }
   
       // Filtered directly for both simple and complex selectors
       return jQuery.filter( qualifier, elements, not );
   }
   
   jQuery.filter = function( expr, elems, not ) {
       var elem = elems[ 0 ];
   
       if ( not ) {
           expr = ":not(" + expr + ")";
       }
   
       if ( elems.length === 1 && elem.nodeType === 1 ) {
           return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
       }
   
       return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
           return elem.nodeType === 1;
       } ) );
   };
   
   jQuery.fn.extend( {
       find: function( selector ) {
           var i, ret,
               len = this.length,
               self = this;
   
           if ( typeof selector !== "string" ) {
               return this.pushStack( jQuery( selector ).filter( function() {
                   for ( i = 0; i < len; i++ ) {
                       if ( jQuery.contains( self[ i ], this ) ) {
                           return true;
                       }
                   }
               } ) );
           }
   
           ret = this.pushStack( [] );
   
           for ( i = 0; i < len; i++ ) {
               jQuery.find( selector, self[ i ], ret );
           }
   
           return len > 1 ? jQuery.uniqueSort( ret ) : ret;
       },
       filter: function( selector ) {
           return this.pushStack( winnow( this, selector || [], false ) );
       },
       not: function( selector ) {
           return this.pushStack( winnow( this, selector || [], true ) );
       },
       is: function( selector ) {
           return !!winnow(
               this,
   
               // If this is a positional/relative selector, check membership in the returned set
               // so $("p:first").is("p:last") won't return true for a doc with two "p".
               typeof selector === "string" && rneedsContext.test( selector ) ?
                   jQuery( selector ) :
                   selector || [],
               false
           ).length;
       }
   } );
   
   
   // Initialize a jQuery object
   
   
   // A central reference to the root jQuery(document)
   var rootjQuery,
   
       // A simple way to check for HTML strings
       // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
       // Strict HTML recognition (#11290: must start with <)
       // Shortcut simple #id case for speed
       rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
   
       init = jQuery.fn.init = function( selector, context, root ) {
           var match, elem;
   
           // HANDLE: $(""), $(null), $(undefined), $(false)
           if ( !selector ) {
               return this;
           }
   
           // Method init() accepts an alternate rootjQuery
           // so migrate can support jQuery.sub (gh-2101)
           root = root || rootjQuery;
   
           // Handle HTML strings
           if ( typeof selector === "string" ) {
               if ( selector[ 0 ] === "<" &&
                   selector[ selector.length - 1 ] === ">" &&
                   selector.length >= 3 ) {
   
                   // Assume that strings that start and end with <> are HTML and skip the regex check
                   match = [ null, selector, null ];
   
               } else {
                   match = rquickExpr.exec( selector );
               }
   
               // Match html or make sure no context is specified for #id
               if ( match && ( match[ 1 ] || !context ) ) {
   
                   // HANDLE: $(html) -> $(array)
                   if ( match[ 1 ] ) {
                       context = context instanceof jQuery ? context[ 0 ] : context;
   
                       // Option to run scripts is true for back-compat
                       // Intentionally let the error be thrown if parseHTML is not present
                       jQuery.merge( this, jQuery.parseHTML(
                           match[ 1 ],
                           context && context.nodeType ? context.ownerDocument || context : document,
                           true
                       ) );
   
                       // HANDLE: $(html, props)
                       if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
                           for ( match in context ) {
   
                               // Properties of context are called as methods if possible
                               if ( isFunction( this[ match ] ) ) {
                                   this[ match ]( context[ match ] );
   
                               // ...and otherwise set as attributes
                               } else {
                                   this.attr( match, context[ match ] );
                               }
                           }
                       }
   
                       return this;
   
                   // HANDLE: $(#id)
                   } else {
                       elem = document.getElementById( match[ 2 ] );
   
                       if ( elem ) {
   
                           // Inject the element directly into the jQuery object
                           this[ 0 ] = elem;
                           this.length = 1;
                       }
                       return this;
                   }
   
               // HANDLE: $(expr, $(...))
               } else if ( !context || context.jquery ) {
                   return ( context || root ).find( selector );
   
               // HANDLE: $(expr, context)
               // (which is just equivalent to: $(context).find(expr)
               } else {
                   return this.constructor( context ).find( selector );
               }
   
           // HANDLE: $(DOMElement)
           } else if ( selector.nodeType ) {
               this[ 0 ] = selector;
               this.length = 1;
               return this;
   
           // HANDLE: $(function)
           // Shortcut for document ready
           } else if ( isFunction( selector ) ) {
               return root.ready !== undefined ?
                   root.ready( selector ) :
   
                   // Execute immediately if ready is not present
                   selector( jQuery );
           }
   
           return jQuery.makeArray( selector, this );
       };
   
   // Give the init function the jQuery prototype for later instantiation
   init.prototype = jQuery.fn;
   
   // Initialize central reference
   rootjQuery = jQuery( document );
   
   
   var rparentsprev = /^(?:parents|prev(?:Until|All))/,
   
       // Methods guaranteed to produce a unique set when starting from a unique set
       guaranteedUnique = {
           children: true,
           contents: true,
           next: true,
           prev: true
       };
   
   jQuery.fn.extend( {
       has: function( target ) {
           var targets = jQuery( target, this ),
               l = targets.length;
   
           return this.filter( function() {
               var i = 0;
               for ( ; i < l; i++ ) {
                   if ( jQuery.contains( this, targets[ i ] ) ) {
                       return true;
                   }
               }
           } );
       },
   
       closest: function( selectors, context ) {
           var cur,
               i = 0,
               l = this.length,
               matched = [],
               targets = typeof selectors !== "string" && jQuery( selectors );
   
           // Positional selectors never match, since there's no _selection_ context
           if ( !rneedsContext.test( selectors ) ) {
               for ( ; i < l; i++ ) {
                   for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
   
                       // Always skip document fragments
                       if ( cur.nodeType < 11 && ( targets ?
                           targets.index( cur ) > -1 :
   
                           // Don't pass non-elements to Sizzle
                           cur.nodeType === 1 &&
                               jQuery.find.matchesSelector( cur, selectors ) ) ) {
   
                           matched.push( cur );
                           break;
                       }
                   }
               }
           }
   
           return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
       },
   
       // Determine the position of an element within the set
       index: function( elem ) {
   
           // No argument, return index in parent
           if ( !elem ) {
               return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
           }
   
           // Index in selector
           if ( typeof elem === "string" ) {
               return indexOf.call( jQuery( elem ), this[ 0 ] );
           }
   
           // Locate the position of the desired element
           return indexOf.call( this,
   
               // If it receives a jQuery object, the first element is used
               elem.jquery ? elem[ 0 ] : elem
           );
       },
   
       add: function( selector, context ) {
           return this.pushStack(
               jQuery.uniqueSort(
                   jQuery.merge( this.get(), jQuery( selector, context ) )
               )
           );
       },
   
       addBack: function( selector ) {
           return this.add( selector == null ?
               this.prevObject : this.prevObject.filter( selector )
           );
       }
   } );
   
   function sibling( cur, dir ) {
       while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
       return cur;
   }
   
   jQuery.each( {
       parent: function( elem ) {
           var parent = elem.parentNode;
           return parent && parent.nodeType !== 11 ? parent : null;
       },
       parents: function( elem ) {
           return dir( elem, "parentNode" );
       },
       parentsUntil: function( elem, i, until ) {
           return dir( elem, "parentNode", until );
       },
       next: function( elem ) {
           return sibling( elem, "nextSibling" );
       },
       prev: function( elem ) {
           return sibling( elem, "previousSibling" );
       },
       nextAll: function( elem ) {
           return dir( elem, "nextSibling" );
       },
       prevAll: function( elem ) {
           return dir( elem, "previousSibling" );
       },
       nextUntil: function( elem, i, until ) {
           return dir( elem, "nextSibling", until );
       },
       prevUntil: function( elem, i, until ) {
           return dir( elem, "previousSibling", until );
       },
       siblings: function( elem ) {
           return siblings( ( elem.parentNode || {} ).firstChild, elem );
       },
       children: function( elem ) {
           return siblings( elem.firstChild );
       },
       contents: function( elem ) {
           if ( nodeName( elem, "iframe" ) ) {
               return elem.contentDocument;
           }
   
           // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
           // Treat the template element as a regular one in browsers that
           // don't support it.
           if ( nodeName( elem, "template" ) ) {
               elem = elem.content || elem;
           }
   
           return jQuery.merge( [], elem.childNodes );
       }
   }, function( name, fn ) {
       jQuery.fn[ name ] = function( until, selector ) {
           var matched = jQuery.map( this, fn, until );
   
           if ( name.slice( -5 ) !== "Until" ) {
               selector = until;
           }
   
           if ( selector && typeof selector === "string" ) {
               matched = jQuery.filter( selector, matched );
           }
   
           if ( this.length > 1 ) {
   
               // Remove duplicates
               if ( !guaranteedUnique[ name ] ) {
                   jQuery.uniqueSort( matched );
               }
   
               // Reverse order for parents* and prev-derivatives
               if ( rparentsprev.test( name ) ) {
                   matched.reverse();
               }
           }
   
           return this.pushStack( matched );
       };
   } );
   var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
   
   
   
   // Convert String-formatted options into Object-formatted ones
   function createOptions( options ) {
       var object = {};
       jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
           object[ flag ] = true;
       } );
       return object;
   }
   
   /*
    * Create a callback list using the following parameters:
    *
    *	options: an optional list of space-separated options that will change how
    *			the callback list behaves or a more traditional option object
    *
    * By default a callback list will act like an event callback list and can be
    * "fired" multiple times.
    *
    * Possible options:
    *
    *	once:			will ensure the callback list can only be fired once (like a Deferred)
    *
    *	memory:			will keep track of previous values and will call any callback added
    *					after the list has been fired right away with the latest "memorized"
    *					values (like a Deferred)
    *
    *	unique:			will ensure a callback can only be added once (no duplicate in the list)
    *
    *	stopOnFalse:	interrupt callings when a callback returns false
    *
    */
   jQuery.Callbacks = function( options ) {
   
       // Convert options from String-formatted to Object-formatted if needed
       // (we check in cache first)
       options = typeof options === "string" ?
           createOptions( options ) :
           jQuery.extend( {}, options );
   
       var // Flag to know if list is currently firing
           firing,
   
           // Last fire value for non-forgettable lists
           memory,
   
           // Flag to know if list was already fired
           fired,
   
           // Flag to prevent firing
           locked,
   
           // Actual callback list
           list = [],
   
           // Queue of execution data for repeatable lists
           queue = [],
   
           // Index of currently firing callback (modified by add/remove as needed)
           firingIndex = -1,
   
           // Fire callbacks
           fire = function() {
   
               // Enforce single-firing
               locked = locked || options.once;
   
               // Execute callbacks for all pending executions,
               // respecting firingIndex overrides and runtime changes
               fired = firing = true;
               for ( ; queue.length; firingIndex = -1 ) {
                   memory = queue.shift();
                   while ( ++firingIndex < list.length ) {
   
                       // Run callback and check for early termination
                       if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
                           options.stopOnFalse ) {
   
                           // Jump to end and forget the data so .add doesn't re-fire
                           firingIndex = list.length;
                           memory = false;
                       }
                   }
               }
   
               // Forget the data if we're done with it
               if ( !options.memory ) {
                   memory = false;
               }
   
               firing = false;
   
               // Clean up if we're done firing for good
               if ( locked ) {
   
                   // Keep an empty list if we have data for future add calls
                   if ( memory ) {
                       list = [];
   
                   // Otherwise, this object is spent
                   } else {
                       list = "";
                   }
               }
           },
   
           // Actual Callbacks object
           self = {
   
               // Add a callback or a collection of callbacks to the list
               add: function() {
                   if ( list ) {
   
                       // If we have memory from a past run, we should fire after adding
                       if ( memory && !firing ) {
                           firingIndex = list.length - 1;
                           queue.push( memory );
                       }
   
                       ( function add( args ) {
                           jQuery.each( args, function( _, arg ) {
                               if ( isFunction( arg ) ) {
                                   if ( !options.unique || !self.has( arg ) ) {
                                       list.push( arg );
                                   }
                               } else if ( arg && arg.length && toType( arg ) !== "string" ) {
   
                                   // Inspect recursively
                                   add( arg );
                               }
                           } );
                       } )( arguments );
   
                       if ( memory && !firing ) {
                           fire();
                       }
                   }
                   return this;
               },
   
               // Remove a callback from the list
               remove: function() {
                   jQuery.each( arguments, function( _, arg ) {
                       var index;
                       while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
                           list.splice( index, 1 );
   
                           // Handle firing indexes
                           if ( index <= firingIndex ) {
                               firingIndex--;
                           }
                       }
                   } );
                   return this;
               },
   
               // Check if a given callback is in the list.
               // If no argument is given, return whether or not list has callbacks attached.
               has: function( fn ) {
                   return fn ?
                       jQuery.inArray( fn, list ) > -1 :
                       list.length > 0;
               },
   
               // Remove all callbacks from the list
               empty: function() {
                   if ( list ) {
                       list = [];
                   }
                   return this;
               },
   
               // Disable .fire and .add
               // Abort any current/pending executions
               // Clear all callbacks and values
               disable: function() {
                   locked = queue = [];
                   list = memory = "";
                   return this;
               },
               disabled: function() {
                   return !list;
               },
   
               // Disable .fire
               // Also disable .add unless we have memory (since it would have no effect)
               // Abort any pending executions
               lock: function() {
                   locked = queue = [];
                   if ( !memory && !firing ) {
                       list = memory = "";
                   }
                   return this;
               },
               locked: function() {
                   return !!locked;
               },
   
               // Call all callbacks with the given context and arguments
               fireWith: function( context, args ) {
                   if ( !locked ) {
                       args = args || [];
                       args = [ context, args.slice ? args.slice() : args ];
                       queue.push( args );
                       if ( !firing ) {
                           fire();
                       }
                   }
                   return this;
               },
   
               // Call all the callbacks with the given arguments
               fire: function() {
                   self.fireWith( this, arguments );
                   return this;
               },
   
               // To know if the callbacks have already been called at least once
               fired: function() {
                   return !!fired;
               }
           };
   
       return self;
   };
   
   
   function Identity( v ) {
       return v;
   }
   function Thrower( ex ) {
       throw ex;
   }
   
   function adoptValue( value, resolve, reject, noValue ) {
       var method;
   
       try {
   
           // Check for promise aspect first to privilege synchronous behavior
           if ( value && isFunction( ( method = value.promise ) ) ) {
               method.call( value ).done( resolve ).fail( reject );
   
           // Other thenables
           } else if ( value && isFunction( ( method = value.then ) ) ) {
               method.call( value, resolve, reject );
   
           // Other non-thenables
           } else {
   
               // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
               // * false: [ value ].slice( 0 ) => resolve( value )
               // * true: [ value ].slice( 1 ) => resolve()
               resolve.apply( undefined, [ value ].slice( noValue ) );
           }
   
       // For Promises/A+, convert exceptions into rejections
       // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
       // Deferred#then to conditionally suppress rejection.
       } catch ( value ) {
   
           // Support: Android 4.0 only
           // Strict mode functions invoked without .call/.apply get global-object context
           reject.apply( undefined, [ value ] );
       }
   }
   
   jQuery.extend( {
   
       Deferred: function( func ) {
           var tuples = [
   
                   // action, add listener, callbacks,
                   // ... .then handlers, argument index, [final state]
                   [ "notify", "progress", jQuery.Callbacks( "memory" ),
                       jQuery.Callbacks( "memory" ), 2 ],
                   [ "resolve", "done", jQuery.Callbacks( "once memory" ),
                       jQuery.Callbacks( "once memory" ), 0, "resolved" ],
                   [ "reject", "fail", jQuery.Callbacks( "once memory" ),
                       jQuery.Callbacks( "once memory" ), 1, "rejected" ]
               ],
               state = "pending",
               promise = {
                   state: function() {
                       return state;
                   },
                   always: function() {
                       deferred.done( arguments ).fail( arguments );
                       return this;
                   },
                   "catch": function( fn ) {
                       return promise.then( null, fn );
                   },
   
                   // Keep pipe for back-compat
                   pipe: function( /* fnDone, fnFail, fnProgress */ ) {
                       var fns = arguments;
   
                       return jQuery.Deferred( function( newDefer ) {
                           jQuery.each( tuples, function( i, tuple ) {
   
                               // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                               var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
   
                               // deferred.progress(function() { bind to newDefer or newDefer.notify })
                               // deferred.done(function() { bind to newDefer or newDefer.resolve })
                               // deferred.fail(function() { bind to newDefer or newDefer.reject })
                               deferred[ tuple[ 1 ] ]( function() {
                                   var returned = fn && fn.apply( this, arguments );
                                   if ( returned && isFunction( returned.promise ) ) {
                                       returned.promise()
                                           .progress( newDefer.notify )
                                           .done( newDefer.resolve )
                                           .fail( newDefer.reject );
                                   } else {
                                       newDefer[ tuple[ 0 ] + "With" ](
                                           this,
                                           fn ? [ returned ] : arguments
                                       );
                                   }
                               } );
                           } );
                           fns = null;
                       } ).promise();
                   },
                   then: function( onFulfilled, onRejected, onProgress ) {
                       var maxDepth = 0;
                       function resolve( depth, deferred, handler, special ) {
                           return function() {
                               var that = this,
                                   args = arguments,
                                   mightThrow = function() {
                                       var returned, then;
   
                                       // Support: Promises/A+ section 2.3.3.3.3
                                       // https://promisesaplus.com/#point-59
                                       // Ignore double-resolution attempts
                                       if ( depth < maxDepth ) {
                                           return;
                                       }
   
                                       returned = handler.apply( that, args );
   
                                       // Support: Promises/A+ section 2.3.1
                                       // https://promisesaplus.com/#point-48
                                       if ( returned === deferred.promise() ) {
                                           throw new TypeError( "Thenable self-resolution" );
                                       }
   
                                       // Support: Promises/A+ sections 2.3.3.1, 3.5
                                       // https://promisesaplus.com/#point-54
                                       // https://promisesaplus.com/#point-75
                                       // Retrieve `then` only once
                                       then = returned &&
   
                                           // Support: Promises/A+ section 2.3.4
                                           // https://promisesaplus.com/#point-64
                                           // Only check objects and functions for thenability
                                           ( typeof returned === "object" ||
                                               typeof returned === "function" ) &&
                                           returned.then;
   
                                       // Handle a returned thenable
                                       if ( isFunction( then ) ) {
   
                                           // Special processors (notify) just wait for resolution
                                           if ( special ) {
                                               then.call(
                                                   returned,
                                                   resolve( maxDepth, deferred, Identity, special ),
                                                   resolve( maxDepth, deferred, Thrower, special )
                                               );
   
                                           // Normal processors (resolve) also hook into progress
                                           } else {
   
                                               // ...and disregard older resolution values
                                               maxDepth++;
   
                                               then.call(
                                                   returned,
                                                   resolve( maxDepth, deferred, Identity, special ),
                                                   resolve( maxDepth, deferred, Thrower, special ),
                                                   resolve( maxDepth, deferred, Identity,
                                                       deferred.notifyWith )
                                               );
                                           }
   
                                       // Handle all other returned values
                                       } else {
   
                                           // Only substitute handlers pass on context
                                           // and multiple values (non-spec behavior)
                                           if ( handler !== Identity ) {
                                               that = undefined;
                                               args = [ returned ];
                                           }
   
                                           // Process the value(s)
                                           // Default process is resolve
                                           ( special || deferred.resolveWith )( that, args );
                                       }
                                   },
   
                                   // Only normal processors (resolve) catch and reject exceptions
                                   process = special ?
                                       mightThrow :
                                       function() {
                                           try {
                                               mightThrow();
                                           } catch ( e ) {
   
                                               if ( jQuery.Deferred.exceptionHook ) {
                                                   jQuery.Deferred.exceptionHook( e,
                                                       process.stackTrace );
                                               }
   
                                               // Support: Promises/A+ section 2.3.3.3.4.1
                                               // https://promisesaplus.com/#point-61
                                               // Ignore post-resolution exceptions
                                               if ( depth + 1 >= maxDepth ) {
   
                                                   // Only substitute handlers pass on context
                                                   // and multiple values (non-spec behavior)
                                                   if ( handler !== Thrower ) {
                                                       that = undefined;
                                                       args = [ e ];
                                                   }
   
                                                   deferred.rejectWith( that, args );
                                               }
                                           }
                                       };
   
                               // Support: Promises/A+ section 2.3.3.3.1
                               // https://promisesaplus.com/#point-57
                               // Re-resolve promises immediately to dodge false rejection from
                               // subsequent errors
                               if ( depth ) {
                                   process();
                               } else {
   
                                   // Call an optional hook to record the stack, in case of exception
                                   // since it's otherwise lost when execution goes async
                                   if ( jQuery.Deferred.getStackHook ) {
                                       process.stackTrace = jQuery.Deferred.getStackHook();
                                   }
                                   window.setTimeout( process );
                               }
                           };
                       }
   
                       return jQuery.Deferred( function( newDefer ) {
   
                           // progress_handlers.add( ... )
                           tuples[ 0 ][ 3 ].add(
                               resolve(
                                   0,
                                   newDefer,
                                   isFunction( onProgress ) ?
                                       onProgress :
                                       Identity,
                                   newDefer.notifyWith
                               )
                           );
   
                           // fulfilled_handlers.add( ... )
                           tuples[ 1 ][ 3 ].add(
                               resolve(
                                   0,
                                   newDefer,
                                   isFunction( onFulfilled ) ?
                                       onFulfilled :
                                       Identity
                               )
                           );
   
                           // rejected_handlers.add( ... )
                           tuples[ 2 ][ 3 ].add(
                               resolve(
                                   0,
                                   newDefer,
                                   isFunction( onRejected ) ?
                                       onRejected :
                                       Thrower
                               )
                           );
                       } ).promise();
                   },
   
                   // Get a promise for this deferred
                   // If obj is provided, the promise aspect is added to the object
                   promise: function( obj ) {
                       return obj != null ? jQuery.extend( obj, promise ) : promise;
                   }
               },
               deferred = {};
   
           // Add list-specific methods
           jQuery.each( tuples, function( i, tuple ) {
               var list = tuple[ 2 ],
                   stateString = tuple[ 5 ];
   
               // promise.progress = list.add
               // promise.done = list.add
               // promise.fail = list.add
               promise[ tuple[ 1 ] ] = list.add;
   
               // Handle state
               if ( stateString ) {
                   list.add(
                       function() {
   
                           // state = "resolved" (i.e., fulfilled)
                           // state = "rejected"
                           state = stateString;
                       },
   
                       // rejected_callbacks.disable
                       // fulfilled_callbacks.disable
                       tuples[ 3 - i ][ 2 ].disable,
   
                       // rejected_handlers.disable
                       // fulfilled_handlers.disable
                       tuples[ 3 - i ][ 3 ].disable,
   
                       // progress_callbacks.lock
                       tuples[ 0 ][ 2 ].lock,
   
                       // progress_handlers.lock
                       tuples[ 0 ][ 3 ].lock
                   );
               }
   
               // progress_handlers.fire
               // fulfilled_handlers.fire
               // rejected_handlers.fire
               list.add( tuple[ 3 ].fire );
   
               // deferred.notify = function() { deferred.notifyWith(...) }
               // deferred.resolve = function() { deferred.resolveWith(...) }
               // deferred.reject = function() { deferred.rejectWith(...) }
               deferred[ tuple[ 0 ] ] = function() {
                   deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
                   return this;
               };
   
               // deferred.notifyWith = list.fireWith
               // deferred.resolveWith = list.fireWith
               // deferred.rejectWith = list.fireWith
               deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
           } );
   
           // Make the deferred a promise
           promise.promise( deferred );
   
           // Call given func if any
           if ( func ) {
               func.call( deferred, deferred );
           }
   
           // All done!
           return deferred;
       },
   
       // Deferred helper
       when: function( singleValue ) {
           var
   
               // count of uncompleted subordinates
               remaining = arguments.length,
   
               // count of unprocessed arguments
               i = remaining,
   
               // subordinate fulfillment data
               resolveContexts = Array( i ),
               resolveValues = slice.call( arguments ),
   
               // the master Deferred
               master = jQuery.Deferred(),
   
               // subordinate callback factory
               updateFunc = function( i ) {
                   return function( value ) {
                       resolveContexts[ i ] = this;
                       resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
                       if ( !( --remaining ) ) {
                           master.resolveWith( resolveContexts, resolveValues );
                       }
                   };
               };
   
           // Single- and empty arguments are adopted like Promise.resolve
           if ( remaining <= 1 ) {
               adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
                   !remaining );
   
               // Use .then() to unwrap secondary thenables (cf. gh-3000)
               if ( master.state() === "pending" ||
                   isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
   
                   return master.then();
               }
           }
   
           // Multiple arguments are aggregated like Promise.all array elements
           while ( i-- ) {
               adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
           }
   
           return master.promise();
       }
   } );
   
   
   // These usually indicate a programmer mistake during development,
   // warn about them ASAP rather than swallowing them by default.
   var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
   
   jQuery.Deferred.exceptionHook = function( error, stack ) {
   
       // Support: IE 8 - 9 only
       // Console exists when dev tools are open, which can happen at any time
       if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
           window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
       }
   };
   
   
   
   
   jQuery.readyException = function( error ) {
       window.setTimeout( function() {
           throw error;
       } );
   };
   
   
   
   
   // The deferred used on DOM ready
   var readyList = jQuery.Deferred();
   
   jQuery.fn.ready = function( fn ) {
   
       readyList
           .then( fn )
   
           // Wrap jQuery.readyException in a function so that the lookup
           // happens at the time of error handling instead of callback
           // registration.
           .catch( function( error ) {
               jQuery.readyException( error );
           } );
   
       return this;
   };
   
   jQuery.extend( {
   
       // Is the DOM ready to be used? Set to true once it occurs.
       isReady: false,
   
       // A counter to track how many items to wait for before
       // the ready event fires. See #6781
       readyWait: 1,
   
       // Handle when the DOM is ready
       ready: function( wait ) {
   
           // Abort if there are pending holds or we're already ready
           if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
               return;
           }
   
           // Remember that the DOM is ready
           jQuery.isReady = true;
   
           // If a normal DOM Ready event fired, decrement, and wait if need be
           if ( wait !== true && --jQuery.readyWait > 0 ) {
               return;
           }
   
           // If there are functions bound, to execute
           readyList.resolveWith( document, [ jQuery ] );
       }
   } );
   
   jQuery.ready.then = readyList.then;
   
   // The ready event handler and self cleanup method
   function completed() {
       document.removeEventListener( "DOMContentLoaded", completed );
       window.removeEventListener( "load", completed );
       jQuery.ready();
   }
   
   // Catch cases where $(document).ready() is called
   // after the browser event has already occurred.
   // Support: IE <=9 - 10 only
   // Older IE sometimes signals "interactive" too soon
   if ( document.readyState === "complete" ||
       ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
   
       // Handle it asynchronously to allow scripts the opportunity to delay ready
       window.setTimeout( jQuery.ready );
   
   } else {
   
       // Use the handy event callback
       document.addEventListener( "DOMContentLoaded", completed );
   
       // A fallback to window.onload, that will always work
       window.addEventListener( "load", completed );
   }
   
   
   
   
   // Multifunctional method to get and set values of a collection
   // The value/s can optionally be executed if it's a function
   var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
       var i = 0,
           len = elems.length,
           bulk = key == null;
   
       // Sets many values
       if ( toType( key ) === "object" ) {
           chainable = true;
           for ( i in key ) {
               access( elems, fn, i, key[ i ], true, emptyGet, raw );
           }
   
       // Sets one value
       } else if ( value !== undefined ) {
           chainable = true;
   
           if ( !isFunction( value ) ) {
               raw = true;
           }
   
           if ( bulk ) {
   
               // Bulk operations run against the entire set
               if ( raw ) {
                   fn.call( elems, value );
                   fn = null;
   
               // ...except when executing function values
               } else {
                   bulk = fn;
                   fn = function( elem, key, value ) {
                       return bulk.call( jQuery( elem ), value );
                   };
               }
           }
   
           if ( fn ) {
               for ( ; i < len; i++ ) {
                   fn(
                       elems[ i ], key, raw ?
                       value :
                       value.call( elems[ i ], i, fn( elems[ i ], key ) )
                   );
               }
           }
       }
   
       if ( chainable ) {
           return elems;
       }
   
       // Gets
       if ( bulk ) {
           return fn.call( elems );
       }
   
       return len ? fn( elems[ 0 ], key ) : emptyGet;
   };
   
   
   // Matches dashed string for camelizing
   var rmsPrefix = /^-ms-/,
       rdashAlpha = /-([a-z])/g;
   
   // Used by camelCase as callback to replace()
   function fcamelCase( all, letter ) {
       return letter.toUpperCase();
   }
   
   // Convert dashed to camelCase; used by the css and data modules
   // Support: IE <=9 - 11, Edge 12 - 15
   // Microsoft forgot to hump their vendor prefix (#9572)
   function camelCase( string ) {
       return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
   }
   var acceptData = function( owner ) {
   
       // Accepts only:
       //  - Node
       //    - Node.ELEMENT_NODE
       //    - Node.DOCUMENT_NODE
       //  - Object
       //    - Any
       return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
   };
   
   
   
   
   function Data() {
       this.expando = jQuery.expando + Data.uid++;
   }
   
   Data.uid = 1;
   
   Data.prototype = {
   
       cache: function( owner ) {
   
           // Check if the owner object already has a cache
           var value = owner[ this.expando ];
   
           // If not, create one
           if ( !value ) {
               value = {};
   
               // We can accept data for non-element nodes in modern browsers,
               // but we should not, see #8335.
               // Always return an empty object.
               if ( acceptData( owner ) ) {
   
                   // If it is a node unlikely to be stringify-ed or looped over
                   // use plain assignment
                   if ( owner.nodeType ) {
                       owner[ this.expando ] = value;
   
                   // Otherwise secure it in a non-enumerable property
                   // configurable must be true to allow the property to be
                   // deleted when data is removed
                   } else {
                       Object.defineProperty( owner, this.expando, {
                           value: value,
                           configurable: true
                       } );
                   }
               }
           }
   
           return value;
       },
       set: function( owner, data, value ) {
           var prop,
               cache = this.cache( owner );
   
           // Handle: [ owner, key, value ] args
           // Always use camelCase key (gh-2257)
           if ( typeof data === "string" ) {
               cache[ camelCase( data ) ] = value;
   
           // Handle: [ owner, { properties } ] args
           } else {
   
               // Copy the properties one-by-one to the cache object
               for ( prop in data ) {
                   cache[ camelCase( prop ) ] = data[ prop ];
               }
           }
           return cache;
       },
       get: function( owner, key ) {
           return key === undefined ?
               this.cache( owner ) :
   
               // Always use camelCase key (gh-2257)
               owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
       },
       access: function( owner, key, value ) {
   
           // In cases where either:
           //
           //   1. No key was specified
           //   2. A string key was specified, but no value provided
           //
           // Take the "read" path and allow the get method to determine
           // which value to return, respectively either:
           //
           //   1. The entire cache object
           //   2. The data stored at the key
           //
           if ( key === undefined ||
                   ( ( key && typeof key === "string" ) && value === undefined ) ) {
   
               return this.get( owner, key );
           }
   
           // When the key is not a string, or both a key and value
           // are specified, set or extend (existing objects) with either:
           //
           //   1. An object of properties
           //   2. A key and value
           //
           this.set( owner, key, value );
   
           // Since the "set" path can have two possible entry points
           // return the expected data based on which path was taken[*]
           return value !== undefined ? value : key;
       },
       remove: function( owner, key ) {
           var i,
               cache = owner[ this.expando ];
   
           if ( cache === undefined ) {
               return;
           }
   
           if ( key !== undefined ) {
   
               // Support array or space separated string of keys
               if ( Array.isArray( key ) ) {
   
                   // If key is an array of keys...
                   // We always set camelCase keys, so remove that.
                   key = key.map( camelCase );
               } else {
                   key = camelCase( key );
   
                   // If a key with the spaces exists, use it.
                   // Otherwise, create an array by matching non-whitespace
                   key = key in cache ?
                       [ key ] :
                       ( key.match( rnothtmlwhite ) || [] );
               }
   
               i = key.length;
   
               while ( i-- ) {
                   delete cache[ key[ i ] ];
               }
           }
   
           // Remove the expando if there's no more data
           if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
   
               // Support: Chrome <=35 - 45
               // Webkit & Blink performance suffers when deleting properties
               // from DOM nodes, so set to undefined instead
               // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
               if ( owner.nodeType ) {
                   owner[ this.expando ] = undefined;
               } else {
                   delete owner[ this.expando ];
               }
           }
       },
       hasData: function( owner ) {
           var cache = owner[ this.expando ];
           return cache !== undefined && !jQuery.isEmptyObject( cache );
       }
   };
   var dataPriv = new Data();
   
   var dataUser = new Data();
   
   
   
   //	Implementation Summary
   //
   //	1. Enforce API surface and semantic compatibility with 1.9.x branch
   //	2. Improve the module's maintainability by reducing the storage
   //		paths to a single mechanism.
   //	3. Use the same single mechanism to support "private" and "user" data.
   //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
   //	5. Avoid exposing implementation details on user objects (eg. expando properties)
   //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
   
   var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
       rmultiDash = /[A-Z]/g;
   
   function getData( data ) {
       if ( data === "true" ) {
           return true;
       }
   
       if ( data === "false" ) {
           return false;
       }
   
       if ( data === "null" ) {
           return null;
       }
   
       // Only convert to a number if it doesn't change the string
       if ( data === +data + "" ) {
           return +data;
       }
   
       if ( rbrace.test( data ) ) {
           return JSON.parse( data );
       }
   
       return data;
   }
   
   function dataAttr( elem, key, data ) {
       var name;
   
       // If nothing was found internally, try to fetch any
       // data from the HTML5 data-* attribute
       if ( data === undefined && elem.nodeType === 1 ) {
           name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
           data = elem.getAttribute( name );
   
           if ( typeof data === "string" ) {
               try {
                   data = getData( data );
               } catch ( e ) {}
   
               // Make sure we set the data so it isn't changed later
               dataUser.set( elem, key, data );
           } else {
               data = undefined;
           }
       }
       return data;
   }
   
   jQuery.extend( {
       hasData: function( elem ) {
           return dataUser.hasData( elem ) || dataPriv.hasData( elem );
       },
   
       data: function( elem, name, data ) {
           return dataUser.access( elem, name, data );
       },
   
       removeData: function( elem, name ) {
           dataUser.remove( elem, name );
       },
   
       // TODO: Now that all calls to _data and _removeData have been replaced
       // with direct calls to dataPriv methods, these can be deprecated.
       _data: function( elem, name, data ) {
           return dataPriv.access( elem, name, data );
       },
   
       _removeData: function( elem, name ) {
           dataPriv.remove( elem, name );
       }
   } );
   
   jQuery.fn.extend( {
       data: function( key, value ) {
           var i, name, data,
               elem = this[ 0 ],
               attrs = elem && elem.attributes;
   
           // Gets all values
           if ( key === undefined ) {
               if ( this.length ) {
                   data = dataUser.get( elem );
   
                   if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
                       i = attrs.length;
                       while ( i-- ) {
   
                           // Support: IE 11 only
                           // The attrs elements can be null (#14894)
                           if ( attrs[ i ] ) {
                               name = attrs[ i ].name;
                               if ( name.indexOf( "data-" ) === 0 ) {
                                   name = camelCase( name.slice( 5 ) );
                                   dataAttr( elem, name, data[ name ] );
                               }
                           }
                       }
                       dataPriv.set( elem, "hasDataAttrs", true );
                   }
               }
   
               return data;
           }
   
           // Sets multiple values
           if ( typeof key === "object" ) {
               return this.each( function() {
                   dataUser.set( this, key );
               } );
           }
   
           return access( this, function( value ) {
               var data;
   
               // The calling jQuery object (element matches) is not empty
               // (and therefore has an element appears at this[ 0 ]) and the
               // `value` parameter was not undefined. An empty jQuery object
               // will result in `undefined` for elem = this[ 0 ] which will
               // throw an exception if an attempt to read a data cache is made.
               if ( elem && value === undefined ) {
   
                   // Attempt to get data from the cache
                   // The key will always be camelCased in Data
                   data = dataUser.get( elem, key );
                   if ( data !== undefined ) {
                       return data;
                   }
   
                   // Attempt to "discover" the data in
                   // HTML5 custom data-* attrs
                   data = dataAttr( elem, key );
                   if ( data !== undefined ) {
                       return data;
                   }
   
                   // We tried really hard, but the data doesn't exist.
                   return;
               }
   
               // Set the data...
               this.each( function() {
   
                   // We always store the camelCased key
                   dataUser.set( this, key, value );
               } );
           }, null, value, arguments.length > 1, null, true );
       },
   
       removeData: function( key ) {
           return this.each( function() {
               dataUser.remove( this, key );
           } );
       }
   } );
   
   
   jQuery.extend( {
       queue: function( elem, type, data ) {
           var queue;
   
           if ( elem ) {
               type = ( type || "fx" ) + "queue";
               queue = dataPriv.get( elem, type );
   
               // Speed up dequeue by getting out quickly if this is just a lookup
               if ( data ) {
                   if ( !queue || Array.isArray( data ) ) {
                       queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
                   } else {
                       queue.push( data );
                   }
               }
               return queue || [];
           }
       },
   
       dequeue: function( elem, type ) {
           type = type || "fx";
   
           var queue = jQuery.queue( elem, type ),
               startLength = queue.length,
               fn = queue.shift(),
               hooks = jQuery._queueHooks( elem, type ),
               next = function() {
                   jQuery.dequeue( elem, type );
               };
   
           // If the fx queue is dequeued, always remove the progress sentinel
           if ( fn === "inprogress" ) {
               fn = queue.shift();
               startLength--;
           }
   
           if ( fn ) {
   
               // Add a progress sentinel to prevent the fx queue from being
               // automatically dequeued
               if ( type === "fx" ) {
                   queue.unshift( "inprogress" );
               }
   
               // Clear up the last queue stop function
               delete hooks.stop;
               fn.call( elem, next, hooks );
           }
   
           if ( !startLength && hooks ) {
               hooks.empty.fire();
           }
       },
   
       // Not public - generate a queueHooks object, or return the current one
       _queueHooks: function( elem, type ) {
           var key = type + "queueHooks";
           return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
               empty: jQuery.Callbacks( "once memory" ).add( function() {
                   dataPriv.remove( elem, [ type + "queue", key ] );
               } )
           } );
       }
   } );
   
   jQuery.fn.extend( {
       queue: function( type, data ) {
           var setter = 2;
   
           if ( typeof type !== "string" ) {
               data = type;
               type = "fx";
               setter--;
           }
   
           if ( arguments.length < setter ) {
               return jQuery.queue( this[ 0 ], type );
           }
   
           return data === undefined ?
               this :
               this.each( function() {
                   var queue = jQuery.queue( this, type, data );
   
                   // Ensure a hooks for this queue
                   jQuery._queueHooks( this, type );
   
                   if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
                       jQuery.dequeue( this, type );
                   }
               } );
       },
       dequeue: function( type ) {
           return this.each( function() {
               jQuery.dequeue( this, type );
           } );
       },
       clearQueue: function( type ) {
           return this.queue( type || "fx", [] );
       },
   
       // Get a promise resolved when queues of a certain type
       // are emptied (fx is the type by default)
       promise: function( type, obj ) {
           var tmp,
               count = 1,
               defer = jQuery.Deferred(),
               elements = this,
               i = this.length,
               resolve = function() {
                   if ( !( --count ) ) {
                       defer.resolveWith( elements, [ elements ] );
                   }
               };
   
           if ( typeof type !== "string" ) {
               obj = type;
               type = undefined;
           }
           type = type || "fx";
   
           while ( i-- ) {
               tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
               if ( tmp && tmp.empty ) {
                   count++;
                   tmp.empty.add( resolve );
               }
           }
           resolve();
           return defer.promise( obj );
       }
   } );
   var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
   
   var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
   
   
   var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
   
   var isHiddenWithinTree = function( elem, el ) {
   
           // isHiddenWithinTree might be called from jQuery#filter function;
           // in that case, element will be second argument
           elem = el || elem;
   
           // Inline style trumps all
           return elem.style.display === "none" ||
               elem.style.display === "" &&
   
               // Otherwise, check computed style
               // Support: Firefox <=43 - 45
               // Disconnected elements can have computed display: none, so first confirm that elem is
               // in the document.
               jQuery.contains( elem.ownerDocument, elem ) &&
   
               jQuery.css( elem, "display" ) === "none";
       };
   
   var swap = function( elem, options, callback, args ) {
       var ret, name,
           old = {};
   
       // Remember the old values, and insert the new ones
       for ( name in options ) {
           old[ name ] = elem.style[ name ];
           elem.style[ name ] = options[ name ];
       }
   
       ret = callback.apply( elem, args || [] );
   
       // Revert the old values
       for ( name in options ) {
           elem.style[ name ] = old[ name ];
       }
   
       return ret;
   };
   
   
   
   
   function adjustCSS( elem, prop, valueParts, tween ) {
       var adjusted, scale,
           maxIterations = 20,
           currentValue = tween ?
               function() {
                   return tween.cur();
               } :
               function() {
                   return jQuery.css( elem, prop, "" );
               },
           initial = currentValue(),
           unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
   
           // Starting value computation is required for potential unit mismatches
           initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
               rcssNum.exec( jQuery.css( elem, prop ) );
   
       if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
   
           // Support: Firefox <=54
           // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
           initial = initial / 2;
   
           // Trust units reported by jQuery.css
           unit = unit || initialInUnit[ 3 ];
   
           // Iteratively approximate from a nonzero starting point
           initialInUnit = +initial || 1;
   
           while ( maxIterations-- ) {
   
               // Evaluate and update our best guess (doubling guesses that zero out).
               // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
               jQuery.style( elem, prop, initialInUnit + unit );
               if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
                   maxIterations = 0;
               }
               initialInUnit = initialInUnit / scale;
   
           }
   
           initialInUnit = initialInUnit * 2;
           jQuery.style( elem, prop, initialInUnit + unit );
   
           // Make sure we update the tween properties later on
           valueParts = valueParts || [];
       }
   
       if ( valueParts ) {
           initialInUnit = +initialInUnit || +initial || 0;
   
           // Apply relative offset (+=/-=) if specified
           adjusted = valueParts[ 1 ] ?
               initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
               +valueParts[ 2 ];
           if ( tween ) {
               tween.unit = unit;
               tween.start = initialInUnit;
               tween.end = adjusted;
           }
       }
       return adjusted;
   }
   
   
   var defaultDisplayMap = {};
   
   function getDefaultDisplay( elem ) {
       var temp,
           doc = elem.ownerDocument,
           nodeName = elem.nodeName,
           display = defaultDisplayMap[ nodeName ];
   
       if ( display ) {
           return display;
       }
   
       temp = doc.body.appendChild( doc.createElement( nodeName ) );
       display = jQuery.css( temp, "display" );
   
       temp.parentNode.removeChild( temp );
   
       if ( display === "none" ) {
           display = "block";
       }
       defaultDisplayMap[ nodeName ] = display;
   
       return display;
   }
   
   function showHide( elements, show ) {
       var display, elem,
           values = [],
           index = 0,
           length = elements.length;
   
       // Determine new display value for elements that need to change
       for ( ; index < length; index++ ) {
           elem = elements[ index ];
           if ( !elem.style ) {
               continue;
           }
   
           display = elem.style.display;
           if ( show ) {
   
               // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
               // check is required in this first loop unless we have a nonempty display value (either
               // inline or about-to-be-restored)
               if ( display === "none" ) {
                   values[ index ] = dataPriv.get( elem, "display" ) || null;
                   if ( !values[ index ] ) {
                       elem.style.display = "";
                   }
               }
               if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
                   values[ index ] = getDefaultDisplay( elem );
               }
           } else {
               if ( display !== "none" ) {
                   values[ index ] = "none";
   
                   // Remember what we're overwriting
                   dataPriv.set( elem, "display", display );
               }
           }
       }
   
       // Set the display of the elements in a second loop to avoid constant reflow
       for ( index = 0; index < length; index++ ) {
           if ( values[ index ] != null ) {
               elements[ index ].style.display = values[ index ];
           }
       }
   
       return elements;
   }
   
   jQuery.fn.extend( {
       show: function() {
           return showHide( this, true );
       },
       hide: function() {
           return showHide( this );
       },
       toggle: function( state ) {
           if ( typeof state === "boolean" ) {
               return state ? this.show() : this.hide();
           }
   
           return this.each( function() {
               if ( isHiddenWithinTree( this ) ) {
                   jQuery( this ).show();
               } else {
                   jQuery( this ).hide();
               }
           } );
       }
   } );
   var rcheckableType = ( /^(?:checkbox|radio)$/i );
   
   var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
   
   var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
   
   
   
   // We have to close these tags to support XHTML (#13200)
   var wrapMap = {
   
       // Support: IE <=9 only
       option: [ 1, "<select multiple='multiple'>", "</select>" ],
   
       // XHTML parsers do not magically insert elements in the
       // same way that tag soup parsers do. So we cannot shorten
       // this by omitting <tbody> or other required elements.
       thead: [ 1, "<table>", "</table>" ],
       col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
       tr: [ 2, "<table><tbody>", "</tbody></table>" ],
       td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
   
       _default: [ 0, "", "" ]
   };
   
   // Support: IE <=9 only
   wrapMap.optgroup = wrapMap.option;
   
   wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
   wrapMap.th = wrapMap.td;
   
   
   function getAll( context, tag ) {
   
       // Support: IE <=9 - 11 only
       // Use typeof to avoid zero-argument method invocation on host objects (#15151)
       var ret;
   
       if ( typeof context.getElementsByTagName !== "undefined" ) {
           ret = context.getElementsByTagName( tag || "*" );
   
       } else if ( typeof context.querySelectorAll !== "undefined" ) {
           ret = context.querySelectorAll( tag || "*" );
   
       } else {
           ret = [];
       }
   
       if ( tag === undefined || tag && nodeName( context, tag ) ) {
           return jQuery.merge( [ context ], ret );
       }
   
       return ret;
   }
   
   
   // Mark scripts as having already been evaluated
   function setGlobalEval( elems, refElements ) {
       var i = 0,
           l = elems.length;
   
       for ( ; i < l; i++ ) {
           dataPriv.set(
               elems[ i ],
               "globalEval",
               !refElements || dataPriv.get( refElements[ i ], "globalEval" )
           );
       }
   }
   
   
   var rhtml = /<|&#?\w+;/;
   
   function buildFragment( elems, context, scripts, selection, ignored ) {
       var elem, tmp, tag, wrap, contains, j,
           fragment = context.createDocumentFragment(),
           nodes = [],
           i = 0,
           l = elems.length;
   
       for ( ; i < l; i++ ) {
           elem = elems[ i ];
   
           if ( elem || elem === 0 ) {
   
               // Add nodes directly
               if ( toType( elem ) === "object" ) {
   
                   // Support: Android <=4.0 only, PhantomJS 1 only
                   // push.apply(_, arraylike) throws on ancient WebKit
                   jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
   
               // Convert non-html into a text node
               } else if ( !rhtml.test( elem ) ) {
                   nodes.push( context.createTextNode( elem ) );
   
               // Convert html into DOM nodes
               } else {
                   tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
   
                   // Deserialize a standard representation
                   tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
                   wrap = wrapMap[ tag ] || wrapMap._default;
                   tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
   
                   // Descend through wrappers to the right content
                   j = wrap[ 0 ];
                   while ( j-- ) {
                       tmp = tmp.lastChild;
                   }
   
                   // Support: Android <=4.0 only, PhantomJS 1 only
                   // push.apply(_, arraylike) throws on ancient WebKit
                   jQuery.merge( nodes, tmp.childNodes );
   
                   // Remember the top-level container
                   tmp = fragment.firstChild;
   
                   // Ensure the created nodes are orphaned (#12392)
                   tmp.textContent = "";
               }
           }
       }
   
       // Remove wrapper from fragment
       fragment.textContent = "";
   
       i = 0;
       while ( ( elem = nodes[ i++ ] ) ) {
   
           // Skip elements already in the context collection (trac-4087)
           if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
               if ( ignored ) {
                   ignored.push( elem );
               }
               continue;
           }
   
           contains = jQuery.contains( elem.ownerDocument, elem );
   
           // Append to fragment
           tmp = getAll( fragment.appendChild( elem ), "script" );
   
           // Preserve script evaluation history
           if ( contains ) {
               setGlobalEval( tmp );
           }
   
           // Capture executables
           if ( scripts ) {
               j = 0;
               while ( ( elem = tmp[ j++ ] ) ) {
                   if ( rscriptType.test( elem.type || "" ) ) {
                       scripts.push( elem );
                   }
               }
           }
       }
   
       return fragment;
   }
   
   
   ( function() {
       var fragment = document.createDocumentFragment(),
           div = fragment.appendChild( document.createElement( "div" ) ),
           input = document.createElement( "input" );
   
       // Support: Android 4.0 - 4.3 only
       // Check state lost if the name is set (#11217)
       // Support: Windows Web Apps (WWA)
       // `name` and `type` must use .setAttribute for WWA (#14901)
       input.setAttribute( "type", "radio" );
       input.setAttribute( "checked", "checked" );
       input.setAttribute( "name", "t" );
   
       div.appendChild( input );
   
       // Support: Android <=4.1 only
       // Older WebKit doesn't clone checked state correctly in fragments
       support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
   
       // Support: IE <=11 only
       // Make sure textarea (and checkbox) defaultValue is properly cloned
       div.innerHTML = "<textarea>x</textarea>";
       support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
   } )();
   var documentElement = document.documentElement;
   
   
   
   var
       rkeyEvent = /^key/,
       rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
       rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
   
   function returnTrue() {
       return true;
   }
   
   function returnFalse() {
       return false;
   }
   
   // Support: IE <=9 only
   // See #13393 for more info
   function safeActiveElement() {
       try {
           return document.activeElement;
       } catch ( err ) { }
   }
   
   function on( elem, types, selector, data, fn, one ) {
       var origFn, type;
   
       // Types can be a map of types/handlers
       if ( typeof types === "object" ) {
   
           // ( types-Object, selector, data )
           if ( typeof selector !== "string" ) {
   
               // ( types-Object, data )
               data = data || selector;
               selector = undefined;
           }
           for ( type in types ) {
               on( elem, type, selector, data, types[ type ], one );
           }
           return elem;
       }
   
       if ( data == null && fn == null ) {
   
           // ( types, fn )
           fn = selector;
           data = selector = undefined;
       } else if ( fn == null ) {
           if ( typeof selector === "string" ) {
   
               // ( types, selector, fn )
               fn = data;
               data = undefined;
           } else {
   
               // ( types, data, fn )
               fn = data;
               data = selector;
               selector = undefined;
           }
       }
       if ( fn === false ) {
           fn = returnFalse;
       } else if ( !fn ) {
           return elem;
       }
   
       if ( one === 1 ) {
           origFn = fn;
           fn = function( event ) {
   
               // Can use an empty set, since event contains the info
               jQuery().off( event );
               return origFn.apply( this, arguments );
           };
   
           // Use same guid so caller can remove using origFn
           fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
       }
       return elem.each( function() {
           jQuery.event.add( this, types, fn, data, selector );
       } );
   }
   
   /*
    * Helper functions for managing events -- not part of the public interface.
    * Props to Dean Edwards' addEvent library for many of the ideas.
    */
   jQuery.event = {
   
       global: {},
   
       add: function( elem, types, handler, data, selector ) {
   
           var handleObjIn, eventHandle, tmp,
               events, t, handleObj,
               special, handlers, type, namespaces, origType,
               elemData = dataPriv.get( elem );
   
           // Don't attach events to noData or text/comment nodes (but allow plain objects)
           if ( !elemData ) {
               return;
           }
   
           // Caller can pass in an object of custom data in lieu of the handler
           if ( handler.handler ) {
               handleObjIn = handler;
               handler = handleObjIn.handler;
               selector = handleObjIn.selector;
           }
   
           // Ensure that invalid selectors throw exceptions at attach time
           // Evaluate against documentElement in case elem is a non-element node (e.g., document)
           if ( selector ) {
               jQuery.find.matchesSelector( documentElement, selector );
           }
   
           // Make sure that the handler has a unique ID, used to find/remove it later
           if ( !handler.guid ) {
               handler.guid = jQuery.guid++;
           }
   
           // Init the element's event structure and main handler, if this is the first
           if ( !( events = elemData.events ) ) {
               events = elemData.events = {};
           }
           if ( !( eventHandle = elemData.handle ) ) {
               eventHandle = elemData.handle = function( e ) {
   
                   // Discard the second event of a jQuery.event.trigger() and
                   // when an event is called after a page has unloaded
                   return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                       jQuery.event.dispatch.apply( elem, arguments ) : undefined;
               };
           }
   
           // Handle multiple events separated by a space
           types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
           t = types.length;
           while ( t-- ) {
               tmp = rtypenamespace.exec( types[ t ] ) || [];
               type = origType = tmp[ 1 ];
               namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
   
               // There *must* be a type, no attaching namespace-only handlers
               if ( !type ) {
                   continue;
               }
   
               // If event changes its type, use the special event handlers for the changed type
               special = jQuery.event.special[ type ] || {};
   
               // If selector defined, determine special event api type, otherwise given type
               type = ( selector ? special.delegateType : special.bindType ) || type;
   
               // Update special based on newly reset type
               special = jQuery.event.special[ type ] || {};
   
               // handleObj is passed to all event handlers
               handleObj = jQuery.extend( {
                   type: type,
                   origType: origType,
                   data: data,
                   handler: handler,
                   guid: handler.guid,
                   selector: selector,
                   needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
                   namespace: namespaces.join( "." )
               }, handleObjIn );
   
               // Init the event handler queue if we're the first
               if ( !( handlers = events[ type ] ) ) {
                   handlers = events[ type ] = [];
                   handlers.delegateCount = 0;
   
                   // Only use addEventListener if the special events handler returns false
                   if ( !special.setup ||
                       special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
   
                       if ( elem.addEventListener ) {
                           elem.addEventListener( type, eventHandle );
                       }
                   }
               }
   
               if ( special.add ) {
                   special.add.call( elem, handleObj );
   
                   if ( !handleObj.handler.guid ) {
                       handleObj.handler.guid = handler.guid;
                   }
               }
   
               // Add to the element's handler list, delegates in front
               if ( selector ) {
                   handlers.splice( handlers.delegateCount++, 0, handleObj );
               } else {
                   handlers.push( handleObj );
               }
   
               // Keep track of which events have ever been used, for event optimization
               jQuery.event.global[ type ] = true;
           }
   
       },
   
       // Detach an event or set of events from an element
       remove: function( elem, types, handler, selector, mappedTypes ) {
   
           var j, origCount, tmp,
               events, t, handleObj,
               special, handlers, type, namespaces, origType,
               elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
   
           if ( !elemData || !( events = elemData.events ) ) {
               return;
           }
   
           // Once for each type.namespace in types; type may be omitted
           types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
           t = types.length;
           while ( t-- ) {
               tmp = rtypenamespace.exec( types[ t ] ) || [];
               type = origType = tmp[ 1 ];
               namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
   
               // Unbind all events (on this namespace, if provided) for the element
               if ( !type ) {
                   for ( type in events ) {
                       jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
                   }
                   continue;
               }
   
               special = jQuery.event.special[ type ] || {};
               type = ( selector ? special.delegateType : special.bindType ) || type;
               handlers = events[ type ] || [];
               tmp = tmp[ 2 ] &&
                   new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
   
               // Remove matching events
               origCount = j = handlers.length;
               while ( j-- ) {
                   handleObj = handlers[ j ];
   
                   if ( ( mappedTypes || origType === handleObj.origType ) &&
                       ( !handler || handler.guid === handleObj.guid ) &&
                       ( !tmp || tmp.test( handleObj.namespace ) ) &&
                       ( !selector || selector === handleObj.selector ||
                           selector === "**" && handleObj.selector ) ) {
                       handlers.splice( j, 1 );
   
                       if ( handleObj.selector ) {
                           handlers.delegateCount--;
                       }
                       if ( special.remove ) {
                           special.remove.call( elem, handleObj );
                       }
                   }
               }
   
               // Remove generic event handler if we removed something and no more handlers exist
               // (avoids potential for endless recursion during removal of special event handlers)
               if ( origCount && !handlers.length ) {
                   if ( !special.teardown ||
                       special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
   
                       jQuery.removeEvent( elem, type, elemData.handle );
                   }
   
                   delete events[ type ];
               }
           }
   
           // Remove data and the expando if it's no longer used
           if ( jQuery.isEmptyObject( events ) ) {
               dataPriv.remove( elem, "handle events" );
           }
       },
   
       dispatch: function( nativeEvent ) {
   
           // Make a writable jQuery.Event from the native event object
           var event = jQuery.event.fix( nativeEvent );
   
           var i, j, ret, matched, handleObj, handlerQueue,
               args = new Array( arguments.length ),
               handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
               special = jQuery.event.special[ event.type ] || {};
   
           // Use the fix-ed jQuery.Event rather than the (read-only) native event
           args[ 0 ] = event;
   
           for ( i = 1; i < arguments.length; i++ ) {
               args[ i ] = arguments[ i ];
           }
   
           event.delegateTarget = this;
   
           // Call the preDispatch hook for the mapped type, and let it bail if desired
           if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
               return;
           }
   
           // Determine handlers
           handlerQueue = jQuery.event.handlers.call( this, event, handlers );
   
           // Run delegates first; they may want to stop propagation beneath us
           i = 0;
           while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
               event.currentTarget = matched.elem;
   
               j = 0;
               while ( ( handleObj = matched.handlers[ j++ ] ) &&
                   !event.isImmediatePropagationStopped() ) {
   
                   // Triggered event must either 1) have no namespace, or 2) have namespace(s)
                   // a subset or equal to those in the bound event (both can have no namespace).
                   if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
   
                       event.handleObj = handleObj;
                       event.data = handleObj.data;
   
                       ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
                           handleObj.handler ).apply( matched.elem, args );
   
                       if ( ret !== undefined ) {
                           if ( ( event.result = ret ) === false ) {
                               event.preventDefault();
                               event.stopPropagation();
                           }
                       }
                   }
               }
           }
   
           // Call the postDispatch hook for the mapped type
           if ( special.postDispatch ) {
               special.postDispatch.call( this, event );
           }
   
           return event.result;
       },
   
       handlers: function( event, handlers ) {
           var i, handleObj, sel, matchedHandlers, matchedSelectors,
               handlerQueue = [],
               delegateCount = handlers.delegateCount,
               cur = event.target;
   
           // Find delegate handlers
           if ( delegateCount &&
   
               // Support: IE <=9
               // Black-hole SVG <use> instance trees (trac-13180)
               cur.nodeType &&
   
               // Support: Firefox <=42
               // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
               // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
               // Support: IE 11 only
               // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
               !( event.type === "click" && event.button >= 1 ) ) {
   
               for ( ; cur !== this; cur = cur.parentNode || this ) {
   
                   // Don't check non-elements (#13208)
                   // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                   if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
                       matchedHandlers = [];
                       matchedSelectors = {};
                       for ( i = 0; i < delegateCount; i++ ) {
                           handleObj = handlers[ i ];
   
                           // Don't conflict with Object.prototype properties (#13203)
                           sel = handleObj.selector + " ";
   
                           if ( matchedSelectors[ sel ] === undefined ) {
                               matchedSelectors[ sel ] = handleObj.needsContext ?
                                   jQuery( sel, this ).index( cur ) > -1 :
                                   jQuery.find( sel, this, null, [ cur ] ).length;
                           }
                           if ( matchedSelectors[ sel ] ) {
                               matchedHandlers.push( handleObj );
                           }
                       }
                       if ( matchedHandlers.length ) {
                           handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
                       }
                   }
               }
           }
   
           // Add the remaining (directly-bound) handlers
           cur = this;
           if ( delegateCount < handlers.length ) {
               handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
           }
   
           return handlerQueue;
       },
   
       addProp: function( name, hook ) {
           Object.defineProperty( jQuery.Event.prototype, name, {
               enumerable: true,
               configurable: true,
   
               get: isFunction( hook ) ?
                   function() {
                       if ( this.originalEvent ) {
                               return hook( this.originalEvent );
                       }
                   } :
                   function() {
                       if ( this.originalEvent ) {
                               return this.originalEvent[ name ];
                       }
                   },
   
               set: function( value ) {
                   Object.defineProperty( this, name, {
                       enumerable: true,
                       configurable: true,
                       writable: true,
                       value: value
                   } );
               }
           } );
       },
   
       fix: function( originalEvent ) {
           return originalEvent[ jQuery.expando ] ?
               originalEvent :
               new jQuery.Event( originalEvent );
       },
   
       special: {
           load: {
   
               // Prevent triggered image.load events from bubbling to window.load
               noBubble: true
           },
           focus: {
   
               // Fire native event if possible so blur/focus sequence is correct
               trigger: function() {
                   if ( this !== safeActiveElement() && this.focus ) {
                       this.focus();
                       return false;
                   }
               },
               delegateType: "focusin"
           },
           blur: {
               trigger: function() {
                   if ( this === safeActiveElement() && this.blur ) {
                       this.blur();
                       return false;
                   }
               },
               delegateType: "focusout"
           },
           click: {
   
               // For checkbox, fire native event so checked state will be right
               trigger: function() {
                   if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
                       this.click();
                       return false;
                   }
               },
   
               // For cross-browser consistency, don't fire native .click() on links
               _default: function( event ) {
                   return nodeName( event.target, "a" );
               }
           },
   
           beforeunload: {
               postDispatch: function( event ) {
   
                   // Support: Firefox 20+
                   // Firefox doesn't alert if the returnValue field is not set.
                   if ( event.result !== undefined && event.originalEvent ) {
                       event.originalEvent.returnValue = event.result;
                   }
               }
           }
       }
   };
   
   jQuery.removeEvent = function( elem, type, handle ) {
   
       // This "if" is needed for plain objects
       if ( elem.removeEventListener ) {
           elem.removeEventListener( type, handle );
       }
   };
   
   jQuery.Event = function( src, props ) {
   
       // Allow instantiation without the 'new' keyword
       if ( !( this instanceof jQuery.Event ) ) {
           return new jQuery.Event( src, props );
       }
   
       // Event object
       if ( src && src.type ) {
           this.originalEvent = src;
           this.type = src.type;
   
           // Events bubbling up the document may have been marked as prevented
           // by a handler lower down the tree; reflect the correct value.
           this.isDefaultPrevented = src.defaultPrevented ||
                   src.defaultPrevented === undefined &&
   
                   // Support: Android <=2.3 only
                   src.returnValue === false ?
               returnTrue :
               returnFalse;
   
           // Create target properties
           // Support: Safari <=6 - 7 only
           // Target should not be a text node (#504, #13143)
           this.target = ( src.target && src.target.nodeType === 3 ) ?
               src.target.parentNode :
               src.target;
   
           this.currentTarget = src.currentTarget;
           this.relatedTarget = src.relatedTarget;
   
       // Event type
       } else {
           this.type = src;
       }
   
       // Put explicitly provided properties onto the event object
       if ( props ) {
           jQuery.extend( this, props );
       }
   
       // Create a timestamp if incoming event doesn't have one
       this.timeStamp = src && src.timeStamp || Date.now();
   
       // Mark it as fixed
       this[ jQuery.expando ] = true;
   };
   
   // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
   // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
   jQuery.Event.prototype = {
       constructor: jQuery.Event,
       isDefaultPrevented: returnFalse,
       isPropagationStopped: returnFalse,
       isImmediatePropagationStopped: returnFalse,
       isSimulated: false,
   
       preventDefault: function() {
           var e = this.originalEvent;
   
           this.isDefaultPrevented = returnTrue;
   
           if ( e && !this.isSimulated ) {
               e.preventDefault();
           }
       },
       stopPropagation: function() {
           var e = this.originalEvent;
   
           this.isPropagationStopped = returnTrue;
   
           if ( e && !this.isSimulated ) {
               e.stopPropagation();
           }
       },
       stopImmediatePropagation: function() {
           var e = this.originalEvent;
   
           this.isImmediatePropagationStopped = returnTrue;
   
           if ( e && !this.isSimulated ) {
               e.stopImmediatePropagation();
           }
   
           this.stopPropagation();
       }
   };
   
   // Includes all common event props including KeyEvent and MouseEvent specific props
   jQuery.each( {
       altKey: true,
       bubbles: true,
       cancelable: true,
       changedTouches: true,
       ctrlKey: true,
       detail: true,
       eventPhase: true,
       metaKey: true,
       pageX: true,
       pageY: true,
       shiftKey: true,
       view: true,
       "char": true,
       charCode: true,
       key: true,
       keyCode: true,
       button: true,
       buttons: true,
       clientX: true,
       clientY: true,
       offsetX: true,
       offsetY: true,
       pointerId: true,
       pointerType: true,
       screenX: true,
       screenY: true,
       targetTouches: true,
       toElement: true,
       touches: true,
   
       which: function( event ) {
           var button = event.button;
   
           // Add which for key events
           if ( event.which == null && rkeyEvent.test( event.type ) ) {
               return event.charCode != null ? event.charCode : event.keyCode;
           }
   
           // Add which for click: 1 === left; 2 === middle; 3 === right
           if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
               if ( button & 1 ) {
                   return 1;
               }
   
               if ( button & 2 ) {
                   return 3;
               }
   
               if ( button & 4 ) {
                   return 2;
               }
   
               return 0;
           }
   
           return event.which;
       }
   }, jQuery.event.addProp );
   
   // Create mouseenter/leave events using mouseover/out and event-time checks
   // so that event delegation works in jQuery.
   // Do the same for pointerenter/pointerleave and pointerover/pointerout
   //
   // Support: Safari 7 only
   // Safari sends mouseenter too often; see:
   // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
   // for the description of the bug (it existed in older Chrome versions as well).
   jQuery.each( {
       mouseenter: "mouseover",
       mouseleave: "mouseout",
       pointerenter: "pointerover",
       pointerleave: "pointerout"
   }, function( orig, fix ) {
       jQuery.event.special[ orig ] = {
           delegateType: fix,
           bindType: fix,
   
           handle: function( event ) {
               var ret,
                   target = this,
                   related = event.relatedTarget,
                   handleObj = event.handleObj;
   
               // For mouseenter/leave call the handler if related is outside the target.
               // NB: No relatedTarget if the mouse left/entered the browser window
               if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
                   event.type = handleObj.origType;
                   ret = handleObj.handler.apply( this, arguments );
                   event.type = fix;
               }
               return ret;
           }
       };
   } );
   
   jQuery.fn.extend( {
   
       on: function( types, selector, data, fn ) {
           return on( this, types, selector, data, fn );
       },
       one: function( types, selector, data, fn ) {
           return on( this, types, selector, data, fn, 1 );
       },
       off: function( types, selector, fn ) {
           var handleObj, type;
           if ( types && types.preventDefault && types.handleObj ) {
   
               // ( event )  dispatched jQuery.Event
               handleObj = types.handleObj;
               jQuery( types.delegateTarget ).off(
                   handleObj.namespace ?
                       handleObj.origType + "." + handleObj.namespace :
                       handleObj.origType,
                   handleObj.selector,
                   handleObj.handler
               );
               return this;
           }
           if ( typeof types === "object" ) {
   
               // ( types-object [, selector] )
               for ( type in types ) {
                   this.off( type, selector, types[ type ] );
               }
               return this;
           }
           if ( selector === false || typeof selector === "function" ) {
   
               // ( types [, fn] )
               fn = selector;
               selector = undefined;
           }
           if ( fn === false ) {
               fn = returnFalse;
           }
           return this.each( function() {
               jQuery.event.remove( this, types, fn, selector );
           } );
       }
   } );
   
   
   var
   
       /* eslint-disable max-len */
   
       // See https://github.com/eslint/eslint/issues/3229
       rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
   
       /* eslint-enable */
   
       // Support: IE <=10 - 11, Edge 12 - 13 only
       // In IE/Edge using regex groups here causes severe slowdowns.
       // See https://connect.microsoft.com/IE/feedback/details/1736512/
       rnoInnerhtml = /<script|<style|<link/i,
   
       // checked="checked" or checked
       rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
       rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
   
   // Prefer a tbody over its parent table for containing new rows
   function manipulationTarget( elem, content ) {
       if ( nodeName( elem, "table" ) &&
           nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
   
           return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
       }
   
       return elem;
   }
   
   // Replace/restore the type attribute of script elements for safe DOM manipulation
   function disableScript( elem ) {
       elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
       return elem;
   }
   function restoreScript( elem ) {
       if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
           elem.type = elem.type.slice( 5 );
       } else {
           elem.removeAttribute( "type" );
       }
   
       return elem;
   }
   
   function cloneCopyEvent( src, dest ) {
       var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
   
       if ( dest.nodeType !== 1 ) {
           return;
       }
   
       // 1. Copy private data: events, handlers, etc.
       if ( dataPriv.hasData( src ) ) {
           pdataOld = dataPriv.access( src );
           pdataCur = dataPriv.set( dest, pdataOld );
           events = pdataOld.events;
   
           if ( events ) {
               delete pdataCur.handle;
               pdataCur.events = {};
   
               for ( type in events ) {
                   for ( i = 0, l = events[ type ].length; i < l; i++ ) {
                       jQuery.event.add( dest, type, events[ type ][ i ] );
                   }
               }
           }
       }
   
       // 2. Copy user data
       if ( dataUser.hasData( src ) ) {
           udataOld = dataUser.access( src );
           udataCur = jQuery.extend( {}, udataOld );
   
           dataUser.set( dest, udataCur );
       }
   }
   
   // Fix IE bugs, see support tests
   function fixInput( src, dest ) {
       var nodeName = dest.nodeName.toLowerCase();
   
       // Fails to persist the checked state of a cloned checkbox or radio button.
       if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
           dest.checked = src.checked;
   
       // Fails to return the selected option to the default selected state when cloning options
       } else if ( nodeName === "input" || nodeName === "textarea" ) {
           dest.defaultValue = src.defaultValue;
       }
   }
   
   function domManip( collection, args, callback, ignored ) {
   
       // Flatten any nested arrays
       args = concat.apply( [], args );
   
       var fragment, first, scripts, hasScripts, node, doc,
           i = 0,
           l = collection.length,
           iNoClone = l - 1,
           value = args[ 0 ],
           valueIsFunction = isFunction( value );
   
       // We can't cloneNode fragments that contain checked, in WebKit
       if ( valueIsFunction ||
               ( l > 1 && typeof value === "string" &&
                   !support.checkClone && rchecked.test( value ) ) ) {
           return collection.each( function( index ) {
               var self = collection.eq( index );
               if ( valueIsFunction ) {
                   args[ 0 ] = value.call( this, index, self.html() );
               }
               domManip( self, args, callback, ignored );
           } );
       }
   
       if ( l ) {
           fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
           first = fragment.firstChild;
   
           if ( fragment.childNodes.length === 1 ) {
               fragment = first;
           }
   
           // Require either new content or an interest in ignored elements to invoke the callback
           if ( first || ignored ) {
               scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
               hasScripts = scripts.length;
   
               // Use the original fragment for the last item
               // instead of the first because it can end up
               // being emptied incorrectly in certain situations (#8070).
               for ( ; i < l; i++ ) {
                   node = fragment;
   
                   if ( i !== iNoClone ) {
                       node = jQuery.clone( node, true, true );
   
                       // Keep references to cloned scripts for later restoration
                       if ( hasScripts ) {
   
                           // Support: Android <=4.0 only, PhantomJS 1 only
                           // push.apply(_, arraylike) throws on ancient WebKit
                           jQuery.merge( scripts, getAll( node, "script" ) );
                       }
                   }
   
                   callback.call( collection[ i ], node, i );
               }
   
               if ( hasScripts ) {
                   doc = scripts[ scripts.length - 1 ].ownerDocument;
   
                   // Reenable scripts
                   jQuery.map( scripts, restoreScript );
   
                   // Evaluate executable scripts on first document insertion
                   for ( i = 0; i < hasScripts; i++ ) {
                       node = scripts[ i ];
                       if ( rscriptType.test( node.type || "" ) &&
                           !dataPriv.access( node, "globalEval" ) &&
                           jQuery.contains( doc, node ) ) {
   
                           if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
   
                               // Optional AJAX dependency, but won't run scripts if not present
                               if ( jQuery._evalUrl ) {
                                   jQuery._evalUrl( node.src );
                               }
                           } else {
                               DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
                           }
                       }
                   }
               }
           }
       }
   
       return collection;
   }
   
   function remove( elem, selector, keepData ) {
       var node,
           nodes = selector ? jQuery.filter( selector, elem ) : elem,
           i = 0;
   
       for ( ; ( node = nodes[ i ] ) != null; i++ ) {
           if ( !keepData && node.nodeType === 1 ) {
               jQuery.cleanData( getAll( node ) );
           }
   
           if ( node.parentNode ) {
               if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
                   setGlobalEval( getAll( node, "script" ) );
               }
               node.parentNode.removeChild( node );
           }
       }
   
       return elem;
   }
   
   jQuery.extend( {
       htmlPrefilter: function( html ) {
           return html.replace( rxhtmlTag, "<$1></$2>" );
       },
   
       clone: function( elem, dataAndEvents, deepDataAndEvents ) {
           var i, l, srcElements, destElements,
               clone = elem.cloneNode( true ),
               inPage = jQuery.contains( elem.ownerDocument, elem );
   
           // Fix IE cloning issues
           if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
                   !jQuery.isXMLDoc( elem ) ) {
   
               // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
               destElements = getAll( clone );
               srcElements = getAll( elem );
   
               for ( i = 0, l = srcElements.length; i < l; i++ ) {
                   fixInput( srcElements[ i ], destElements[ i ] );
               }
           }
   
           // Copy the events from the original to the clone
           if ( dataAndEvents ) {
               if ( deepDataAndEvents ) {
                   srcElements = srcElements || getAll( elem );
                   destElements = destElements || getAll( clone );
   
                   for ( i = 0, l = srcElements.length; i < l; i++ ) {
                       cloneCopyEvent( srcElements[ i ], destElements[ i ] );
                   }
               } else {
                   cloneCopyEvent( elem, clone );
               }
           }
   
           // Preserve script evaluation history
           destElements = getAll( clone, "script" );
           if ( destElements.length > 0 ) {
               setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
           }
   
           // Return the cloned set
           return clone;
       },
   
       cleanData: function( elems ) {
           var data, elem, type,
               special = jQuery.event.special,
               i = 0;
   
           for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
               if ( acceptData( elem ) ) {
                   if ( ( data = elem[ dataPriv.expando ] ) ) {
                       if ( data.events ) {
                           for ( type in data.events ) {
                               if ( special[ type ] ) {
                                   jQuery.event.remove( elem, type );
   
                               // This is a shortcut to avoid jQuery.event.remove's overhead
                               } else {
                                   jQuery.removeEvent( elem, type, data.handle );
                               }
                           }
                       }
   
                       // Support: Chrome <=35 - 45+
                       // Assign undefined instead of using delete, see Data#remove
                       elem[ dataPriv.expando ] = undefined;
                   }
                   if ( elem[ dataUser.expando ] ) {
   
                       // Support: Chrome <=35 - 45+
                       // Assign undefined instead of using delete, see Data#remove
                       elem[ dataUser.expando ] = undefined;
                   }
               }
           }
       }
   } );
   
   jQuery.fn.extend( {
       detach: function( selector ) {
           return remove( this, selector, true );
       },
   
       remove: function( selector ) {
           return remove( this, selector );
       },
   
       text: function( value ) {
           return access( this, function( value ) {
               return value === undefined ?
                   jQuery.text( this ) :
                   this.empty().each( function() {
                       if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                           this.textContent = value;
                       }
                   } );
           }, null, value, arguments.length );
       },
   
       append: function() {
           return domManip( this, arguments, function( elem ) {
               if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                   var target = manipulationTarget( this, elem );
                   target.appendChild( elem );
               }
           } );
       },
   
       prepend: function() {
           return domManip( this, arguments, function( elem ) {
               if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                   var target = manipulationTarget( this, elem );
                   target.insertBefore( elem, target.firstChild );
               }
           } );
       },
   
       before: function() {
           return domManip( this, arguments, function( elem ) {
               if ( this.parentNode ) {
                   this.parentNode.insertBefore( elem, this );
               }
           } );
       },
   
       after: function() {
           return domManip( this, arguments, function( elem ) {
               if ( this.parentNode ) {
                   this.parentNode.insertBefore( elem, this.nextSibling );
               }
           } );
       },
   
       empty: function() {
           var elem,
               i = 0;
   
           for ( ; ( elem = this[ i ] ) != null; i++ ) {
               if ( elem.nodeType === 1 ) {
   
                   // Prevent memory leaks
                   jQuery.cleanData( getAll( elem, false ) );
   
                   // Remove any remaining nodes
                   elem.textContent = "";
               }
           }
   
           return this;
       },
   
       clone: function( dataAndEvents, deepDataAndEvents ) {
           dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
           deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
   
           return this.map( function() {
               return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
           } );
       },
   
       html: function( value ) {
           return access( this, function( value ) {
               var elem = this[ 0 ] || {},
                   i = 0,
                   l = this.length;
   
               if ( value === undefined && elem.nodeType === 1 ) {
                   return elem.innerHTML;
               }
   
               // See if we can take a shortcut and just use innerHTML
               if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
                   !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
   
                   value = jQuery.htmlPrefilter( value );
   
                   try {
                       for ( ; i < l; i++ ) {
                           elem = this[ i ] || {};
   
                           // Remove element nodes and prevent memory leaks
                           if ( elem.nodeType === 1 ) {
                               jQuery.cleanData( getAll( elem, false ) );
                               elem.innerHTML = value;
                           }
                       }
   
                       elem = 0;
   
                   // If using innerHTML throws an exception, use the fallback method
                   } catch ( e ) {}
               }
   
               if ( elem ) {
                   this.empty().append( value );
               }
           }, null, value, arguments.length );
       },
   
       replaceWith: function() {
           var ignored = [];
   
           // Make the changes, replacing each non-ignored context element with the new content
           return domManip( this, arguments, function( elem ) {
               var parent = this.parentNode;
   
               if ( jQuery.inArray( this, ignored ) < 0 ) {
                   jQuery.cleanData( getAll( this ) );
                   if ( parent ) {
                       parent.replaceChild( elem, this );
                   }
               }
   
           // Force callback invocation
           }, ignored );
       }
   } );
   
   jQuery.each( {
       appendTo: "append",
       prependTo: "prepend",
       insertBefore: "before",
       insertAfter: "after",
       replaceAll: "replaceWith"
   }, function( name, original ) {
       jQuery.fn[ name ] = function( selector ) {
           var elems,
               ret = [],
               insert = jQuery( selector ),
               last = insert.length - 1,
               i = 0;
   
           for ( ; i <= last; i++ ) {
               elems = i === last ? this : this.clone( true );
               jQuery( insert[ i ] )[ original ]( elems );
   
               // Support: Android <=4.0 only, PhantomJS 1 only
               // .get() because push.apply(_, arraylike) throws on ancient WebKit
               push.apply( ret, elems.get() );
           }
   
           return this.pushStack( ret );
       };
   } );
   var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
   
   var getStyles = function( elem ) {
   
           // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
           // IE throws on elements created in popups
           // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
           var view = elem.ownerDocument.defaultView;
   
           if ( !view || !view.opener ) {
               view = window;
           }
   
           return view.getComputedStyle( elem );
       };
   
   var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
   
   
   
   ( function() {
   
       // Executing both pixelPosition & boxSizingReliable tests require only one layout
       // so they're executed at the same time to save the second computation.
       function computeStyleTests() {
   
           // This is a singleton, we need to execute it only once
           if ( !div ) {
               return;
           }
   
           container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
               "margin-top:1px;padding:0;border:0";
           div.style.cssText =
               "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
               "margin:auto;border:1px;padding:1px;" +
               "width:60%;top:1%";
           documentElement.appendChild( container ).appendChild( div );
   
           var divStyle = window.getComputedStyle( div );
           pixelPositionVal = divStyle.top !== "1%";
   
           // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
           reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
   
           // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
           // Some styles come back with percentage values, even though they shouldn't
           div.style.right = "60%";
           pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
   
           // Support: IE 9 - 11 only
           // Detect misreporting of content dimensions for box-sizing:border-box elements
           boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
   
           // Support: IE 9 only
           // Detect overflow:scroll screwiness (gh-3699)
           div.style.position = "absolute";
           scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
   
           documentElement.removeChild( container );
   
           // Nullify the div so it wouldn't be stored in the memory and
           // it will also be a sign that checks already performed
           div = null;
       }
   
       function roundPixelMeasures( measure ) {
           return Math.round( parseFloat( measure ) );
       }
   
       var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
           reliableMarginLeftVal,
           container = document.createElement( "div" ),
           div = document.createElement( "div" );
   
       // Finish early in limited (non-browser) environments
       if ( !div.style ) {
           return;
       }
   
       // Support: IE <=9 - 11 only
       // Style of cloned element affects source element cloned (#8908)
       div.style.backgroundClip = "content-box";
       div.cloneNode( true ).style.backgroundClip = "";
       support.clearCloneStyle = div.style.backgroundClip === "content-box";
   
       jQuery.extend( support, {
           boxSizingReliable: function() {
               computeStyleTests();
               return boxSizingReliableVal;
           },
           pixelBoxStyles: function() {
               computeStyleTests();
               return pixelBoxStylesVal;
           },
           pixelPosition: function() {
               computeStyleTests();
               return pixelPositionVal;
           },
           reliableMarginLeft: function() {
               computeStyleTests();
               return reliableMarginLeftVal;
           },
           scrollboxSize: function() {
               computeStyleTests();
               return scrollboxSizeVal;
           }
       } );
   } )();
   
   
   function curCSS( elem, name, computed ) {
       var width, minWidth, maxWidth, ret,
   
           // Support: Firefox 51+
           // Retrieving style before computed somehow
           // fixes an issue with getting wrong values
           // on detached elements
           style = elem.style;
   
       computed = computed || getStyles( elem );
   
       // getPropertyValue is needed for:
       //   .css('filter') (IE 9 only, #12537)
       //   .css('--customProperty) (#3144)
       if ( computed ) {
           ret = computed.getPropertyValue( name ) || computed[ name ];
   
           if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
               ret = jQuery.style( elem, name );
           }
   
           // A tribute to the "awesome hack by Dean Edwards"
           // Android Browser returns percentage for some values,
           // but width seems to be reliably pixels.
           // This is against the CSSOM draft spec:
           // https://drafts.csswg.org/cssom/#resolved-values
           if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
   
               // Remember the original values
               width = style.width;
               minWidth = style.minWidth;
               maxWidth = style.maxWidth;
   
               // Put in the new values to get a computed value out
               style.minWidth = style.maxWidth = style.width = ret;
               ret = computed.width;
   
               // Revert the changed values
               style.width = width;
               style.minWidth = minWidth;
               style.maxWidth = maxWidth;
           }
       }
   
       return ret !== undefined ?
   
           // Support: IE <=9 - 11 only
           // IE returns zIndex value as an integer.
           ret + "" :
           ret;
   }
   
   
   function addGetHookIf( conditionFn, hookFn ) {
   
       // Define the hook, we'll check on the first run if it's really needed.
       return {
           get: function() {
               if ( conditionFn() ) {
   
                   // Hook not needed (or it's not possible to use it due
                   // to missing dependency), remove it.
                   delete this.get;
                   return;
               }
   
               // Hook needed; redefine it so that the support test is not executed again.
               return ( this.get = hookFn ).apply( this, arguments );
           }
       };
   }
   
   
   var
   
       // Swappable if display is none or starts with table
       // except "table", "table-cell", or "table-caption"
       // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
       rdisplayswap = /^(none|table(?!-c[ea]).+)/,
       rcustomProp = /^--/,
       cssShow = { position: "absolute", visibility: "hidden", display: "block" },
       cssNormalTransform = {
           letterSpacing: "0",
           fontWeight: "400"
       },
   
       cssPrefixes = [ "Webkit", "Moz", "ms" ],
       emptyStyle = document.createElement( "div" ).style;
   
   // Return a css property mapped to a potentially vendor prefixed property
   function vendorPropName( name ) {
   
       // Shortcut for names that are not vendor prefixed
       if ( name in emptyStyle ) {
           return name;
       }
   
       // Check for vendor prefixed names
       var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
           i = cssPrefixes.length;
   
       while ( i-- ) {
           name = cssPrefixes[ i ] + capName;
           if ( name in emptyStyle ) {
               return name;
           }
       }
   }
   
   // Return a property mapped along what jQuery.cssProps suggests or to
   // a vendor prefixed property.
   function finalPropName( name ) {
       var ret = jQuery.cssProps[ name ];
       if ( !ret ) {
           ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
       }
       return ret;
   }
   
   function setPositiveNumber( elem, value, subtract ) {
   
       // Any relative (+/-) values have already been
       // normalized at this point
       var matches = rcssNum.exec( value );
       return matches ?
   
           // Guard against undefined "subtract", e.g., when used as in cssHooks
           Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
           value;
   }
   
   function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
       var i = dimension === "width" ? 1 : 0,
           extra = 0,
           delta = 0;
   
       // Adjustment may not be necessary
       if ( box === ( isBorderBox ? "border" : "content" ) ) {
           return 0;
       }
   
       for ( ; i < 4; i += 2 ) {
   
           // Both box models exclude margin
           if ( box === "margin" ) {
               delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
           }
   
           // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
           if ( !isBorderBox ) {
   
               // Add padding
               delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
   
               // For "border" or "margin", add border
               if ( box !== "padding" ) {
                   delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
   
               // But still keep track of it otherwise
               } else {
                   extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
               }
   
           // If we get here with a border-box (content + padding + border), we're seeking "content" or
           // "padding" or "margin"
           } else {
   
               // For "content", subtract padding
               if ( box === "content" ) {
                   delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
               }
   
               // For "content" or "padding", subtract border
               if ( box !== "margin" ) {
                   delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
               }
           }
       }
   
       // Account for positive content-box scroll gutter when requested by providing computedVal
       if ( !isBorderBox && computedVal >= 0 ) {
   
           // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
           // Assuming integer scroll gutter, subtract the rest and round down
           delta += Math.max( 0, Math.ceil(
               elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
               computedVal -
               delta -
               extra -
               0.5
           ) );
       }
   
       return delta;
   }
   
   function getWidthOrHeight( elem, dimension, extra ) {
   
       // Start with computed style
       var styles = getStyles( elem ),
           val = curCSS( elem, dimension, styles ),
           isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
           valueIsBorderBox = isBorderBox;
   
       // Support: Firefox <=54
       // Return a confounding non-pixel value or feign ignorance, as appropriate.
       if ( rnumnonpx.test( val ) ) {
           if ( !extra ) {
               return val;
           }
           val = "auto";
       }
   
       // Check for style in case a browser which returns unreliable values
       // for getComputedStyle silently falls back to the reliable elem.style
       valueIsBorderBox = valueIsBorderBox &&
           ( support.boxSizingReliable() || val === elem.style[ dimension ] );
   
       // Fall back to offsetWidth/offsetHeight when value is "auto"
       // This happens for inline elements with no explicit setting (gh-3571)
       // Support: Android <=4.1 - 4.3 only
       // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
       if ( val === "auto" ||
           !parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
   
           val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
   
           // offsetWidth/offsetHeight provide border-box values
           valueIsBorderBox = true;
       }
   
       // Normalize "" and auto
       val = parseFloat( val ) || 0;
   
       // Adjust for the element's box model
       return ( val +
           boxModelAdjustment(
               elem,
               dimension,
               extra || ( isBorderBox ? "border" : "content" ),
               valueIsBorderBox,
               styles,
   
               // Provide the current computed size to request scroll gutter calculation (gh-3589)
               val
           )
       ) + "px";
   }
   
   jQuery.extend( {
   
       // Add in style property hooks for overriding the default
       // behavior of getting and setting a style property
       cssHooks: {
           opacity: {
               get: function( elem, computed ) {
                   if ( computed ) {
   
                       // We should always get a number back from opacity
                       var ret = curCSS( elem, "opacity" );
                       return ret === "" ? "1" : ret;
                   }
               }
           }
       },
   
       // Don't automatically add "px" to these possibly-unitless properties
       cssNumber: {
           "animationIterationCount": true,
           "columnCount": true,
           "fillOpacity": true,
           "flexGrow": true,
           "flexShrink": true,
           "fontWeight": true,
           "lineHeight": true,
           "opacity": true,
           "order": true,
           "orphans": true,
           "widows": true,
           "zIndex": true,
           "zoom": true
       },
   
       // Add in properties whose names you wish to fix before
       // setting or getting the value
       cssProps: {},
   
       // Get and set the style property on a DOM Node
       style: function( elem, name, value, extra ) {
   
           // Don't set styles on text and comment nodes
           if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
               return;
           }
   
           // Make sure that we're working with the right name
           var ret, type, hooks,
               origName = camelCase( name ),
               isCustomProp = rcustomProp.test( name ),
               style = elem.style;
   
           // Make sure that we're working with the right name. We don't
           // want to query the value if it is a CSS custom property
           // since they are user-defined.
           if ( !isCustomProp ) {
               name = finalPropName( origName );
           }
   
           // Gets hook for the prefixed version, then unprefixed version
           hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
   
           // Check if we're setting a value
           if ( value !== undefined ) {
               type = typeof value;
   
               // Convert "+=" or "-=" to relative numbers (#7345)
               if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
                   value = adjustCSS( elem, name, ret );
   
                   // Fixes bug #9237
                   type = "number";
               }
   
               // Make sure that null and NaN values aren't set (#7116)
               if ( value == null || value !== value ) {
                   return;
               }
   
               // If a number was passed in, add the unit (except for certain CSS properties)
               if ( type === "number" ) {
                   value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
               }
   
               // background-* props affect original clone's values
               if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
                   style[ name ] = "inherit";
               }
   
               // If a hook was provided, use that value, otherwise just set the specified value
               if ( !hooks || !( "set" in hooks ) ||
                   ( value = hooks.set( elem, value, extra ) ) !== undefined ) {
   
                   if ( isCustomProp ) {
                       style.setProperty( name, value );
                   } else {
                       style[ name ] = value;
                   }
               }
   
           } else {
   
               // If a hook was provided get the non-computed value from there
               if ( hooks && "get" in hooks &&
                   ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
   
                   return ret;
               }
   
               // Otherwise just get the value from the style object
               return style[ name ];
           }
       },
   
       css: function( elem, name, extra, styles ) {
           var val, num, hooks,
               origName = camelCase( name ),
               isCustomProp = rcustomProp.test( name );
   
           // Make sure that we're working with the right name. We don't
           // want to modify the value if it is a CSS custom property
           // since they are user-defined.
           if ( !isCustomProp ) {
               name = finalPropName( origName );
           }
   
           // Try prefixed name followed by the unprefixed name
           hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
   
           // If a hook was provided get the computed value from there
           if ( hooks && "get" in hooks ) {
               val = hooks.get( elem, true, extra );
           }
   
           // Otherwise, if a way to get the computed value exists, use that
           if ( val === undefined ) {
               val = curCSS( elem, name, styles );
           }
   
           // Convert "normal" to computed value
           if ( val === "normal" && name in cssNormalTransform ) {
               val = cssNormalTransform[ name ];
           }
   
           // Make numeric if forced or a qualifier was provided and val looks numeric
           if ( extra === "" || extra ) {
               num = parseFloat( val );
               return extra === true || isFinite( num ) ? num || 0 : val;
           }
   
           return val;
       }
   } );
   
   jQuery.each( [ "height", "width" ], function( i, dimension ) {
       jQuery.cssHooks[ dimension ] = {
           get: function( elem, computed, extra ) {
               if ( computed ) {
   
                   // Certain elements can have dimension info if we invisibly show them
                   // but it must have a current display style that would benefit
                   return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
   
                       // Support: Safari 8+
                       // Table columns in Safari have non-zero offsetWidth & zero
                       // getBoundingClientRect().width unless display is changed.
                       // Support: IE <=11 only
                       // Running getBoundingClientRect on a disconnected node
                       // in IE throws an error.
                       ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
                           swap( elem, cssShow, function() {
                               return getWidthOrHeight( elem, dimension, extra );
                           } ) :
                           getWidthOrHeight( elem, dimension, extra );
               }
           },
   
           set: function( elem, value, extra ) {
               var matches,
                   styles = getStyles( elem ),
                   isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
                   subtract = extra && boxModelAdjustment(
                       elem,
                       dimension,
                       extra,
                       isBorderBox,
                       styles
                   );
   
               // Account for unreliable border-box dimensions by comparing offset* to computed and
               // faking a content-box to get border and padding (gh-3699)
               if ( isBorderBox && support.scrollboxSize() === styles.position ) {
                   subtract -= Math.ceil(
                       elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
                       parseFloat( styles[ dimension ] ) -
                       boxModelAdjustment( elem, dimension, "border", false, styles ) -
                       0.5
                   );
               }
   
               // Convert to pixels if value adjustment is needed
               if ( subtract && ( matches = rcssNum.exec( value ) ) &&
                   ( matches[ 3 ] || "px" ) !== "px" ) {
   
                   elem.style[ dimension ] = value;
                   value = jQuery.css( elem, dimension );
               }
   
               return setPositiveNumber( elem, value, subtract );
           }
       };
   } );
   
   jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
       function( elem, computed ) {
           if ( computed ) {
               return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
                   elem.getBoundingClientRect().left -
                       swap( elem, { marginLeft: 0 }, function() {
                           return elem.getBoundingClientRect().left;
                       } )
                   ) + "px";
           }
       }
   );
   
   // These hooks are used by animate to expand properties
   jQuery.each( {
       margin: "",
       padding: "",
       border: "Width"
   }, function( prefix, suffix ) {
       jQuery.cssHooks[ prefix + suffix ] = {
           expand: function( value ) {
               var i = 0,
                   expanded = {},
   
                   // Assumes a single number if not a string
                   parts = typeof value === "string" ? value.split( " " ) : [ value ];
   
               for ( ; i < 4; i++ ) {
                   expanded[ prefix + cssExpand[ i ] + suffix ] =
                       parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
               }
   
               return expanded;
           }
       };
   
       if ( prefix !== "margin" ) {
           jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
       }
   } );
   
   jQuery.fn.extend( {
       css: function( name, value ) {
           return access( this, function( elem, name, value ) {
               var styles, len,
                   map = {},
                   i = 0;
   
               if ( Array.isArray( name ) ) {
                   styles = getStyles( elem );
                   len = name.length;
   
                   for ( ; i < len; i++ ) {
                       map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
                   }
   
                   return map;
               }
   
               return value !== undefined ?
                   jQuery.style( elem, name, value ) :
                   jQuery.css( elem, name );
           }, name, value, arguments.length > 1 );
       }
   } );
   
   
   function Tween( elem, options, prop, end, easing ) {
       return new Tween.prototype.init( elem, options, prop, end, easing );
   }
   jQuery.Tween = Tween;
   
   Tween.prototype = {
       constructor: Tween,
       init: function( elem, options, prop, end, easing, unit ) {
           this.elem = elem;
           this.prop = prop;
           this.easing = easing || jQuery.easing._default;
           this.options = options;
           this.start = this.now = this.cur();
           this.end = end;
           this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
       },
       cur: function() {
           var hooks = Tween.propHooks[ this.prop ];
   
           return hooks && hooks.get ?
               hooks.get( this ) :
               Tween.propHooks._default.get( this );
       },
       run: function( percent ) {
           var eased,
               hooks = Tween.propHooks[ this.prop ];
   
           if ( this.options.duration ) {
               this.pos = eased = jQuery.easing[ this.easing ](
                   percent, this.options.duration * percent, 0, 1, this.options.duration
               );
           } else {
               this.pos = eased = percent;
           }
           this.now = ( this.end - this.start ) * eased + this.start;
   
           if ( this.options.step ) {
               this.options.step.call( this.elem, this.now, this );
           }
   
           if ( hooks && hooks.set ) {
               hooks.set( this );
           } else {
               Tween.propHooks._default.set( this );
           }
           return this;
       }
   };
   
   Tween.prototype.init.prototype = Tween.prototype;
   
   Tween.propHooks = {
       _default: {
           get: function( tween ) {
               var result;
   
               // Use a property on the element directly when it is not a DOM element,
               // or when there is no matching style property that exists.
               if ( tween.elem.nodeType !== 1 ||
                   tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
                   return tween.elem[ tween.prop ];
               }
   
               // Passing an empty string as a 3rd parameter to .css will automatically
               // attempt a parseFloat and fallback to a string if the parse fails.
               // Simple values such as "10px" are parsed to Float;
               // complex values such as "rotate(1rad)" are returned as-is.
               result = jQuery.css( tween.elem, tween.prop, "" );
   
               // Empty strings, null, undefined and "auto" are converted to 0.
               return !result || result === "auto" ? 0 : result;
           },
           set: function( tween ) {
   
               // Use step hook for back compat.
               // Use cssHook if its there.
               // Use .style if available and use plain properties where available.
               if ( jQuery.fx.step[ tween.prop ] ) {
                   jQuery.fx.step[ tween.prop ]( tween );
               } else if ( tween.elem.nodeType === 1 &&
                   ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
                       jQuery.cssHooks[ tween.prop ] ) ) {
                   jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
               } else {
                   tween.elem[ tween.prop ] = tween.now;
               }
           }
       }
   };
   
   // Support: IE <=9 only
   // Panic based approach to setting things on disconnected nodes
   Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
       set: function( tween ) {
           if ( tween.elem.nodeType && tween.elem.parentNode ) {
               tween.elem[ tween.prop ] = tween.now;
           }
       }
   };
   
   jQuery.easing = {
       linear: function( p ) {
           return p;
       },
       swing: function( p ) {
           return 0.5 - Math.cos( p * Math.PI ) / 2;
       },
       _default: "swing"
   };
   
   jQuery.fx = Tween.prototype.init;
   
   // Back compat <1.8 extension point
   jQuery.fx.step = {};
   
   
   
   
   var
       fxNow, inProgress,
       rfxtypes = /^(?:toggle|show|hide)$/,
       rrun = /queueHooks$/;
   
   function schedule() {
       if ( inProgress ) {
           if ( document.hidden === false && window.requestAnimationFrame ) {
               window.requestAnimationFrame( schedule );
           } else {
               window.setTimeout( schedule, jQuery.fx.interval );
           }
   
           jQuery.fx.tick();
       }
   }
   
   // Animations created synchronously will run synchronously
   function createFxNow() {
       window.setTimeout( function() {
           fxNow = undefined;
       } );
       return ( fxNow = Date.now() );
   }
   
   // Generate parameters to create a standard animation
   function genFx( type, includeWidth ) {
       var which,
           i = 0,
           attrs = { height: type };
   
       // If we include width, step value is 1 to do all cssExpand values,
       // otherwise step value is 2 to skip over Left and Right
       includeWidth = includeWidth ? 1 : 0;
       for ( ; i < 4; i += 2 - includeWidth ) {
           which = cssExpand[ i ];
           attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
       }
   
       if ( includeWidth ) {
           attrs.opacity = attrs.width = type;
       }
   
       return attrs;
   }
   
   function createTween( value, prop, animation ) {
       var tween,
           collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
           index = 0,
           length = collection.length;
       for ( ; index < length; index++ ) {
           if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
   
               // We're done with this property
               return tween;
           }
       }
   }
   
   function defaultPrefilter( elem, props, opts ) {
       var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
           isBox = "width" in props || "height" in props,
           anim = this,
           orig = {},
           style = elem.style,
           hidden = elem.nodeType && isHiddenWithinTree( elem ),
           dataShow = dataPriv.get( elem, "fxshow" );
   
       // Queue-skipping animations hijack the fx hooks
       if ( !opts.queue ) {
           hooks = jQuery._queueHooks( elem, "fx" );
           if ( hooks.unqueued == null ) {
               hooks.unqueued = 0;
               oldfire = hooks.empty.fire;
               hooks.empty.fire = function() {
                   if ( !hooks.unqueued ) {
                       oldfire();
                   }
               };
           }
           hooks.unqueued++;
   
           anim.always( function() {
   
               // Ensure the complete handler is called before this completes
               anim.always( function() {
                   hooks.unqueued--;
                   if ( !jQuery.queue( elem, "fx" ).length ) {
                       hooks.empty.fire();
                   }
               } );
           } );
       }
   
       // Detect show/hide animations
       for ( prop in props ) {
           value = props[ prop ];
           if ( rfxtypes.test( value ) ) {
               delete props[ prop ];
               toggle = toggle || value === "toggle";
               if ( value === ( hidden ? "hide" : "show" ) ) {
   
                   // Pretend to be hidden if this is a "show" and
                   // there is still data from a stopped show/hide
                   if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
                       hidden = true;
   
                   // Ignore all other no-op show/hide data
                   } else {
                       continue;
                   }
               }
               orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
           }
       }
   
       // Bail out if this is a no-op like .hide().hide()
       propTween = !jQuery.isEmptyObject( props );
       if ( !propTween && jQuery.isEmptyObject( orig ) ) {
           return;
       }
   
       // Restrict "overflow" and "display" styles during box animations
       if ( isBox && elem.nodeType === 1 ) {
   
           // Support: IE <=9 - 11, Edge 12 - 15
           // Record all 3 overflow attributes because IE does not infer the shorthand
           // from identically-valued overflowX and overflowY and Edge just mirrors
           // the overflowX value there.
           opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
   
           // Identify a display type, preferring old show/hide data over the CSS cascade
           restoreDisplay = dataShow && dataShow.display;
           if ( restoreDisplay == null ) {
               restoreDisplay = dataPriv.get( elem, "display" );
           }
           display = jQuery.css( elem, "display" );
           if ( display === "none" ) {
               if ( restoreDisplay ) {
                   display = restoreDisplay;
               } else {
   
                   // Get nonempty value(s) by temporarily forcing visibility
                   showHide( [ elem ], true );
                   restoreDisplay = elem.style.display || restoreDisplay;
                   display = jQuery.css( elem, "display" );
                   showHide( [ elem ] );
               }
           }
   
           // Animate inline elements as inline-block
           if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
               if ( jQuery.css( elem, "float" ) === "none" ) {
   
                   // Restore the original display value at the end of pure show/hide animations
                   if ( !propTween ) {
                       anim.done( function() {
                           style.display = restoreDisplay;
                       } );
                       if ( restoreDisplay == null ) {
                           display = style.display;
                           restoreDisplay = display === "none" ? "" : display;
                       }
                   }
                   style.display = "inline-block";
               }
           }
       }
   
       if ( opts.overflow ) {
           style.overflow = "hidden";
           anim.always( function() {
               style.overflow = opts.overflow[ 0 ];
               style.overflowX = opts.overflow[ 1 ];
               style.overflowY = opts.overflow[ 2 ];
           } );
       }
   
       // Implement show/hide animations
       propTween = false;
       for ( prop in orig ) {
   
           // General show/hide setup for this element animation
           if ( !propTween ) {
               if ( dataShow ) {
                   if ( "hidden" in dataShow ) {
                       hidden = dataShow.hidden;
                   }
               } else {
                   dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
               }
   
               // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
               if ( toggle ) {
                   dataShow.hidden = !hidden;
               }
   
               // Show elements before animating them
               if ( hidden ) {
                   showHide( [ elem ], true );
               }
   
               /* eslint-disable no-loop-func */
   
               anim.done( function() {
   
               /* eslint-enable no-loop-func */
   
                   // The final step of a "hide" animation is actually hiding the element
                   if ( !hidden ) {
                       showHide( [ elem ] );
                   }
                   dataPriv.remove( elem, "fxshow" );
                   for ( prop in orig ) {
                       jQuery.style( elem, prop, orig[ prop ] );
                   }
               } );
           }
   
           // Per-property setup
           propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
           if ( !( prop in dataShow ) ) {
               dataShow[ prop ] = propTween.start;
               if ( hidden ) {
                   propTween.end = propTween.start;
                   propTween.start = 0;
               }
           }
       }
   }
   
   function propFilter( props, specialEasing ) {
       var index, name, easing, value, hooks;
   
       // camelCase, specialEasing and expand cssHook pass
       for ( index in props ) {
           name = camelCase( index );
           easing = specialEasing[ name ];
           value = props[ index ];
           if ( Array.isArray( value ) ) {
               easing = value[ 1 ];
               value = props[ index ] = value[ 0 ];
           }
   
           if ( index !== name ) {
               props[ name ] = value;
               delete props[ index ];
           }
   
           hooks = jQuery.cssHooks[ name ];
           if ( hooks && "expand" in hooks ) {
               value = hooks.expand( value );
               delete props[ name ];
   
               // Not quite $.extend, this won't overwrite existing keys.
               // Reusing 'index' because we have the correct "name"
               for ( index in value ) {
                   if ( !( index in props ) ) {
                       props[ index ] = value[ index ];
                       specialEasing[ index ] = easing;
                   }
               }
           } else {
               specialEasing[ name ] = easing;
           }
       }
   }
   
   function Animation( elem, properties, options ) {
       var result,
           stopped,
           index = 0,
           length = Animation.prefilters.length,
           deferred = jQuery.Deferred().always( function() {
   
               // Don't match elem in the :animated selector
               delete tick.elem;
           } ),
           tick = function() {
               if ( stopped ) {
                   return false;
               }
               var currentTime = fxNow || createFxNow(),
                   remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
   
                   // Support: Android 2.3 only
                   // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                   temp = remaining / animation.duration || 0,
                   percent = 1 - temp,
                   index = 0,
                   length = animation.tweens.length;
   
               for ( ; index < length; index++ ) {
                   animation.tweens[ index ].run( percent );
               }
   
               deferred.notifyWith( elem, [ animation, percent, remaining ] );
   
               // If there's more to do, yield
               if ( percent < 1 && length ) {
                   return remaining;
               }
   
               // If this was an empty animation, synthesize a final progress notification
               if ( !length ) {
                   deferred.notifyWith( elem, [ animation, 1, 0 ] );
               }
   
               // Resolve the animation and report its conclusion
               deferred.resolveWith( elem, [ animation ] );
               return false;
           },
           animation = deferred.promise( {
               elem: elem,
               props: jQuery.extend( {}, properties ),
               opts: jQuery.extend( true, {
                   specialEasing: {},
                   easing: jQuery.easing._default
               }, options ),
               originalProperties: properties,
               originalOptions: options,
               startTime: fxNow || createFxNow(),
               duration: options.duration,
               tweens: [],
               createTween: function( prop, end ) {
                   var tween = jQuery.Tween( elem, animation.opts, prop, end,
                           animation.opts.specialEasing[ prop ] || animation.opts.easing );
                   animation.tweens.push( tween );
                   return tween;
               },
               stop: function( gotoEnd ) {
                   var index = 0,
   
                       // If we are going to the end, we want to run all the tweens
                       // otherwise we skip this part
                       length = gotoEnd ? animation.tweens.length : 0;
                   if ( stopped ) {
                       return this;
                   }
                   stopped = true;
                   for ( ; index < length; index++ ) {
                       animation.tweens[ index ].run( 1 );
                   }
   
                   // Resolve when we played the last frame; otherwise, reject
                   if ( gotoEnd ) {
                       deferred.notifyWith( elem, [ animation, 1, 0 ] );
                       deferred.resolveWith( elem, [ animation, gotoEnd ] );
                   } else {
                       deferred.rejectWith( elem, [ animation, gotoEnd ] );
                   }
                   return this;
               }
           } ),
           props = animation.props;
   
       propFilter( props, animation.opts.specialEasing );
   
       for ( ; index < length; index++ ) {
           result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
           if ( result ) {
               if ( isFunction( result.stop ) ) {
                   jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
                       result.stop.bind( result );
               }
               return result;
           }
       }
   
       jQuery.map( props, createTween, animation );
   
       if ( isFunction( animation.opts.start ) ) {
           animation.opts.start.call( elem, animation );
       }
   
       // Attach callbacks from options
       animation
           .progress( animation.opts.progress )
           .done( animation.opts.done, animation.opts.complete )
           .fail( animation.opts.fail )
           .always( animation.opts.always );
   
       jQuery.fx.timer(
           jQuery.extend( tick, {
               elem: elem,
               anim: animation,
               queue: animation.opts.queue
           } )
       );
   
       return animation;
   }
   
   jQuery.Animation = jQuery.extend( Animation, {
   
       tweeners: {
           "*": [ function( prop, value ) {
               var tween = this.createTween( prop, value );
               adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
               return tween;
           } ]
       },
   
       tweener: function( props, callback ) {
           if ( isFunction( props ) ) {
               callback = props;
               props = [ "*" ];
           } else {
               props = props.match( rnothtmlwhite );
           }
   
           var prop,
               index = 0,
               length = props.length;
   
           for ( ; index < length; index++ ) {
               prop = props[ index ];
               Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
               Animation.tweeners[ prop ].unshift( callback );
           }
       },
   
       prefilters: [ defaultPrefilter ],
   
       prefilter: function( callback, prepend ) {
           if ( prepend ) {
               Animation.prefilters.unshift( callback );
           } else {
               Animation.prefilters.push( callback );
           }
       }
   } );
   
   jQuery.speed = function( speed, easing, fn ) {
       var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
           complete: fn || !fn && easing ||
               isFunction( speed ) && speed,
           duration: speed,
           easing: fn && easing || easing && !isFunction( easing ) && easing
       };
   
       // Go to the end state if fx are off
       if ( jQuery.fx.off ) {
           opt.duration = 0;
   
       } else {
           if ( typeof opt.duration !== "number" ) {
               if ( opt.duration in jQuery.fx.speeds ) {
                   opt.duration = jQuery.fx.speeds[ opt.duration ];
   
               } else {
                   opt.duration = jQuery.fx.speeds._default;
               }
           }
       }
   
       // Normalize opt.queue - true/undefined/null -> "fx"
       if ( opt.queue == null || opt.queue === true ) {
           opt.queue = "fx";
       }
   
       // Queueing
       opt.old = opt.complete;
   
       opt.complete = function() {
           if ( isFunction( opt.old ) ) {
               opt.old.call( this );
           }
   
           if ( opt.queue ) {
               jQuery.dequeue( this, opt.queue );
           }
       };
   
       return opt;
   };
   
   jQuery.fn.extend( {
       fadeTo: function( speed, to, easing, callback ) {
   
           // Show any hidden elements after setting opacity to 0
           return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
   
               // Animate to the value specified
               .end().animate( { opacity: to }, speed, easing, callback );
       },
       animate: function( prop, speed, easing, callback ) {
           var empty = jQuery.isEmptyObject( prop ),
               optall = jQuery.speed( speed, easing, callback ),
               doAnimation = function() {
   
                   // Operate on a copy of prop so per-property easing won't be lost
                   var anim = Animation( this, jQuery.extend( {}, prop ), optall );
   
                   // Empty animations, or finishing resolves immediately
                   if ( empty || dataPriv.get( this, "finish" ) ) {
                       anim.stop( true );
                   }
               };
               doAnimation.finish = doAnimation;
   
           return empty || optall.queue === false ?
               this.each( doAnimation ) :
               this.queue( optall.queue, doAnimation );
       },
       stop: function( type, clearQueue, gotoEnd ) {
           var stopQueue = function( hooks ) {
               var stop = hooks.stop;
               delete hooks.stop;
               stop( gotoEnd );
           };
   
           if ( typeof type !== "string" ) {
               gotoEnd = clearQueue;
               clearQueue = type;
               type = undefined;
           }
           if ( clearQueue && type !== false ) {
               this.queue( type || "fx", [] );
           }
   
           return this.each( function() {
               var dequeue = true,
                   index = type != null && type + "queueHooks",
                   timers = jQuery.timers,
                   data = dataPriv.get( this );
   
               if ( index ) {
                   if ( data[ index ] && data[ index ].stop ) {
                       stopQueue( data[ index ] );
                   }
               } else {
                   for ( index in data ) {
                       if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
                           stopQueue( data[ index ] );
                       }
                   }
               }
   
               for ( index = timers.length; index--; ) {
                   if ( timers[ index ].elem === this &&
                       ( type == null || timers[ index ].queue === type ) ) {
   
                       timers[ index ].anim.stop( gotoEnd );
                       dequeue = false;
                       timers.splice( index, 1 );
                   }
               }
   
               // Start the next in the queue if the last step wasn't forced.
               // Timers currently will call their complete callbacks, which
               // will dequeue but only if they were gotoEnd.
               if ( dequeue || !gotoEnd ) {
                   jQuery.dequeue( this, type );
               }
           } );
       },
       finish: function( type ) {
           if ( type !== false ) {
               type = type || "fx";
           }
           return this.each( function() {
               var index,
                   data = dataPriv.get( this ),
                   queue = data[ type + "queue" ],
                   hooks = data[ type + "queueHooks" ],
                   timers = jQuery.timers,
                   length = queue ? queue.length : 0;
   
               // Enable finishing flag on private data
               data.finish = true;
   
               // Empty the queue first
               jQuery.queue( this, type, [] );
   
               if ( hooks && hooks.stop ) {
                   hooks.stop.call( this, true );
               }
   
               // Look for any active animations, and finish them
               for ( index = timers.length; index--; ) {
                   if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
                       timers[ index ].anim.stop( true );
                       timers.splice( index, 1 );
                   }
               }
   
               // Look for any animations in the old queue and finish them
               for ( index = 0; index < length; index++ ) {
                   if ( queue[ index ] && queue[ index ].finish ) {
                       queue[ index ].finish.call( this );
                   }
               }
   
               // Turn off finishing flag
               delete data.finish;
           } );
       }
   } );
   
   jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
       var cssFn = jQuery.fn[ name ];
       jQuery.fn[ name ] = function( speed, easing, callback ) {
           return speed == null || typeof speed === "boolean" ?
               cssFn.apply( this, arguments ) :
               this.animate( genFx( name, true ), speed, easing, callback );
       };
   } );
   
   // Generate shortcuts for custom animations
   jQuery.each( {
       slideDown: genFx( "show" ),
       slideUp: genFx( "hide" ),
       slideToggle: genFx( "toggle" ),
       fadeIn: { opacity: "show" },
       fadeOut: { opacity: "hide" },
       fadeToggle: { opacity: "toggle" }
   }, function( name, props ) {
       jQuery.fn[ name ] = function( speed, easing, callback ) {
           return this.animate( props, speed, easing, callback );
       };
   } );
   
   jQuery.timers = [];
   jQuery.fx.tick = function() {
       var timer,
           i = 0,
           timers = jQuery.timers;
   
       fxNow = Date.now();
   
       for ( ; i < timers.length; i++ ) {
           timer = timers[ i ];
   
           // Run the timer and safely remove it when done (allowing for external removal)
           if ( !timer() && timers[ i ] === timer ) {
               timers.splice( i--, 1 );
           }
       }
   
       if ( !timers.length ) {
           jQuery.fx.stop();
       }
       fxNow = undefined;
   };
   
   jQuery.fx.timer = function( timer ) {
       jQuery.timers.push( timer );
       jQuery.fx.start();
   };
   
   jQuery.fx.interval = 13;
   jQuery.fx.start = function() {
       if ( inProgress ) {
           return;
       }
   
       inProgress = true;
       schedule();
   };
   
   jQuery.fx.stop = function() {
       inProgress = null;
   };
   
   jQuery.fx.speeds = {
       slow: 600,
       fast: 200,
   
       // Default speed
       _default: 400
   };
   
   
   // Based off of the plugin by Clint Helfers, with permission.
   // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
   jQuery.fn.delay = function( time, type ) {
       time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
       type = type || "fx";
   
       return this.queue( type, function( next, hooks ) {
           var timeout = window.setTimeout( next, time );
           hooks.stop = function() {
               window.clearTimeout( timeout );
           };
       } );
   };
   
   
   ( function() {
       var input = document.createElement( "input" ),
           select = document.createElement( "select" ),
           opt = select.appendChild( document.createElement( "option" ) );
   
       input.type = "checkbox";
   
       // Support: Android <=4.3 only
       // Default value for a checkbox should be "on"
       support.checkOn = input.value !== "";
   
       // Support: IE <=11 only
       // Must access selectedIndex to make default options select
       support.optSelected = opt.selected;
   
       // Support: IE <=11 only
       // An input loses its value after becoming a radio
       input = document.createElement( "input" );
       input.value = "t";
       input.type = "radio";
       support.radioValue = input.value === "t";
   } )();
   
   
   var boolHook,
       attrHandle = jQuery.expr.attrHandle;
   
   jQuery.fn.extend( {
       attr: function( name, value ) {
           return access( this, jQuery.attr, name, value, arguments.length > 1 );
       },
   
       removeAttr: function( name ) {
           return this.each( function() {
               jQuery.removeAttr( this, name );
           } );
       }
   } );
   
   jQuery.extend( {
       attr: function( elem, name, value ) {
           var ret, hooks,
               nType = elem.nodeType;
   
           // Don't get/set attributes on text, comment and attribute nodes
           if ( nType === 3 || nType === 8 || nType === 2 ) {
               return;
           }
   
           // Fallback to prop when attributes are not supported
           if ( typeof elem.getAttribute === "undefined" ) {
               return jQuery.prop( elem, name, value );
           }
   
           // Attribute hooks are determined by the lowercase version
           // Grab necessary hook if one is defined
           if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
               hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
                   ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
           }
   
           if ( value !== undefined ) {
               if ( value === null ) {
                   jQuery.removeAttr( elem, name );
                   return;
               }
   
               if ( hooks && "set" in hooks &&
                   ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                   return ret;
               }
   
               elem.setAttribute( name, value + "" );
               return value;
           }
   
           if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
               return ret;
           }
   
           ret = jQuery.find.attr( elem, name );
   
           // Non-existent attributes return null, we normalize to undefined
           return ret == null ? undefined : ret;
       },
   
       attrHooks: {
           type: {
               set: function( elem, value ) {
                   if ( !support.radioValue && value === "radio" &&
                       nodeName( elem, "input" ) ) {
                       var val = elem.value;
                       elem.setAttribute( "type", value );
                       if ( val ) {
                           elem.value = val;
                       }
                       return value;
                   }
               }
           }
       },
   
       removeAttr: function( elem, value ) {
           var name,
               i = 0,
   
               // Attribute names can contain non-HTML whitespace characters
               // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
               attrNames = value && value.match( rnothtmlwhite );
   
           if ( attrNames && elem.nodeType === 1 ) {
               while ( ( name = attrNames[ i++ ] ) ) {
                   elem.removeAttribute( name );
               }
           }
       }
   } );
   
   // Hooks for boolean attributes
   boolHook = {
       set: function( elem, value, name ) {
           if ( value === false ) {
   
               // Remove boolean attributes when set to false
               jQuery.removeAttr( elem, name );
           } else {
               elem.setAttribute( name, name );
           }
           return name;
       }
   };
   
   jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
       var getter = attrHandle[ name ] || jQuery.find.attr;
   
       attrHandle[ name ] = function( elem, name, isXML ) {
           var ret, handle,
               lowercaseName = name.toLowerCase();
   
           if ( !isXML ) {
   
               // Avoid an infinite loop by temporarily removing this function from the getter
               handle = attrHandle[ lowercaseName ];
               attrHandle[ lowercaseName ] = ret;
               ret = getter( elem, name, isXML ) != null ?
                   lowercaseName :
                   null;
               attrHandle[ lowercaseName ] = handle;
           }
           return ret;
       };
   } );
   
   
   
   
   var rfocusable = /^(?:input|select|textarea|button)$/i,
       rclickable = /^(?:a|area)$/i;
   
   jQuery.fn.extend( {
       prop: function( name, value ) {
           return access( this, jQuery.prop, name, value, arguments.length > 1 );
       },
   
       removeProp: function( name ) {
           return this.each( function() {
               delete this[ jQuery.propFix[ name ] || name ];
           } );
       }
   } );
   
   jQuery.extend( {
       prop: function( elem, name, value ) {
           var ret, hooks,
               nType = elem.nodeType;
   
           // Don't get/set properties on text, comment and attribute nodes
           if ( nType === 3 || nType === 8 || nType === 2 ) {
               return;
           }
   
           if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
   
               // Fix name and attach hooks
               name = jQuery.propFix[ name ] || name;
               hooks = jQuery.propHooks[ name ];
           }
   
           if ( value !== undefined ) {
               if ( hooks && "set" in hooks &&
                   ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                   return ret;
               }
   
               return ( elem[ name ] = value );
           }
   
           if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
               return ret;
           }
   
           return elem[ name ];
       },
   
       propHooks: {
           tabIndex: {
               get: function( elem ) {
   
                   // Support: IE <=9 - 11 only
                   // elem.tabIndex doesn't always return the
                   // correct value when it hasn't been explicitly set
                   // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                   // Use proper attribute retrieval(#12072)
                   var tabindex = jQuery.find.attr( elem, "tabindex" );
   
                   if ( tabindex ) {
                       return parseInt( tabindex, 10 );
                   }
   
                   if (
                       rfocusable.test( elem.nodeName ) ||
                       rclickable.test( elem.nodeName ) &&
                       elem.href
                   ) {
                       return 0;
                   }
   
                   return -1;
               }
           }
       },
   
       propFix: {
           "for": "htmlFor",
           "class": "className"
       }
   } );
   
   // Support: IE <=11 only
   // Accessing the selectedIndex property
   // forces the browser to respect setting selected
   // on the option
   // The getter ensures a default option is selected
   // when in an optgroup
   // eslint rule "no-unused-expressions" is disabled for this code
   // since it considers such accessions noop
   if ( !support.optSelected ) {
       jQuery.propHooks.selected = {
           get: function( elem ) {
   
               /* eslint no-unused-expressions: "off" */
   
               var parent = elem.parentNode;
               if ( parent && parent.parentNode ) {
                   parent.parentNode.selectedIndex;
               }
               return null;
           },
           set: function( elem ) {
   
               /* eslint no-unused-expressions: "off" */
   
               var parent = elem.parentNode;
               if ( parent ) {
                   parent.selectedIndex;
   
                   if ( parent.parentNode ) {
                       parent.parentNode.selectedIndex;
                   }
               }
           }
       };
   }
   
   jQuery.each( [
       "tabIndex",
       "readOnly",
       "maxLength",
       "cellSpacing",
       "cellPadding",
       "rowSpan",
       "colSpan",
       "useMap",
       "frameBorder",
       "contentEditable"
   ], function() {
       jQuery.propFix[ this.toLowerCase() ] = this;
   } );
   
   
   
   
       // Strip and collapse whitespace according to HTML spec
       // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
       function stripAndCollapse( value ) {
           var tokens = value.match( rnothtmlwhite ) || [];
           return tokens.join( " " );
       }
   
   
   function getClass( elem ) {
       return elem.getAttribute && elem.getAttribute( "class" ) || "";
   }
   
   function classesToArray( value ) {
       if ( Array.isArray( value ) ) {
           return value;
       }
       if ( typeof value === "string" ) {
           return value.match( rnothtmlwhite ) || [];
       }
       return [];
   }
   
   jQuery.fn.extend( {
       addClass: function( value ) {
           var classes, elem, cur, curValue, clazz, j, finalValue,
               i = 0;
   
           if ( isFunction( value ) ) {
               return this.each( function( j ) {
                   jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
               } );
           }
   
           classes = classesToArray( value );
   
           if ( classes.length ) {
               while ( ( elem = this[ i++ ] ) ) {
                   curValue = getClass( elem );
                   cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
   
                   if ( cur ) {
                       j = 0;
                       while ( ( clazz = classes[ j++ ] ) ) {
                           if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
                               cur += clazz + " ";
                           }
                       }
   
                       // Only assign if different to avoid unneeded rendering.
                       finalValue = stripAndCollapse( cur );
                       if ( curValue !== finalValue ) {
                           elem.setAttribute( "class", finalValue );
                       }
                   }
               }
           }
   
           return this;
       },
   
       removeClass: function( value ) {
           var classes, elem, cur, curValue, clazz, j, finalValue,
               i = 0;
   
           if ( isFunction( value ) ) {
               return this.each( function( j ) {
                   jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
               } );
           }
   
           if ( !arguments.length ) {
               return this.attr( "class", "" );
           }
   
           classes = classesToArray( value );
   
           if ( classes.length ) {
               while ( ( elem = this[ i++ ] ) ) {
                   curValue = getClass( elem );
   
                   // This expression is here for better compressibility (see addClass)
                   cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
   
                   if ( cur ) {
                       j = 0;
                       while ( ( clazz = classes[ j++ ] ) ) {
   
                           // Remove *all* instances
                           while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
                               cur = cur.replace( " " + clazz + " ", " " );
                           }
                       }
   
                       // Only assign if different to avoid unneeded rendering.
                       finalValue = stripAndCollapse( cur );
                       if ( curValue !== finalValue ) {
                           elem.setAttribute( "class", finalValue );
                       }
                   }
               }
           }
   
           return this;
       },
   
       toggleClass: function( value, stateVal ) {
           var type = typeof value,
               isValidValue = type === "string" || Array.isArray( value );
   
           if ( typeof stateVal === "boolean" && isValidValue ) {
               return stateVal ? this.addClass( value ) : this.removeClass( value );
           }
   
           if ( isFunction( value ) ) {
               return this.each( function( i ) {
                   jQuery( this ).toggleClass(
                       value.call( this, i, getClass( this ), stateVal ),
                       stateVal
                   );
               } );
           }
   
           return this.each( function() {
               var className, i, self, classNames;
   
               if ( isValidValue ) {
   
                   // Toggle individual class names
                   i = 0;
                   self = jQuery( this );
                   classNames = classesToArray( value );
   
                   while ( ( className = classNames[ i++ ] ) ) {
   
                       // Check each className given, space separated list
                       if ( self.hasClass( className ) ) {
                           self.removeClass( className );
                       } else {
                           self.addClass( className );
                       }
                   }
   
               // Toggle whole class name
               } else if ( value === undefined || type === "boolean" ) {
                   className = getClass( this );
                   if ( className ) {
   
                       // Store className if set
                       dataPriv.set( this, "__className__", className );
                   }
   
                   // If the element has a class name or if we're passed `false`,
                   // then remove the whole classname (if there was one, the above saved it).
                   // Otherwise bring back whatever was previously saved (if anything),
                   // falling back to the empty string if nothing was stored.
                   if ( this.setAttribute ) {
                       this.setAttribute( "class",
                           className || value === false ?
                           "" :
                           dataPriv.get( this, "__className__" ) || ""
                       );
                   }
               }
           } );
       },
   
       hasClass: function( selector ) {
           var className, elem,
               i = 0;
   
           className = " " + selector + " ";
           while ( ( elem = this[ i++ ] ) ) {
               if ( elem.nodeType === 1 &&
                   ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
                       return true;
               }
           }
   
           return false;
       }
   } );
   
   
   
   
   var rreturn = /\r/g;
   
   jQuery.fn.extend( {
       val: function( value ) {
           var hooks, ret, valueIsFunction,
               elem = this[ 0 ];
   
           if ( !arguments.length ) {
               if ( elem ) {
                   hooks = jQuery.valHooks[ elem.type ] ||
                       jQuery.valHooks[ elem.nodeName.toLowerCase() ];
   
                   if ( hooks &&
                       "get" in hooks &&
                       ( ret = hooks.get( elem, "value" ) ) !== undefined
                   ) {
                       return ret;
                   }
   
                   ret = elem.value;
   
                   // Handle most common string cases
                   if ( typeof ret === "string" ) {
                       return ret.replace( rreturn, "" );
                   }
   
                   // Handle cases where value is null/undef or number
                   return ret == null ? "" : ret;
               }
   
               return;
           }
   
           valueIsFunction = isFunction( value );
   
           return this.each( function( i ) {
               var val;
   
               if ( this.nodeType !== 1 ) {
                   return;
               }
   
               if ( valueIsFunction ) {
                   val = value.call( this, i, jQuery( this ).val() );
               } else {
                   val = value;
               }
   
               // Treat null/undefined as ""; convert numbers to string
               if ( val == null ) {
                   val = "";
   
               } else if ( typeof val === "number" ) {
                   val += "";
   
               } else if ( Array.isArray( val ) ) {
                   val = jQuery.map( val, function( value ) {
                       return value == null ? "" : value + "";
                   } );
               }
   
               hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
   
               // If set returns undefined, fall back to normal setting
               if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
                   this.value = val;
               }
           } );
       }
   } );
   
   jQuery.extend( {
       valHooks: {
           option: {
               get: function( elem ) {
   
                   var val = jQuery.find.attr( elem, "value" );
                   return val != null ?
                       val :
   
                       // Support: IE <=10 - 11 only
                       // option.text throws exceptions (#14686, #14858)
                       // Strip and collapse whitespace
                       // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                       stripAndCollapse( jQuery.text( elem ) );
               }
           },
           select: {
               get: function( elem ) {
                   var value, option, i,
                       options = elem.options,
                       index = elem.selectedIndex,
                       one = elem.type === "select-one",
                       values = one ? null : [],
                       max = one ? index + 1 : options.length;
   
                   if ( index < 0 ) {
                       i = max;
   
                   } else {
                       i = one ? index : 0;
                   }
   
                   // Loop through all the selected options
                   for ( ; i < max; i++ ) {
                       option = options[ i ];
   
                       // Support: IE <=9 only
                       // IE8-9 doesn't update selected after form reset (#2551)
                       if ( ( option.selected || i === index ) &&
   
                               // Don't return options that are disabled or in a disabled optgroup
                               !option.disabled &&
                               ( !option.parentNode.disabled ||
                                   !nodeName( option.parentNode, "optgroup" ) ) ) {
   
                           // Get the specific value for the option
                           value = jQuery( option ).val();
   
                           // We don't need an array for one selects
                           if ( one ) {
                               return value;
                           }
   
                           // Multi-Selects return an array
                           values.push( value );
                       }
                   }
   
                   return values;
               },
   
               set: function( elem, value ) {
                   var optionSet, option,
                       options = elem.options,
                       values = jQuery.makeArray( value ),
                       i = options.length;
   
                   while ( i-- ) {
                       option = options[ i ];
   
                       /* eslint-disable no-cond-assign */
   
                       if ( option.selected =
                           jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
                       ) {
                           optionSet = true;
                       }
   
                       /* eslint-enable no-cond-assign */
                   }
   
                   // Force browsers to behave consistently when non-matching value is set
                   if ( !optionSet ) {
                       elem.selectedIndex = -1;
                   }
                   return values;
               }
           }
       }
   } );
   
   // Radios and checkboxes getter/setter
   jQuery.each( [ "radio", "checkbox" ], function() {
       jQuery.valHooks[ this ] = {
           set: function( elem, value ) {
               if ( Array.isArray( value ) ) {
                   return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
               }
           }
       };
       if ( !support.checkOn ) {
           jQuery.valHooks[ this ].get = function( elem ) {
               return elem.getAttribute( "value" ) === null ? "on" : elem.value;
           };
       }
   } );
   
   
   
   
   // Return jQuery for attributes-only inclusion
   
   
   support.focusin = "onfocusin" in window;
   
   
   var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
       stopPropagationCallback = function( e ) {
           e.stopPropagation();
       };
   
   jQuery.extend( jQuery.event, {
   
       trigger: function( event, data, elem, onlyHandlers ) {
   
           var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
               eventPath = [ elem || document ],
               type = hasOwn.call( event, "type" ) ? event.type : event,
               namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
   
           cur = lastElement = tmp = elem = elem || document;
   
           // Don't do events on text and comment nodes
           if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
               return;
           }
   
           // focus/blur morphs to focusin/out; ensure we're not firing them right now
           if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
               return;
           }
   
           if ( type.indexOf( "." ) > -1 ) {
   
               // Namespaced trigger; create a regexp to match event type in handle()
               namespaces = type.split( "." );
               type = namespaces.shift();
               namespaces.sort();
           }
           ontype = type.indexOf( ":" ) < 0 && "on" + type;
   
           // Caller can pass in a jQuery.Event object, Object, or just an event type string
           event = event[ jQuery.expando ] ?
               event :
               new jQuery.Event( type, typeof event === "object" && event );
   
           // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
           event.isTrigger = onlyHandlers ? 2 : 3;
           event.namespace = namespaces.join( "." );
           event.rnamespace = event.namespace ?
               new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
               null;
   
           // Clean up the event in case it is being reused
           event.result = undefined;
           if ( !event.target ) {
               event.target = elem;
           }
   
           // Clone any incoming data and prepend the event, creating the handler arg list
           data = data == null ?
               [ event ] :
               jQuery.makeArray( data, [ event ] );
   
           // Allow special events to draw outside the lines
           special = jQuery.event.special[ type ] || {};
           if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
               return;
           }
   
           // Determine event propagation path in advance, per W3C events spec (#9951)
           // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
           if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
   
               bubbleType = special.delegateType || type;
               if ( !rfocusMorph.test( bubbleType + type ) ) {
                   cur = cur.parentNode;
               }
               for ( ; cur; cur = cur.parentNode ) {
                   eventPath.push( cur );
                   tmp = cur;
               }
   
               // Only add window if we got to document (e.g., not plain obj or detached DOM)
               if ( tmp === ( elem.ownerDocument || document ) ) {
                   eventPath.push( tmp.defaultView || tmp.parentWindow || window );
               }
           }
   
           // Fire handlers on the event path
           i = 0;
           while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
               lastElement = cur;
               event.type = i > 1 ?
                   bubbleType :
                   special.bindType || type;
   
               // jQuery handler
               handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
                   dataPriv.get( cur, "handle" );
               if ( handle ) {
                   handle.apply( cur, data );
               }
   
               // Native handler
               handle = ontype && cur[ ontype ];
               if ( handle && handle.apply && acceptData( cur ) ) {
                   event.result = handle.apply( cur, data );
                   if ( event.result === false ) {
                       event.preventDefault();
                   }
               }
           }
           event.type = type;
   
           // If nobody prevented the default action, do it now
           if ( !onlyHandlers && !event.isDefaultPrevented() ) {
   
               if ( ( !special._default ||
                   special._default.apply( eventPath.pop(), data ) === false ) &&
                   acceptData( elem ) ) {
   
                   // Call a native DOM method on the target with the same name as the event.
                   // Don't do default actions on window, that's where global variables be (#6170)
                   if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
   
                       // Don't re-trigger an onFOO event when we call its FOO() method
                       tmp = elem[ ontype ];
   
                       if ( tmp ) {
                           elem[ ontype ] = null;
                       }
   
                       // Prevent re-triggering of the same event, since we already bubbled it above
                       jQuery.event.triggered = type;
   
                       if ( event.isPropagationStopped() ) {
                           lastElement.addEventListener( type, stopPropagationCallback );
                       }
   
                       elem[ type ]();
   
                       if ( event.isPropagationStopped() ) {
                           lastElement.removeEventListener( type, stopPropagationCallback );
                       }
   
                       jQuery.event.triggered = undefined;
   
                       if ( tmp ) {
                           elem[ ontype ] = tmp;
                       }
                   }
               }
           }
   
           return event.result;
       },
   
       // Piggyback on a donor event to simulate a different one
       // Used only for `focus(in | out)` events
       simulate: function( type, elem, event ) {
           var e = jQuery.extend(
               new jQuery.Event(),
               event,
               {
                   type: type,
                   isSimulated: true
               }
           );
   
           jQuery.event.trigger( e, null, elem );
       }
   
   } );
   
   jQuery.fn.extend( {
   
       trigger: function( type, data ) {
           return this.each( function() {
               jQuery.event.trigger( type, data, this );
           } );
       },
       triggerHandler: function( type, data ) {
           var elem = this[ 0 ];
           if ( elem ) {
               return jQuery.event.trigger( type, data, elem, true );
           }
       }
   } );
   
   
   // Support: Firefox <=44
   // Firefox doesn't have focus(in | out) events
   // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
   //
   // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
   // focus(in | out) events fire after focus & blur events,
   // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
   // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
   if ( !support.focusin ) {
       jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
   
           // Attach a single capturing handler on the document while someone wants focusin/focusout
           var handler = function( event ) {
               jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
           };
   
           jQuery.event.special[ fix ] = {
               setup: function() {
                   var doc = this.ownerDocument || this,
                       attaches = dataPriv.access( doc, fix );
   
                   if ( !attaches ) {
                       doc.addEventListener( orig, handler, true );
                   }
                   dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
               },
               teardown: function() {
                   var doc = this.ownerDocument || this,
                       attaches = dataPriv.access( doc, fix ) - 1;
   
                   if ( !attaches ) {
                       doc.removeEventListener( orig, handler, true );
                       dataPriv.remove( doc, fix );
   
                   } else {
                       dataPriv.access( doc, fix, attaches );
                   }
               }
           };
       } );
   }
   var location = window.location;
   
   var nonce = Date.now();
   
   var rquery = ( /\?/ );
   
   
   
   // Cross-browser xml parsing
   jQuery.parseXML = function( data ) {
       var xml;
       if ( !data || typeof data !== "string" ) {
           return null;
       }
   
       // Support: IE 9 - 11 only
       // IE throws on parseFromString with invalid input.
       try {
           xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
       } catch ( e ) {
           xml = undefined;
       }
   
       if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
           jQuery.error( "Invalid XML: " + data );
       }
       return xml;
   };
   
   
   var
       rbracket = /\[\]$/,
       rCRLF = /\r?\n/g,
       rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
       rsubmittable = /^(?:input|select|textarea|keygen)/i;
   
   function buildParams( prefix, obj, traditional, add ) {
       var name;
   
       if ( Array.isArray( obj ) ) {
   
           // Serialize array item.
           jQuery.each( obj, function( i, v ) {
               if ( traditional || rbracket.test( prefix ) ) {
   
                   // Treat each array item as a scalar.
                   add( prefix, v );
   
               } else {
   
                   // Item is non-scalar (array or object), encode its numeric index.
                   buildParams(
                       prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
                       v,
                       traditional,
                       add
                   );
               }
           } );
   
       } else if ( !traditional && toType( obj ) === "object" ) {
   
           // Serialize object item.
           for ( name in obj ) {
               buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
           }
   
       } else {
   
           // Serialize scalar item.
           add( prefix, obj );
       }
   }
   
   // Serialize an array of form elements or a set of
   // key/values into a query string
   jQuery.param = function( a, traditional ) {
       var prefix,
           s = [],
           add = function( key, valueOrFunction ) {
   
               // If value is a function, invoke it and use its return value
               var value = isFunction( valueOrFunction ) ?
                   valueOrFunction() :
                   valueOrFunction;
   
               s[ s.length ] = encodeURIComponent( key ) + "=" +
                   encodeURIComponent( value == null ? "" : value );
           };
   
       // If an array was passed in, assume that it is an array of form elements.
       if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
   
           // Serialize the form elements
           jQuery.each( a, function() {
               add( this.name, this.value );
           } );
   
       } else {
   
           // If traditional, encode the "old" way (the way 1.3.2 or older
           // did it), otherwise encode params recursively.
           for ( prefix in a ) {
               buildParams( prefix, a[ prefix ], traditional, add );
           }
       }
   
       // Return the resulting serialization
       return s.join( "&" );
   };
   
   jQuery.fn.extend( {
       serialize: function() {
           return jQuery.param( this.serializeArray() );
       },
       serializeArray: function() {
           return this.map( function() {
   
               // Can add propHook for "elements" to filter or add form elements
               var elements = jQuery.prop( this, "elements" );
               return elements ? jQuery.makeArray( elements ) : this;
           } )
           .filter( function() {
               var type = this.type;
   
               // Use .is( ":disabled" ) so that fieldset[disabled] works
               return this.name && !jQuery( this ).is( ":disabled" ) &&
                   rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
                   ( this.checked || !rcheckableType.test( type ) );
           } )
           .map( function( i, elem ) {
               var val = jQuery( this ).val();
   
               if ( val == null ) {
                   return null;
               }
   
               if ( Array.isArray( val ) ) {
                   return jQuery.map( val, function( val ) {
                       return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                   } );
               }
   
               return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
           } ).get();
       }
   } );
   
   
   var
       r20 = /%20/g,
       rhash = /#.*$/,
       rantiCache = /([?&])_=[^&]*/,
       rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
   
       // #7653, #8125, #8152: local protocol detection
       rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
       rnoContent = /^(?:GET|HEAD)$/,
       rprotocol = /^\/\//,
   
       /* Prefilters
        * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
        * 2) These are called:
        *    - BEFORE asking for a transport
        *    - AFTER param serialization (s.data is a string if s.processData is true)
        * 3) key is the dataType
        * 4) the catchall symbol "*" can be used
        * 5) execution will start with transport dataType and THEN continue down to "*" if needed
        */
       prefilters = {},
   
       /* Transports bindings
        * 1) key is the dataType
        * 2) the catchall symbol "*" can be used
        * 3) selection will start with transport dataType and THEN go to "*" if needed
        */
       transports = {},
   
       // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
       allTypes = "*/".concat( "*" ),
   
       // Anchor tag for parsing the document origin
       originAnchor = document.createElement( "a" );
       originAnchor.href = location.href;
   
   // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
   function addToPrefiltersOrTransports( structure ) {
   
       // dataTypeExpression is optional and defaults to "*"
       return function( dataTypeExpression, func ) {
   
           if ( typeof dataTypeExpression !== "string" ) {
               func = dataTypeExpression;
               dataTypeExpression = "*";
           }
   
           var dataType,
               i = 0,
               dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
   
           if ( isFunction( func ) ) {
   
               // For each dataType in the dataTypeExpression
               while ( ( dataType = dataTypes[ i++ ] ) ) {
   
                   // Prepend if requested
                   if ( dataType[ 0 ] === "+" ) {
                       dataType = dataType.slice( 1 ) || "*";
                       ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
   
                   // Otherwise append
                   } else {
                       ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
                   }
               }
           }
       };
   }
   
   // Base inspection function for prefilters and transports
   function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
   
       var inspected = {},
           seekingTransport = ( structure === transports );
   
       function inspect( dataType ) {
           var selected;
           inspected[ dataType ] = true;
           jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
               var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
               if ( typeof dataTypeOrTransport === "string" &&
                   !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
   
                   options.dataTypes.unshift( dataTypeOrTransport );
                   inspect( dataTypeOrTransport );
                   return false;
               } else if ( seekingTransport ) {
                   return !( selected = dataTypeOrTransport );
               }
           } );
           return selected;
       }
   
       return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
   }
   
   // A special extend for ajax options
   // that takes "flat" options (not to be deep extended)
   // Fixes #9887
   function ajaxExtend( target, src ) {
       var key, deep,
           flatOptions = jQuery.ajaxSettings.flatOptions || {};
   
       for ( key in src ) {
           if ( src[ key ] !== undefined ) {
               ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
           }
       }
       if ( deep ) {
           jQuery.extend( true, target, deep );
       }
   
       return target;
   }
   
   /* Handles responses to an ajax request:
    * - finds the right dataType (mediates between content-type and expected dataType)
    * - returns the corresponding response
    */
   function ajaxHandleResponses( s, jqXHR, responses ) {
   
       var ct, type, finalDataType, firstDataType,
           contents = s.contents,
           dataTypes = s.dataTypes;
   
       // Remove auto dataType and get content-type in the process
       while ( dataTypes[ 0 ] === "*" ) {
           dataTypes.shift();
           if ( ct === undefined ) {
               ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
           }
       }
   
       // Check if we're dealing with a known content-type
       if ( ct ) {
           for ( type in contents ) {
               if ( contents[ type ] && contents[ type ].test( ct ) ) {
                   dataTypes.unshift( type );
                   break;
               }
           }
       }
   
       // Check to see if we have a response for the expected dataType
       if ( dataTypes[ 0 ] in responses ) {
           finalDataType = dataTypes[ 0 ];
       } else {
   
           // Try convertible dataTypes
           for ( type in responses ) {
               if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
                   finalDataType = type;
                   break;
               }
               if ( !firstDataType ) {
                   firstDataType = type;
               }
           }
   
           // Or just use first one
           finalDataType = finalDataType || firstDataType;
       }
   
       // If we found a dataType
       // We add the dataType to the list if needed
       // and return the corresponding response
       if ( finalDataType ) {
           if ( finalDataType !== dataTypes[ 0 ] ) {
               dataTypes.unshift( finalDataType );
           }
           return responses[ finalDataType ];
       }
   }
   
   /* Chain conversions given the request and the original response
    * Also sets the responseXXX fields on the jqXHR instance
    */
   function ajaxConvert( s, response, jqXHR, isSuccess ) {
       var conv2, current, conv, tmp, prev,
           converters = {},
   
           // Work with a copy of dataTypes in case we need to modify it for conversion
           dataTypes = s.dataTypes.slice();
   
       // Create converters map with lowercased keys
       if ( dataTypes[ 1 ] ) {
           for ( conv in s.converters ) {
               converters[ conv.toLowerCase() ] = s.converters[ conv ];
           }
       }
   
       current = dataTypes.shift();
   
       // Convert to each sequential dataType
       while ( current ) {
   
           if ( s.responseFields[ current ] ) {
               jqXHR[ s.responseFields[ current ] ] = response;
           }
   
           // Apply the dataFilter if provided
           if ( !prev && isSuccess && s.dataFilter ) {
               response = s.dataFilter( response, s.dataType );
           }
   
           prev = current;
           current = dataTypes.shift();
   
           if ( current ) {
   
               // There's only work to do if current dataType is non-auto
               if ( current === "*" ) {
   
                   current = prev;
   
               // Convert response if prev dataType is non-auto and differs from current
               } else if ( prev !== "*" && prev !== current ) {
   
                   // Seek a direct converter
                   conv = converters[ prev + " " + current ] || converters[ "* " + current ];
   
                   // If none found, seek a pair
                   if ( !conv ) {
                       for ( conv2 in converters ) {
   
                           // If conv2 outputs current
                           tmp = conv2.split( " " );
                           if ( tmp[ 1 ] === current ) {
   
                               // If prev can be converted to accepted input
                               conv = converters[ prev + " " + tmp[ 0 ] ] ||
                                   converters[ "* " + tmp[ 0 ] ];
                               if ( conv ) {
   
                                   // Condense equivalence converters
                                   if ( conv === true ) {
                                       conv = converters[ conv2 ];
   
                                   // Otherwise, insert the intermediate dataType
                                   } else if ( converters[ conv2 ] !== true ) {
                                       current = tmp[ 0 ];
                                       dataTypes.unshift( tmp[ 1 ] );
                                   }
                                   break;
                               }
                           }
                       }
                   }
   
                   // Apply converter (if not an equivalence)
                   if ( conv !== true ) {
   
                       // Unless errors are allowed to bubble, catch and return them
                       if ( conv && s.throws ) {
                           response = conv( response );
                       } else {
                           try {
                               response = conv( response );
                           } catch ( e ) {
                               return {
                                   state: "parsererror",
                                   error: conv ? e : "No conversion from " + prev + " to " + current
                               };
                           }
                       }
                   }
               }
           }
       }
   
       return { state: "success", data: response };
   }
   
   jQuery.extend( {
   
       // Counter for holding the number of active queries
       active: 0,
   
       // Last-Modified header cache for next request
       lastModified: {},
       etag: {},
   
       ajaxSettings: {
           url: location.href,
           type: "GET",
           isLocal: rlocalProtocol.test( location.protocol ),
           global: true,
           processData: true,
           async: true,
           contentType: "application/x-www-form-urlencoded; charset=UTF-8",
   
           /*
           timeout: 0,
           data: null,
           dataType: null,
           username: null,
           password: null,
           cache: null,
           throws: false,
           traditional: false,
           headers: {},
           */
   
           accepts: {
               "*": allTypes,
               text: "text/plain",
               html: "text/html",
               xml: "application/xml, text/xml",
               json: "application/json, text/javascript"
           },
   
           contents: {
               xml: /\bxml\b/,
               html: /\bhtml/,
               json: /\bjson\b/
           },
   
           responseFields: {
               xml: "responseXML",
               text: "responseText",
               json: "responseJSON"
           },
   
           // Data converters
           // Keys separate source (or catchall "*") and destination types with a single space
           converters: {
   
               // Convert anything to text
               "* text": String,
   
               // Text to html (true = no transformation)
               "text html": true,
   
               // Evaluate text as a json expression
               "text json": JSON.parse,
   
               // Parse text as xml
               "text xml": jQuery.parseXML
           },
   
           // For options that shouldn't be deep extended:
           // you can add your own custom options here if
           // and when you create one that shouldn't be
           // deep extended (see ajaxExtend)
           flatOptions: {
               url: true,
               context: true
           }
       },
   
       // Creates a full fledged settings object into target
       // with both ajaxSettings and settings fields.
       // If target is omitted, writes into ajaxSettings.
       ajaxSetup: function( target, settings ) {
           return settings ?
   
               // Building a settings object
               ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
   
               // Extending ajaxSettings
               ajaxExtend( jQuery.ajaxSettings, target );
       },
   
       ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
       ajaxTransport: addToPrefiltersOrTransports( transports ),
   
       // Main method
       ajax: function( url, options ) {
   
           // If url is an object, simulate pre-1.5 signature
           if ( typeof url === "object" ) {
               options = url;
               url = undefined;
           }
   
           // Force options to be an object
           options = options || {};
   
           var transport,
   
               // URL without anti-cache param
               cacheURL,
   
               // Response headers
               responseHeadersString,
               responseHeaders,
   
               // timeout handle
               timeoutTimer,
   
               // Url cleanup var
               urlAnchor,
   
               // Request state (becomes false upon send and true upon completion)
               completed,
   
               // To know if global events are to be dispatched
               fireGlobals,
   
               // Loop variable
               i,
   
               // uncached part of the url
               uncached,
   
               // Create the final options object
               s = jQuery.ajaxSetup( {}, options ),
   
               // Callbacks context
               callbackContext = s.context || s,
   
               // Context for global events is callbackContext if it is a DOM node or jQuery collection
               globalEventContext = s.context &&
                   ( callbackContext.nodeType || callbackContext.jquery ) ?
                       jQuery( callbackContext ) :
                       jQuery.event,
   
               // Deferreds
               deferred = jQuery.Deferred(),
               completeDeferred = jQuery.Callbacks( "once memory" ),
   
               // Status-dependent callbacks
               statusCode = s.statusCode || {},
   
               // Headers (they are sent all at once)
               requestHeaders = {},
               requestHeadersNames = {},
   
               // Default abort message
               strAbort = "canceled",
   
               // Fake xhr
               jqXHR = {
                   readyState: 0,
   
                   // Builds headers hashtable if needed
                   getResponseHeader: function( key ) {
                       var match;
                       if ( completed ) {
                           if ( !responseHeaders ) {
                               responseHeaders = {};
                               while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
                                   responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
                               }
                           }
                           match = responseHeaders[ key.toLowerCase() ];
                       }
                       return match == null ? null : match;
                   },
   
                   // Raw string
                   getAllResponseHeaders: function() {
                       return completed ? responseHeadersString : null;
                   },
   
                   // Caches the header
                   setRequestHeader: function( name, value ) {
                       if ( completed == null ) {
                           name = requestHeadersNames[ name.toLowerCase() ] =
                               requestHeadersNames[ name.toLowerCase() ] || name;
                           requestHeaders[ name ] = value;
                       }
                       return this;
                   },
   
                   // Overrides response content-type header
                   overrideMimeType: function( type ) {
                       if ( completed == null ) {
                           s.mimeType = type;
                       }
                       return this;
                   },
   
                   // Status-dependent callbacks
                   statusCode: function( map ) {
                       var code;
                       if ( map ) {
                           if ( completed ) {
   
                               // Execute the appropriate callbacks
                               jqXHR.always( map[ jqXHR.status ] );
                           } else {
   
                               // Lazy-add the new callbacks in a way that preserves old ones
                               for ( code in map ) {
                                   statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
                               }
                           }
                       }
                       return this;
                   },
   
                   // Cancel the request
                   abort: function( statusText ) {
                       var finalText = statusText || strAbort;
                       if ( transport ) {
                           transport.abort( finalText );
                       }
                       done( 0, finalText );
                       return this;
                   }
               };
   
           // Attach deferreds
           deferred.promise( jqXHR );
   
           // Add protocol if not provided (prefilters might expect it)
           // Handle falsy url in the settings object (#10093: consistency with old signature)
           // We also use the url parameter if available
           s.url = ( ( url || s.url || location.href ) + "" )
               .replace( rprotocol, location.protocol + "//" );
   
           // Alias method option to type as per ticket #12004
           s.type = options.method || options.type || s.method || s.type;
   
           // Extract dataTypes list
           s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
   
           // A cross-domain request is in order when the origin doesn't match the current origin.
           if ( s.crossDomain == null ) {
               urlAnchor = document.createElement( "a" );
   
               // Support: IE <=8 - 11, Edge 12 - 15
               // IE throws exception on accessing the href property if url is malformed,
               // e.g. http://example.com:80x/
               try {
                   urlAnchor.href = s.url;
   
                   // Support: IE <=8 - 11 only
                   // Anchor's host property isn't correctly set when s.url is relative
                   urlAnchor.href = urlAnchor.href;
                   s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
                       urlAnchor.protocol + "//" + urlAnchor.host;
               } catch ( e ) {
   
                   // If there is an error parsing the URL, assume it is crossDomain,
                   // it can be rejected by the transport if it is invalid
                   s.crossDomain = true;
               }
           }
   
           // Convert data if not already a string
           if ( s.data && s.processData && typeof s.data !== "string" ) {
               s.data = jQuery.param( s.data, s.traditional );
           }
   
           // Apply prefilters
           inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
   
           // If request was aborted inside a prefilter, stop there
           if ( completed ) {
               return jqXHR;
           }
   
           // We can fire global events as of now if asked to
           // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
           fireGlobals = jQuery.event && s.global;
   
           // Watch for a new set of requests
           if ( fireGlobals && jQuery.active++ === 0 ) {
               jQuery.event.trigger( "ajaxStart" );
           }
   
           // Uppercase the type
           s.type = s.type.toUpperCase();
   
           // Determine if request has content
           s.hasContent = !rnoContent.test( s.type );
   
           // Save the URL in case we're toying with the If-Modified-Since
           // and/or If-None-Match header later on
           // Remove hash to simplify url manipulation
           cacheURL = s.url.replace( rhash, "" );
   
           // More options handling for requests with no content
           if ( !s.hasContent ) {
   
               // Remember the hash so we can put it back
               uncached = s.url.slice( cacheURL.length );
   
               // If data is available and should be processed, append data to url
               if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
                   cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
   
                   // #9682: remove data so that it's not used in an eventual retry
                   delete s.data;
               }
   
               // Add or update anti-cache param if needed
               if ( s.cache === false ) {
                   cacheURL = cacheURL.replace( rantiCache, "$1" );
                   uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
               }
   
               // Put hash and anti-cache on the URL that will be requested (gh-1732)
               s.url = cacheURL + uncached;
   
           // Change '%20' to '+' if this is encoded form body content (gh-2658)
           } else if ( s.data && s.processData &&
               ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
               s.data = s.data.replace( r20, "+" );
           }
   
           // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
           if ( s.ifModified ) {
               if ( jQuery.lastModified[ cacheURL ] ) {
                   jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
               }
               if ( jQuery.etag[ cacheURL ] ) {
                   jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
               }
           }
   
           // Set the correct header, if data is being sent
           if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
               jqXHR.setRequestHeader( "Content-Type", s.contentType );
           }
   
           // Set the Accepts header for the server, depending on the dataType
           jqXHR.setRequestHeader(
               "Accept",
               s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
                   s.accepts[ s.dataTypes[ 0 ] ] +
                       ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
                   s.accepts[ "*" ]
           );
   
           // Check for headers option
           for ( i in s.headers ) {
               jqXHR.setRequestHeader( i, s.headers[ i ] );
           }
   
           // Allow custom headers/mimetypes and early abort
           if ( s.beforeSend &&
               ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
   
               // Abort if not done already and return
               return jqXHR.abort();
           }
   
           // Aborting is no longer a cancellation
           strAbort = "abort";
   
           // Install callbacks on deferreds
           completeDeferred.add( s.complete );
           jqXHR.done( s.success );
           jqXHR.fail( s.error );
   
           // Get transport
           transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
   
           // If no transport, we auto-abort
           if ( !transport ) {
               done( -1, "No Transport" );
           } else {
               jqXHR.readyState = 1;
   
               // Send global event
               if ( fireGlobals ) {
                   globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
               }
   
               // If request was aborted inside ajaxSend, stop there
               if ( completed ) {
                   return jqXHR;
               }
   
               // Timeout
               if ( s.async && s.timeout > 0 ) {
                   timeoutTimer = window.setTimeout( function() {
                       jqXHR.abort( "timeout" );
                   }, s.timeout );
               }
   
               try {
                   completed = false;
                   transport.send( requestHeaders, done );
               } catch ( e ) {
   
                   // Rethrow post-completion exceptions
                   if ( completed ) {
                       throw e;
                   }
   
                   // Propagate others as results
                   done( -1, e );
               }
           }
   
           // Callback for when everything is done
           function done( status, nativeStatusText, responses, headers ) {
               var isSuccess, success, error, response, modified,
                   statusText = nativeStatusText;
   
               // Ignore repeat invocations
               if ( completed ) {
                   return;
               }
   
               completed = true;
   
               // Clear timeout if it exists
               if ( timeoutTimer ) {
                   window.clearTimeout( timeoutTimer );
               }
   
               // Dereference transport for early garbage collection
               // (no matter how long the jqXHR object will be used)
               transport = undefined;
   
               // Cache response headers
               responseHeadersString = headers || "";
   
               // Set readyState
               jqXHR.readyState = status > 0 ? 4 : 0;
   
               // Determine if successful
               isSuccess = status >= 200 && status < 300 || status === 304;
   
               // Get response data
               if ( responses ) {
                   response = ajaxHandleResponses( s, jqXHR, responses );
               }
   
               // Convert no matter what (that way responseXXX fields are always set)
               response = ajaxConvert( s, response, jqXHR, isSuccess );
   
               // If successful, handle type chaining
               if ( isSuccess ) {
   
                   // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                   if ( s.ifModified ) {
                       modified = jqXHR.getResponseHeader( "Last-Modified" );
                       if ( modified ) {
                           jQuery.lastModified[ cacheURL ] = modified;
                       }
                       modified = jqXHR.getResponseHeader( "etag" );
                       if ( modified ) {
                           jQuery.etag[ cacheURL ] = modified;
                       }
                   }
   
                   // if no content
                   if ( status === 204 || s.type === "HEAD" ) {
                       statusText = "nocontent";
   
                   // if not modified
                   } else if ( status === 304 ) {
                       statusText = "notmodified";
   
                   // If we have data, let's convert it
                   } else {
                       statusText = response.state;
                       success = response.data;
                       error = response.error;
                       isSuccess = !error;
                   }
               } else {
   
                   // Extract error from statusText and normalize for non-aborts
                   error = statusText;
                   if ( status || !statusText ) {
                       statusText = "error";
                       if ( status < 0 ) {
                           status = 0;
                       }
                   }
               }
   
               // Set data for the fake xhr object
               jqXHR.status = status;
               jqXHR.statusText = ( nativeStatusText || statusText ) + "";
   
               // Success/Error
               if ( isSuccess ) {
                   deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
               } else {
                   deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
               }
   
               // Status-dependent callbacks
               jqXHR.statusCode( statusCode );
               statusCode = undefined;
   
               if ( fireGlobals ) {
                   globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
                       [ jqXHR, s, isSuccess ? success : error ] );
               }
   
               // Complete
               completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
   
               if ( fireGlobals ) {
                   globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
   
                   // Handle the global AJAX counter
                   if ( !( --jQuery.active ) ) {
                       jQuery.event.trigger( "ajaxStop" );
                   }
               }
           }
   
           return jqXHR;
       },
   
       getJSON: function( url, data, callback ) {
           return jQuery.get( url, data, callback, "json" );
       },
   
       getScript: function( url, callback ) {
           return jQuery.get( url, undefined, callback, "script" );
       }
   } );
   
   jQuery.each( [ "get", "post" ], function( i, method ) {
       jQuery[ method ] = function( url, data, callback, type ) {
   
           // Shift arguments if data argument was omitted
           if ( isFunction( data ) ) {
               type = type || callback;
               callback = data;
               data = undefined;
           }
   
           // The url can be an options object (which then must have .url)
           return jQuery.ajax( jQuery.extend( {
               url: url,
               type: method,
               dataType: type,
               data: data,
               success: callback
           }, jQuery.isPlainObject( url ) && url ) );
       };
   } );
   
   
   jQuery._evalUrl = function( url ) {
       return jQuery.ajax( {
           url: url,
   
           // Make this explicit, since user can override this through ajaxSetup (#11264)
           type: "GET",
           dataType: "script",
           cache: true,
           async: false,
           global: false,
           "throws": true
       } );
   };
   
   
   jQuery.fn.extend( {
       wrapAll: function( html ) {
           var wrap;
   
           if ( this[ 0 ] ) {
               if ( isFunction( html ) ) {
                   html = html.call( this[ 0 ] );
               }
   
               // The elements to wrap the target around
               wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
   
               if ( this[ 0 ].parentNode ) {
                   wrap.insertBefore( this[ 0 ] );
               }
   
               wrap.map( function() {
                   var elem = this;
   
                   while ( elem.firstElementChild ) {
                       elem = elem.firstElementChild;
                   }
   
                   return elem;
               } ).append( this );
           }
   
           return this;
       },
   
       wrapInner: function( html ) {
           if ( isFunction( html ) ) {
               return this.each( function( i ) {
                   jQuery( this ).wrapInner( html.call( this, i ) );
               } );
           }
   
           return this.each( function() {
               var self = jQuery( this ),
                   contents = self.contents();
   
               if ( contents.length ) {
                   contents.wrapAll( html );
   
               } else {
                   self.append( html );
               }
           } );
       },
   
       wrap: function( html ) {
           var htmlIsFunction = isFunction( html );
   
           return this.each( function( i ) {
               jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
           } );
       },
   
       unwrap: function( selector ) {
           this.parent( selector ).not( "body" ).each( function() {
               jQuery( this ).replaceWith( this.childNodes );
           } );
           return this;
       }
   } );
   
   
   jQuery.expr.pseudos.hidden = function( elem ) {
       return !jQuery.expr.pseudos.visible( elem );
   };
   jQuery.expr.pseudos.visible = function( elem ) {
       return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
   };
   
   
   
   
   jQuery.ajaxSettings.xhr = function() {
       try {
           return new window.XMLHttpRequest();
       } catch ( e ) {}
   };
   
   var xhrSuccessStatus = {
   
           // File protocol always yields status code 0, assume 200
           0: 200,
   
           // Support: IE <=9 only
           // #1450: sometimes IE returns 1223 when it should be 204
           1223: 204
       },
       xhrSupported = jQuery.ajaxSettings.xhr();
   
   support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
   support.ajax = xhrSupported = !!xhrSupported;
   
   jQuery.ajaxTransport( function( options ) {
       var callback, errorCallback;
   
       // Cross domain only allowed if supported through XMLHttpRequest
       if ( support.cors || xhrSupported && !options.crossDomain ) {
           return {
               send: function( headers, complete ) {
                   var i,
                       xhr = options.xhr();
   
                   xhr.open(
                       options.type,
                       options.url,
                       options.async,
                       options.username,
                       options.password
                   );
   
                   // Apply custom fields if provided
                   if ( options.xhrFields ) {
                       for ( i in options.xhrFields ) {
                           xhr[ i ] = options.xhrFields[ i ];
                       }
                   }
   
                   // Override mime type if needed
                   if ( options.mimeType && xhr.overrideMimeType ) {
                       xhr.overrideMimeType( options.mimeType );
                   }
   
                   // X-Requested-With header
                   // For cross-domain requests, seeing as conditions for a preflight are
                   // akin to a jigsaw puzzle, we simply never set it to be sure.
                   // (it can always be set on a per-request basis or even using ajaxSetup)
                   // For same-domain requests, won't change header if already provided.
                   if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
                       headers[ "X-Requested-With" ] = "XMLHttpRequest";
                   }
   
                   // Set headers
                   for ( i in headers ) {
                       xhr.setRequestHeader( i, headers[ i ] );
                   }
   
                   // Callback
                   callback = function( type ) {
                       return function() {
                           if ( callback ) {
                               callback = errorCallback = xhr.onload =
                                   xhr.onerror = xhr.onabort = xhr.ontimeout =
                                       xhr.onreadystatechange = null;
   
                               if ( type === "abort" ) {
                                   xhr.abort();
                               } else if ( type === "error" ) {
   
                                   // Support: IE <=9 only
                                   // On a manual native abort, IE9 throws
                                   // errors on any property access that is not readyState
                                   if ( typeof xhr.status !== "number" ) {
                                       complete( 0, "error" );
                                   } else {
                                       complete(
   
                                           // File: protocol always yields status 0; see #8605, #14207
                                           xhr.status,
                                           xhr.statusText
                                       );
                                   }
                               } else {
                                   complete(
                                       xhrSuccessStatus[ xhr.status ] || xhr.status,
                                       xhr.statusText,
   
                                       // Support: IE <=9 only
                                       // IE9 has no XHR2 but throws on binary (trac-11426)
                                       // For XHR2 non-text, let the caller handle it (gh-2498)
                                       ( xhr.responseType || "text" ) !== "text"  ||
                                       typeof xhr.responseText !== "string" ?
                                           { binary: xhr.response } :
                                           { text: xhr.responseText },
                                       xhr.getAllResponseHeaders()
                                   );
                               }
                           }
                       };
                   };
   
                   // Listen to events
                   xhr.onload = callback();
                   errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
   
                   // Support: IE 9 only
                   // Use onreadystatechange to replace onabort
                   // to handle uncaught aborts
                   if ( xhr.onabort !== undefined ) {
                       xhr.onabort = errorCallback;
                   } else {
                       xhr.onreadystatechange = function() {
   
                           // Check readyState before timeout as it changes
                           if ( xhr.readyState === 4 ) {
   
                               // Allow onerror to be called first,
                               // but that will not handle a native abort
                               // Also, save errorCallback to a variable
                               // as xhr.onerror cannot be accessed
                               window.setTimeout( function() {
                                   if ( callback ) {
                                       errorCallback();
                                   }
                               } );
                           }
                       };
                   }
   
                   // Create the abort callback
                   callback = callback( "abort" );
   
                   try {
   
                       // Do send the request (this may raise an exception)
                       xhr.send( options.hasContent && options.data || null );
                   } catch ( e ) {
   
                       // #14683: Only rethrow if this hasn't been notified as an error yet
                       if ( callback ) {
                           throw e;
                       }
                   }
               },
   
               abort: function() {
                   if ( callback ) {
                       callback();
                   }
               }
           };
       }
   } );
   
   
   
   
   // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
   jQuery.ajaxPrefilter( function( s ) {
       if ( s.crossDomain ) {
           s.contents.script = false;
       }
   } );
   
   // Install script dataType
   jQuery.ajaxSetup( {
       accepts: {
           script: "text/javascript, application/javascript, " +
               "application/ecmascript, application/x-ecmascript"
       },
       contents: {
           script: /\b(?:java|ecma)script\b/
       },
       converters: {
           "text script": function( text ) {
               jQuery.globalEval( text );
               return text;
           }
       }
   } );
   
   // Handle cache's special case and crossDomain
   jQuery.ajaxPrefilter( "script", function( s ) {
       if ( s.cache === undefined ) {
           s.cache = false;
       }
       if ( s.crossDomain ) {
           s.type = "GET";
       }
   } );
   
   // Bind script tag hack transport
   jQuery.ajaxTransport( "script", function( s ) {
   
       // This transport only deals with cross domain requests
       if ( s.crossDomain ) {
           var script, callback;
           return {
               send: function( _, complete ) {
                   script = jQuery( "<script>" ).prop( {
                       charset: s.scriptCharset,
                       src: s.url
                   } ).on(
                       "load error",
                       callback = function( evt ) {
                           script.remove();
                           callback = null;
                           if ( evt ) {
                               complete( evt.type === "error" ? 404 : 200, evt.type );
                           }
                       }
                   );
   
                   // Use native DOM manipulation to avoid our domManip AJAX trickery
                   document.head.appendChild( script[ 0 ] );
               },
               abort: function() {
                   if ( callback ) {
                       callback();
                   }
               }
           };
       }
   } );
   
   
   
   
   var oldCallbacks = [],
       rjsonp = /(=)\?(?=&|$)|\?\?/;
   
   // Default jsonp settings
   jQuery.ajaxSetup( {
       jsonp: "callback",
       jsonpCallback: function() {
           var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
           this[ callback ] = true;
           return callback;
       }
   } );
   
   // Detect, normalize options and install callbacks for jsonp requests
   jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
   
       var callbackName, overwritten, responseContainer,
           jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
               "url" :
               typeof s.data === "string" &&
                   ( s.contentType || "" )
                       .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
                   rjsonp.test( s.data ) && "data"
           );
   
       // Handle iff the expected data type is "jsonp" or we have a parameter to set
       if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
   
           // Get callback name, remembering preexisting value associated with it
           callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
               s.jsonpCallback() :
               s.jsonpCallback;
   
           // Insert callback into url or form data
           if ( jsonProp ) {
               s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
           } else if ( s.jsonp !== false ) {
               s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
           }
   
           // Use data converter to retrieve json after script execution
           s.converters[ "script json" ] = function() {
               if ( !responseContainer ) {
                   jQuery.error( callbackName + " was not called" );
               }
               return responseContainer[ 0 ];
           };
   
           // Force json dataType
           s.dataTypes[ 0 ] = "json";
   
           // Install callback
           overwritten = window[ callbackName ];
           window[ callbackName ] = function() {
               responseContainer = arguments;
           };
   
           // Clean-up function (fires after converters)
           jqXHR.always( function() {
   
               // If previous value didn't exist - remove it
               if ( overwritten === undefined ) {
                   jQuery( window ).removeProp( callbackName );
   
               // Otherwise restore preexisting value
               } else {
                   window[ callbackName ] = overwritten;
               }
   
               // Save back as free
               if ( s[ callbackName ] ) {
   
                   // Make sure that re-using the options doesn't screw things around
                   s.jsonpCallback = originalSettings.jsonpCallback;
   
                   // Save the callback name for future use
                   oldCallbacks.push( callbackName );
               }
   
               // Call if it was a function and we have a response
               if ( responseContainer && isFunction( overwritten ) ) {
                   overwritten( responseContainer[ 0 ] );
               }
   
               responseContainer = overwritten = undefined;
           } );
   
           // Delegate to script
           return "script";
       }
   } );
   
   
   
   
   // Support: Safari 8 only
   // In Safari 8 documents created via document.implementation.createHTMLDocument
   // collapse sibling forms: the second one becomes a child of the first one.
   // Because of that, this security measure has to be disabled in Safari 8.
   // https://bugs.webkit.org/show_bug.cgi?id=137337
   support.createHTMLDocument = ( function() {
       var body = document.implementation.createHTMLDocument( "" ).body;
       body.innerHTML = "<form></form><form></form>";
       return body.childNodes.length === 2;
   } )();
   
   
   // Argument "data" should be string of html
   // context (optional): If specified, the fragment will be created in this context,
   // defaults to document
   // keepScripts (optional): If true, will include scripts passed in the html string
   jQuery.parseHTML = function( data, context, keepScripts ) {
       if ( typeof data !== "string" ) {
           return [];
       }
       if ( typeof context === "boolean" ) {
           keepScripts = context;
           context = false;
       }
   
       var base, parsed, scripts;
   
       if ( !context ) {
   
           // Stop scripts or inline event handlers from being executed immediately
           // by using document.implementation
           if ( support.createHTMLDocument ) {
               context = document.implementation.createHTMLDocument( "" );
   
               // Set the base href for the created document
               // so any parsed elements with URLs
               // are based on the document's URL (gh-2965)
               base = context.createElement( "base" );
               base.href = document.location.href;
               context.head.appendChild( base );
           } else {
               context = document;
           }
       }
   
       parsed = rsingleTag.exec( data );
       scripts = !keepScripts && [];
   
       // Single tag
       if ( parsed ) {
           return [ context.createElement( parsed[ 1 ] ) ];
       }
   
       parsed = buildFragment( [ data ], context, scripts );
   
       if ( scripts && scripts.length ) {
           jQuery( scripts ).remove();
       }
   
       return jQuery.merge( [], parsed.childNodes );
   };
   
   
   /**
    * Load a url into a page
    */
   jQuery.fn.load = function( url, params, callback ) {
       var selector, type, response,
           self = this,
           off = url.indexOf( " " );
   
       if ( off > -1 ) {
           selector = stripAndCollapse( url.slice( off ) );
           url = url.slice( 0, off );
       }
   
       // If it's a function
       if ( isFunction( params ) ) {
   
           // We assume that it's the callback
           callback = params;
           params = undefined;
   
       // Otherwise, build a param string
       } else if ( params && typeof params === "object" ) {
           type = "POST";
       }
   
       // If we have elements to modify, make the request
       if ( self.length > 0 ) {
           jQuery.ajax( {
               url: url,
   
               // If "type" variable is undefined, then "GET" method will be used.
               // Make value of this field explicit since
               // user can override it through ajaxSetup method
               type: type || "GET",
               dataType: "html",
               data: params
           } ).done( function( responseText ) {
   
               // Save response for use in complete callback
               response = arguments;
   
               self.html( selector ?
   
                   // If a selector was specified, locate the right elements in a dummy div
                   // Exclude scripts to avoid IE 'Permission Denied' errors
                   jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
   
                   // Otherwise use the full result
                   responseText );
   
           // If the request succeeds, this function gets "data", "status", "jqXHR"
           // but they are ignored because response was set above.
           // If it fails, this function gets "jqXHR", "status", "error"
           } ).always( callback && function( jqXHR, status ) {
               self.each( function() {
                   callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
               } );
           } );
       }
   
       return this;
   };
   
   
   
   
   // Attach a bunch of functions for handling common AJAX events
   jQuery.each( [
       "ajaxStart",
       "ajaxStop",
       "ajaxComplete",
       "ajaxError",
       "ajaxSuccess",
       "ajaxSend"
   ], function( i, type ) {
       jQuery.fn[ type ] = function( fn ) {
           return this.on( type, fn );
       };
   } );
   
   
   
   
   jQuery.expr.pseudos.animated = function( elem ) {
       return jQuery.grep( jQuery.timers, function( fn ) {
           return elem === fn.elem;
       } ).length;
   };
   
   
   
   
   jQuery.offset = {
       setOffset: function( elem, options, i ) {
           var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
               position = jQuery.css( elem, "position" ),
               curElem = jQuery( elem ),
               props = {};
   
           // Set position first, in-case top/left are set even on static elem
           if ( position === "static" ) {
               elem.style.position = "relative";
           }
   
           curOffset = curElem.offset();
           curCSSTop = jQuery.css( elem, "top" );
           curCSSLeft = jQuery.css( elem, "left" );
           calculatePosition = ( position === "absolute" || position === "fixed" ) &&
               ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
   
           // Need to be able to calculate position if either
           // top or left is auto and position is either absolute or fixed
           if ( calculatePosition ) {
               curPosition = curElem.position();
               curTop = curPosition.top;
               curLeft = curPosition.left;
   
           } else {
               curTop = parseFloat( curCSSTop ) || 0;
               curLeft = parseFloat( curCSSLeft ) || 0;
           }
   
           if ( isFunction( options ) ) {
   
               // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
               options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
           }
   
           if ( options.top != null ) {
               props.top = ( options.top - curOffset.top ) + curTop;
           }
           if ( options.left != null ) {
               props.left = ( options.left - curOffset.left ) + curLeft;
           }
   
           if ( "using" in options ) {
               options.using.call( elem, props );
   
           } else {
               curElem.css( props );
           }
       }
   };
   
   jQuery.fn.extend( {
   
       // offset() relates an element's border box to the document origin
       offset: function( options ) {
   
           // Preserve chaining for setter
           if ( arguments.length ) {
               return options === undefined ?
                   this :
                   this.each( function( i ) {
                       jQuery.offset.setOffset( this, options, i );
                   } );
           }
   
           var rect, win,
               elem = this[ 0 ];
   
           if ( !elem ) {
               return;
           }
   
           // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
           // Support: IE <=11 only
           // Running getBoundingClientRect on a
           // disconnected node in IE throws an error
           if ( !elem.getClientRects().length ) {
               return { top: 0, left: 0 };
           }
   
           // Get document-relative position by adding viewport scroll to viewport-relative gBCR
           rect = elem.getBoundingClientRect();
           win = elem.ownerDocument.defaultView;
           return {
               top: rect.top + win.pageYOffset,
               left: rect.left + win.pageXOffset
           };
       },
   
       // position() relates an element's margin box to its offset parent's padding box
       // This corresponds to the behavior of CSS absolute positioning
       position: function() {
           if ( !this[ 0 ] ) {
               return;
           }
   
           var offsetParent, offset, doc,
               elem = this[ 0 ],
               parentOffset = { top: 0, left: 0 };
   
           // position:fixed elements are offset from the viewport, which itself always has zero offset
           if ( jQuery.css( elem, "position" ) === "fixed" ) {
   
               // Assume position:fixed implies availability of getBoundingClientRect
               offset = elem.getBoundingClientRect();
   
           } else {
               offset = this.offset();
   
               // Account for the *real* offset parent, which can be the document or its root element
               // when a statically positioned element is identified
               doc = elem.ownerDocument;
               offsetParent = elem.offsetParent || doc.documentElement;
               while ( offsetParent &&
                   ( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
                   jQuery.css( offsetParent, "position" ) === "static" ) {
   
                   offsetParent = offsetParent.parentNode;
               }
               if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
   
                   // Incorporate borders into its offset, since they are outside its content origin
                   parentOffset = jQuery( offsetParent ).offset();
                   parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
                   parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
               }
           }
   
           // Subtract parent offsets and element margins
           return {
               top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
               left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
           };
       },
   
       // This method will return documentElement in the following cases:
       // 1) For the element inside the iframe without offsetParent, this method will return
       //    documentElement of the parent window
       // 2) For the hidden or detached element
       // 3) For body or html element, i.e. in case of the html node - it will return itself
       //
       // but those exceptions were never presented as a real life use-cases
       // and might be considered as more preferable results.
       //
       // This logic, however, is not guaranteed and can change at any point in the future
       offsetParent: function() {
           return this.map( function() {
               var offsetParent = this.offsetParent;
   
               while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
                   offsetParent = offsetParent.offsetParent;
               }
   
               return offsetParent || documentElement;
           } );
       }
   } );
   
   // Create scrollLeft and scrollTop methods
   jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
       var top = "pageYOffset" === prop;
   
       jQuery.fn[ method ] = function( val ) {
           return access( this, function( elem, method, val ) {
   
               // Coalesce documents and windows
               var win;
               if ( isWindow( elem ) ) {
                   win = elem;
               } else if ( elem.nodeType === 9 ) {
                   win = elem.defaultView;
               }
   
               if ( val === undefined ) {
                   return win ? win[ prop ] : elem[ method ];
               }
   
               if ( win ) {
                   win.scrollTo(
                       !top ? val : win.pageXOffset,
                       top ? val : win.pageYOffset
                   );
   
               } else {
                   elem[ method ] = val;
               }
           }, method, val, arguments.length );
       };
   } );
   
   // Support: Safari <=7 - 9.1, Chrome <=37 - 49
   // Add the top/left cssHooks using jQuery.fn.position
   // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
   // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
   // getComputedStyle returns percent when specified for top/left/bottom/right;
   // rather than make the css module depend on the offset module, just check for it here
   jQuery.each( [ "top", "left" ], function( i, prop ) {
       jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
           function( elem, computed ) {
               if ( computed ) {
                   computed = curCSS( elem, prop );
   
                   // If curCSS returns percentage, fallback to offset
                   return rnumnonpx.test( computed ) ?
                       jQuery( elem ).position()[ prop ] + "px" :
                       computed;
               }
           }
       );
   } );
   
   
   // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
   jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
       jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
           function( defaultExtra, funcName ) {
   
           // Margin is only for outerHeight, outerWidth
           jQuery.fn[ funcName ] = function( margin, value ) {
               var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
                   extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
   
               return access( this, function( elem, type, value ) {
                   var doc;
   
                   if ( isWindow( elem ) ) {
   
                       // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                       return funcName.indexOf( "outer" ) === 0 ?
                           elem[ "inner" + name ] :
                           elem.document.documentElement[ "client" + name ];
                   }
   
                   // Get document width or height
                   if ( elem.nodeType === 9 ) {
                       doc = elem.documentElement;
   
                       // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                       // whichever is greatest
                       return Math.max(
                           elem.body[ "scroll" + name ], doc[ "scroll" + name ],
                           elem.body[ "offset" + name ], doc[ "offset" + name ],
                           doc[ "client" + name ]
                       );
                   }
   
                   return value === undefined ?
   
                       // Get width or height on the element, requesting but not forcing parseFloat
                       jQuery.css( elem, type, extra ) :
   
                       // Set width or height on the element
                       jQuery.style( elem, type, value, extra );
               }, type, chainable ? margin : undefined, chainable );
           };
       } );
   } );
   
   
   jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
       "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
       "change select submit keydown keypress keyup contextmenu" ).split( " " ),
       function( i, name ) {
   
       // Handle event binding
       jQuery.fn[ name ] = function( data, fn ) {
           return arguments.length > 0 ?
               this.on( name, null, data, fn ) :
               this.trigger( name );
       };
   } );
   
   jQuery.fn.extend( {
       hover: function( fnOver, fnOut ) {
           return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
       }
   } );
   
   
   
   
   jQuery.fn.extend( {
   
       bind: function( types, data, fn ) {
           return this.on( types, null, data, fn );
       },
       unbind: function( types, fn ) {
           return this.off( types, null, fn );
       },
   
       delegate: function( selector, types, data, fn ) {
           return this.on( types, selector, data, fn );
       },
       undelegate: function( selector, types, fn ) {
   
           // ( namespace ) or ( selector, types [, fn] )
           return arguments.length === 1 ?
               this.off( selector, "**" ) :
               this.off( types, selector || "**", fn );
       }
   } );
   
   // Bind a function to a context, optionally partially applying any
   // arguments.
   // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
   // However, it is not slated for removal any time soon
   jQuery.proxy = function( fn, context ) {
       var tmp, args, proxy;
   
       if ( typeof context === "string" ) {
           tmp = fn[ context ];
           context = fn;
           fn = tmp;
       }
   
       // Quick check to determine if target is callable, in the spec
       // this throws a TypeError, but we will just return undefined.
       if ( !isFunction( fn ) ) {
           return undefined;
       }
   
       // Simulated bind
       args = slice.call( arguments, 2 );
       proxy = function() {
           return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
       };
   
       // Set the guid of unique handler to the same of original handler, so it can be removed
       proxy.guid = fn.guid = fn.guid || jQuery.guid++;
   
       return proxy;
   };
   
   jQuery.holdReady = function( hold ) {
       if ( hold ) {
           jQuery.readyWait++;
       } else {
           jQuery.ready( true );
       }
   };
   jQuery.isArray = Array.isArray;
   jQuery.parseJSON = JSON.parse;
   jQuery.nodeName = nodeName;
   jQuery.isFunction = isFunction;
   jQuery.isWindow = isWindow;
   jQuery.camelCase = camelCase;
   jQuery.type = toType;
   
   jQuery.now = Date.now;
   
   jQuery.isNumeric = function( obj ) {
   
       // As of jQuery 3.0, isNumeric is limited to
       // strings and numbers (primitives or objects)
       // that can be coerced to finite numbers (gh-2662)
       var type = jQuery.type( obj );
       return ( type === "number" || type === "string" ) &&
   
           // parseFloat NaNs numeric-cast false positives ("")
           // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
           // subtraction forces infinities to NaN
           !isNaN( obj - parseFloat( obj ) );
   };
   
   
   
   
   // Register as a named AMD module, since jQuery can be concatenated with other
   // files that may use define, but not via a proper concatenation script that
   // understands anonymous AMD modules. A named AMD is safest and most robust
   // way to register. Lowercase jquery is used because AMD module names are
   // derived from file names, and jQuery is normally delivered in a lowercase
   // file name. Do this after creating the global so that if an AMD module wants
   // to call noConflict to hide this version of jQuery, it will work.
   
   // Note that for maximum portability, libraries that are not jQuery should
   // declare themselves as anonymous modules, and avoid setting a global if an
   // AMD loader is present. jQuery is a special case. For more information, see
   // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
   
   if ( true ) {
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
           return jQuery;
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
   }
   
   
   
   
   var
   
       // Map over jQuery in case of overwrite
       _jQuery = window.jQuery,
   
       // Map over the $ in case of overwrite
       _$ = window.$;
   
   jQuery.noConflict = function( deep ) {
       if ( window.$ === jQuery ) {
           window.$ = _$;
       }
   
       if ( deep && window.jQuery === jQuery ) {
           window.jQuery = _jQuery;
       }
   
       return jQuery;
   };
   
   // Expose jQuery and $ identifiers, even in AMD
   // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
   // and CommonJS for browser emulators (#13566)
   if ( !noGlobal ) {
       window.jQuery = window.$ = jQuery;
   }
   
   
   
   
   return jQuery;
   } );
   
   
   /***/ }),
   /* 1 */
   /***/ (function(module, exports, __webpack_require__) {
   
   "use strict";
   
   
   Object.defineProperty(exports, '__esModule', { value: true });
   
   var moneyFormats = {
     USD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} USD'
     },
     EUR: {
       'money_format': '&euro;{{amount}}',
       'money_with_currency_format': '&euro;{{amount}} EUR'
     },
     GBP: {
       'money_format': '&pound;{{amount}}',
       'money_with_currency_format': '&pound;{{amount}} GBP'
     },
     CAD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} CAD'
     },
     ALL: {
       'money_format': 'Lek {{amount}}',
       'money_with_currency_format': 'Lek {{amount}} ALL'
     },
     DZD: {
       'money_format': 'DA {{amount}}',
       'money_with_currency_format': 'DA {{amount}} DZD'
     },
     AOA: {
       'money_format': 'Kz{{amount}}',
       'money_with_currency_format': 'Kz{{amount}} AOA'
     },
     ARS: {
       'money_format': '${{amount_with_comma_separator}}',
       'money_with_currency_format': '${{amount_with_comma_separator}} ARS'
     },
     AMD: {
       'money_format': '{{amount}} AMD',
       'money_with_currency_format': '{{amount}} AMD'
     },
     AWG: {
       'money_format': 'Afl{{amount}}',
       'money_with_currency_format': 'Afl{{amount}} AWG'
     },
     AUD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} AUD'
     },
     BBD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} Bds'
     },
     AZN: {
       'money_format': 'm.{{amount}}',
       'money_with_currency_format': 'm.{{amount}} AZN'
     },
     BDT: {
       'money_format': 'Tk {{amount}}',
       'money_with_currency_format': 'Tk {{amount}} BDT'
     },
     BSD: {
       'money_format': 'BS${{amount}}',
       'money_with_currency_format': 'BS${{amount}} BSD'
     },
     BHD: {
       'money_format': '{{amount}}0 BD',
       'money_with_currency_format': '{{amount}}0 BHD'
     },
     BYR: {
       'money_format': 'Br {{amount}}',
       'money_with_currency_format': 'Br {{amount}} BYR'
     },
     BZD: {
       'money_format': 'BZ${{amount}}',
       'money_with_currency_format': 'BZ${{amount}} BZD'
     },
     BTN: {
       'money_format': 'Nu {{amount}}',
       'money_with_currency_format': 'Nu {{amount}} BTN'
     },
     BAM: {
       'money_format': 'KM {{amount_with_comma_separator}}',
       'money_with_currency_format': 'KM {{amount_with_comma_separator}} BAM'
     },
     BRL: {
       'money_format': 'R$ {{amount_with_comma_separator}}',
       'money_with_currency_format': 'R$ {{amount_with_comma_separator}} BRL'
     },
     BOB: {
       'money_format': 'Bs{{amount_with_comma_separator}}',
       'money_with_currency_format': 'Bs{{amount_with_comma_separator}} BOB'
     },
     BWP: {
       'money_format': 'P{{amount}}',
       'money_with_currency_format': 'P{{amount}} BWP'
     },
     BND: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} BND'
     },
     BGN: {
       'money_format': '{{amount}} лв',
       'money_with_currency_format': '{{amount}} лв BGN'
     },
     MMK: {
       'money_format': 'K{{amount}}',
       'money_with_currency_format': 'K{{amount}} MMK'
     },
     KHR: {
       'money_format': 'KHR{{amount}}',
       'money_with_currency_format': 'KHR{{amount}}'
     },
     KYD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} KYD'
     },
     XAF: {
       'money_format': 'FCFA{{amount}}',
       'money_with_currency_format': 'FCFA{{amount}} XAF'
     },
     CLP: {
       'money_format': '${{amount_no_decimals}}',
       'money_with_currency_format': '${{amount_no_decimals}} CLP'
     },
     CNY: {
       'money_format': '&#165;{{amount}}',
       'money_with_currency_format': '&#165;{{amount}} CNY'
     },
     COP: {
       'money_format': '${{amount_with_comma_separator}}',
       'money_with_currency_format': '${{amount_with_comma_separator}} COP'
     },
     CRC: {
       'money_format': '&#8353; {{amount_with_comma_separator}}',
       'money_with_currency_format': '&#8353; {{amount_with_comma_separator}} CRC'
     },
     HRK: {
       'money_format': '{{amount_with_comma_separator}} kn',
       'money_with_currency_format': '{{amount_with_comma_separator}} kn HRK'
     },
     CZK: {
       'money_format': '{{amount_with_comma_separator}} K&#269;',
       'money_with_currency_format': '{{amount_with_comma_separator}} K&#269;'
     },
     DKK: {
       'money_format': '{{amount_with_comma_separator}}',
       'money_with_currency_format': 'kr.{{amount_with_comma_separator}}'
     },
     DOP: {
       'money_format': 'RD$ {{amount}}',
       'money_with_currency_format': 'RD$ {{amount}}'
     },
     XCD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': 'EC${{amount}}'
     },
     EGP: {
       'money_format': 'LE {{amount}}',
       'money_with_currency_format': 'LE {{amount}} EGP'
     },
     ETB: {
       'money_format': 'Br{{amount}}',
       'money_with_currency_format': 'Br{{amount}} ETB'
     },
     XPF: {
       'money_format': '{{amount_no_decimals_with_comma_separator}} XPF',
       'money_with_currency_format': '{{amount_no_decimals_with_comma_separator}} XPF'
     },
     FJD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': 'FJ${{amount}}'
     },
     GMD: {
       'money_format': 'D {{amount}}',
       'money_with_currency_format': 'D {{amount}} GMD'
     },
     GHS: {
       'money_format': 'GH&#8373;{{amount}}',
       'money_with_currency_format': 'GH&#8373;{{amount}}'
     },
     GTQ: {
       'money_format': 'Q{{amount}}',
       'money_with_currency_format': '{{amount}} GTQ'
     },
     GYD: {
       'money_format': 'G${{amount}}',
       'money_with_currency_format': '${{amount}} GYD'
     },
     GEL: {
       'money_format': '{{amount}} GEL',
       'money_with_currency_format': '{{amount}} GEL'
     },
     HNL: {
       'money_format': 'L {{amount}}',
       'money_with_currency_format': 'L {{amount}} HNL'
     },
     HKD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': 'HK${{amount}}'
     },
     HUF: {
       'money_format': '{{amount_no_decimals_with_comma_separator}}',
       'money_with_currency_format': '{{amount_no_decimals_with_comma_separator}} Ft'
     },
     ISK: {
       'money_format': '{{amount_no_decimals}} kr',
       'money_with_currency_format': '{{amount_no_decimals}} kr ISK'
     },
     INR: {
       'money_format': 'Rs. {{amount}}',
       'money_with_currency_format': 'Rs. {{amount}}'
     },
     IDR: {
       'money_format': '{{amount_with_comma_separator}}',
       'money_with_currency_format': 'Rp {{amount_with_comma_separator}}'
     },
     ILS: {
       'money_format': '{{amount}} NIS',
       'money_with_currency_format': '{{amount}} NIS'
     },
     JMD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} JMD'
     },
     JPY: {
       'money_format': '&#165;{{amount_no_decimals}}',
       'money_with_currency_format': '&#165;{{amount_no_decimals}} JPY'
     },
     JEP: {
       'money_format': '&pound;{{amount}}',
       'money_with_currency_format': '&pound;{{amount}} JEP'
     },
     JOD: {
       'money_format': '{{amount}}0 JD',
       'money_with_currency_format': '{{amount}}0 JOD'
     },
     KZT: {
       'money_format': '{{amount}} KZT',
       'money_with_currency_format': '{{amount}} KZT'
     },
     KES: {
       'money_format': 'KSh{{amount}}',
       'money_with_currency_format': 'KSh{{amount}}'
     },
     KWD: {
       'money_format': '{{amount}}0 KD',
       'money_with_currency_format': '{{amount}}0 KWD'
     },
     KGS: {
       'money_format': 'лв{{amount}}',
       'money_with_currency_format': 'лв{{amount}}'
     },
     LVL: {
       'money_format': 'Ls {{amount}}',
       'money_with_currency_format': 'Ls {{amount}} LVL'
     },
     LBP: {
       'money_format': 'L&pound;{{amount}}',
       'money_with_currency_format': 'L&pound;{{amount}} LBP'
     },
     LTL: {
       'money_format': '{{amount}} Lt',
       'money_with_currency_format': '{{amount}} Lt'
     },
     MGA: {
       'money_format': 'Ar {{amount}}',
       'money_with_currency_format': 'Ar {{amount}} MGA'
     },
     MKD: {
       'money_format': 'ден {{amount}}',
       'money_with_currency_format': 'ден {{amount}} MKD'
     },
     MOP: {
       'money_format': 'MOP${{amount}}',
       'money_with_currency_format': 'MOP${{amount}}'
     },
     MVR: {
       'money_format': 'Rf{{amount}}',
       'money_with_currency_format': 'Rf{{amount}} MRf'
     },
     MXN: {
       'money_format': '$ {{amount}}',
       'money_with_currency_format': '$ {{amount}} MXN'
     },
     MYR: {
       'money_format': 'RM{{amount}} MYR',
       'money_with_currency_format': 'RM{{amount}} MYR'
     },
     MUR: {
       'money_format': 'Rs {{amount}}',
       'money_with_currency_format': 'Rs {{amount}} MUR'
     },
     MDL: {
       'money_format': '{{amount}} MDL',
       'money_with_currency_format': '{{amount}} MDL'
     },
     MAD: {
       'money_format': '{{amount}} dh',
       'money_with_currency_format': 'Dh {{amount}} MAD'
     },
     MNT: {
       'money_format': '{{amount_no_decimals}} &#8366',
       'money_with_currency_format': '{{amount_no_decimals}} MNT'
     },
     MZN: {
       'money_format': '{{amount}} Mt',
       'money_with_currency_format': 'Mt {{amount}} MZN'
     },
     NAD: {
       'money_format': 'N${{amount}}',
       'money_with_currency_format': 'N${{amount}} NAD'
     },
     NPR: {
       'money_format': 'Rs{{amount}}',
       'money_with_currency_format': 'Rs{{amount}} NPR'
     },
     ANG: {
       'money_format': '&fnof;{{amount}}',
       'money_with_currency_format': '{{amount}} NA&fnof;'
     },
     NZD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} NZD'
     },
     NIO: {
       'money_format': 'C${{amount}}',
       'money_with_currency_format': 'C${{amount}} NIO'
     },
     NGN: {
       'money_format': '&#8358;{{amount}}',
       'money_with_currency_format': '&#8358;{{amount}} NGN'
     },
     NOK: {
       'money_format': 'kr {{amount_with_comma_separator}}',
       'money_with_currency_format': 'kr {{amount_with_comma_separator}} NOK'
     },
     OMR: {
       'money_format': '{{amount_with_comma_separator}} OMR',
       'money_with_currency_format': '{{amount_with_comma_separator}} OMR'
     },
     PKR: {
       'money_format': 'Rs.{{amount}}',
       'money_with_currency_format': 'Rs.{{amount}} PKR'
     },
     PGK: {
       'money_format': 'K {{amount}}',
       'money_with_currency_format': 'K {{amount}} PGK'
     },
     PYG: {
       'money_format': 'Gs. {{amount_no_decimals_with_comma_separator}}',
       'money_with_currency_format': 'Gs. {{amount_no_decimals_with_comma_separator}} PYG'
     },
     PEN: {
       'money_format': 'S/. {{amount}}',
       'money_with_currency_format': 'S/. {{amount}} PEN'
     },
     PHP: {
       'money_format': '&#8369;{{amount}}',
       'money_with_currency_format': '&#8369;{{amount}} PHP'
     },
     PLN: {
       'money_format': '{{amount_with_comma_separator}} zl',
       'money_with_currency_format': '{{amount_with_comma_separator}} zl PLN'
     },
     QAR: {
       'money_format': 'QAR {{amount_with_comma_separator}}',
       'money_with_currency_format': 'QAR {{amount_with_comma_separator}}'
     },
     RON: {
       'money_format': '{{amount_with_comma_separator}} lei',
       'money_with_currency_format': '{{amount_with_comma_separator}} lei RON'
     },
     RUB: {
       'money_format': '&#1088;&#1091;&#1073;{{amount_with_comma_separator}}',
       'money_with_currency_format': '&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB'
     },
     RWF: {
       'money_format': '{{amount_no_decimals}} RF',
       'money_with_currency_format': '{{amount_no_decimals}} RWF'
     },
     WST: {
       'money_format': 'WS$ {{amount}}',
       'money_with_currency_format': 'WS$ {{amount}} WST'
     },
     SAR: {
       'money_format': '{{amount}} SR',
       'money_with_currency_format': '{{amount}} SAR'
     },
     STD: {
       'money_format': 'Db {{amount}}',
       'money_with_currency_format': 'Db {{amount}} STD'
     },
     RSD: {
       'money_format': '{{amount}} RSD',
       'money_with_currency_format': '{{amount}} RSD'
     },
     SCR: {
       'money_format': 'Rs {{amount}}',
       'money_with_currency_format': 'Rs {{amount}} SCR'
     },
     SGD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} SGD'
     },
     SYP: {
       'money_format': 'S&pound;{{amount}}',
       'money_with_currency_format': 'S&pound;{{amount}} SYP'
     },
     ZAR: {
       'money_format': 'R {{amount}}',
       'money_with_currency_format': 'R {{amount}} ZAR'
     },
     KRW: {
       'money_format': '&#8361;{{amount_no_decimals}}',
       'money_with_currency_format': '&#8361;{{amount_no_decimals}} KRW'
     },
     LKR: {
       'money_format': 'Rs {{amount}}',
       'money_with_currency_format': 'Rs {{amount}} LKR'
     },
     SEK: {
       'money_format': '{{amount_no_decimals}} kr',
       'money_with_currency_format': '{{amount_no_decimals}} kr SEK'
     },
     CHF: {
       'money_format': 'SFr. {{amount}}',
       'money_with_currency_format': 'SFr. {{amount}} CHF'
     },
     TWD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} TWD'
     },
     THB: {
       'money_format': '{{amount}} &#xe3f;',
       'money_with_currency_format': '{{amount}} &#xe3f; THB'
     },
     TZS: {
       'money_format': '{{amount}} TZS',
       'money_with_currency_format': '{{amount}} TZS'
     },
     TTD: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}} TTD'
     },
     TND: {
       'money_format': '{{amount}}',
       'money_with_currency_format': '{{amount}} DT'
     },
     TRY: {
       'money_format': '{{amount}}TL',
       'money_with_currency_format': '{{amount}}TL'
     },
     UGX: {
       'money_format': 'Ush {{amount_no_decimals}}',
       'money_with_currency_format': 'Ush {{amount_no_decimals}} UGX'
     },
     UAH: {
       'money_format': '₴{{amount}}',
       'money_with_currency_format': '₴{{amount}} UAH'
     },
     AED: {
       'money_format': 'Dhs. {{amount}}',
       'money_with_currency_format': 'Dhs. {{amount}} AED'
     },
     UYU: {
       'money_format': '${{amount_with_comma_separator}}',
       'money_with_currency_format': '${{amount_with_comma_separator}} UYU'
     },
     VUV: {
       'money_format': '${{amount}}',
       'money_with_currency_format': '${{amount}}VT'
     },
     VEF: {
       'money_format': 'Bs. {{amount_with_comma_separator}}',
       'money_with_currency_format': 'Bs. {{amount_with_comma_separator}} VEF'
     },
     VND: {
       'money_format': '{{amount_no_decimals_with_comma_separator}}&#8363;',
       'money_with_currency_format': '{{amount_no_decimals_with_comma_separator}} VND'
     },
     XBT: {
       'money_format': '{{amount_no_decimals}} BTC',
       'money_with_currency_format': '{{amount_no_decimals}} BTC'
     },
     XOF: {
       'money_format': 'CFA{{amount}}',
       'money_with_currency_format': 'CFA{{amount}} XOF'
     },
     ZMW: {
       'money_format': 'K{{amount_no_decimals_with_comma_separator}}',
       'money_with_currency_format': 'ZMW{{amount_no_decimals_with_comma_separator}}'
     }
   };
   
   /**
    * Format a number to a specific format
    *
    * @param {Number} number - Value to format
    * @param {Number} precision - Amount of decimal points to show
    * @param {String} thousands - Thousands delimiter
    * @param {String} decimal - Decimal delimiter
    * @returns {String|Number}
    */
   function formatWithDelimiters(number) {
     var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
     var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
     var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
   
     if (isNaN(number) || !number) {
       return 0;
     }
   
     var preciseNumber = (number / 100.0).toFixed(precision);
   
     var parts = preciseNumber.split(thousands);
     var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
     var centsAmount = parts[1] ? decimal + parts[1] : '';
   
     return dollarsAmount + centsAmount;
   }
   
   /**
    * Convert a money value in cents to a formatted currency string
    *
    * @param {Number|String} cents
    * @param {String} format
    * @returns {String}
    */
   function formatMoney(cents, format) {
     if (typeof cents === 'string') {
       cents = cents.replace('.', '');
     }
   
     var value = '';
     var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
   
     switch (format.match(placeholderRegex)[1]) {
       case 'amount':
         value = formatWithDelimiters(cents, 2, ',', '.');
         break;
       case 'amount_with_space_separator':
         value = formatWithDelimiters(cents, 2, ' ', '.');
         break;
       case 'amount_with_comma_separator':
         value = formatWithDelimiters(cents, 2, '.', ',');
         break;
       case 'amount_with_apostrophe_separator':
         value = formatWithDelimiters(cents, 2, '\'', '.');
         break;
       case 'amount_no_decimals':
         value = formatWithDelimiters(cents, 0, ',', '.');
         break;
       case 'amount_no_decimals_with_space_separator':
         value = formatWithDelimiters(cents, 0, ' ', '.');
         break;
       case 'amount_no_decimals_with_comma_separator':
         value = formatWithDelimiters(cents, 0, ',', '.');
         break;
     }
   
     return format.replace(placeholderRegex, value);
   }
   
   /**
    * Return the value of money in cents value
    *
    * @param {Number} moneyAmount - Money value of a price
    *                 eg: 1000
    * @param {String} format - Shop formatting of a price
    *                 eg: {{amount}}
    * @param {String} currency - Currency of a price
    *                 eg: 'CAD'
    * @returns {Number}
    * @private
    */
   function getCentsValue(moneyAmount, format, currency) {
     var cents = 0;
     // Convert prices from float values to integers if needed, then convert
     if (format.indexOf('amount_no_decimals') !== -1) {
       cents = moneyAmount * 100;
     } else if (currency === 'JOD' || currency === 'KWD' || currency === 'BHD') {
       cents = moneyAmount / 10;
     } else {
       cents = moneyAmount;
     }
   
     return cents;
   }
   
   /**
    * Converts formatted money to a number
    *
    * @param {Element} priceEl
    * @returns {Number|String}
    */
   function getMoneyValue(priceEl) {
     var price = priceEl.getAttribute('data-currency-original') || priceEl.textContent;
     var value = parseInt(price.replace(/[^0-9]/g, ''), 10);
   
     return !isNaN(value) ? value : '';
   }
   
   var classCallCheck = function (instance, Constructor) {
     if (!(instance instanceof Constructor)) {
       throw new TypeError("Cannot call a class as a function");
     }
   };
   
   var createClass = function () {
     function defineProperties(target, props) {
       for (var i = 0; i < props.length; i++) {
         var descriptor = props[i];
         descriptor.enumerable = descriptor.enumerable || false;
         descriptor.configurable = true;
         if ("value" in descriptor) descriptor.writable = true;
         Object.defineProperty(target, descriptor.key, descriptor);
       }
     }
   
     return function (Constructor, protoProps, staticProps) {
       if (protoProps) defineProperties(Constructor.prototype, protoProps);
       if (staticProps) defineProperties(Constructor, staticProps);
       return Constructor;
     };
   }();
   
   var CurrencyConverter = function () {
     function CurrencyConverter() {
       classCallCheck(this, CurrencyConverter);
   
       this.defaults = {
         switcherSelector: '[data-currency-converter]',
         priceSelector: '.money',
         shopCurrency: '',
         defaultCurrency: '',
         displayFormat: '',
         moneyFormat: '',
         moneyFormatNoCurrency: '',
         moneyFormatCurrency: ''
       };
   
       this.options = {};
       this.moneyFormats = moneyFormats;
       this.storage = 'currency';
       this.currentCurrency = null;
       this.isInitialised = false;
     }
   
     /**
      * Initialize CurrencyConverter
      *
      * @param settings
      * @property {Object} settings
      *                    Configuration for CurrencyConverter
      * @property {String} settings.switcherSelector
      *                    CSS Selector for dropdown(s) which controls currency conversion
      * @property {String} settings.priceSelector
      *                    CSS Selector for elements containing prices
      * @property {String} settings.shopCurrency
      *                    Shop's currency (The currency used to process transactions)
      * @property {String} settings.defaultCurrency
      *                    Theme's currency setting, or initial currency to show on the page
      * @property {String} settings.displayFormat
      *                    `money_with_currency_format` or `money_format`
      * @property {String} settings.moneyFormat
      *                    Shop's currency formatted using the selected display format
      * @property {String} settings.moneyFormatNoCurrency
      *                    Shop's currency formatted without showing currency code
      * @property {String} settings.moneyFormatCurrency
      *                    Shop's currency formatted showing currency code
      */
   
   
     createClass(CurrencyConverter, [{
       key: 'init',
       value: function init(settings) {
         var _this = this;
   
         if (!window.Currency || this.isInitialised) return;
   
         Object.keys(this.defaults).forEach(function (key) {
           _this.options[key] = settings[key] || _this.defaults[key];
         });
   
         this.currentCurrency = this._getStoredCurrency() || this.options.defaultCurrency;
         this.moneyFormats[this.options.shopCurrency].money_with_currency_format = this.options.moneyFormatCurrency;
         this.moneyFormats[this.options.shopCurrency].money_format = this.options.moneyFormatNoCurrency;
   
         this.isInitialised = true;
         this._current();
       }
   
       /**
        * Change the currency to a new currency using an ISO currency code
        *
        * @param {String} newCurrency - New currency to convert prices to
        */
   
     }, {
       key: 'setCurrency',
       value: function setCurrency(newCurrency) {
         if (!this.isInitialised) return;
   
         this._convertAll(newCurrency);
       }
   
       /**
        * Update a price on the page from shop currency to the active currency, and formatting
        *
        * @param priceEl {HTMLElement} - element containing price text, in the shop currency
        */
   
     }, {
       key: 'update',
       value: function update(priceEl) {
         if (!this.isInitialised) return;
   
         // unset any stored previous conversions and the data-currency attribute itself
         var attributes = priceEl.attributes;
         for (var attr = 0; attr < attributes.length; attr++) {
           var attribute = attributes[attr];
   
           if (attribute.name.indexOf('data-currency') === 0) {
             priceEl.setAttribute(attribute.name, '');
           }
         }
   
         this._convertEl(priceEl, this.currentCurrency);
       }
   
       /**
        * Return the stored currency from the client's browser
        * @returns {String}
        * @private
        */
   
     }, {
       key: '_getStoredCurrency',
       value: function _getStoredCurrency() {
         try {
           return localStorage.getItem(this.storage);
         } catch (error) {
           console.warn(error);
           return this.options.defaultCurrency;
         }
       }
   
       /**
        * Save the client's currency in localstorage for persistence across pages
        * and sessions
        * @param {String} currency
        * @private
        */
   
     }, {
       key: '_setStoredCurrency',
       value: function _setStoredCurrency(currency) {
         try {
           localStorage.setItem(this.storage, currency);
         } catch (error) {
           console.warn(error);
         }
       }
   
       /**
        * Update the currency switcher to the current currency
        * @private
        */
   
     }, {
       key: '_current',
       value: function _current() {
         var switchers = document.querySelectorAll(this.options.switcherSelector);
         for (var i = 0; i < switchers.length; i += 1) {
           var switcher = switchers[i];
           var childrenEls = switcher.querySelectorAll('option');
   
           for (var j = 0; j < childrenEls.length; j += 1) {
             var optionEl = childrenEls[j];
   
             if (optionEl.selected && optionEl.value !== this.currentCurrency) {
               optionEl.selected = false;
             }
   
             if (optionEl.value === this.currentCurrency) {
               optionEl.selected = true;
             }
           }
         }
   
         this._convertAll(this.currentCurrency);
       }
   
       /**
        * Converts an individual price to the new format
        *
        * @param {Element} priceEl - Node element containing price
        * @param {String} oldCurrency - Currency of element converting from
        * @param {String} newCurrency - Currency to convert to
        * @private
        */
   
     }, {
       key: '_convertEl',
       value: function _convertEl(priceEl, newCurrency) {
         var oldCurrency = this.options.shopCurrency;
         // If the amount has already been converted, we leave it alone.
         if (priceEl.getAttribute('data-currency') === newCurrency) {
           return;
         }
   
         // If we are converting to a currency that we have saved, we will use the saved amount.
         if (priceEl.getAttribute('data-currency-' + newCurrency)) {
           priceEl.innerHTML = priceEl.getAttribute('data-currency-' + newCurrency);
         } else {
           var oldFormat = this.moneyFormats[oldCurrency][this.options.displayFormat];
           var newFormat = this.moneyFormats[newCurrency][this.options.displayFormat];
   
           var moneyValue = getMoneyValue(priceEl);
           var centsValue = getCentsValue(moneyValue, oldFormat, oldCurrency);
   
           // Cents value is empty, but not 0. 0$ is a valid price, while empty is not
           if (centsValue === '') return;
   
           var cents = window.Currency.convert(centsValue, oldCurrency, newCurrency);
           var oldPriceFormatted = formatMoney(centsValue, oldFormat);
           var priceFormatted = formatMoney(cents, newFormat);
   
           if (!priceEl.getAttribute('data-currency-original')) {
             priceEl.setAttribute('data-currency-original', oldPriceFormatted);
           }
   
           priceEl.setAttribute('data-currency-' + oldCurrency, oldPriceFormatted);
           priceEl.setAttribute('data-currency-' + newCurrency, priceFormatted);
           priceEl.innerHTML = priceFormatted;
         }
   
         priceEl.setAttribute('data-currency', newCurrency);
       }
   
       /**
        * Convert all prices on the page to the new currency
        *
        * @param {String} oldCurrency - Currency of element converting from
        * @param {String} newCurrency - Currency to convert to
        * @private
        */
   
     }, {
       key: '_convertAll',
       value: function _convertAll(newCurrency) {
         var priceEls = document.querySelectorAll(this.options.priceSelector);
         if (!priceEls) return;
   
         this.currentCurrency = newCurrency;
         this._setStoredCurrency(newCurrency);
   
         for (var i = 0; i < priceEls.length; i += 1) {
           this._convertEl(priceEls[i], newCurrency);
         }
       }
     }]);
     return CurrencyConverter;
   }();
   
   var singletonInstance = new CurrencyConverter();
   
   exports['default'] = singletonInstance;
   exports.CurrencyConverter = CurrencyConverter;
   
   
   /***/ }),
   /* 2 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
     * $script.js JS loader & dependency manager
     * https://github.com/ded/script.js
     * (c) Dustin Diaz 2014 | License MIT
     */
   
   (function (name, definition) {
     if ( true && module.exports) module.exports = definition()
     else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
                   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                   (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                   __WEBPACK_AMD_DEFINE_FACTORY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
     else {}
   })('$script', function () {
     var doc = document
       , head = doc.getElementsByTagName('head')[0]
       , s = 'string'
       , f = false
       , push = 'push'
       , readyState = 'readyState'
       , onreadystatechange = 'onreadystatechange'
       , list = {}
       , ids = {}
       , delay = {}
       , scripts = {}
       , scriptpath
       , urlArgs
   
     function every(ar, fn) {
       for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
       return 1
     }
     function each(ar, fn) {
       every(ar, function (el) {
         fn(el)
         return 1
       })
     }
   
     function $script(paths, idOrDone, optDone) {
       paths = paths[push] ? paths : [paths]
       var idOrDoneIsDone = idOrDone && idOrDone.call
         , done = idOrDoneIsDone ? idOrDone : optDone
         , id = idOrDoneIsDone ? paths.join('') : idOrDone
         , queue = paths.length
       function loopFn(item) {
         return item.call ? item() : list[item]
       }
       function callback() {
         if (!--queue) {
           list[id] = 1
           done && done()
           for (var dset in delay) {
             every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
           }
         }
       }
       setTimeout(function () {
         each(paths, function loading(path, force) {
           if (path === null) return callback()
           
           if (!force && !/^https?:\/\//.test(path) && scriptpath) {
             path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
           }
           
           if (scripts[path]) {
             if (id) ids[id] = 1
             return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
           }
   
           scripts[path] = 1
           if (id) ids[id] = 1
           create(path, callback)
         })
       }, 0)
       return $script
     }
   
     function create(path, fn) {
       var el = doc.createElement('script'), loaded
       el.onload = el.onerror = el[onreadystatechange] = function () {
         if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
         el.onload = el[onreadystatechange] = null
         loaded = 1
         scripts[path] = 2
         fn()
       }
       el.async = 1
       el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
       head.insertBefore(el, head.lastChild)
     }
   
     $script.get = create
   
     $script.order = function (scripts, id, done) {
       (function callback(s) {
         s = scripts.shift()
         !scripts.length ? $script(s, id, done) : $script(s, callback)
       }())
     }
   
     $script.path = function (p) {
       scriptpath = p
     }
     $script.urlArgs = function (str) {
       urlArgs = str;
     }
     $script.ready = function (deps, ready, req) {
       deps = deps[push] ? deps : [deps]
       var missing = [];
       !each(deps, function (dep) {
         list[dep] || missing[push](dep);
       }) && every(deps, function (dep) {return list[dep]}) ?
         ready() : !function (key) {
         delay[key] = delay[key] || []
         delay[key][push](ready)
         req && req(missing)
       }(deps.join('|'))
       return $script
     }
   
     $script.done = function (idOrDone) {
       $script([null], idOrDone)
     }
   
     return $script
   });
   
   
   /***/ }),
   /* 3 */
   /***/ (function(module, exports) {
   
   module.exports = debounce
   
   function debounce (fn, delay, at_start, guarantee) {
     var timeout
     var args
     var self
   
     return function debounced () {
       self = this
       args = Array.prototype.slice.call(arguments)
   
       if (timeout && (at_start || guarantee)) {
         return
       } else if (!at_start) {
         clear()
   
         timeout = setTimeout(run, delay)
         return timeout
       }
   
       timeout = setTimeout(clear, delay)
       fn.apply(self, args)
   
       function run () {
         clear()
         fn.apply(self, args)
       }
   
       function clear () {
         clearTimeout(timeout)
         timeout = null
       }
     }
   }
   
   
   /***/ }),
   /* 4 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
    * Flickity v2.2.0
    * Touch, responsive, flickable carousels
    *
    * Licensed GPLv3 for open source use
    * or Flickity Commercial License for commercial use
    *
    * https://flickity.metafizzy.co
    * Copyright 2015-2018 Metafizzy
    */
   
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(6),
         __webpack_require__(21),
         __webpack_require__(23),
         __webpack_require__(24),
         __webpack_require__(25),
         __webpack_require__(26),
         __webpack_require__(27)
       ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                   (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   })( window, function factory( Flickity ) {
     /*jshint strict: false*/
     return Flickity;
   });
   
   
   /***/ }),
   /* 5 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
    * Fizzy UI utils v2.0.7
    * MIT license
    */
   
   /*jshint browser: true, undef: true, unused: true, strict: true */
   
   ( function( window, factory ) {
     // universal module definition
     /*jshint strict: false */ /*globals define, module, require */
   
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(17)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( matchesSelector ) {
         return factory( window, matchesSelector );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, matchesSelector ) {
   
   'use strict';
   
   var utils = {};
   
   // ----- extend ----- //
   
   // extends objects
   utils.extend = function( a, b ) {
     for ( var prop in b ) {
       a[ prop ] = b[ prop ];
     }
     return a;
   };
   
   // ----- modulo ----- //
   
   utils.modulo = function( num, div ) {
     return ( ( num % div ) + div ) % div;
   };
   
   // ----- makeArray ----- //
   
   var arraySlice = Array.prototype.slice;
   
   // turn element or nodeList into an array
   utils.makeArray = function( obj ) {
     if ( Array.isArray( obj ) ) {
       // use object if already an array
       return obj;
     }
     // return empty array if undefined or null. #6
     if ( obj === null || obj === undefined ) {
       return [];
     }
   
     var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
     if ( isArrayLike ) {
       // convert nodeList to array
       return arraySlice.call( obj );
     }
   
     // array of single index
     return [ obj ];
   };
   
   // ----- removeFrom ----- //
   
   utils.removeFrom = function( ary, obj ) {
     var index = ary.indexOf( obj );
     if ( index != -1 ) {
       ary.splice( index, 1 );
     }
   };
   
   // ----- getParent ----- //
   
   utils.getParent = function( elem, selector ) {
     while ( elem.parentNode && elem != document.body ) {
       elem = elem.parentNode;
       if ( matchesSelector( elem, selector ) ) {
         return elem;
       }
     }
   };
   
   // ----- getQueryElement ----- //
   
   // use element as selector string
   utils.getQueryElement = function( elem ) {
     if ( typeof elem == 'string' ) {
       return document.querySelector( elem );
     }
     return elem;
   };
   
   // ----- handleEvent ----- //
   
   // enable .ontype to trigger from .addEventListener( elem, 'type' )
   utils.handleEvent = function( event ) {
     var method = 'on' + event.type;
     if ( this[ method ] ) {
       this[ method ]( event );
     }
   };
   
   // ----- filterFindElements ----- //
   
   utils.filterFindElements = function( elems, selector ) {
     // make array of elems
     elems = utils.makeArray( elems );
     var ffElems = [];
   
     elems.forEach( function( elem ) {
       // check that elem is an actual element
       if ( !( elem instanceof HTMLElement ) ) {
         return;
       }
       // add elem if no selector
       if ( !selector ) {
         ffElems.push( elem );
         return;
       }
       // filter & find items if we have a selector
       // filter
       if ( matchesSelector( elem, selector ) ) {
         ffElems.push( elem );
       }
       // find children
       var childElems = elem.querySelectorAll( selector );
       // concat childElems to filterFound array
       for ( var i=0; i < childElems.length; i++ ) {
         ffElems.push( childElems[i] );
       }
     });
   
     return ffElems;
   };
   
   // ----- debounceMethod ----- //
   
   utils.debounceMethod = function( _class, methodName, threshold ) {
     threshold = threshold || 100;
     // original method
     var method = _class.prototype[ methodName ];
     var timeoutName = methodName + 'Timeout';
   
     _class.prototype[ methodName ] = function() {
       var timeout = this[ timeoutName ];
       clearTimeout( timeout );
   
       var args = arguments;
       var _this = this;
       this[ timeoutName ] = setTimeout( function() {
         method.apply( _this, args );
         delete _this[ timeoutName ];
       }, threshold );
     };
   };
   
   // ----- docReady ----- //
   
   utils.docReady = function( callback ) {
     var readyState = document.readyState;
     if ( readyState == 'complete' || readyState == 'interactive' ) {
       // do async to allow for other scripts to run. metafizzy/flickity#441
       setTimeout( callback );
     } else {
       document.addEventListener( 'DOMContentLoaded', callback );
     }
   };
   
   // ----- htmlInit ----- //
   
   // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
   utils.toDashed = function( str ) {
     return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
       return $1 + '-' + $2;
     }).toLowerCase();
   };
   
   var console = window.console;
   /**
    * allow user to initialize classes via [data-namespace] or .js-namespace class
    * htmlInit( Widget, 'widgetName' )
    * options are parsed from data-namespace-options
    */
   utils.htmlInit = function( WidgetClass, namespace ) {
     utils.docReady( function() {
       var dashedNamespace = utils.toDashed( namespace );        

       var dataAttr = 'data-' + dashedNamespace;
 
       var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' ); 

       var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
       var elems = utils.makeArray( dataAttrElems )
         .concat( utils.makeArray( jsDashElems ) );
       var dataOptionsAttr = dataAttr + '-options';
       var jQuery = window.jQuery;
   
       elems.forEach( function( elem ) {
         var attr = elem.getAttribute( dataAttr ) ||
           elem.getAttribute( dataOptionsAttr );
 
         var options;
         try {
           options = attr && JSON.parse( attr );
         } catch ( error ) {
           // log error, do not initialize
           if ( console ) {
             console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
             ': ' + error );
           }
           return;
         }
         // initialize
         var instance = new WidgetClass( elem, options );
         // make available via $().data('namespace')
         if ( jQuery ) {
           jQuery.data( elem, namespace, instance );
         }
       });
   
     });
   };
   
   // -----  ----- //
   
   return utils;
   
   }));
   
   
   /***/ }),
   /* 6 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(7),
         __webpack_require__(9),
         __webpack_require__(5),
         __webpack_require__(18),
         __webpack_require__(19),
         __webpack_require__(20)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
         return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else { var _Flickity; }
   
   }( window, function factory( window, EvEmitter, getSize,
     utils, Cell, Slide, animatePrototype ) {
   
   'use strict';
   
   // vars
   var jQuery = window.jQuery;
   var getComputedStyle = window.getComputedStyle;
   var console = window.console;
   
   function moveElements( elems, toElem ) {
     elems = utils.makeArray( elems );
     while ( elems.length ) {
       toElem.appendChild( elems.shift() );
     }
   }
   
   // -------------------------- Flickity -------------------------- //
   
   // globally unique identifiers
   var GUID = 0;
   // internal store of all Flickity intances
   var instances = {};
   
   function Flickity( element, options ) {
     var queryElement = utils.getQueryElement( element );
     if ( !queryElement ) {
       if ( console ) {
         console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
       }
       return;
     }
     this.element = queryElement;
     // do not initialize twice on same element
     if ( this.element.flickityGUID ) {
       var instance = instances[ this.element.flickityGUID ];
       instance.option( options );
       return instance;
     }
   
     // add jQuery
     if ( jQuery ) {
       this.$element = jQuery( this.element );
     }
     // options
     this.options = utils.extend( {}, this.constructor.defaults );
     this.option( options );
   
     // kick things off
     this._create();
   }
   
   Flickity.defaults = {
     accessibility: true,
     // adaptiveHeight: false,
     cellAlign: 'center',
     // cellSelector: undefined,
     // contain: false,
     freeScrollFriction: 0.075, // friction when free-scrolling
     friction: 0.28, // friction when selecting
     namespaceJQueryEvents: true,
     // initialIndex: 0,
     percentPosition: true,
     resize: true,
     selectedAttraction: 0.025,
     setGallerySize: true
     // watchCSS: false,
     // wrapAround: false
   };
   
   // hash of methods triggered on _create()
   Flickity.createMethods = [];
   
   var proto = Flickity.prototype;
   // inherit EventEmitter
   utils.extend( proto, EvEmitter.prototype );
   
   proto._create = function() {
     // add id for Flickity.data
     var id = this.guid = ++GUID;
     this.element.flickityGUID = id; // expando
     instances[ id ] = this; // associate via id
     // initial properties
     this.selectedIndex = 0;
     // how many frames slider has been in same position
     this.restingFrames = 0;
     // initial physics properties
     this.x = 0;
     this.velocity = 0;
     this.originSide = this.options.rightToLeft ? 'right' : 'left';
     // create viewport & slider
     let cl = this.element.classList
     if(cl.contains('product-section--content') || cl.contains('home-section--content')){
        this.viewport = document.createElement('li'); //ADA fix: Incorrect child element in list
     }else{
        this.viewport = document.createElement('div');
     }

     this.viewport.className = 'flickity-viewport';
     this._createSlider();      
  
     if ( this.options.resize || this.options.watchCSS ) {
       window.addEventListener( 'resize', this );
     }
   
     // add listeners from on option
     for ( var eventName in this.options.on ) {
       var listener = this.options.on[ eventName ];
       this.on( eventName, listener );
     }
   
     Flickity.createMethods.forEach( function( method ) {
       this[ method ]();
     }, this );
   
     if ( this.options.watchCSS ) {
       this.watchCSS();
     } else {
       this.activate();
     }
   
   };
   
   /**
    * set options
    * @param {Object} opts
    */
   proto.option = function( opts ) {
     utils.extend( this.options, opts );
   };
   
   proto.activate = function() {
     if ( this.isActive ) {
       return;
     }
     this.isActive = true;
     this.element.classList.add('flickity-enabled');
     if ( this.options.rightToLeft ) {
       this.element.classList.add('flickity-rtl');
     }
   
     this.getSize();
     // move initial cell elements so they can be loaded as cells
     var cellElems = this._filterFindCellElements( this.element.children );
     moveElements( cellElems, this.slider );
     this.viewport.appendChild( this.slider );
     this.element.appendChild( this.viewport );
     // get cells from children
     this.reloadCells();
   
     if ( this.options.accessibility ) {
       // allow element to focusable
       this.element.tabIndex = 0;
       // listen for key presses
       this.element.addEventListener( 'keydown', this );
     }
   
     this.emitEvent('activate');
     this.selectInitialIndex();
     // flag for initial activation, for using initialIndex
     this.isInitActivated = true;
     // ready event. #493
     this.dispatchEvent('ready');
   };
   
   // slider positions the cells
   proto._createSlider = function() {
     // slider element does all the positioning
     let cl = this.element.classList
     if(cl.contains('product-section--content') || cl.contains('home-section--content')){ 
        var slider = document.createElement('ul'); //ADA fix: Incorrect child element in list
     }else{
        var slider = document.createElement('div');
     }

     slider.className = 'flickity-slider';
     slider.style[ this.originSide ] = 0;
     this.slider = slider;
   };
   
   proto._filterFindCellElements = function( elems ) {
     return utils.filterFindElements( elems, this.options.cellSelector );
   };
   
   // goes through all children
   proto.reloadCells = function() {
     // collection of item elements
     this.cells = this._makeCells( this.slider.children );
     this.positionCells();
     this._getWrapShiftCells();
     this.setGallerySize();
   };
   
   /**
    * turn elements into Flickity.Cells
    * @param {Array or NodeList or HTMLElement} elems
    * @returns {Array} items - collection of new Flickity Cells
    */
   proto._makeCells = function( elems ) {
     var cellElems = this._filterFindCellElements( elems );
   
     // create new Flickity for collection
     var cells = cellElems.map( function( cellElem ) {
       return new Cell( cellElem, this );
     }, this );
   
     return cells;
   };
   
   proto.getLastCell = function() {
     return this.cells[ this.cells.length - 1 ];
   };
   
   proto.getLastSlide = function() {
     return this.slides[ this.slides.length - 1 ];
   };
   
   // positions all cells
   proto.positionCells = function() {
     // size all cells
     this._sizeCells( this.cells );
     // position all cells
     this._positionCells( 0 );
   };
   
   /**
    * position certain cells
    * @param {Integer} index - which cell to start with
    */
   proto._positionCells = function( index ) {
     index = index || 0;
     // also measure maxCellHeight
     // start 0 if positioning all cells
     this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
     var cellX = 0;
     // get cellX
     if ( index > 0 ) {
       var startCell = this.cells[ index - 1 ];
       cellX = startCell.x + startCell.size.outerWidth;
     }
     var len = this.cells.length;
     for ( var i=index; i < len; i++ ) {
       var cell = this.cells[i];
       cell.setPosition( cellX );
       cellX += cell.size.outerWidth;
       this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
     }
     // keep track of cellX for wrap-around
     this.slideableWidth = cellX;
     // slides
     this.updateSlides();
     // contain slides target
     this._containSlides();
     // update slidesWidth
     this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
   };
   
   /**
    * cell.getSize() on multiple cells
    * @param {Array} cells
    */
   proto._sizeCells = function( cells ) {
     cells.forEach( function( cell ) {
       cell.getSize();
     });
   };
   
   // --------------------------  -------------------------- //
   
   proto.updateSlides = function() {
     this.slides = [];
     if ( !this.cells.length ) {
       return;
     }
   
     var slide = new Slide( this );
     this.slides.push( slide );
     var isOriginLeft = this.originSide == 'left';
     var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';
   
     var canCellFit = this._getCanCellFit();
   
     this.cells.forEach( function( cell, i ) {
       // just add cell if first cell in slide
       if ( !slide.cells.length ) {
         slide.addCell( cell );
         return;
       }
   
       var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
         ( cell.size.outerWidth - cell.size[ nextMargin ] );
   
       if ( canCellFit.call( this, i, slideWidth ) ) {
         slide.addCell( cell );
       } else {
         // doesn't fit, new slide
         slide.updateTarget();
   
         slide = new Slide( this );
         this.slides.push( slide );
         slide.addCell( cell );
       }
     }, this );
     // last slide
     slide.updateTarget();
     // update .selectedSlide
     this.updateSelectedSlide();
   };
   
   proto._getCanCellFit = function() {
     var groupCells = this.options.groupCells;
     if ( !groupCells ) {
       return function() {
         return false;
       };
     } else if ( typeof groupCells == 'number' ) {
       // group by number. 3 -> [0,1,2], [3,4,5], ...
       var number = parseInt( groupCells, 10 );
       return function( i ) {
         return ( i % number ) !== 0;
       };
     }
     // default, group by width of slide
     // parse '75%
     var percentMatch = typeof groupCells == 'string' &&
       groupCells.match(/^(\d+)%$/);
     var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
     return function( i, slideWidth ) {
       return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
     };
   };
   
   // alias _init for jQuery plugin .flickity()
   proto._init =
   proto.reposition = function() {
     this.positionCells();
     this.positionSliderAtSelected();
   };
   
   proto.getSize = function() {
     this.size = getSize( this.element );
     this.setCellAlign();
     this.cursorPosition = this.size.innerWidth * this.cellAlign;
   };
   
   var cellAlignShorthands = {
     // cell align, then based on origin side
     center: {
       left: 0.5,
       right: 0.5
     },
     left: {
       left: 0,
       right: 1
     },
     right: {
       right: 0,
       left: 1
     }
   };
   
   proto.setCellAlign = function() {
     var shorthand = cellAlignShorthands[ this.options.cellAlign ];
     this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
   };
   
   proto.setGallerySize = function() {
     if ( this.options.setGallerySize ) {
       var height = this.options.adaptiveHeight && this.selectedSlide ?
         this.selectedSlide.height : this.maxCellHeight;
       this.viewport.style.height = height + 'px';
     }
   };
   
   proto._getWrapShiftCells = function() {
     // only for wrap-around
     if ( !this.options.wrapAround ) {
       return;
     }
     // unshift previous cells
     this._unshiftCells( this.beforeShiftCells );
     this._unshiftCells( this.afterShiftCells );
     // get before cells
     // initial gap
     var gapX = this.cursorPosition;
     var cellIndex = this.cells.length - 1;
     this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
     // get after cells
     // ending gap between last cell and end of gallery viewport
     gapX = this.size.innerWidth - this.cursorPosition;
     // start cloning at first cell, working forwards
     this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
   };
   
   proto._getGapCells = function( gapX, cellIndex, increment ) {
     // keep adding cells until the cover the initial gap
     var cells = [];
     while ( gapX > 0 ) {
       var cell = this.cells[ cellIndex ];
       if ( !cell ) {
         break;
       }
       cells.push( cell );
       cellIndex += increment;
       gapX -= cell.size.outerWidth;
     }
     return cells;
   };
   
   // ----- contain ----- //
   
   // contain cell targets so no excess sliding
   proto._containSlides = function() {
     if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
       return;
     }
     var isRightToLeft = this.options.rightToLeft;
     var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
     var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
     var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
     // content is less than gallery size
     var isContentSmaller = contentWidth < this.size.innerWidth;
     // bounds
     var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
     var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
     // contain each cell target
     this.slides.forEach( function( slide ) {
       if ( isContentSmaller ) {
         // all cells fit inside gallery
         slide.target = contentWidth * this.cellAlign;
       } else {
         // contain to bounds
         slide.target = Math.max( slide.target, beginBound );
         slide.target = Math.min( slide.target, endBound );
       }
     }, this );
   };
   
   // -----  ----- //
   
   /**
    * emits events via eventEmitter and jQuery events
    * @param {String} type - name of event
    * @param {Event} event - original event
    * @param {Array} args - extra arguments
    */
   proto.dispatchEvent = function( type, event, args ) {
     var emitArgs = event ? [ event ].concat( args ) : args;
     this.emitEvent( type, emitArgs );
   
     if ( jQuery && this.$element ) {
       // default trigger with type if no event
       type += this.options.namespaceJQueryEvents ? '.flickity' : '';
       var $event = type;
       if ( event ) {
         // create jQuery event
         var jQEvent = jQuery.Event( event );
         jQEvent.type = type;
         $event = jQEvent;
       }
       this.$element.trigger( $event, args );
     }
   };
   
   // -------------------------- select -------------------------- //
   
   /**
    * @param {Integer} index - index of the slide
    * @param {Boolean} isWrap - will wrap-around to last/first if at the end
    * @param {Boolean} isInstant - will immediately set position at selected cell
    */
   proto.select = function( index, isWrap, isInstant ) {
     if ( !this.isActive ) {
       return;
     }
     index = parseInt( index, 10 );
     this._wrapSelect( index );
   
     if ( this.options.wrapAround || isWrap ) {
       index = utils.modulo( index, this.slides.length );
     }
     // bail if invalid index
     if ( !this.slides[ index ] ) {
       return;
     }
     var prevIndex = this.selectedIndex;
     this.selectedIndex = index;
     this.updateSelectedSlide();
     if ( isInstant ) {
       this.positionSliderAtSelected();
     } else {
       this.startAnimation();
     }
     if ( this.options.adaptiveHeight ) {
       this.setGallerySize();
     }
     // events
     this.dispatchEvent( 'select', null, [ index ] );
     // change event if new index
     if ( index != prevIndex ) {
       this.dispatchEvent( 'change', null, [ index ] );
     }
     // old v1 event name, remove in v3
     this.dispatchEvent('cellSelect');
   };
   
   // wraps position for wrapAround, to move to closest slide. #113
   proto._wrapSelect = function( index ) {
     var len = this.slides.length;
     var isWrapping = this.options.wrapAround && len > 1;
     if ( !isWrapping ) {
       return index;
     }
     var wrapIndex = utils.modulo( index, len );
     // go to shortest
     var delta = Math.abs( wrapIndex - this.selectedIndex );
     var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
     var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
     if ( !this.isDragSelect && backWrapDelta < delta ) {
       index += len;
     } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
       index -= len;
     }
     // wrap position so slider is within normal area
     if ( index < 0 ) {
       this.x -= this.slideableWidth;
     } else if ( index >= len ) {
       this.x += this.slideableWidth;
     }
   };
   
   proto.previous = function( isWrap, isInstant ) {
     this.select( this.selectedIndex - 1, isWrap, isInstant );
   };
   
   proto.next = function( isWrap, isInstant ) {
     this.select( this.selectedIndex + 1, isWrap, isInstant );
   };
   
   proto.updateSelectedSlide = function() {
     var slide = this.slides[ this.selectedIndex ];
     // selectedIndex could be outside of slides, if triggered before resize()
     if ( !slide ) {
       return;
     }
     // unselect previous selected slide
     this.unselectSelectedSlide();
     // update new selected slide
     this.selectedSlide = slide;
     slide.select();
     this.selectedCells = slide.cells;
     this.selectedElements = slide.getCellElements();
     // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
     // Remove in v3?
     this.selectedCell = slide.cells[0];
     this.selectedElement = this.selectedElements[0];
   };
   
   proto.unselectSelectedSlide = function() {
     if ( this.selectedSlide ) {
       this.selectedSlide.unselect();
     }
   };
   
   proto.selectInitialIndex = function() {
     var initialIndex = this.options.initialIndex;
     // already activated, select previous selectedIndex
     if ( this.isInitActivated ) {
       this.select( this.selectedIndex, false, true );
       return;
     }
     // select with selector string
     if ( initialIndex && typeof initialIndex == 'string' ) {
       var cell = this.queryCell( initialIndex );
       if ( cell ) {
         this.selectCell( initialIndex, false, true );
         return;
       }
     }
   
     var index = 0;
     // select with number
     if ( initialIndex && this.slides[ initialIndex ] ) {
       index = initialIndex;
     }
     // select instantly
     this.select( index, false, true );
   };
   
   /**
    * select slide from number or cell element
    * @param {Element or Number} elem
    */
   proto.selectCell = function( value, isWrap, isInstant ) {
     // get cell
     var cell = this.queryCell( value );
     if ( !cell ) {
       return;
     }
   
     var index = this.getCellSlideIndex( cell );
     this.select( index, isWrap, isInstant );
   };
   
   proto.getCellSlideIndex = function( cell ) {
     // get index of slides that has cell
     for ( var i=0; i < this.slides.length; i++ ) {
       var slide = this.slides[i];
       var index = slide.cells.indexOf( cell );
       if ( index != -1 ) {
         return i;
       }
     }
   };
   
   // -------------------------- get cells -------------------------- //
   
   /**
    * get Flickity.Cell, given an Element
    * @param {Element} elem
    * @returns {Flickity.Cell} item
    */
   proto.getCell = function( elem ) {
     // loop through cells to get the one that matches
     for ( var i=0; i < this.cells.length; i++ ) {
       var cell = this.cells[i];
       if ( cell.element == elem ) {
         return cell;
       }
     }
   };
   
   /**
    * get collection of Flickity.Cells, given Elements
    * @param {Element, Array, NodeList} elems
    * @returns {Array} cells - Flickity.Cells
    */
   proto.getCells = function( elems ) {
     elems = utils.makeArray( elems );
     var cells = [];
     elems.forEach( function( elem ) {
       var cell = this.getCell( elem );
       if ( cell ) {
         cells.push( cell );
       }
     }, this );
     return cells;
   };
   
   /**
    * get cell elements
    * @returns {Array} cellElems
    */
   proto.getCellElements = function() {
     return this.cells.map( function( cell ) {
       return cell.element;
     });
   };
   
   /**
    * get parent cell from an element
    * @param {Element} elem
    * @returns {Flickit.Cell} cell
    */
   proto.getParentCell = function( elem ) {
     // first check if elem is cell
     var cell = this.getCell( elem );
     if ( cell ) {
       return cell;
     }
     // try to get parent cell elem
     elem = utils.getParent( elem, '.flickity-slider > *' );
     return this.getCell( elem );
   };
   
   /**
    * get cells adjacent to a slide
    * @param {Integer} adjCount - number of adjacent slides
    * @param {Integer} index - index of slide to start
    * @returns {Array} cells - array of Flickity.Cells
    */
   proto.getAdjacentCellElements = function( adjCount, index ) {
     if ( !adjCount ) {
       return this.selectedSlide.getCellElements();
     }
     index = index === undefined ? this.selectedIndex : index;
   
     var len = this.slides.length;
     if ( 1 + ( adjCount * 2 ) >= len ) {
       return this.getCellElements();
     }
   
     var cellElems = [];
     for ( var i = index - adjCount; i <= index + adjCount ; i++ ) {
       var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
       var slide = this.slides[ slideIndex ];
       if ( slide ) {
         cellElems = cellElems.concat( slide.getCellElements() );
       }
     }
     return cellElems;
   };
   
   /**
    * select slide from number or cell element
    * @param {Element, Selector String, or Number} selector
    */
   proto.queryCell = function( selector ) {
     if ( typeof selector == 'number' ) {
       // use number as index
       return this.cells[ selector ];
     }
     if ( typeof selector == 'string' ) {
       // do not select invalid selectors from hash: #123, #/. #791
       if ( selector.match(/^[#\.]?[\d\/]/) ) {
         return;
       }
       // use string as selector, get element
       selector = this.element.querySelector( selector );
     }
     // get cell from element
     return this.getCell( selector );
   };
   
   // -------------------------- events -------------------------- //
   
   proto.uiChange = function() {
     this.emitEvent('uiChange');
   };
   
   // keep focus on element when child UI elements are clicked
   proto.childUIPointerDown = function( event ) {
     // HACK iOS does not allow touch events to bubble up?!
     if ( event.type != 'touchstart' ) {
       event.preventDefault();
     }
     this.focus();
   };
   
   // ----- resize ----- //
   
   proto.onresize = function() {
     this.watchCSS();
     this.resize();
   };
   
   utils.debounceMethod( Flickity, 'onresize', 150 );
   
   proto.resize = function() {
     if ( !this.isActive ) {
       return;
     }
     this.getSize();
     // wrap values
     if ( this.options.wrapAround ) {
       this.x = utils.modulo( this.x, this.slideableWidth );
     }
     this.positionCells();
     this._getWrapShiftCells();
     this.setGallerySize();
     this.emitEvent('resize');
     // update selected index for group slides, instant
     // TODO: position can be lost between groups of various numbers
     var selectedElement = this.selectedElements && this.selectedElements[0];
     this.selectCell( selectedElement, false, true );
   };
   
   // watches the :after property, activates/deactivates
   proto.watchCSS = function() {
     var watchOption = this.options.watchCSS;
     if ( !watchOption ) {
       return;
     }
   
     var afterContent = getComputedStyle( this.element, ':after' ).content;
     // activate if :after { content: 'flickity' }
     if ( afterContent.indexOf('flickity') != -1 ) {
       this.activate();
     } else {
       this.deactivate();
     }
   };
   
   // ----- keydown ----- //
   
   // go previous/next if left/right keys pressed
   proto.onkeydown = function( event ) {
     // only work if element is in focus
     var isNotFocused = document.activeElement && document.activeElement != this.element;
     if ( !this.options.accessibility ||isNotFocused ) {
       return;
     }
   
     var handler = Flickity.keyboardHandlers[ event.keyCode ];
     if ( handler ) {
       handler.call( this );
     }
   };
   
   Flickity.keyboardHandlers = {
     // left arrow
     37: function() {
       var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
       this.uiChange();
       this[ leftMethod ]();
     },
     // right arrow
     39: function() {
       var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
       this.uiChange();
       this[ rightMethod ]();
     },
   };
   
   // ----- focus ----- //
   
   proto.focus = function() {
     // TODO remove scrollTo once focus options gets more support
     // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
     var prevScrollY = window.pageYOffset;
     this.element.focus({ preventScroll: true });
     // hack to fix scroll jump after focus, #76
     if ( window.pageYOffset != prevScrollY ) {
       window.scrollTo( window.pageXOffset, prevScrollY );
     }
   };
   
   // -------------------------- destroy -------------------------- //
   
   // deactivate all Flickity functionality, but keep stuff available
   proto.deactivate = function() {
     if ( !this.isActive ) {
       return;
     }
     this.element.classList.remove('flickity-enabled');
     this.element.classList.remove('flickity-rtl');
     this.unselectSelectedSlide();
     // destroy cells
     this.cells.forEach( function( cell ) {
       cell.destroy();
     });
     this.element.removeChild( this.viewport );
     // move child elements back into element
     moveElements( this.slider.children, this.element );
     if ( this.options.accessibility ) {
       this.element.removeAttribute('tabIndex');
       this.element.removeEventListener( 'keydown', this );
     }
     // set flags
     this.isActive = false;
     this.emitEvent('deactivate');
   };
   
   proto.destroy = function() {
     this.deactivate();
     window.removeEventListener( 'resize', this );
     this.allOff();
     this.emitEvent('destroy');
     if ( jQuery && this.$element ) {
       jQuery.removeData( this.element, 'flickity' );
     }
     delete this.element.flickityGUID;
     delete instances[ this.guid ];
   };
   
   // -------------------------- prototype -------------------------- //
   
   utils.extend( proto, animatePrototype );
   
   // -------------------------- extras -------------------------- //
   
   /**
    * get Flickity instance from element
    * @param {Element} elem
    * @returns {Flickity}
    */
   Flickity.data = function( elem ) {
     elem = utils.getQueryElement( elem );
     var id = elem && elem.flickityGUID;
     return id && instances[ id ];
   };
   
   utils.htmlInit( Flickity, 'flickity' );
   
   if ( jQuery && jQuery.bridget ) {
     jQuery.bridget( 'flickity', Flickity );
   }
   
   // set internal jQuery, for Webpack + jQuery v3, #478
   Flickity.setJQuery = function( jq ) {
     jQuery = jq;
   };
   
   Flickity.Cell = Cell;
   Flickity.Slide = Slide;
   
   return Flickity;
   
   }));
   
   
   /***/ }),
   /* 7 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
    * EvEmitter v1.1.0
    * Lil' event emitter
    * MIT License
    */
   
   /* jshint unused: true, undef: true, strict: true */
   
   ( function( global, factory ) {
     // universal module definition
     /* jshint strict: false */ /* globals define, module, window */
     if ( true ) {
       // AMD - RequireJS
       !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                   (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                   __WEBPACK_AMD_DEFINE_FACTORY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( typeof window != 'undefined' ? window : this, function() {
   
   "use strict";
   
   function EvEmitter() {}
   
   var proto = EvEmitter.prototype;
   
   proto.on = function( eventName, listener ) {
     if ( !eventName || !listener ) {
       return;
     }
     // set events hash
     var events = this._events = this._events || {};
     // set listeners array
     var listeners = events[ eventName ] = events[ eventName ] || [];
     // only add once
     if ( listeners.indexOf( listener ) == -1 ) {
       listeners.push( listener );
     }
   
     return this;
   };
   
   proto.once = function( eventName, listener ) {
     if ( !eventName || !listener ) {
       return;
     }
     // add event
     this.on( eventName, listener );
     // set once flag
     // set onceEvents hash
     var onceEvents = this._onceEvents = this._onceEvents || {};
     // set onceListeners object
     var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
     // set flag
     onceListeners[ listener ] = true;
   
     return this;
   };
   
   proto.off = function( eventName, listener ) {
     var listeners = this._events && this._events[ eventName ];
     if ( !listeners || !listeners.length ) {
       return;
     }
     var index = listeners.indexOf( listener );
     if ( index != -1 ) {
       listeners.splice( index, 1 );
     }
   
     return this;
   };
   
   proto.emitEvent = function( eventName, args ) {
     var listeners = this._events && this._events[ eventName ];
     if ( !listeners || !listeners.length ) {
       return;
     }
     // copy over to avoid interference if .off() in listener
     listeners = listeners.slice(0);
     args = args || [];
     // once stuff
     var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
   
     for ( var i=0; i < listeners.length; i++ ) {
       var listener = listeners[i]
       var isOnce = onceListeners && onceListeners[ listener ];
       if ( isOnce ) {
         // remove listener
         // remove before trigger to prevent recursion
         this.off( eventName, listener );
         // unset once flag
         delete onceListeners[ listener ];
       }
       // trigger listener
       listener.apply( this, args );
     }
   
     return this;
   };
   
   proto.allOff = function() {
     delete this._events;
     delete this._onceEvents;
   };
   
   return EvEmitter;
   
   }));
   
   
   /***/ }),
   /* 8 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
    * Unipointer v2.3.0
    * base class for doing one thing with pointer event
    * MIT license
    */
   
   /*jshint browser: true, undef: true, unused: true, strict: true */
   
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */ /*global define, module, require */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(7)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
         return factory( window, EvEmitter );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, EvEmitter ) {
   
   'use strict';
   
   function noop() {}
   
   function Unipointer() {}
   
   // inherit EvEmitter
   var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );
   
   proto.bindStartEvent = function( elem ) {
     this._bindStartEvent( elem, true );
   };
   
   proto.unbindStartEvent = function( elem ) {
     this._bindStartEvent( elem, false );
   };
   
   /**
    * Add or remove start event
    * @param {Boolean} isAdd - remove if falsey
    */
   proto._bindStartEvent = function( elem, isAdd ) {
     // munge isAdd, default to true
     isAdd = isAdd === undefined ? true : isAdd;
     var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
   
     // default to mouse events
     var startEvent = 'mousedown';
     if ( window.PointerEvent ) {
       // Pointer Events
       startEvent = 'pointerdown';
     } else if ( 'ontouchstart' in window ) {
       // Touch Events. iOS Safari
       startEvent = 'touchstart';
     }
     elem[ bindMethod ]( startEvent, this );
   };
   
   // trigger handler methods for events
   proto.handleEvent = function( event ) {
     var method = 'on' + event.type;
     if ( this[ method ] ) {
       this[ method ]( event );
     }
   };
   
   // returns the touch that we're keeping track of
   proto.getTouch = function( touches ) {
     for ( var i=0; i < touches.length; i++ ) {
       var touch = touches[i];
       if ( touch.identifier == this.pointerIdentifier ) {
         return touch;
       }
     }
   };
   
   // ----- start event ----- //
   
   proto.onmousedown = function( event ) {
     // dismiss clicks from right or middle buttons
     var button = event.button;
     if ( button && ( button !== 0 && button !== 1 ) ) {
       return;
     }
     this._pointerDown( event, event );
   };
   
   proto.ontouchstart = function( event ) {
     this._pointerDown( event, event.changedTouches[0] );
   };
   
   proto.onpointerdown = function( event ) {
     this._pointerDown( event, event );
   };
   
   /**
    * pointer start
    * @param {Event} event
    * @param {Event or Touch} pointer
    */
   proto._pointerDown = function( event, pointer ) {
     // dismiss right click and other pointers
     // button = 0 is okay, 1-4 not
     if ( event.button || this.isPointerDown ) {
       return;
     }
   
     this.isPointerDown = true;
     // save pointer identifier to match up touch events
     this.pointerIdentifier = pointer.pointerId !== undefined ?
       // pointerId for pointer events, touch.indentifier for touch events
       pointer.pointerId : pointer.identifier;
   
     this.pointerDown( event, pointer );
   };
   
   proto.pointerDown = function( event, pointer ) {
     this._bindPostStartEvents( event );
     this.emitEvent( 'pointerDown', [ event, pointer ] );
   };
   
   // hash of events to be bound after start event
   var postStartEvents = {
     mousedown: [ 'mousemove', 'mouseup' ],
     touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
     pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
   };
   
   proto._bindPostStartEvents = function( event ) {
     if ( !event ) {
       return;
     }
     // get proper events to match start event
     var events = postStartEvents[ event.type ];
     // bind events to node
     events.forEach( function( eventName ) {
       window.addEventListener( eventName, this );
     }, this );
     // save these arguments
     this._boundPointerEvents = events;
   };
   
   proto._unbindPostStartEvents = function() {
     // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
     if ( !this._boundPointerEvents ) {
       return;
     }
     this._boundPointerEvents.forEach( function( eventName ) {
       window.removeEventListener( eventName, this );
     }, this );
   
     delete this._boundPointerEvents;
   };
   
   // ----- move event ----- //
   
   proto.onmousemove = function( event ) {
     this._pointerMove( event, event );
   };
   
   proto.onpointermove = function( event ) {
     if ( event.pointerId == this.pointerIdentifier ) {
       this._pointerMove( event, event );
     }
   };
   
   proto.ontouchmove = function( event ) {
     var touch = this.getTouch( event.changedTouches );
     if ( touch ) {
       this._pointerMove( event, touch );
     }
   };
   
   /**
    * pointer move
    * @param {Event} event
    * @param {Event or Touch} pointer
    * @private
    */
   proto._pointerMove = function( event, pointer ) {
     this.pointerMove( event, pointer );
   };
   
   // public
   proto.pointerMove = function( event, pointer ) {
     this.emitEvent( 'pointerMove', [ event, pointer ] );
   };
   
   // ----- end event ----- //
   
   
   proto.onmouseup = function( event ) {
     this._pointerUp( event, event );
   };
   
   proto.onpointerup = function( event ) {
     if ( event.pointerId == this.pointerIdentifier ) {
       this._pointerUp( event, event );
     }
   };
   
   proto.ontouchend = function( event ) {
     var touch = this.getTouch( event.changedTouches );
     if ( touch ) {
       this._pointerUp( event, touch );
     }
   };
   
   /**
    * pointer up
    * @param {Event} event
    * @param {Event or Touch} pointer
    * @private
    */
   proto._pointerUp = function( event, pointer ) {
     this._pointerDone();
     this.pointerUp( event, pointer );
   };
   
   // public
   proto.pointerUp = function( event, pointer ) {
     this.emitEvent( 'pointerUp', [ event, pointer ] );
   };
   
   // ----- pointer done ----- //
   
   // triggered on pointer up & pointer cancel
   proto._pointerDone = function() {
     this._pointerReset();
     this._unbindPostStartEvents();
     this.pointerDone();
   };
   
   proto._pointerReset = function() {
     // reset properties
     this.isPointerDown = false;
     delete this.pointerIdentifier;
   };
   
   proto.pointerDone = noop;
   
   // ----- pointer cancel ----- //
   
   proto.onpointercancel = function( event ) {
     if ( event.pointerId == this.pointerIdentifier ) {
       this._pointerCancel( event, event );
     }
   };
   
   proto.ontouchcancel = function( event ) {
     var touch = this.getTouch( event.changedTouches );
     if ( touch ) {
       this._pointerCancel( event, touch );
     }
   };
   
   /**
    * pointer cancel
    * @param {Event} event
    * @param {Event or Touch} pointer
    * @private
    */
   proto._pointerCancel = function( event, pointer ) {
     this._pointerDone();
     this.pointerCancel( event, pointer );
   };
   
   // public
   proto.pointerCancel = function( event, pointer ) {
     this.emitEvent( 'pointerCancel', [ event, pointer ] );
   };
   
   // -----  ----- //
   
   // utility function for getting x/y coords from event
   Unipointer.getPointerPoint = function( pointer ) {
     return {
       x: pointer.pageX,
       y: pointer.pageY
     };
   };
   
   // -----  ----- //
   
   return Unipointer;
   
   }));
   
   
   /***/ }),
   /* 9 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
    * getSize v2.0.3
    * measure size of elements
    * MIT license
    */
   
   /* jshint browser: true, strict: true, undef: true, unused: true */
   /* globals console: false */
   
   ( function( window, factory ) {
     /* jshint strict: false */ /* globals define, module */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                   (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                   __WEBPACK_AMD_DEFINE_FACTORY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   })( window, function factory() {
   'use strict';
   
   // -------------------------- helpers -------------------------- //
   
   // get a number from a string, not a percentage
   function getStyleSize( value ) {
     var num = parseFloat( value );
     // not a percent like '100%', and a number
     var isValid = value.indexOf('%') == -1 && !isNaN( num );
     return isValid && num;
   }
   
   function noop() {}
   
   var logError = typeof console == 'undefined' ? noop :
     function( message ) {
       console.error( message );
     };
   
   // -------------------------- measurements -------------------------- //
   
   var measurements = [
     'paddingLeft',
     'paddingRight',
     'paddingTop',
     'paddingBottom',
     'marginLeft',
     'marginRight',
     'marginTop',
     'marginBottom',
     'borderLeftWidth',
     'borderRightWidth',
     'borderTopWidth',
     'borderBottomWidth'
   ];
   
   var measurementsLength = measurements.length;
   
   function getZeroSize() {
     var size = {
       width: 0,
       height: 0,
       innerWidth: 0,
       innerHeight: 0,
       outerWidth: 0,
       outerHeight: 0
     };
     for ( var i=0; i < measurementsLength; i++ ) {
       var measurement = measurements[i];
       size[ measurement ] = 0;
     }
     return size;
   }
   
   // -------------------------- getStyle -------------------------- //
   
   /**
    * getStyle, get style of element, check for Firefox bug
    * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    */
   function getStyle( elem ) {
     var style = getComputedStyle( elem );
     if ( !style ) {
       logError( 'Style returned ' + style +
         '. Are you running this code in a hidden iframe on Firefox? ' +
         'See https://bit.ly/getsizebug1' );
     }
     return style;
   }
   
   // -------------------------- setup -------------------------- //
   
   var isSetup = false;
   
   var isBoxSizeOuter;
   
   /**
    * setup
    * check isBoxSizerOuter
    * do on first getSize() rather than on page load for Firefox bug
    */
   function setup() {
     // setup once
     if ( isSetup ) {
       return;
     }
     isSetup = true;
   
     // -------------------------- box sizing -------------------------- //
   
     /**
      * Chrome & Safari measure the outer-width on style.width on border-box elems
      * IE11 & Firefox<29 measures the inner-width
      */
     var div = document.createElement('div');
     div.style.width = '200px';
     div.style.padding = '1px 2px 3px 4px';
     div.style.borderStyle = 'solid';
     div.style.borderWidth = '1px 2px 3px 4px';
     div.style.boxSizing = 'border-box';
   
     var body = document.body || document.documentElement;
     body.appendChild( div );
     var style = getStyle( div );
     // round value for browser zoom. desandro/masonry#928
     isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
     getSize.isBoxSizeOuter = isBoxSizeOuter;
   
     body.removeChild( div );
   }
   
   // -------------------------- getSize -------------------------- //
   
   function getSize( elem ) {
     setup();
   
     // use querySeletor if elem is string
     if ( typeof elem == 'string' ) {
       elem = document.querySelector( elem );
     }
   
     // do not proceed on non-objects
     if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
       return;
     }
   
     var style = getStyle( elem );
   
     // if hidden, everything is 0
     if ( style.display == 'none' ) {
       return getZeroSize();
     }
   
     var size = {};
     size.width = elem.offsetWidth;
     size.height = elem.offsetHeight;
   
     var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
   
     // get all measurements
     for ( var i=0; i < measurementsLength; i++ ) {
       var measurement = measurements[i];
       var value = style[ measurement ];
       var num = parseFloat( value );
       // any 'auto', 'medium' value will be 0
       size[ measurement ] = !isNaN( num ) ? num : 0;
     }
   
     var paddingWidth = size.paddingLeft + size.paddingRight;
     var paddingHeight = size.paddingTop + size.paddingBottom;
     var marginWidth = size.marginLeft + size.marginRight;
     var marginHeight = size.marginTop + size.marginBottom;
     var borderWidth = size.borderLeftWidth + size.borderRightWidth;
     var borderHeight = size.borderTopWidth + size.borderBottomWidth;
   
     var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
   
     // overwrite width and height if we can get it from style
     var styleWidth = getStyleSize( style.width );
     if ( styleWidth !== false ) {
       size.width = styleWidth +
         // add padding and border unless it's already including it
         ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
     }
   
     var styleHeight = getStyleSize( style.height );
     if ( styleHeight !== false ) {
       size.height = styleHeight +
         // add padding and border unless it's already including it
         ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
     }
   
     size.innerWidth = size.width - ( paddingWidth + borderWidth );
     size.innerHeight = size.height - ( paddingHeight + borderHeight );
   
     size.outerWidth = size.width + marginWidth;
     size.outerHeight = size.height + marginHeight;
   
     return size;
   }
   
   return getSize;
   
   });
   
   
   /***/ }),
   /* 10 */
   /***/ (function(module, exports, __webpack_require__) {
   
   "use strict";
   
   
   
   var selectors = [
       'iframe[src*="player.vimeo.com"]',
       'iframe[src*="youtube.com"]',
       'iframe[src*="youtube-nocookie.com"]',
       'iframe[src*="kickstarter.com"][src*="video.html"]',
       'object'
   ]
   
   var css = '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}'
   
   module.exports = function (parentSelector, opts) {
       parentSelector = parentSelector || 'body'
       opts = opts || {}
   
       if (isObject(parentSelector)) {
           opts = parentSelector
           parentSelector = 'body'
       }
   
       opts.ignore = opts.ignore || ''
       opts.players = opts.players || ''
   
       var containers = queryAll(parentSelector)
       if (!hasLength(containers)) return
   
       if (!document.getElementById('fit-vids-style')) {
           var head = document.head || document.getElementsByTagName('head')[0]
           head.appendChild(styles())
       }
   
       var custom = toSelectorArray(opts.players) || []
       var ignored = toSelectorArray(opts.ignore) || []
       var selector = selectors
           .filter(notIgnored(ignored))
           .concat(custom)
           .join()
   
       if (!hasLength(selector)) return
   
       containers.forEach(function (container) {
           var videos = queryAll(container, selector)
           videos.forEach(function (video) {
               wrap(video)
           })
       })
   }
   
   function queryAll (el, selector) {
       if (typeof el === 'string') {
           selector = el
           el = document
       }
       return Array.prototype.slice.call(el.querySelectorAll(selector))
   }
   
   function toSelectorArray (input) {
       if (typeof input === 'string') {
           return input.split(',').map(trim).filter(hasLength)
       } else if (isArray(input)) {
           return flatten(input.map(toSelectorArray).filter(hasLength))
       }
       return input || []
   }
   
   function wrap (el) {
       if (/fluid-width-video-wrapper/.test(el.parentNode.className)) return
   
       var widthAttr = parseInt(el.getAttribute('width'), 10)
       var heightAttr = parseInt(el.getAttribute('height'), 10)
   
       var width = !isNaN(widthAttr) ? widthAttr : el.clientWidth
       var height = !isNaN(heightAttr) ? heightAttr : el.clientHeight
       var aspect = height / width
   
       el.removeAttribute('width')
       el.removeAttribute('height')
   
       var wrapper = document.createElement('div')
       el.parentNode.insertBefore(wrapper, el)
       wrapper.className = 'fluid-width-video-wrapper'
       wrapper.style.paddingTop = (aspect * 100) + '%'
       wrapper.appendChild(el)
   }
   
   function styles () {
       var div = document.createElement('div')
       div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>'
       return div.childNodes[1]
   }
   
   function notIgnored (ignored) {
       if (ignored.length < 1) {
           return function () {
               return true
           }
       }
       return function (selector) {
           return ignored.indexOf(selector) === -1
       }
   }
   
   function hasLength (input) {
       return input.length > 0
   }
   
   function trim (str) {
       return str.replace(/^\s+|\s+$/g, '')
   }
   
   function flatten (input) {
       return [].concat.apply([], input)
   }
   
   function isObject (input) {
       return Object.prototype.toString.call(input) === '[object Object]'
   }
   
   function isArray (input) {
       return Object.prototype.toString.call(input) === '[object Array]'
   }
   
   
   /***/ }),
   /* 11 */
   /***/ (function(module, exports, __webpack_require__) {
   
   "use strict";
   
   
   // forEach method, could be shipped as part of an Object Literal/Module
   function forEach(array, callback, scope) {
     var index = 0;
   
     for (index = 0; index < array.length; index += 1) {
       callback.call(scope, array[index], index); // passes back stuff we need
     }
   }
   
   function hasClass(el, className) {
     var regex = new RegExp('^' + className + '| +' + className, 'g');
   
     return el.className.match(regex);
   }
   
   function addClass(el, className) {
     // Return if it already has the className
     if (hasClass(el, className)) return;
   
     el.className += ' ' + className;
   }
   
   function removeClass(el, className) {
     // Return if it doesn't already have the className
     if (!hasClass(el, className)) return;
   
     var regex = new RegExp('^' + className + '| +' + className, 'g');
   
     el.className = el.className.replace(regex, '');
   }
   
   function toggleClass(el, className) {
     if (hasClass(el, className)) {
       removeClass(el, className);
     } else {
       addClass(el, className);
     }
   }
   
   function findPairingFromPairingTrigger(pairings, pairingTrigger) {
     var foundPairing = null;
   
     forEach(pairings, function (pairing) {
       if (pairing.trigger === pairingTrigger) {
         foundPairing = pairing;
       }
     });
   
     return foundPairing;
   }
   
   /**
    * See {@link https://stackoverflow.com/revisions/2117523/11 Stack Overflow}
    * An RFC4122 v4 compliant uuid solution
    */
   function uuidv4() {
     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
       var r = Math.random() * 16 | 0;
       var v = c === 'x' ? r : r & 0x3 | 0x8;
   
       return v.toString(16);
     });
   }
   
   function init(groupedContent) {
     var triggers = groupedContent.triggers;
     var pairings = groupedContent.pairings;
   
     triggers.setAttribute('role', 'tablist');
   
     forEach(pairings, function (pairing, index) {
       pairing.trigger.setAttribute('role', 'tab');
       pairing.trigger.setAttribute('aria-controls', groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content');
   
       if (pairing.trigger.children.length > 0) {
         forEach(pairing.trigger.children, function (child) {
           child.setAttribute('tabIndex', '-1');
         });
       }
   
       if (hasClass(pairing.trigger, 'active')) {
         pairing.trigger.setAttribute('aria-selected', 'true');
         pairing.trigger.setAttribute('tabIndex', '0');
       } else {
         pairing.trigger.setAttribute('tabIndex', '-1');
       }
   
       pairing.content.id = groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content';
       pairing.content.setAttribute('role', 'tabpanel');
   
       if (!hasClass(pairing.content, 'active')) {
         pairing.content.setAttribute('aria-hidden', 'true');
       }
     });
   }
   
   function update(groupedContent) {
     var pairings = groupedContent.pairings;
   
     forEach(pairings, function (pairing) {
       pairing.trigger.removeAttribute('aria-selected');
       pairing.content.removeAttribute('aria-hidden');
   
       if (hasClass(pairing.trigger, 'active')) {
         pairing.trigger.setAttribute('aria-selected', 'true');
         pairing.trigger.setAttribute('tabIndex', '0');
       } else {
         pairing.trigger.setAttribute('tabIndex', '-1');
       }
   
       if (!hasClass(pairing.content, 'active')) {
         pairing.content.setAttribute('aria-hidden', 'true');
       }
     });
   }
   
   var a11y = {
     init: init,
     update: update
   };
   
   var asyncGenerator = function () {
     function AwaitValue(value) {
       this.value = value;
     }
   
     function AsyncGenerator(gen) {
       var front, back;
   
       function send(key, arg) {
         return new Promise(function (resolve, reject) {
           var request = {
             key: key,
             arg: arg,
             resolve: resolve,
             reject: reject,
             next: null
           };
   
           if (back) {
             back = back.next = request;
           } else {
             front = back = request;
             resume(key, arg);
           }
         });
       }
   
       function resume(key, arg) {
         try {
           var result = gen[key](arg);
           var value = result.value;
   
           if (value instanceof AwaitValue) {
             Promise.resolve(value.value).then(function (arg) {
               resume("next", arg);
             }, function (arg) {
               resume("throw", arg);
             });
           } else {
             settle(result.done ? "return" : "normal", result.value);
           }
         } catch (err) {
           settle("throw", err);
         }
       }
   
       function settle(type, value) {
         switch (type) {
           case "return":
             front.resolve({
               value: value,
               done: true
             });
             break;
   
           case "throw":
             front.reject(value);
             break;
   
           default:
             front.resolve({
               value: value,
               done: false
             });
             break;
         }
   
         front = front.next;
   
         if (front) {
           resume(front.key, front.arg);
         } else {
           back = null;
         }
       }
   
       this._invoke = send;
   
       if (typeof gen.return !== "function") {
         this.return = undefined;
       }
     }
   
     if (typeof Symbol === "function" && Symbol.asyncIterator) {
       AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
         return this;
       };
     }
   
     AsyncGenerator.prototype.next = function (arg) {
       return this._invoke("next", arg);
     };
   
     AsyncGenerator.prototype.throw = function (arg) {
       return this._invoke("throw", arg);
     };
   
     AsyncGenerator.prototype.return = function (arg) {
       return this._invoke("return", arg);
     };
   
     return {
       wrap: function (fn) {
         return function () {
           return new AsyncGenerator(fn.apply(this, arguments));
         };
       },
       await: function (value) {
         return new AwaitValue(value);
       }
     };
   }();
   
   
   
   
   
   var classCallCheck = function (instance, Constructor) {
     if (!(instance instanceof Constructor)) {
       throw new TypeError("Cannot call a class as a function");
     }
   };
   
   var createClass = function () {
     function defineProperties(target, props) {
       for (var i = 0; i < props.length; i++) {
         var descriptor = props[i];
         descriptor.enumerable = descriptor.enumerable || false;
         descriptor.configurable = true;
         if ("value" in descriptor) descriptor.writable = true;
         Object.defineProperty(target, descriptor.key, descriptor);
       }
     }
   
     return function (Constructor, protoProps, staticProps) {
       if (protoProps) defineProperties(Constructor.prototype, protoProps);
       if (staticProps) defineProperties(Constructor, staticProps);
       return Constructor;
     };
   }();
   
   /** A class for creating, managing, and destroying groupable content as tabs. */
   
   var TabsLayout = function () {
     function TabsLayout(groupedContent) {
       classCallCheck(this, TabsLayout);
   
       this.groupedContent = groupedContent;
       this.pairings = groupedContent.pairings;
       this.events = [];
   
       this._handleKeydown = this._handleKeydown.bind(this);
       this._handleClick = this._handleClick.bind(this);
   
       this._init();
       a11y.init(this.groupedContent);
     }
   
     createClass(TabsLayout, [{
       key: 'unload',
       value: function unload() {
         forEach(this.events, function (event) {
           event.trigger.removeEventListener(event.type, event.fn);
         });
       }
     }, {
       key: '_init',
       value: function _init() {
         var _this = this;
   
         var existingActive = false;
   
         forEach(this.pairings, function (pairing) {
           var trigger = pairing.trigger;
   
           if (hasClass(trigger, 'active')) {
             existingActive = true;
           }
   
           trigger.addEventListener('keydown', _this._handleKeydown);
           trigger.addEventListener('click', _this._handleClick);
   
           _this.events.push({
             trigger: trigger,
             type: 'keydown',
             fn: _this._handleKeydown
           });
   
           _this.events.push({
             trigger: trigger,
             type: 'click',
             fn: _this._handleClick
           });
         });
   
         if (!existingActive) {
           addClass(this.pairings[0].trigger, 'active');
           addClass(this.pairings[0].content, 'active');
         }
       }
     }, {
       key: '_handleKeydown',
       value: function _handleKeydown(event) {
         var trigger = event.currentTarget;
         var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
         var pairingIndex = this.pairings.indexOf(pairing);
         var prevIndex = pairingIndex - 1 < 0 ? this.pairings.length - 1 : pairingIndex - 1;
         var nextIndex = pairingIndex + 1 >= this.pairings.length ? 0 : pairingIndex + 1;
   
         var nextPairing = null;
   
         switch (event.key) {
           case 'ArrowLeft':
             nextPairing = this.pairings[prevIndex];
             break;
           case 'ArrowRight':
             nextPairing = this.pairings[nextIndex];
             break;
           default:
             nextPairing = null;
             break;
         }
   
         // Fast exit if we can't find the tab or tabs
         if (nextPairing === null) return;
   
         event.preventDefault();
   
         forEach(this.pairings, function (inactivePairing) {
           removeClass(inactivePairing.trigger, 'active');
           removeClass(inactivePairing.content, 'active');
         });
   
         addClass(nextPairing.trigger, 'active');
         addClass(nextPairing.content, 'active');
   
         nextPairing.trigger.focus();
   
         a11y.update(this.groupedContent);
       }
     }, {
       key: '_handleClick',
       value: function _handleClick(event) {
         var trigger = event.currentTarget;
         var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
   
         // Fast exit if we can't find the tab or tabs
         if (pairing === null) return;
   
         event.preventDefault();
   
         forEach(this.pairings, function (inactivePairing) {
           removeClass(inactivePairing.trigger, 'active');
           removeClass(inactivePairing.content, 'active');
         });
   
         addClass(pairing.trigger, 'active');
         addClass(pairing.content, 'active');
   
         a11y.update(this.groupedContent);
       }
     }]);
     return TabsLayout;
   }();
   
   function init$1(groupedContent) {
     var pairings = groupedContent.pairings;
   
     forEach(pairings, function (pairing, index) {
       pairing.trigger.setAttribute('role', 'button');
       pairing.trigger.setAttribute('aria-controls', groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content');
       pairing.trigger.setAttribute('tabIndex', '0');
   
       if (pairing.trigger.children.length > 0) {
         forEach(pairing.trigger.children, function (child) {
           child.setAttribute('tabIndex', '-1');
         });
       }
   
       if (hasClass(pairing.trigger, 'active')) {
         pairing.trigger.setAttribute('aria-expanded', 'true');
       } else {
         pairing.trigger.setAttribute('aria-expanded', 'false');
       }
   
       pairing.content.id = groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content';
   
       if (!hasClass(pairing.content, 'active')) {
         pairing.content.setAttribute('aria-hidden', 'true');
       }
     });
   }
   
   function update$1(groupedContent) {
     var pairings = groupedContent.pairings;
   
     forEach(pairings, function (pairing) {
       pairing.content.removeAttribute('aria-hidden');
   
       if (hasClass(pairing.trigger, 'active')) {
         pairing.trigger.setAttribute('aria-expanded', 'true');
       } else {
         pairing.trigger.setAttribute('aria-expanded', 'false');
       }
   
       if (!hasClass(pairing.content, 'active')) {
         pairing.content.setAttribute('aria-hidden', 'true');
       }
     });
   }
   
   var a11y$1 = {
     init: init$1,
     update: update$1
   };
   
   /** A class for creating, managing, and destroying groupable content as an accordion. */
   
   var AccordionLayout = function () {
     function AccordionLayout(groupedContent) {
       classCallCheck(this, AccordionLayout);
   
       this.groupedContent = groupedContent;
       this.pairings = groupedContent.pairings;
       this.events = [];
   
       this._handleKeydown = this._handleKeydown.bind(this);
       this._handleClick = this._handleClick.bind(this);
   
       this._init(this.pairings);
       a11y$1.init(this.groupedContent);
     }
   
     createClass(AccordionLayout, [{
       key: 'unload',
       value: function unload() {
         forEach(this.events, function (event) {
           event.trigger.removeEventListener(event.type, event.fn);
         });
       }
     }, {
       key: '_init',
       value: function _init() {
         var _this = this;
   
         forEach(this.pairings, function (pairing) {
           var trigger = pairing.trigger;
           var content = pairing.content;
   
           trigger.parentNode.insertBefore(content, trigger.nextSibling);
   
           trigger.addEventListener('keydown', _this._handleKeydown);
           trigger.addEventListener('click', _this._handleClick);
   
           _this.events.push({
             trigger: trigger,
             type: 'keydown',
             fn: _this._handleKeydown
           });
   
           _this.events.push({
             trigger: trigger,
             type: 'click',
             fn: _this._handleClick
           });
         });
   
         this.groupedContent.contents.remove();
       }
     }, {
       key: '_handleKeydown',
       value: function _handleKeydown(event) {
         var trigger = event.currentTarget;
         var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
   
         // Fast exit if enter isn't pressed or we can't find the group
         if (event.key !== 'Enter' || pairing === null) return;
   
         event.preventDefault();
   
         toggleClass(pairing.trigger, 'active');
         toggleClass(pairing.content, 'active');
         a11y$1.update(this.groupedContent);
       }
     }, {
       key: '_handleClick',
       value: function _handleClick(event) {
         var trigger = event.currentTarget;
         var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
   
         // Fast exit if we can't find the group
         if (pairing === null) return;
   
         event.preventDefault();
   
         toggleClass(pairing.trigger, 'active');
         toggleClass(pairing.content, 'active');
         a11y$1.update(this.groupedContent);
       }
     }]);
     return AccordionLayout;
   }();
   
   /**
    * Returns an array of nodes related to the heading node.
    * @param {node} heading - The heading node to search for content from.
    * @returns {node[]}
    */
   function getHeadingContent(heading) {
     var headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
     var tagNameIndex = headingTagNames.indexOf(heading.tagName);
     var content = [];
   
     var sibling = heading.nextElementSibling;
   
     while (sibling !== null && (headingTagNames.indexOf(sibling.tagName) === -1 || headingTagNames.indexOf(sibling.tagName) > tagNameIndex)) {
       content.push(sibling);
   
       sibling = sibling.nextElementSibling;
     }
   
     return content;
   }
   
   /**
    * Returns an object array representing the heading tree from a given node.
    * Root nodes are evaluated differently, and requires the evaluatingRoot flag
    * to be true.
    * @param {node} el - The node being evaluated.
    * @param {node[]} children - The children of the evaluated node.
    * @param {boolean} [evaluatingRoot] - Whether to evaluate as root node.
    * @returns {Object[]}
    */
   function getHeadingTree(el, children) {
     var evaluatingRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
   
     var headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
     var tagNameIndex = headingTagNames.indexOf(el.tagName);
     var headings = [];
   
     var currentLowestTagNameIndex = 5;
   
     for (var i = 0; i < children.length; i += 1) {
       var child = children[i];
       var childTagNameIndex = headingTagNames.indexOf(child.tagName);
   
       if (childTagNameIndex !== -1 && childTagNameIndex < currentLowestTagNameIndex) {
         currentLowestTagNameIndex = childTagNameIndex;
       }
   
       if (evaluatingRoot && childTagNameIndex !== -1 && childTagNameIndex <= currentLowestTagNameIndex || !evaluatingRoot && childTagNameIndex !== -1 && childTagNameIndex === tagNameIndex + 1) {
         var siblings = getHeadingContent(child);
   
         var childNode = {
           el: child,
           content: siblings,
           children: getHeadingTree(child, siblings)
         };
   
         headings.push(childNode);
       }
     }
   
     return headings;
   }
   
   /**
    * Returns groupings of headings that meet the minimum sequence value
    * and don't contain any invalid headings.
    * @param {Object[]} headings - An array of heading objects.
    * @param {int[]} invalidHeadings - An array of invalid heading integers,
    *                                  representing indexes of headings.
    * @param {*} minInSequence - Minimum headings in sequence before being considered
    *                            as a grouping.
    * @returns {Object[][]}
    */
   function getHeadingGroupsInSequence(headings, invalidHeadings, minInSequence) {
     var headingGroupsInSequence = [];
     var currentHeadingGroupInSequence = [];
     var currentSequence = 0;
   
     for (var i = 0; i < headings.length; i += 1) {
       if (invalidHeadings.indexOf(i) === -1) {
         currentHeadingGroupInSequence.push(headings[i]);
         currentSequence += 1;
   
         if (i !== headings.length - 1 && headings[i].el.tagName !== headings[i + 1].el.tagName && invalidHeadings.indexOf(i + 1)) {
           currentHeadingGroupInSequence = [];
           currentSequence = 0;
         } else if (i !== 0 && headings[i].el.tagName !== headings[i - 1].el.tagName) {
           currentHeadingGroupInSequence.pop();
           currentSequence -= 1;
   
           if (currentSequence >= minInSequence) {
             headingGroupsInSequence.push(currentHeadingGroupInSequence);
           }
   
           currentHeadingGroupInSequence = [headings[i]];
           currentSequence = 1;
         }
       }
     }
   
     if (currentSequence >= minInSequence) {
       headingGroupsInSequence.push(currentHeadingGroupInSequence);
     }
   
     return headingGroupsInSequence;
   }
   
   /**
    * Generates necessary DOM elements to group related content.
    * Returns a object array representing the grouped content.
    * @param {Object[]} children - An array of objects.
    * @returns {Object[]}
    */
   function createGroupedContent(children) {
     var pairings = [];
   
     var firstChild = children[0].el;
     var triggers = document.createElement('div');
     var contents = document.createElement('div');
   
     contents = firstChild.parentNode.insertBefore(contents, firstChild.nextSibling);
     triggers = firstChild.parentNode.insertBefore(triggers, firstChild.nextSibling);
   
     for (var i = 0; i < children.length; i += 1) {
       var child = children[i];
       var trigger = child.el;
       var content = document.createElement('div');
   
       trigger = triggers.appendChild(trigger);
       content = contents.appendChild(content);
   
       for (var j = 0; j < child.content.length; j += 1) {
         content.appendChild(child.content[j]);
       }
   
       pairings.push({
         trigger: trigger,
         content: content
       });
     }
   
     return {
       triggers: triggers,
       contents: contents,
       pairings: pairings
     };
   }
   
   /**
    * Returns all groupable content within the supplied node.
    * @param {node} node - A node to traverse for groupable content.
    * @returns {Object[][]}
    */
   /*
    * Recursive function:
    *  Returns all groups of headings that
    *  are elegible to become grouped content.
    */
   function getGroupedContentSet(node) {
     var children = node.children;
     var childrenWithGroupableContent = [];
     var groupedContentSet = [];
   
     if (children.length === 0) {
       return [];
     }
   
     for (var i = 0; i < children.length; i += 1) {
       var childGroupableContent = getGroupedContentSet(children[i]);
   
       if (childGroupableContent.length > 0) {
         childrenWithGroupableContent.push(i);
         groupedContentSet = groupedContentSet.concat(childGroupableContent);
       }
     }
   
     var headingGroupsInSequence = getHeadingGroupsInSequence(children, childrenWithGroupableContent, 3);
   
     for (var _i = 0; _i < headingGroupsInSequence.length; _i += 1) {
       groupedContentSet.push(createGroupedContent(headingGroupsInSequence[_i]));
     }
   
     return groupedContentSet;
   }
   
   /**
    * When static parsing isn't enough, there's intelliparse™!
    * Searches through dom content to find heading groupings that
    * are elegible to become tab groups.
    * Assumes that content is in a flattened hierarchy in the dom
    * and interprets increasing heading values as a deeper level of nesting.
    * Returns all groupable content as an array of object arrays.
    * @param {node} el - The node who's content will be searched for groupable content.
    * @returns {Object[][]}
    */
   function intelliParse(el) {
     var children = el.children;
     var heading = el.querySelector('h1, h2, h3, h4, h5, h6');
   
     // Fast return if there's no headings
     if (children.length === 0) return [];
   
     var rootNode = {
       el: el,
       content: null,
       children: getHeadingTree(heading, children, true)
     };
   
     return getGroupedContentSet(rootNode);
   }
   
   /**
    * Parses content from a given node based on a static structure.
    * The structure is as follows:
    * <ul class="tabs">
    *   <li class="active">Tab 1</li>
    *   <li>Tab 2</li>
    *   <li>Tab 3</li>
    * </ul>
    *
    * <ul class="tabs-content">
    *   <li class="active">
    *     <p>Tab 1 content goes here.</p>
    *   </li>
    *   <li>
    *     <p>Tab 2 content goes here.</p>
    *   </li>
    *   <li>
    *     <p>Tab 3 content goes here.</p>
    *   </li>
    * </ul>
    * Returns all groupable content as an array of object arrays.
    * @param {node} el - The node who's content will be searched for groupable content.
    * @returns {Object[][]}
    */
   function staticParse(el) {
     var groupedContentSet = [];
   
     var tabs = el.querySelectorAll('.tabs');
   
     for (var i = 0; i < tabs.length; i += 1) {
       var triggers = tabs[i].children;
       var contents = tabs[i].nextElementSibling.children;
   
       // Only add a tab group if equal triggers to contents
       if (triggers.length === contents.length) {
         var length = groupedContentSet.push({
           triggers: tabs[i],
           contents: tabs[i].nextElementSibling,
           pairings: []
         });
         var index = length - 1;
   
         for (var j = 0; j < triggers.length; j += 1) {
           var trigger = triggers[j];
           var content = contents[j];
   
           var pairing = {
             trigger: trigger,
             content: content
           };
   
           groupedContentSet[index].pairings.push(pairing);
         }
       }
     }
   
     return groupedContentSet;
   }
   
   /**
    * Returns all groupable content as an array of object arrays.
    * @param {node} content - The node to parse for groupable content.
    * @param {boolean} intelliparse - Whether to use intelligent parsing.
    * @returns {Object[][]}
    */
   function parse(content) {
     var intelliparse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
   
     var groupedContentSet = intelliparse ? intelliParse(content) : staticParse(content);
   
     return groupedContentSet;
   }
   
   /** A class for creating, managing, and destroying groupable content. */
   
   var GroupedContent = function () {
     /**
      * Create grouped content
      * @param {node} el - The element to search for groupable content in.
      * @param {Object}  [options] - Additional options
      * @param {string}  [options.layout] - The layout to display groupable content in.
      * @param {boolean} [options.intelliparse] - The parsing algorithm used to find content with.
      */
     function GroupedContent(el) {
       var _this = this;
   
       var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
       classCallCheck(this, GroupedContent);
   
       this.namespace = 'grouped-content';
       this.el = el;
       this.groupedContentInstances = [];
   
       var layout = options.layout || 'tabs';
       var intelliparse = !!options.intelliparse;
   
       forEach(parse(el, intelliparse), function (groupedContent) {
         var id = uuidv4();
         var instance = null;
         var groupedContentWrapper = document.createElement('div');
   
         groupedContentWrapper = groupedContent.triggers.parentNode.insertBefore(groupedContentWrapper, groupedContent.triggers.nextSibling);
   
         addClass(groupedContentWrapper, _this.namespace);
         addClass(groupedContentWrapper, _this.namespace + '-layout-' + layout);
   
         groupedContentWrapper.appendChild(groupedContent.triggers);
         groupedContentWrapper.appendChild(groupedContent.contents);
   
         groupedContent.namespace = _this.namespace;
         groupedContent.id = id;
         groupedContent.triggers.id = _this.namespace + '-' + id + '-triggers';
         groupedContent.contents.id = _this.namespace + '-' + id + '-contents';
   
         addClass(groupedContent.triggers, _this.namespace + '-triggers');
         addClass(groupedContent.contents, _this.namespace + '-contents');
   
         forEach(groupedContent.pairings, function (pairing) {
           addClass(pairing.trigger, _this.namespace + '-trigger');
           addClass(pairing.content, _this.namespace + '-content');
         });
   
         switch (layout) {
           case 'accordion':
             instance = new AccordionLayout(groupedContent);
             break;
           case 'tabs':
           default:
             instance = new TabsLayout(groupedContent);
             break;
         }
   
         _this.groupedContentInstances.push({
           groupedContent: groupedContent,
           instance: instance
         });
       });
     }
   
     /** Unload all grouped content instances */
   
   
     createClass(GroupedContent, [{
       key: 'unload',
       value: function unload() {
         forEach(this.groupedContentInstances, function (groupedContentInstance) {
           groupedContentInstance.instance.unload();
         });
       }
     }]);
     return GroupedContent;
   }();
   
   module.exports = GroupedContent;
   
   
   /***/ }),
   /* 12 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_RESULT__;/*!
    * EventEmitter2
    * https://github.com/hij1nx/EventEmitter2
    *
    * Copyright (c) 2013 hij1nx
    * Licensed under the MIT license.
    */
   ;!function(undefined) {
   
     var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
       return Object.prototype.toString.call(obj) === "[object Array]";
     };
     var defaultMaxListeners = 10;
   
     function init() {
       this._events = {};
       if (this._conf) {
         configure.call(this, this._conf);
       }
     }
   
     function configure(conf) {
       if (conf) {
         this._conf = conf;
   
         conf.delimiter && (this.delimiter = conf.delimiter);
         this._events.maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
         conf.wildcard && (this.wildcard = conf.wildcard);
         conf.newListener && (this.newListener = conf.newListener);
         conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
   
         if (this.wildcard) {
           this.listenerTree = {};
         }
       } else {
         this._events.maxListeners = defaultMaxListeners;
       }
     }
   
     function logPossibleMemoryLeak(count, eventName) {
       var errorMsg = '(node) warning: possible EventEmitter memory ' +
           'leak detected. %d listeners added. ' +
           'Use emitter.setMaxListeners() to increase limit.';
   
       if(this.verboseMemoryLeak){
         errorMsg += ' Event name: %s.';
         console.error(errorMsg, count, eventName);
       } else {
         console.error(errorMsg, count);
       }
   
       if (console.trace){
         console.trace();
       }
     }
   
     function EventEmitter(conf) {
       this._events = {};
       this.newListener = false;
       this.verboseMemoryLeak = false;
       configure.call(this, conf);
     }
     EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
   
     //
     // Attention, function return type now is array, always !
     // It has zero elements if no any matches found and one or more
     // elements (leafs) if there are matches
     //
     function searchListenerTree(handlers, type, tree, i) {
       if (!tree) {
         return [];
       }
       var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
           typeLength = type.length, currentType = type[i], nextType = type[i+1];
       if (i === typeLength && tree._listeners) {
         //
         // If at the end of the event(s) list and the tree has listeners
         // invoke those listeners.
         //
         if (typeof tree._listeners === 'function') {
           handlers && handlers.push(tree._listeners);
           return [tree];
         } else {
           for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
             handlers && handlers.push(tree._listeners[leaf]);
           }
           return [tree];
         }
       }
   
       if ((currentType === '*' || currentType === '**') || tree[currentType]) {
         //
         // If the event emitted is '*' at this part
         // or there is a concrete match at this patch
         //
         if (currentType === '*') {
           for (branch in tree) {
             if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
               listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
             }
           }
           return listeners;
         } else if(currentType === '**') {
           endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
           if(endReached && tree._listeners) {
             // The next element has a _listeners, add it to the handlers.
             listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
           }
   
           for (branch in tree) {
             if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
               if(branch === '*' || branch === '**') {
                 if(tree[branch]._listeners && !endReached) {
                   listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                 }
                 listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
               } else if(branch === nextType) {
                 listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
               } else {
                 // No match on this one, shift into the tree but not in the type array.
                 listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
               }
             }
           }
           return listeners;
         }
   
         listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
       }
   
       xTree = tree['*'];
       if (xTree) {
         //
         // If the listener tree will allow any match for this part,
         // then recursively explore all branches of the tree
         //
         searchListenerTree(handlers, type, xTree, i+1);
       }
   
       xxTree = tree['**'];
       if(xxTree) {
         if(i < typeLength) {
           if(xxTree._listeners) {
             // If we have a listener on a '**', it will catch all, so add its handler.
             searchListenerTree(handlers, type, xxTree, typeLength);
           }
   
           // Build arrays of matching next branches and others.
           for(branch in xxTree) {
             if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
               if(branch === nextType) {
                 // We know the next element will match, so jump twice.
                 searchListenerTree(handlers, type, xxTree[branch], i+2);
               } else if(branch === currentType) {
                 // Current node matches, move into the tree.
                 searchListenerTree(handlers, type, xxTree[branch], i+1);
               } else {
                 isolatedBranch = {};
                 isolatedBranch[branch] = xxTree[branch];
                 searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
               }
             }
           }
         } else if(xxTree._listeners) {
           // We have reached the end and still on a '**'
           searchListenerTree(handlers, type, xxTree, typeLength);
         } else if(xxTree['*'] && xxTree['*']._listeners) {
           searchListenerTree(handlers, type, xxTree['*'], typeLength);
         }
       }
   
       return listeners;
     }
   
     function growListenerTree(type, listener) {
   
       type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
   
       //
       // Looks for two consecutive '**', if so, don't add the event at all.
       //
       for(var i = 0, len = type.length; i+1 < len; i++) {
         if(type[i] === '**' && type[i+1] === '**') {
           return;
         }
       }
   
       var tree = this.listenerTree;
       var name = type.shift();
   
       while (name !== undefined) {
   
         if (!tree[name]) {
           tree[name] = {};
         }
   
         tree = tree[name];
   
         if (type.length === 0) {
   
           if (!tree._listeners) {
             tree._listeners = listener;
           }
           else {
             if (typeof tree._listeners === 'function') {
               tree._listeners = [tree._listeners];
             }
   
             tree._listeners.push(listener);
   
             if (
               !tree._listeners.warned &&
               this._events.maxListeners > 0 &&
               tree._listeners.length > this._events.maxListeners
             ) {
               tree._listeners.warned = true;
               logPossibleMemoryLeak.call(this, tree._listeners.length, name);
             }
           }
           return true;
         }
         name = type.shift();
       }
       return true;
     }
   
     // By default EventEmitters will print a warning if more than
     // 10 listeners are added to it. This is a useful default which
     // helps finding memory leaks.
     //
     // Obviously not all Emitters should be limited to 10. This function allows
     // that to be increased. Set to zero for unlimited.
   
     EventEmitter.prototype.delimiter = '.';
   
     EventEmitter.prototype.setMaxListeners = function(n) {
       if (n !== undefined) {
         this._events || init.call(this);
         this._events.maxListeners = n;
         if (!this._conf) this._conf = {};
         this._conf.maxListeners = n;
       }
     };
   
     EventEmitter.prototype.event = '';
   
     EventEmitter.prototype.once = function(event, fn) {
       this.many(event, 1, fn);
       return this;
     };
   
     EventEmitter.prototype.many = function(event, ttl, fn) {
       var self = this;
   
       if (typeof fn !== 'function') {
         throw new Error('many only accepts instances of Function');
       }
   
       function listener() {
         if (--ttl === 0) {
           self.off(event, listener);
         }
         return fn.apply(this, arguments);
       }
   
       listener._origin = fn;
   
       this.on(event, listener);
   
       return self;
     };
   
     EventEmitter.prototype.emit = function() {
   
       this._events || init.call(this);
   
       var type = arguments[0];
   
       if (type === 'newListener' && !this.newListener) {
         if (!this._events.newListener) {
           return false;
         }
       }
   
       var al = arguments.length;
       var args,l,i,j;
       var handler;
   
       if (this._all && this._all.length) {
         handler = this._all.slice();
         if (al > 3) {
           args = new Array(al);
           for (j = 0; j < al; j++) args[j] = arguments[j];
         }
   
         for (i = 0, l = handler.length; i < l; i++) {
           this.event = type;
           switch (al) {
           case 1:
             handler[i].call(this, type);
             break;
           case 2:
             handler[i].call(this, type, arguments[1]);
             break;
           case 3:
             handler[i].call(this, type, arguments[1], arguments[2]);
             break;
           default:
             handler[i].apply(this, args);
           }
         }
       }
   
       if (this.wildcard) {
         handler = [];
         var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
         searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
       } else {
         handler = this._events[type];
         if (typeof handler === 'function') {
           this.event = type;
           switch (al) {
           case 1:
             handler.call(this);
             break;
           case 2:
             handler.call(this, arguments[1]);
             break;
           case 3:
             handler.call(this, arguments[1], arguments[2]);
             break;
           default:
             args = new Array(al - 1);
             for (j = 1; j < al; j++) args[j - 1] = arguments[j];
             handler.apply(this, args);
           }
           return true;
         } else if (handler) {
           // need to make copy of handlers because list can change in the middle
           // of emit call
           handler = handler.slice();
         }
       }
   
       if (handler && handler.length) {
         if (al > 3) {
           args = new Array(al - 1);
           for (j = 1; j < al; j++) args[j - 1] = arguments[j];
         }
         for (i = 0, l = handler.length; i < l; i++) {
           this.event = type;
           switch (al) {
           case 1:
             handler[i].call(this);
             break;
           case 2:
             handler[i].call(this, arguments[1]);
             break;
           case 3:
             handler[i].call(this, arguments[1], arguments[2]);
             break;
           default:
             handler[i].apply(this, args);
           }
         }
         return true;
       } else if (!this._all && type === 'error') {
         if (arguments[1] instanceof Error) {
           throw arguments[1]; // Unhandled 'error' event
         } else {
           throw new Error("Uncaught, unspecified 'error' event.");
         }
         return false;
       }
   
       return !!this._all;
     };
   
     EventEmitter.prototype.emitAsync = function() {
   
       this._events || init.call(this);
   
       var type = arguments[0];
   
       if (type === 'newListener' && !this.newListener) {
           if (!this._events.newListener) { return Promise.resolve([false]); }
       }
   
       var promises= [];
   
       var al = arguments.length;
       var args,l,i,j;
       var handler;
   
       if (this._all) {
         if (al > 3) {
           args = new Array(al);
           for (j = 1; j < al; j++) args[j] = arguments[j];
         }
         for (i = 0, l = this._all.length; i < l; i++) {
           this.event = type;
           switch (al) {
           case 1:
             promises.push(this._all[i].call(this, type));
             break;
           case 2:
             promises.push(this._all[i].call(this, type, arguments[1]));
             break;
           case 3:
             promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
             break;
           default:
             promises.push(this._all[i].apply(this, args));
           }
         }
       }
   
       if (this.wildcard) {
         handler = [];
         var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
         searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
       } else {
         handler = this._events[type];
       }
   
       if (typeof handler === 'function') {
         this.event = type;
         switch (al) {
         case 1:
           promises.push(handler.call(this));
           break;
         case 2:
           promises.push(handler.call(this, arguments[1]));
           break;
         case 3:
           promises.push(handler.call(this, arguments[1], arguments[2]));
           break;
         default:
           args = new Array(al - 1);
           for (j = 1; j < al; j++) args[j - 1] = arguments[j];
           promises.push(handler.apply(this, args));
         }
       } else if (handler && handler.length) {
         handler = handler.slice();
         if (al > 3) {
           args = new Array(al - 1);
           for (j = 1; j < al; j++) args[j - 1] = arguments[j];
         }
         for (i = 0, l = handler.length; i < l; i++) {
           this.event = type;
           switch (al) {
           case 1:
             promises.push(handler[i].call(this));
             break;
           case 2:
             promises.push(handler[i].call(this, arguments[1]));
             break;
           case 3:
             promises.push(handler[i].call(this, arguments[1], arguments[2]));
             break;
           default:
             promises.push(handler[i].apply(this, args));
           }
         }
       } else if (!this._all && type === 'error') {
         if (arguments[1] instanceof Error) {
           return Promise.reject(arguments[1]); // Unhandled 'error' event
         } else {
           return Promise.reject("Uncaught, unspecified 'error' event.");
         }
       }
   
       return Promise.all(promises);
     };
   
     EventEmitter.prototype.on = function(type, listener) {
       if (typeof type === 'function') {
         this.onAny(type);
         return this;
       }
   
       if (typeof listener !== 'function') {
         throw new Error('on only accepts instances of Function');
       }
       this._events || init.call(this);
   
       // To avoid recursion in the case that type == "newListeners"! Before
       // adding it to the listeners, first emit "newListeners".
       this.emit('newListener', type, listener);
   
       if (this.wildcard) {
         growListenerTree.call(this, type, listener);
         return this;
       }
   
       if (!this._events[type]) {
         // Optimize the case of one listener. Don't need the extra array object.
         this._events[type] = listener;
       }
       else {
         if (typeof this._events[type] === 'function') {
           // Change to array.
           this._events[type] = [this._events[type]];
         }
   
         // If we've already got an array, just append.
         this._events[type].push(listener);
   
         // Check for listener leak
         if (
           !this._events[type].warned &&
           this._events.maxListeners > 0 &&
           this._events[type].length > this._events.maxListeners
         ) {
           this._events[type].warned = true;
           logPossibleMemoryLeak.call(this, this._events[type].length, type);
         }
       }
   
       return this;
     };
   
     EventEmitter.prototype.onAny = function(fn) {
       if (typeof fn !== 'function') {
         throw new Error('onAny only accepts instances of Function');
       }
   
       if (!this._all) {
         this._all = [];
       }
   
       // Add the function to the event listener collection.
       this._all.push(fn);
       return this;
     };
   
     EventEmitter.prototype.addListener = EventEmitter.prototype.on;
   
     EventEmitter.prototype.off = function(type, listener) {
       if (typeof listener !== 'function') {
         throw new Error('removeListener only takes instances of Function');
       }
   
       var handlers,leafs=[];
   
       if(this.wildcard) {
         var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
         leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
       }
       else {
         // does not use listeners(), so no side effect of creating _events[type]
         if (!this._events[type]) return this;
         handlers = this._events[type];
         leafs.push({_listeners:handlers});
       }
   
       for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
         var leaf = leafs[iLeaf];
         handlers = leaf._listeners;
         if (isArray(handlers)) {
   
           var position = -1;
   
           for (var i = 0, length = handlers.length; i < length; i++) {
             if (handlers[i] === listener ||
               (handlers[i].listener && handlers[i].listener === listener) ||
               (handlers[i]._origin && handlers[i]._origin === listener)) {
               position = i;
               break;
             }
           }
   
           if (position < 0) {
             continue;
           }
   
           if(this.wildcard) {
             leaf._listeners.splice(position, 1);
           }
           else {
             this._events[type].splice(position, 1);
           }
   
           if (handlers.length === 0) {
             if(this.wildcard) {
               delete leaf._listeners;
             }
             else {
               delete this._events[type];
             }
           }
   
           this.emit("removeListener", type, listener);
   
           return this;
         }
         else if (handlers === listener ||
           (handlers.listener && handlers.listener === listener) ||
           (handlers._origin && handlers._origin === listener)) {
           if(this.wildcard) {
             delete leaf._listeners;
           }
           else {
             delete this._events[type];
           }
   
           this.emit("removeListener", type, listener);
         }
       }
   
       function recursivelyGarbageCollect(root) {
         if (root === undefined) {
           return;
         }
         var keys = Object.keys(root);
         for (var i in keys) {
           var key = keys[i];
           var obj = root[key];
           if ((obj instanceof Function) || (typeof obj !== "object") || (obj === null))
             continue;
           if (Object.keys(obj).length > 0) {
             recursivelyGarbageCollect(root[key]);
           }
           if (Object.keys(obj).length === 0) {
             delete root[key];
           }
         }
       }
       recursivelyGarbageCollect(this.listenerTree);
   
       return this;
     };
   
     EventEmitter.prototype.offAny = function(fn) {
       var i = 0, l = 0, fns;
       if (fn && this._all && this._all.length > 0) {
         fns = this._all;
         for(i = 0, l = fns.length; i < l; i++) {
           if(fn === fns[i]) {
             fns.splice(i, 1);
             this.emit("removeListenerAny", fn);
             return this;
           }
         }
       } else {
         fns = this._all;
         for(i = 0, l = fns.length; i < l; i++)
           this.emit("removeListenerAny", fns[i]);
         this._all = [];
       }
       return this;
     };
   
     EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
   
     EventEmitter.prototype.removeAllListeners = function(type) {
       if (arguments.length === 0) {
         !this._events || init.call(this);
         return this;
       }
   
       if (this.wildcard) {
         var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
         var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
   
         for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
           var leaf = leafs[iLeaf];
           leaf._listeners = null;
         }
       }
       else if (this._events) {
         this._events[type] = null;
       }
       return this;
     };
   
     EventEmitter.prototype.listeners = function(type) {
       if (this.wildcard) {
         var handlers = [];
         var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
         searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
         return handlers;
       }
   
       this._events || init.call(this);
   
       if (!this._events[type]) this._events[type] = [];
       if (!isArray(this._events[type])) {
         this._events[type] = [this._events[type]];
       }
       return this._events[type];
     };
   
     EventEmitter.prototype.listenerCount = function(type) {
       return this.listeners(type).length;
     };
   
     EventEmitter.prototype.listenersAny = function() {
   
       if(this._all) {
         return this._all;
       }
       else {
         return [];
       }
   
     };
   
     if (true) {
        // AMD. Register as an anonymous module.
       !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
         return EventEmitter;
       }).call(exports, __webpack_require__, exports, module),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   }();
   
   
   /***/ }),
   /* 13 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
     if (true) {
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                   (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else { var mod; }
   })(this, function (exports) {
     'use strict';
   
     Object.defineProperty(exports, "__esModule", {
       value: true
     });
   
     function _classCallCheck(instance, Constructor) {
       if (!(instance instanceof Constructor)) {
         throw new TypeError("Cannot call a class as a function");
       }
     }
   
     var _createClass = function () {
       function defineProperties(target, props) {
         for (var i = 0; i < props.length; i++) {
           var descriptor = props[i];
           descriptor.enumerable = descriptor.enumerable || false;
           descriptor.configurable = true;
           if ("value" in descriptor) descriptor.writable = true;
           Object.defineProperty(target, descriptor.key, descriptor);
         }
       }
   
       return function (Constructor, protoProps, staticProps) {
         if (protoProps) defineProperties(Constructor.prototype, protoProps);
         if (staticProps) defineProperties(Constructor, staticProps);
         return Constructor;
       };
     }();
   
     var _extends = Object.assign || function (target) {
       for (var i = 1; i < arguments.length; i++) {
         var source = arguments[i];
   
         for (var key in source) {
           if (Object.prototype.hasOwnProperty.call(source, key)) {
             target[key] = source[key];
           }
         }
       }
   
       return target;
     };
   
     var defaults = {
       modal: '.modal',
       modalInner: '.modal-inner',
       modalContent: '.modal-content',
       open: '[data-modal-open]',
       close: '[data-modal-close]',
       page: 'body',
       class: 'modal-visible',
       loadClass: 'vanilla-modal',
       clickOutside: true,
       closeKeys: [27],
       transitions: true,
       transitionEnd: null,
       onBeforeOpen: null,
       onBeforeClose: null,
       onOpen: null,
       onClose: null
     };
   
     function throwError(message) {
       // eslint-disable-next-line no-console
       console.error('VanillaModal: ' + message);
     }
   
     function find(arr, callback) {
       return function (key) {
         var filteredArray = arr.filter(callback);
         return filteredArray[0] ? filteredArray[0][key] : undefined;
       };
     }
   
     function transitionEndVendorSniff() {
       var el = document.createElement('div');
       var transitions = [{ key: 'transition', value: 'transitionend' }, { key: 'OTransition', value: 'otransitionend' }, { key: 'MozTransition', value: 'transitionend' }, { key: 'WebkitTransition', value: 'webkitTransitionEnd' }];
       return find(transitions, function (_ref) {
         var key = _ref.key;
         return typeof el.style[key] !== 'undefined';
       })('value');
     }
   
     function isPopulatedArray(arr) {
       return Object.prototype.toString.call(arr) === '[object Array]' && arr.length;
     }
   
     function getNode(selector, parent) {
       var targetNode = parent || document;
       var node = targetNode.querySelector(selector);
       if (!node) {
         throwError(selector + ' not found in document.');
       }
       return node;
     }
   
     function addClass(el, className) {
       if (!(el instanceof HTMLElement)) {
         throwError('Not a valid HTML element.');
       }
       el.setAttribute('class', el.className.split(' ').filter(function (cn) {
         return cn !== className;
       }).concat(className).join(' '));
     }
   
     function removeClass(el, className) {
       if (!(el instanceof HTMLElement)) {
         throwError('Not a valid HTML element.');
       }
       el.setAttribute('class', el.className.split(' ').filter(function (cn) {
         return cn !== className;
       }).join(' '));
     }
   
     function getElementContext(e) {
       if (e && typeof e.hash === 'string') {
         return document.querySelector(e.hash);
       } else if (typeof e === 'string') {
         return document.querySelector(e);
       }
       throwError('No selector supplied to open()');
       return null;
     }
   
     function applyUserSettings(settings) {
       return _extends({}, defaults, settings, {
         transitionEnd: transitionEndVendorSniff()
       });
     }
   
     function matches(e, selector) {
       var allMatches = (e.target.document || e.target.ownerDocument).querySelectorAll(selector);
       for (var i = 0; i < allMatches.length; i += 1) {
         var node = e.target;
         while (node && node !== document.body) {
           if (node === allMatches[i]) {
             return node;
           }
           node = node.parentNode;
         }
       }
       return null;
     }
   
     var VanillaModal = function () {
       function VanillaModal(settings) {
         _classCallCheck(this, VanillaModal);
   
         this.isOpen = false;
         this.current = null;
         this.isListening = false;
   
         this.settings = applyUserSettings(settings);
         this.dom = this.getDomNodes();
   
         this.open = this.open.bind(this);
         this.close = this.close.bind(this);
         this.closeKeyHandler = this.closeKeyHandler.bind(this);
         this.outsideClickHandler = this.outsideClickHandler.bind(this);
         this.delegateOpen = this.delegateOpen.bind(this);
         this.delegateClose = this.delegateClose.bind(this);
         this.listen = this.listen.bind(this);
         this.destroy = this.destroy.bind(this);
   
         this.addLoadedCssClass();
         this.listen();
       }
   
       _createClass(VanillaModal, [{
         key: 'getDomNodes',
         value: function getDomNodes() {
           var _settings = this.settings,
               modal = _settings.modal,
               page = _settings.page,
               modalInner = _settings.modalInner,
               modalContent = _settings.modalContent;
   
           return {
             modal: getNode(modal),
             page: getNode(page),
             modalInner: getNode(modalInner, getNode(modal)),
             modalContent: getNode(modalContent, getNode(modal))
           };
         }
       }, {
         key: 'addLoadedCssClass',
         value: function addLoadedCssClass() {
           addClass(this.dom.page, this.settings.loadClass);
         }
       }, {
         key: 'setOpenId',
         value: function setOpenId(id) {
           var page = this.dom.page;
   
           page.setAttribute('data-current-modal', id || 'anonymous');
         }
       }, {
         key: 'removeOpenId',
         value: function removeOpenId() {
           var page = this.dom.page;
   
           page.removeAttribute('data-current-modal');
         }
       }, {
         key: 'open',
         value: function open(allMatches, e) {
           var page = this.dom.page;
           var _settings2 = this.settings,
               onBeforeOpen = _settings2.onBeforeOpen,
               onOpen = _settings2.onOpen;
   
           if (!(this.current instanceof HTMLElement === false)) {
             throwError('VanillaModal target must exist on page.');
             return;
           }
           this.releaseNode(this.current);
           this.current = getElementContext(allMatches);
           if (typeof onBeforeOpen === 'function') {
             onBeforeOpen.call(this, e);
           }
           this.captureNode(this.current);
           addClass(page, this.settings.class);
           this.setOpenId(this.current.id);
           this.isOpen = true;
           if (typeof onOpen === 'function') {
             onOpen.call(this, e);
           }
         }
       }, {
         key: 'detectTransition',
         value: function detectTransition() {
           var modal = this.dom.modal;
   
           var css = window.getComputedStyle(modal, null);
           return Boolean(['transitionDuration', 'oTransitionDuration', 'MozTransitionDuration', 'webkitTransitionDuration'].filter(function (i) {
             return typeof css[i] === 'string' && parseFloat(css[i]) > 0;
           }).length);
         }
       }, {
         key: 'close',
         value: function close(e) {
           var _settings3 = this.settings,
               transitions = _settings3.transitions,
               transitionEnd = _settings3.transitionEnd,
               onBeforeClose = _settings3.onBeforeClose;
   
           var hasTransition = this.detectTransition();
           if (this.isOpen) {
             this.isOpen = false;
             if (typeof onBeforeClose === 'function') {
               onBeforeClose.call(this, e);
             }
             removeClass(this.dom.page, this.settings.class);
             if (transitions && transitionEnd && hasTransition) {
               this.closeModalWithTransition(e);
             } else {
               this.closeModal(e);
             }
           }
         }
       }, {
         key: 'closeModal',
         value: function closeModal(e) {
           var onClose = this.settings.onClose;
   
           this.removeOpenId(this.dom.page);
           this.releaseNode(this.current);
           this.isOpen = false;
           this.current = null;
           if (typeof onClose === 'function') {
             onClose.call(this, e);
           }
         }
       }, {
         key: 'closeModalWithTransition',
         value: function closeModalWithTransition(e) {
           var _this = this;
   
           var modal = this.dom.modal;
           var transitionEnd = this.settings.transitionEnd;
   
           var closeTransitionHandler = function closeTransitionHandler() {
             modal.removeEventListener(transitionEnd, closeTransitionHandler);
             _this.closeModal(e);
           };
           modal.addEventListener(transitionEnd, closeTransitionHandler);
         }
       }, {
         key: 'captureNode',
         value: function captureNode(node) {
           var modalContent = this.dom.modalContent;
   
           while (node.childNodes.length) {
             modalContent.appendChild(node.childNodes[0]);
           }
         }
       }, {
         key: 'releaseNode',
         value: function releaseNode(node) {
           var modalContent = this.dom.modalContent;
   
           while (modalContent.childNodes.length) {
             node.appendChild(modalContent.childNodes[0]);
           }
         }
       }, {
         key: 'closeKeyHandler',
         value: function closeKeyHandler(e) {
           var closeKeys = this.settings.closeKeys;
   
           if (isPopulatedArray(closeKeys) && closeKeys.indexOf(e.which) > -1 && this.isOpen === true) {
             e.preventDefault();
             this.close(e);
           }
         }
       }, {
         key: 'outsideClickHandler',
         value: function outsideClickHandler(e) {
           var clickOutside = this.settings.clickOutside;
           var modalInner = this.dom.modalInner;
   
           if (clickOutside) {
             var node = e.target;
             while (node && node !== document.body) {
               if (node === modalInner) {
                 return;
               }
               node = node.parentNode;
             }
             this.close(e);
           }
         }
       }, {
         key: 'delegateOpen',
         value: function delegateOpen(e) {
           var open = this.settings.open;
   
           var matchedNode = matches(e, open);
           if (matchedNode) {
             e.preventDefault();
             this.open(matchedNode, e);
           }
         }
       }, {
         key: 'delegateClose',
         value: function delegateClose(e) {
           var close = this.settings.close;
   
           if (matches(e, close)) {
             e.preventDefault();
             this.close(e);
           }
         }
       }, {
         key: 'listen',
         value: function listen() {
           var modal = this.dom.modal;
   
           if (!this.isListening) {
             modal.addEventListener('click', this.outsideClickHandler, false);
             document.addEventListener('keydown', this.closeKeyHandler, false);
             document.addEventListener('click', this.delegateOpen, false);
             document.addEventListener('click', this.delegateClose, false);
             this.isListening = true;
           } else {
             throwError('Event listeners already applied.');
           }
         }
       }, {
         key: 'destroy',
         value: function destroy() {
           var modal = this.dom.modal;
   
           if (this.isListening) {
             this.close();
             modal.removeEventListener('click', this.outsideClickHandler);
             document.removeEventListener('keydown', this.closeKeyHandler);
             document.removeEventListener('click', this.delegateOpen);
             document.removeEventListener('click', this.delegateClose);
             this.isListening = false;
           } else {
             throwError('Event listeners already removed.');
           }
         }
       }]);
   
       return VanillaModal;
     }();
   
     exports.default = VanillaModal;
   });
   
   
   /***/ }),
   /* 14 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*********************************************************************
   *  #### Twitter Post Fetcher v17.0.3 ####
   *  Coded by Jason Mayes 2015. A present to all the developers out there.
   *  www.jasonmayes.com
   *  Please keep this disclaimer with my code if you use it. Thanks. :-)
   *  Got feedback or questions, ask here:
   *  http://www.jasonmayes.com/projects/twitterApi/
   *  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
   *  Updates will be posted to this site.
   *********************************************************************/
   !function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
                   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                   (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):undefined}(0,function(){var e="",t=20,a=!0,i=[],n=!1,s=!0,l=!0,r=null,o=!0,c=!0,d=null,m=!0,u=!1,p=!1,g=!0,h="en",w=!0,f=!1,v=null;function b(e){return e.replace(/<b[^>]*>(.*?)<\/b>/gi,function(e,t){return t}).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,"")}function _(e){for(var t=e.getElementsByTagName("a"),a=t.length-1;a>=0;a--)t[a].setAttribute("target","_blank")}function y(e,t){for(var a=[],i=new RegExp("(^| )"+t+"( |$)"),n=e.getElementsByTagName("*"),s=0,l=n.length;s<l;s++)i.test(n[s].className)&&a.push(n[s]);return a}function T(e){if(void 0!==e&&e.innerHTML.indexOf("data-image")>=0){var t=e.innerHTML.split('data-image="')[1].split('"')[0];return decodeURIComponent(t)+".jpg"}}var k={fetch:function(o){if(void 0===o.maxTweets&&(o.maxTweets=20),void 0===o.enableLinks&&(o.enableLinks=!0),void 0===o.showUser&&(o.showUser=!0),void 0===o.showTime&&(o.showTime=!0),void 0===o.dateFunction&&(o.dateFunction="default"),void 0===o.showRetweet&&(o.showRetweet=!0),void 0===o.customCallback&&(o.customCallback=null),void 0===o.showInteraction&&(o.showInteraction=!0),void 0===o.showImages&&(o.showImages=!1),void 0===o.useEmoji&&(o.useEmoji=!1),void 0===o.linksInNewWindow&&(o.linksInNewWindow=!0),void 0===o.showPermalinks&&(o.showPermalinks=!0),void 0===o.dataOnly&&(o.dataOnly=!1),n)i.push(o);else{n=!0,e=o.domId,t=o.maxTweets,a=o.enableLinks,l=o.showUser,s=o.showTime,c=o.showRetweet,r=o.dateFunction,d=o.customCallback,m=o.showInteraction,u=o.showImages,p=o.useEmoji,g=o.linksInNewWindow,w=o.showPermalinks,f=o.dataOnly;var b=document.getElementsByTagName("head")[0];null!==v&&b.removeChild(v),(v=document.createElement("script")).type="text/javascript",void 0!==o.list?v.src="https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug="+o.list.listSlug+"&screen_name="+o.list.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():void 0!==o.profile?v.src="https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name="+o.profile.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():void 0!==o.likes?v.src="https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name="+o.likes.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():v.src="https://cdn.syndication.twimg.com/widgets/timelines/"+o.id+"?&lang="+(o.lang||h)+"&callback=__twttrf.callback&suppress_response_codes=true&rnd="+Math.random(),b.appendChild(v)}},callback:function(h){if(void 0===h||void 0===h.body)return n=!1,void(i.length>0&&(k.fetch(i[0]),i.splice(0,1)));p||(h.body=h.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,"")),u||(h.body=h.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,"")),l||(h.body=h.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g,""));var v=document.createElement("div");function C(e){var t=e.getElementsByTagName("img")[0];return t&&t.length&&(t.src=t.getAttribute("data-src-2x")),e}v.innerHTML=h.body,void 0===v.getElementsByClassName&&(o=!1);var x=[],E=[],N=[],A=[],I=[],B=[],L=[],M=0;if(o)for(var H=v.getElementsByClassName("timeline-Tweet");M<H.length;)H[M].getElementsByClassName("timeline-Tweet-retweetCredit").length>0?I.push(!0):I.push(!1),(!I[M]||I[M]&&c)&&(x.push(H[M].getElementsByClassName("timeline-Tweet-text")[0]),B.push(H[M].getAttribute("data-tweet-id")),l&&E.push(C(H[M].getElementsByClassName("timeline-Tweet-author")[0])),N.push(H[M].getElementsByClassName("dt-updated")[0]),L.push(H[M].getElementsByClassName("timeline-Tweet-timestamp")[0]),void 0!==H[M].getElementsByClassName("timeline-Tweet-media")[0]?A.push(H[M].getElementsByClassName("timeline-Tweet-media")[0]):A.push(void 0)),M++;else for(H=y(v,"timeline-Tweet");M<H.length;)y(H[M],"timeline-Tweet-retweetCredit").length>0?I.push(!0):I.push(!1),(!I[M]||I[M]&&c)&&(x.push(y(H[M],"timeline-Tweet-text")[0]),B.push(H[M].getAttribute("data-tweet-id")),l&&E.push(C(y(H[M],"timeline-Tweet-author")[0])),N.push(y(H[M],"dt-updated")[0]),L.push(y(H[M],"timeline-Tweet-timestamp")[0]),void 0!==y(H[M],"timeline-Tweet-media")[0]?A.push(y(H[M],"timeline-Tweet-media")[0]):A.push(void 0)),M++;x.length>t&&(x.splice(t,x.length-t),E.splice(t,E.length-t),N.splice(t,N.length-t),I.splice(t,I.length-t),A.splice(t,A.length-t),L.splice(t,L.length-t));var R=[],j=(M=x.length,0);if(f)for(;j<M;)R.push({tweet:x[j].innerHTML,author:E[j]?E[j].innerHTML:"Unknown Author",author_data:{profile_url:E[j]?E[j].querySelector('[data-scribe="element:user_link"]').href:null,profile_image:E[j]?E[j].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-1x"):null,profile_image_2x:E[j]?E[j].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-2x"):null,screen_name:E[j]?E[j].querySelector('[data-scribe="element:screen_name"]').title:null,name:E[j]?E[j].querySelector('[data-scribe="element:name"]').title:null},time:N[j].textContent,timestamp:N[j].getAttribute("datetime").replace("+0000","Z").replace(/([\+\-])(\d\d)(\d\d)/,"$1$2:$3"),image:T(A[j]),rt:I[j],tid:B[j],permalinkURL:void 0===L[j]?"":L[j].href}),j++;else for(;j<M;){if("string"!=typeof r){var q=N[j].getAttribute("datetime"),P=new Date(N[j].getAttribute("datetime").replace(/-/g,"/").replace("T"," ").split("+")[0]),S=r(P,q);if(N[j].setAttribute("aria-label",S),x[j].textContent)if(o)N[j].textContent=S;else{var U=document.createElement("p"),F=document.createTextNode(S);U.appendChild(F),U.setAttribute("aria-label",S),N[j]=U}else N[j].textContent=S}var O="";a?(g&&(_(x[j]),l&&_(E[j])),l&&(O+='<div class="user">'+b(E[j].innerHTML)+"</div>"),O+='<p class="tweet">'+b(x[j].innerHTML)+"</p>",s&&(O+=w?'<p class="timePosted"><a href="'+L[j]+'">'+N[j].getAttribute("aria-label")+"</a></p>":'<p class="timePosted">'+N[j].getAttribute("aria-label")+"</p>")):(x[j].textContent,l&&(O+='<p class="user">'+E[j].textContent+"</p>"),O+='<p class="tweet">'+x[j].textContent+"</p>",s&&(O+='<p class="timePosted">'+N[j].textContent+"</p>")),m&&(O+='<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to='+B[j]+'" class="twitter_reply_icon"'+(g?' target="_blank">':">")+'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id='+B[j]+'" class="twitter_retweet_icon"'+(g?' target="_blank">':">")+'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id='+B[j]+'" class="twitter_fav_icon"'+(g?' target="_blank">':">")+"Favorite</a></p>"),u&&void 0!==A[j]&&void 0!==T(A[j])&&(O+='<div class="media"><img src="'+T(A[j])+'" alt="Image from tweet" /></div>'),u?R.push(O):!u&&x[j].textContent.length&&R.push(O),j++}!function(t){if(null===d){for(var a=t.length,i=0,n=document.getElementById(e),s="<ul>";i<a;)s+="<li>"+t[i]+"</li>",i++;s+="</ul>",n.innerHTML=s}else d(t)}(R),n=!1,i.length>0&&(k.fetch(i[0]),i.splice(0,1))}};return window.__twttrf=k,window.twitterFetcher=k,k});
   
   
   /***/ }),
   /* 15 */
   /***/ (function(module, exports) {
   
   /*!
    * Trend 0.2.0
    *
    * Fail-safe TransitionEnd event for jQuery.
    *
    * Adds a new "trend" event that can be used in browsers that don't
    * support "transitionend".
    *
    * NOTE: Only supports being bound with "jQuery.one".
    *
    * Copyright 2014, Pixel Union - http://pixelunion.net
    * Released under the MIT license
    */
   ;(function($){
   
     // Prefixed transitionend event names
     var transitionEndEvents =
       "webkitTransitionEnd " +
       "otransitionend " +
       "oTransitionEnd " +
       "msTransitionEnd " +
       "transitionend";
   
     // Prefixed transition duration property names
     var transitionDurationProperties = [
       "transition-duration",
       "-moz-transition-duration",
       "-webkit-transition-duration",
       "-ms-transition-duration",
       "-o-transition-duration",
       "-khtml-transition-duration"
     ];
   
     // Prefixed transition delay property names
     var transitionDelayProperties = [
       "transition-delay",
       "-moz-transition-delay",
       "-webkit-transition-delay",
       "-ms-transition-delay",
       "-o-transition-delay",
       "-khtml-transition-delay"
     ];
   
     // Parses a CSS time value into milliseconds.
     var parseTime = function(s) {
       s = s.replace(/\s/, "");
       var v = window.parseFloat(s);
   
       return s.match(/[^m]s$/i)
         ? v * 1000
         : v;
     };
   
     // Parses the longest time unit found in a series of CSS properties.
     // Returns a value in milliseconds.
     var parseProperties = function(el, properties) {
       var duration = 0;
   
       for (var i = 0; i < properties.length; i++) {
         // Get raw CSS value
         var value = el.css(properties[i]);
         if (!value) continue;
   
         // Multiple transitions--pick the longest
         if (value.indexOf(",") !== -1) {
           var values = value.split(",");
           var durations = (function(){
             var results = [];
             for (var i = 0; i < values.length; i++) {
               var duration = parseTime(values[i]);
               results.push(duration);
             }
             return results;
           })();
   
           duration = Math.max.apply(Math, durations);
         }
   
         // Single transition
         else {
           duration = parseTime(value);
         }
   
         // Accept first vaue
         break;
       }
   
       return duration;
     };
   
     $.event.special.trend = {
       // Triggers an event handler when an element is done transitioning.
       //
       // Handles browsers that don't support transitionend by adding a
       // timeout with the transition duration.
       add: function(handleObj) {
         var el = $(this);
         var fired = false;
   
         // Mark element as being in transition
         el.data("trend", true);
   
         // Calculate a fallback duration. + 20 because some browsers fire
         // timeouts faster than transitionend.
         var time =
           parseProperties(el, transitionDurationProperties) +
           parseProperties(el, transitionDelayProperties) +
           20;
   
         var cb = function(e) {
           // transitionend events can be sent for each property. Let's just
           // skip all but the first. Also handles the timeout callback.
           if (fired) return;
   
           // Child elements that also have transitions can be fired before we
           // complete. This will catch and ignore those. Unfortunately, we'll
           // have to rely on the timeout in these cases.
           if (e && e.srcElement !== el[0]) return;
   
           // Mark element has not being in transition
           el.data("trend", false);
   
           // Callback
           fired = true;
           if (handleObj.handler) handleObj.handler();
         };
   
         el.one(transitionEndEvents, cb);
         el.data("trend-timeout", window.setTimeout(cb, time));
       },
   
       remove: function(handleObj) {
         var el = $(this);
         el.off(transitionEndEvents);
         window.clearTimeout(el.data("trend-timeout"));
       }
     };
   
   })(jQuery);
   
   
   /***/ }),
   /* 16 */
   /***/ (function(module, exports) {
   
   /*!
    * Revealer 2.0.1
    *
    * Copyright 2015, Pixel Union - http://pixelunion.net
    * Released under the MIT license
    */
   (function($){
     // check for trend event (make sure jquery.trend is included)
     if (typeof $.event.special.trend !== "object") {
       console.warn("Please make sure jquery.trend is included! Otherwise revealer won't work.");
     }
   
     // Simple requestAnimationFrame polyfill
     var raf = window.requestAnimationFrame ||
       window.mozRequestAnimationFrame ||
       window.webkitRequestAnimationFrame ||
       function(fn) { window.setTimeout(fn, 1000/60); }
   
   
     // Public API
     var methods = {
       isVisible: function(el) {
         return !!el.data("revealer-visible");
       },
   
       show: function(el, force) {
         // Check state
         if (methods.isVisible(el)) {
           el.removeClass("animating animating-in");
           el.off("revealer-animating revealer-show");
           return;
         }
   
         // Remove previous event listeners
         el.data("revealer-visible", true);
         el.off("trend");
   
         if (force) {
           el.addClass("visible");
           raf(function(){
             el.trigger("revealer-animating");
             el.trigger("revealer-show");
           });
           return;
         }
   
         raf(function(){
           // Start animation state transition
           el.addClass("animating animating-in");
           el.trigger("revealer-animating");
   
           raf(function(){
             el.addClass("visible");
   
             el.one("trend", function(){
               el.removeClass("animating animating-in");
               el.trigger("revealer-show");
             });
           });
         });
       },
   
       hide: function(el, force) {
         // Check state
         if (!methods.isVisible(el)) {
           el.removeClass("animating animating-out visible");
           el.off("revealer-animating revealer-hide");
           return;
         }
   
         // Remove previous event listeners
         el.data("revealer-visible", false);
         el.off("trend");
   
         if (force) {
           el.removeClass("visible");
           raf(function(){
             el.trigger("revealer-animating");
             el.trigger("revealer-hide");
           });
           return;
         }
   
         raf(function(){
           el.addClass("animating animating-out");
           el.trigger("revealer-animating");
   
           raf(function(){
             el.removeClass("visible");
   
             el.one("trend", function(){
               el.removeClass("animating animating-in animating-out");
               el.trigger("revealer-hide");
             });
           });
         });
       },
   
       toggle: function(el, force) {
         if (methods.isVisible(el)) {
           methods.hide(el, force);
         } else {
           methods.show(el, force);
         }
       }
     };
   
     // jQuery plugin
     $.fn.revealer = function(method, force) {
       // Get action
       var action = methods[method || "toggle"];
       if (!action) return this;
   
       // Run action
       if (method === "isVisible") {
         return action(this);
       }
   
       return this.each(function(){
         action($(this), force);
       });
     };
   })(jQuery);
   
   
   /***/ }),
   /* 17 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
    * matchesSelector v2.0.2
    * matchesSelector( element, '.selector' )
    * MIT license
    */
   
   /*jshint browser: true, strict: true, undef: true, unused: true */
   
   ( function( window, factory ) {
     /*global define: false, module: false */
     'use strict';
     // universal module definition
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                   (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                   __WEBPACK_AMD_DEFINE_FACTORY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory() {
     'use strict';
   
     var matchesMethod = ( function() {
       var ElemProto = window.Element.prototype;
       // check for the standard method name first
       if ( ElemProto.matches ) {
         return 'matches';
       }
       // check un-prefixed
       if ( ElemProto.matchesSelector ) {
         return 'matchesSelector';
       }
       // check vendor prefixes
       var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
   
       for ( var i=0; i < prefixes.length; i++ ) {
         var prefix = prefixes[i];
         var method = prefix + 'MatchesSelector';
         if ( ElemProto[ method ] ) {
           return method;
         }
       }
     })();
   
     return function matchesSelector( elem, selector ) {
       return elem[ matchesMethod ]( selector );
     };
   
   }));
   
   
   /***/ }),
   /* 18 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(9)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( getSize ) {
         return factory( window, getSize );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, getSize ) {
   
   'use strict';
   
   function Cell( elem, parent ) {
     this.element = elem;
     this.parent = parent;
   
     this.create();
   }
   
   var proto = Cell.prototype;
   
   proto.create = function() {
     this.element.style.position = 'absolute';
     this.element.setAttribute( 'aria-hidden', 'true' );
     this.x = 0;
     this.shift = 0;
   };
   
   proto.destroy = function() {
     // reset style
     this.unselect();
     this.element.style.position = '';
     var side = this.parent.originSide;
     this.element.style[ side ] = '';
   };
   
   proto.getSize = function() {
     this.size = getSize( this.element );
   };
   
   proto.setPosition = function( x ) {
     this.x = x;
     this.updateTarget();
     this.renderPosition( x );
   };
   
   // setDefaultTarget v1 method, backwards compatibility, remove in v3
   proto.updateTarget = proto.setDefaultTarget = function() {
     var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
     this.target = this.x + this.size[ marginProperty ] +
       this.size.width * this.parent.cellAlign;
   };
   
   proto.renderPosition = function( x ) {
     // render position of cell with in slider
     var side = this.parent.originSide;
     this.element.style[ side ] = this.parent.getPositionValue( x );
   };
   
   proto.select = function() {
     this.element.classList.add('is-selected');
     this.element.removeAttribute('aria-hidden');
   };
   
   proto.unselect = function() {
     this.element.classList.remove('is-selected');
     this.element.setAttribute( 'aria-hidden', 'true' );
   };
   
   /**
    * @param {Integer} factor - 0, 1, or -1
   **/
   proto.wrapShift = function( shift ) {
     this.shift = shift;
     this.renderPosition( this.x + this.parent.slideableWidth * shift );
   };
   
   proto.remove = function() {
     this.element.parentNode.removeChild( this.element );
   };
   
   return Cell;
   
   }));
   
   
   /***/ }),
   /* 19 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                   (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                   __WEBPACK_AMD_DEFINE_FACTORY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory() {
   'use strict';
   
   function Slide( parent ) {
     this.parent = parent;
     this.isOriginLeft = parent.originSide == 'left';
     this.cells = [];
     this.outerWidth = 0;
     this.height = 0;
   }
   
   var proto = Slide.prototype;
   
   proto.addCell = function( cell ) {
     this.cells.push( cell );
     this.outerWidth += cell.size.outerWidth;
     this.height = Math.max( cell.size.outerHeight, this.height );
     // first cell stuff
     if ( this.cells.length == 1 ) {
       this.x = cell.x; // x comes from first cell
       var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
       this.firstMargin = cell.size[ beginMargin ];
     }
   };
   
   proto.updateTarget = function() {
     var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
     var lastCell = this.getLastCell();
     var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
     var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
     this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
   };
   
   proto.getLastCell = function() {
     return this.cells[ this.cells.length - 1 ];
   };
   
   proto.select = function() {
     this.cells.forEach( function( cell ) {
       cell.select();
     });
   };
   
   proto.unselect = function() {
     this.cells.forEach( function( cell ) {
       cell.unselect();
     });
   };
   
   proto.getCellElements = function() {
     return this.cells.map( function( cell ) {
       return cell.element;
     });
   };
   
   return Slide;
   
   }));
   
   
   /***/ }),
   /* 20 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(5)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( utils ) {
         return factory( window, utils );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, utils ) {
   
   'use strict';
   
   // -------------------------- animate -------------------------- //
   
   var proto = {};
   
   proto.startAnimation = function() {
     if ( this.isAnimating ) {
       return;
     }
   
     this.isAnimating = true;
     this.restingFrames = 0;
     this.animate();
   };
   
   proto.animate = function() {
     this.applyDragForce();
     this.applySelectedAttraction();
   
     var previousX = this.x;
   
     this.integratePhysics();
     this.positionSlider();
     this.settle( previousX );
     // animate next frame
     if ( this.isAnimating ) {
       var _this = this;
       requestAnimationFrame( function animateFrame() {
         _this.animate();
       });
     }
   };
   
   proto.positionSlider = function() {
     var x = this.x;
     // wrap position around
     if ( this.options.wrapAround && this.cells.length > 1 ) {
       x = utils.modulo( x, this.slideableWidth );
       x = x - this.slideableWidth;
       this.shiftWrapCells( x );
     }
   
     this.setTranslateX( x, this.isAnimating );
     this.dispatchScrollEvent();
   };
   
   proto.setTranslateX = function( x, is3d ) {
     x += this.cursorPosition;
     // reverse if right-to-left and using transform
     x = this.options.rightToLeft ? -x : x;
     var translateX = this.getPositionValue( x );
     // use 3D tranforms for hardware acceleration on iOS
     // but use 2D when settled, for better font-rendering
     this.slider.style.transform = is3d ?
       'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
   };
   
   proto.dispatchScrollEvent = function() {
     var firstSlide = this.slides[0];
     if ( !firstSlide ) {
       return;
     }
     var positionX = -this.x - firstSlide.target;
     var progress = positionX / this.slidesWidth;
     this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
   };
   
   proto.positionSliderAtSelected = function() {
     if ( !this.cells.length ) {
       return;
     }
     this.x = -this.selectedSlide.target;
     this.velocity = 0; // stop wobble
     this.positionSlider();
   };
   
   proto.getPositionValue = function( position ) {
     if ( this.options.percentPosition ) {
       // percent position, round to 2 digits, like 12.34%
       return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 )+ '%';
     } else {
       // pixel positioning
       return Math.round( position ) + 'px';
     }
   };
   
   proto.settle = function( previousX ) {
     // keep track of frames where x hasn't moved
     if ( !this.isPointerDown && Math.round( this.x * 100 ) == Math.round( previousX * 100 ) ) {
       this.restingFrames++;
     }
     // stop animating if resting for 3 or more frames
     if ( this.restingFrames > 2 ) {
       this.isAnimating = false;
       delete this.isFreeScrolling;
       // render position with translateX when settled
       this.positionSlider();
       this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
     }
   };
   
   proto.shiftWrapCells = function( x ) {
     // shift before cells
     var beforeGap = this.cursorPosition + x;
     this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
     // shift after cells
     var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
     this._shiftCells( this.afterShiftCells, afterGap, 1 );
   };
   
   proto._shiftCells = function( cells, gap, shift ) {
     for ( var i=0; i < cells.length; i++ ) {
       var cell = cells[i];
       var cellShift = gap > 0 ? shift : 0;
       cell.wrapShift( cellShift );
       gap -= cell.size.outerWidth;
     }
   };
   
   proto._unshiftCells = function( cells ) {
     if ( !cells || !cells.length ) {
       return;
     }
     for ( var i=0; i < cells.length; i++ ) {
       cells[i].wrapShift( 0 );
     }
   };
   
   // -------------------------- physics -------------------------- //
   
   proto.integratePhysics = function() {
     this.x += this.velocity;
     this.velocity *= this.getFrictionFactor();
   };
   
   proto.applyForce = function( force ) {
     this.velocity += force;
   };
   
   proto.getFrictionFactor = function() {
     return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
   };
   
   proto.getRestingPosition = function() {
     // my thanks to Steven Wittens, who simplified this math greatly
     return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
   };
   
   proto.applyDragForce = function() {
     if ( !this.isDraggable || !this.isPointerDown ) {
       return;
     }
     // change the position to drag position by applying force
     var dragVelocity = this.dragX - this.x;
     var dragForce = dragVelocity - this.velocity;
     this.applyForce( dragForce );
   };
   
   proto.applySelectedAttraction = function() {
     // do not attract if pointer down or no slides
     var dragDown = this.isDraggable && this.isPointerDown;
     if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
       return;
     }
     var distance = this.selectedSlide.target * -1 - this.x;
     var force = distance * this.options.selectedAttraction;
     this.applyForce( force );
   };
   
   return proto;
   
   }));
   
   
   /***/ }),
   /* 21 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(6),
         __webpack_require__(22),
         __webpack_require__(5)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unidragger, utils ) {
         return factory( window, Flickity, Unidragger, utils );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, Flickity, Unidragger, utils ) {
   
   'use strict';
   
   // ----- defaults ----- //
   
   utils.extend( Flickity.defaults, {
     draggable: '>1',
     dragThreshold: 3,
   });
   
   // ----- create ----- //
   
   Flickity.createMethods.push('_createDrag');
   
   // -------------------------- drag prototype -------------------------- //
   
   var proto = Flickity.prototype;
   utils.extend( proto, Unidragger.prototype );
   proto._touchActionValue = 'pan-y';
   
   // --------------------------  -------------------------- //
   
   var isTouch = 'createTouch' in document;
   var isTouchmoveScrollCanceled = false;
   
   proto._createDrag = function() {
     this.on( 'activate', this.onActivateDrag );
     this.on( 'uiChange', this._uiChangeDrag );
     this.on( 'deactivate', this.onDeactivateDrag );
     this.on( 'cellChange', this.updateDraggable );
     // TODO updateDraggable on resize? if groupCells & slides change
     // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
     // #457, RubaXa/Sortable#973
     if ( isTouch && !isTouchmoveScrollCanceled ) {
       window.addEventListener( 'touchmove', function() {});
       isTouchmoveScrollCanceled = true;
     }
   };
   
   proto.onActivateDrag = function() {
     this.handles = [ this.viewport ];
     this.bindHandles();
     this.updateDraggable();
   };
   
   proto.onDeactivateDrag = function() {
     this.unbindHandles();
     this.element.classList.remove('is-draggable');
   };
   
   proto.updateDraggable = function() {
     // disable dragging if less than 2 slides. #278
     if ( this.options.draggable == '>1' ) {
       this.isDraggable = this.slides.length > 1;
     } else {
       this.isDraggable = this.options.draggable;
     }
     if ( this.isDraggable ) {
       this.element.classList.add('is-draggable');
     } else {
       this.element.classList.remove('is-draggable');
     }
   };
   
   // backwards compatibility
   proto.bindDrag = function() {
     this.options.draggable = true;
     this.updateDraggable();
   };
   
   proto.unbindDrag = function() {
     this.options.draggable = false;
     this.updateDraggable();
   };
   
   proto._uiChangeDrag = function() {
     delete this.isFreeScrolling;
   };
   
   // -------------------------- pointer events -------------------------- //
   
   proto.pointerDown = function( event, pointer ) {
     if ( !this.isDraggable ) {
       this._pointerDownDefault( event, pointer );
       return;
     }
     var isOkay = this.okayPointerDown( event );
     if ( !isOkay ) {
       return;
     }
   
     this._pointerDownPreventDefault( event );
     this.pointerDownFocus( event );
     // blur
     if ( document.activeElement != this.element ) {
       // do not blur if already focused
       this.pointerDownBlur();
     }
   
     // stop if it was moving
     this.dragX = this.x;
     this.viewport.classList.add('is-pointer-down');
     // track scrolling
     this.pointerDownScroll = getScrollPosition();
     window.addEventListener( 'scroll', this );
   
     this._pointerDownDefault( event, pointer );
   };
   
   // default pointerDown logic, used for staticClick
   proto._pointerDownDefault = function( event, pointer ) {
     // track start event position
     // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
     this.pointerDownPointer = {
       pageX: pointer.pageX,
       pageY: pointer.pageY,
     };
     // bind move and end events
     this._bindPostStartEvents( event );
     this.dispatchEvent( 'pointerDown', event, [ pointer ] );
   };
   
   var focusNodes = {
     INPUT: true,
     TEXTAREA: true,
     SELECT: true,
   };
   
   proto.pointerDownFocus = function( event ) {
     var isFocusNode = focusNodes[ event.target.nodeName ];
     if ( !isFocusNode ) {
       this.focus();
     }
   };
   
   proto._pointerDownPreventDefault = function( event ) {
     var isTouchStart = event.type == 'touchstart';
     var isTouchPointer = event.pointerType == 'touch';
     var isFocusNode = focusNodes[ event.target.nodeName ];
     if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
       event.preventDefault();
     }
   };
   
   // ----- move ----- //
   
   proto.hasDragStarted = function( moveVector ) {
     return Math.abs( moveVector.x ) > this.options.dragThreshold;
   };
   
   // ----- up ----- //
   
   proto.pointerUp = function( event, pointer ) {
     delete this.isTouchScrolling;
     this.viewport.classList.remove('is-pointer-down');
     this.dispatchEvent( 'pointerUp', event, [ pointer ] );
     this._dragPointerUp( event, pointer );
   };
   
   proto.pointerDone = function() {
     window.removeEventListener( 'scroll', this );
     delete this.pointerDownScroll;
   };
   
   // -------------------------- dragging -------------------------- //
   
   proto.dragStart = function( event, pointer ) {
     if ( !this.isDraggable ) {
       return;
     }
     this.dragStartPosition = this.x;
     this.startAnimation();
     window.removeEventListener( 'scroll', this );
     this.dispatchEvent( 'dragStart', event, [ pointer ] );
   };
   
   proto.pointerMove = function( event, pointer ) {
     var moveVector = this._dragPointerMove( event, pointer );
     this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
     this._dragMove( event, pointer, moveVector );
   };
   
   proto.dragMove = function( event, pointer, moveVector ) {
     if ( !this.isDraggable ) {
       return;
     }
     event.preventDefault();
   
     this.previousDragX = this.dragX;
     // reverse if right-to-left
     var direction = this.options.rightToLeft ? -1 : 1;
     if ( this.options.wrapAround ) {
       // wrap around move. #589
       moveVector.x = moveVector.x % this.slideableWidth;
     }
     var dragX = this.dragStartPosition + moveVector.x * direction;
   
     if ( !this.options.wrapAround && this.slides.length ) {
       // slow drag
       var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
       dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
       var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
       dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
     }
   
     this.dragX = dragX;
   
     this.dragMoveTime = new Date();
     this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
   };
   
   proto.dragEnd = function( event, pointer ) {
     if ( !this.isDraggable ) {
       return;
     }
     if ( this.options.freeScroll ) {
       this.isFreeScrolling = true;
     }
     // set selectedIndex based on where flick will end up
     var index = this.dragEndRestingSelect();
   
     if ( this.options.freeScroll && !this.options.wrapAround ) {
       // if free-scroll & not wrap around
       // do not free-scroll if going outside of bounding slides
       // so bounding slides can attract slider, and keep it in bounds
       var restingX = this.getRestingPosition();
       this.isFreeScrolling = -restingX > this.slides[0].target &&
         -restingX < this.getLastSlide().target;
     } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
       // boost selection if selected index has not changed
       index += this.dragEndBoostSelect();
     }
     delete this.previousDragX;
     // apply selection
     // TODO refactor this, selecting here feels weird
     // HACK, set flag so dragging stays in correct direction
     this.isDragSelect = this.options.wrapAround;
     this.select( index );
     delete this.isDragSelect;
     this.dispatchEvent( 'dragEnd', event, [ pointer ] );
   };
   
   proto.dragEndRestingSelect = function() {
     var restingX = this.getRestingPosition();
     // how far away from selected slide
     var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
     // get closet resting going up and going down
     var positiveResting = this._getClosestResting( restingX, distance, 1 );
     var negativeResting = this._getClosestResting( restingX, distance, -1 );
     // use closer resting for wrap-around
     var index = positiveResting.distance < negativeResting.distance ?
       positiveResting.index : negativeResting.index;
     return index;
   };
   
   /**
    * given resting X and distance to selected cell
    * get the distance and index of the closest cell
    * @param {Number} restingX - estimated post-flick resting position
    * @param {Number} distance - distance to selected cell
    * @param {Integer} increment - +1 or -1, going up or down
    * @returns {Object} - { distance: {Number}, index: {Integer} }
    */
   proto._getClosestResting = function( restingX, distance, increment ) {
     var index = this.selectedIndex;
     var minDistance = Infinity;
     var condition = this.options.contain && !this.options.wrapAround ?
       // if contain, keep going if distance is equal to minDistance
       function( d, md ) { return d <= md; } : function( d, md ) { return d < md; };
     while ( condition( distance, minDistance ) ) {
       // measure distance to next cell
       index += increment;
       minDistance = distance;
       distance = this.getSlideDistance( -restingX, index );
       if ( distance === null ) {
         break;
       }
       distance = Math.abs( distance );
     }
     return {
       distance: minDistance,
       // selected was previous index
       index: index - increment
     };
   };
   
   /**
    * measure distance between x and a slide target
    * @param {Number} x
    * @param {Integer} index - slide index
    */
   proto.getSlideDistance = function( x, index ) {
     var len = this.slides.length;
     // wrap around if at least 2 slides
     var isWrapAround = this.options.wrapAround && len > 1;
     var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
     var slide = this.slides[ slideIndex ];
     if ( !slide ) {
       return null;
     }
     // add distance for wrap-around slides
     var wrap = isWrapAround ? this.slideableWidth * Math.floor( index / len ) : 0;
     return x - ( slide.target + wrap );
   };
   
   proto.dragEndBoostSelect = function() {
     // do not boost if no previousDragX or dragMoveTime
     if ( this.previousDragX === undefined || !this.dragMoveTime ||
       // or if drag was held for 100 ms
       new Date() - this.dragMoveTime > 100 ) {
       return 0;
     }
   
     var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
     var delta = this.previousDragX - this.dragX;
     if ( distance > 0 && delta > 0 ) {
       // boost to next if moving towards the right, and positive velocity
       return 1;
     } else if ( distance < 0 && delta < 0 ) {
       // boost to previous if moving towards the left, and negative velocity
       return -1;
     }
     return 0;
   };
   
   // ----- staticClick ----- //
   
   proto.staticClick = function( event, pointer ) {
     // get clickedCell, if cell was clicked
     var clickedCell = this.getParentCell( event.target );
     var cellElem = clickedCell && clickedCell.element;
     var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
     this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
   };
   
   // ----- scroll ----- //
   
   proto.onscroll = function() {
     var scroll = getScrollPosition();
     var scrollMoveX = this.pointerDownScroll.x - scroll.x;
     var scrollMoveY = this.pointerDownScroll.y - scroll.y;
     // cancel click/tap if scroll is too much
     if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
       this._pointerDone();
     }
   };
   
   // ----- utils ----- //
   
   function getScrollPosition() {
     return {
       x: window.pageXOffset,
       y: window.pageYOffset
     };
   }
   
   // -----  ----- //
   
   return Flickity;
   
   }));
   
   
   /***/ }),
   /* 22 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
    * Unidragger v2.3.0
    * Draggable base class
    * MIT license
    */
   
   /*jshint browser: true, unused: true, undef: true, strict: true */
   
   ( function( window, factory ) {
     // universal module definition
     /*jshint strict: false */ /*globals define, module, require */
   
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(8)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Unipointer ) {
         return factory( window, Unipointer );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, Unipointer ) {
   
   'use strict';
   
   // -------------------------- Unidragger -------------------------- //
   
   function Unidragger() {}
   
   // inherit Unipointer & EvEmitter
   var proto = Unidragger.prototype = Object.create( Unipointer.prototype );
   
   // ----- bind start ----- //
   
   proto.bindHandles = function() {
     this._bindHandles( true );
   };
   
   proto.unbindHandles = function() {
     this._bindHandles( false );
   };
   
   /**
    * Add or remove start event
    * @param {Boolean} isAdd
    */
   proto._bindHandles = function( isAdd ) {
     // munge isAdd, default to true
     isAdd = isAdd === undefined ? true : isAdd;
     // bind each handle
     var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
     var touchAction = isAdd ? this._touchActionValue : '';
     for ( var i=0; i < this.handles.length; i++ ) {
       var handle = this.handles[i];
       this._bindStartEvent( handle, isAdd );
       handle[ bindMethod ]( 'click', this );
       // touch-action: none to override browser touch gestures. metafizzy/flickity#540
       if ( window.PointerEvent ) {
         handle.style.touchAction = touchAction;
       }
     }
   };
   
   // prototype so it can be overwriteable by Flickity
   proto._touchActionValue = 'none';
   
   // ----- start event ----- //
   
   /**
    * pointer start
    * @param {Event} event
    * @param {Event or Touch} pointer
    */
   proto.pointerDown = function( event, pointer ) {
     var isOkay = this.okayPointerDown( event );
     if ( !isOkay ) {
       return;
     }
     // track start event position
     this.pointerDownPointer = pointer;
   
     event.preventDefault();
     this.pointerDownBlur();
     // bind move and end events
     this._bindPostStartEvents( event );
     this.emitEvent( 'pointerDown', [ event, pointer ] );
   };
   
   // nodes that have text fields
   var cursorNodes = {
     TEXTAREA: true,
     INPUT: true,
     SELECT: true,
     OPTION: true,
   };
   
   // input types that do not have text fields
   var clickTypes = {
     radio: true,
     checkbox: true,
     button: true,
     submit: true,
     image: true,
     file: true,
   };
   
   // dismiss inputs with text fields. flickity#403, flickity#404
   proto.okayPointerDown = function( event ) {
     var isCursorNode = cursorNodes[ event.target.nodeName ];
     var isClickType = clickTypes[ event.target.type ];
     var isOkay = !isCursorNode || isClickType;
     if ( !isOkay ) {
       this._pointerReset();
     }
     return isOkay;
   };
   
   // kludge to blur previously focused input
   proto.pointerDownBlur = function() {
     var focused = document.activeElement;
     // do not blur body for IE10, metafizzy/flickity#117
     var canBlur = focused && focused.blur && focused != document.body;
     if ( canBlur ) {
       focused.blur();
     }
   };
   
   // ----- move event ----- //
   
   /**
    * drag move
    * @param {Event} event
    * @param {Event or Touch} pointer
    */
   proto.pointerMove = function( event, pointer ) {
     var moveVector = this._dragPointerMove( event, pointer );
     this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
     this._dragMove( event, pointer, moveVector );
   };
   
   // base pointer move logic
   proto._dragPointerMove = function( event, pointer ) {
     var moveVector = {
       x: pointer.pageX - this.pointerDownPointer.pageX,
       y: pointer.pageY - this.pointerDownPointer.pageY
     };
     // start drag if pointer has moved far enough to start drag
     if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
       this._dragStart( event, pointer );
     }
     return moveVector;
   };
   
   // condition if pointer has moved far enough to start drag
   proto.hasDragStarted = function( moveVector ) {
     return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
   };
   
   // ----- end event ----- //
   
   /**
    * pointer up
    * @param {Event} event
    * @param {Event or Touch} pointer
    */
   proto.pointerUp = function( event, pointer ) {
     this.emitEvent( 'pointerUp', [ event, pointer ] );
     this._dragPointerUp( event, pointer );
   };
   
   proto._dragPointerUp = function( event, pointer ) {
     if ( this.isDragging ) {
       this._dragEnd( event, pointer );
     } else {
       // pointer didn't move enough for drag to start
       this._staticClick( event, pointer );
     }
   };
   
   // -------------------------- drag -------------------------- //
   
   // dragStart
   proto._dragStart = function( event, pointer ) {
     this.isDragging = true;
     // prevent clicks
     this.isPreventingClicks = true;
     this.dragStart( event, pointer );
   };
   
   proto.dragStart = function( event, pointer ) {
     this.emitEvent( 'dragStart', [ event, pointer ] );
   };
   
   // dragMove
   proto._dragMove = function( event, pointer, moveVector ) {
     // do not drag if not dragging yet
     if ( !this.isDragging ) {
       return;
     }
   
     this.dragMove( event, pointer, moveVector );
   };
   
   proto.dragMove = function( event, pointer, moveVector ) {
     event.preventDefault();
     this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
   };
   
   // dragEnd
   proto._dragEnd = function( event, pointer ) {
     // set flags
     this.isDragging = false;
     // re-enable clicking async
     setTimeout( function() {
       delete this.isPreventingClicks;
     }.bind( this ) );
   
     this.dragEnd( event, pointer );
   };
   
   proto.dragEnd = function( event, pointer ) {
     this.emitEvent( 'dragEnd', [ event, pointer ] );
   };
   
   // ----- onclick ----- //
   
   // handle all clicks and prevent clicks when dragging
   proto.onclick = function( event ) {
     if ( this.isPreventingClicks ) {
       event.preventDefault();
     }
   };
   
   // ----- staticClick ----- //
   
   // triggered after pointer down & up with no/tiny movement
   proto._staticClick = function( event, pointer ) {
     // ignore emulated mouse up clicks
     if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
       return;
     }
   
     this.staticClick( event, pointer );
   
     // set flag for emulated clicks 300ms after touchend
     if ( event.type != 'mouseup' ) {
       this.isIgnoringMouseUp = true;
       // reset flag after 300ms
       setTimeout( function() {
         delete this.isIgnoringMouseUp;
       }.bind( this ), 400 );
     }
   };
   
   proto.staticClick = function( event, pointer ) {
     this.emitEvent( 'staticClick', [ event, pointer ] );
   };
   
   // ----- utils ----- //
   
   Unidragger.getPointerPoint = Unipointer.getPointerPoint;
   
   // -----  ----- //
   
   return Unidragger;
   
   }));
   
   
   /***/ }),
   /* 23 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(6),
         __webpack_require__(8),
         __webpack_require__(5)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unipointer, utils ) {
         return factory( window, Flickity, Unipointer, utils );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, Flickity, Unipointer, utils ) {
   'use strict';
   
   var svgURI = 'http://www.w3.org/2000/svg';
   
   // -------------------------- PrevNextButton -------------------------- //
   
   function PrevNextButton( direction, parent ) {
     this.direction = direction;
     this.parent = parent;
     this._create();
   }
   
   PrevNextButton.prototype = Object.create( Unipointer.prototype );
   
   PrevNextButton.prototype._create = function() {
     // properties
     this.isEnabled = true;
     this.isPrevious = this.direction == -1;
     var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
     this.isLeft = this.direction == leftDirection;
   
     var element = this.element = document.createElement('button');
     element.className = 'flickity-button flickity-prev-next-button';
     element.className += this.isPrevious ? ' previous' : ' next';
     // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
     element.setAttribute( 'type', 'button' );
     // init as disabled
     this.disable();
   
     element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );
   
     // create arrow
     var svg = this.createSVG();
     element.appendChild( svg );
     // events
     this.parent.on( 'select', this.update.bind( this ) );
     this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
   };
   
   PrevNextButton.prototype.activate = function() {
     this.bindStartEvent( this.element );
     this.element.addEventListener( 'click', this );
     // add to DOM
     this.parent.element.appendChild( this.element );
   };
   
   PrevNextButton.prototype.deactivate = function() {
     // remove from DOM
     this.parent.element.removeChild( this.element );
     // click events
     this.unbindStartEvent( this.element );
     this.element.removeEventListener( 'click', this );
   };
   
   PrevNextButton.prototype.createSVG = function() {
     var svg = document.createElementNS( svgURI, 'svg');
     svg.setAttribute( 'class', 'flickity-button-icon' );
     svg.setAttribute( 'viewBox', '0 0 100 100' );
     var path = document.createElementNS( svgURI, 'path');
     var pathMovements = getArrowMovements( this.parent.options.arrowShape );
     path.setAttribute( 'd', pathMovements );
     path.setAttribute( 'class', 'arrow' );
     // rotate arrow
     if ( !this.isLeft ) {
       path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
     }
     svg.appendChild( path );
     return svg;
   };
   
   // get SVG path movmement
   function getArrowMovements( shape ) {
     // use shape as movement if string
     if ( typeof shape == 'string' ) {
       return shape;
     }
     // create movement string
     return 'M ' + shape.x0 + ',50' +
       ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
       ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
       ' L ' + shape.x3 + ',50 ' +
       ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
       ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
       ' Z';
   }
   
   PrevNextButton.prototype.handleEvent = utils.handleEvent;
   
   PrevNextButton.prototype.onclick = function() {
     if ( !this.isEnabled ) {
       return;
     }
     this.parent.uiChange();
     var method = this.isPrevious ? 'previous' : 'next';
     this.parent[ method ]();
   };
   
   // -----  ----- //
   
   PrevNextButton.prototype.enable = function() {
     if ( this.isEnabled ) {
       return;
     }
     this.element.disabled = false;
     this.isEnabled = true;
   };
   
   PrevNextButton.prototype.disable = function() {
     if ( !this.isEnabled ) {
       return;
     }
     this.element.disabled = true;
     this.isEnabled = false;
   };
   
   PrevNextButton.prototype.update = function() {
     // index of first or last slide, if previous or next
     var slides = this.parent.slides;
     // enable is wrapAround and at least 2 slides
     if ( this.parent.options.wrapAround && slides.length > 1 ) {
       this.enable();
       return;
     }
     var lastIndex = slides.length ? slides.length - 1 : 0;
     var boundIndex = this.isPrevious ? 0 : lastIndex;
     var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
     this[ method ]();
   };
   
   PrevNextButton.prototype.destroy = function() {
     this.deactivate();
     this.allOff();
   };
   
   // -------------------------- Flickity prototype -------------------------- //
   
   utils.extend( Flickity.defaults, {
     prevNextButtons: true,
     arrowShape: {
       x0: 10,
       x1: 60, y1: 50,
       x2: 70, y2: 40,
       x3: 30
     }
   });
   
   Flickity.createMethods.push('_createPrevNextButtons');
   var proto = Flickity.prototype;
   
   proto._createPrevNextButtons = function() {
     
     if ( !this.options.prevNextButtons ) {
       return;
     }
   
     this.prevButton = new PrevNextButton( -1, this );
     this.nextButton = new PrevNextButton( 1, this );
   
     this.on( 'activate', this.activatePrevNextButtons );
   };
   
   proto.activatePrevNextButtons = function() {
     this.prevButton.activate();
     this.nextButton.activate();
     this.on( 'deactivate', this.deactivatePrevNextButtons );
   };
   
   proto.deactivatePrevNextButtons = function() {
     this.prevButton.deactivate();
     this.nextButton.deactivate();
     this.off( 'deactivate', this.deactivatePrevNextButtons );
   };
   
   // --------------------------  -------------------------- //
   
   Flickity.PrevNextButton = PrevNextButton;
   
   return Flickity;
   
   }));
   
   
   /***/ }),
   /* 24 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(6),
         __webpack_require__(8),
         __webpack_require__(5)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unipointer, utils ) {
         return factory( window, Flickity, Unipointer, utils );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, Flickity, Unipointer, utils ) {
   
   // -------------------------- PageDots -------------------------- //
   
   'use strict';
   
   function PageDots( parent ) {
     this.parent = parent;
     this._create();
   }
   
   PageDots.prototype = Object.create( Unipointer.prototype );
   
   PageDots.prototype._create = function() {
     // create holder element
     this.holder = document.createElement('ol');
     this.holder.className = 'flickity-page-dots';
     // create dots, array of elements
     this.dots = [];
     // events
     this.handleClick = this.onClick.bind( this );
     this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
   };
   
   PageDots.prototype.activate = function() {
     this.setDots();
     this.holder.addEventListener( 'click', this.handleClick );
     this.bindStartEvent( this.holder );
     // add to DOM
     this.parent.element.appendChild( this.holder );
   };
   
   PageDots.prototype.deactivate = function() {
     this.holder.removeEventListener( 'click', this.handleClick );
     this.unbindStartEvent( this.holder );
     // remove from DOM
     this.parent.element.removeChild( this.holder );
   };
   
   PageDots.prototype.setDots = function() {
     // get difference between number of slides and number of dots
     var delta = this.parent.slides.length - this.dots.length;
     if ( delta > 0 ) {
       this.addDots( delta );
     } else if ( delta < 0 ) {
       this.removeDots( -delta );
     }
   };
   
   PageDots.prototype.addDots = function( count ) {
     var fragment = document.createDocumentFragment();
     var newDots = [];
     var length = this.dots.length;
     var max = length + count;
   
     for ( var i = length; i < max; i++ ) {
       var dot = document.createElement('li');
       dot.className = 'dot';
       dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
       fragment.appendChild( dot );
       newDots.push( dot );
     }
   
     this.holder.appendChild( fragment );
     this.dots = this.dots.concat( newDots );
   };
   
   PageDots.prototype.removeDots = function( count ) {
     // remove from this.dots collection
     var removeDots = this.dots.splice( this.dots.length - count, count );
     // remove from DOM
     removeDots.forEach( function( dot ) {
       this.holder.removeChild( dot );
     }, this );
   };
   
   PageDots.prototype.updateSelected = function() {
     // remove selected class on previous
     if ( this.selectedDot ) {
       this.selectedDot.className = 'dot';
       this.selectedDot.removeAttribute('aria-current');
     }
     // don't proceed if no dots
     if ( !this.dots.length ) {
       return;
     }
     this.selectedDot = this.dots[ this.parent.selectedIndex ];
     this.selectedDot.className = 'dot is-selected';
     this.selectedDot.setAttribute( 'aria-current', 'step' );
   };
   
   PageDots.prototype.onTap = // old method name, backwards-compatible
   PageDots.prototype.onClick = function( event ) {
     var target = event.target;
     // only care about dot clicks
     if ( target.nodeName != 'LI' ) {
       return;
     }
   
     this.parent.uiChange();
     var index = this.dots.indexOf( target );
     this.parent.select( index );
   };
   
   PageDots.prototype.destroy = function() {
     this.deactivate();
     this.allOff();
   };
   
   Flickity.PageDots = PageDots;
   
   // -------------------------- Flickity -------------------------- //
   
   utils.extend( Flickity.defaults, {
     pageDots: true
   });
   
   Flickity.createMethods.push('_createPageDots');
   
   var proto = Flickity.prototype;
   
   proto._createPageDots = function() {
     if ( !this.options.pageDots ) {
       return;
     }
     this.pageDots = new PageDots( this );
     // events
     this.on( 'activate', this.activatePageDots );
     this.on( 'select', this.updateSelectedPageDots );
     this.on( 'cellChange', this.updatePageDots );
     this.on( 'resize', this.updatePageDots );
     this.on( 'deactivate', this.deactivatePageDots );
   };
   
   proto.activatePageDots = function() {
     this.pageDots.activate();
   };
   
   proto.updateSelectedPageDots = function() {
     this.pageDots.updateSelected();
   };
   
   proto.updatePageDots = function() {
     this.pageDots.setDots();
   };
   
   proto.deactivatePageDots = function() {
     this.pageDots.deactivate();
   };
   
   // -----  ----- //
   
   Flickity.PageDots = PageDots;
   
   return Flickity;
   
   }));
   
   
   /***/ }),
   /* 25 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(7),
         __webpack_require__(5),
         __webpack_require__(6)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, utils, Flickity ) {
         return factory( EvEmitter, utils, Flickity );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( EvEmitter, utils, Flickity ) {
   
   'use strict';
   
   // -------------------------- Player -------------------------- //
   
   function Player( parent ) {
     this.parent = parent;
     this.state = 'stopped';
     // visibility change event handler
     this.onVisibilityChange = this.visibilityChange.bind( this );
     this.onVisibilityPlay = this.visibilityPlay.bind( this );
   }
   
   Player.prototype = Object.create( EvEmitter.prototype );
   
   // start play
   Player.prototype.play = function() {
     if ( this.state == 'playing' ) {
       return;
     }
     // do not play if page is hidden, start playing when page is visible
     var isPageHidden = document.hidden;
     if ( isPageHidden ) {
       document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
       return;
     }
   
     this.state = 'playing';
     // listen to visibility change
     document.addEventListener( 'visibilitychange', this.onVisibilityChange );
     // start ticking
     this.tick();
   };
   
   Player.prototype.tick = function() {
     // do not tick if not playing
     if ( this.state != 'playing' ) {
       return;
     }
   
     var time = this.parent.options.autoPlay;
     // default to 3 seconds
     time = typeof time == 'number' ? time : 3000;
     var _this = this;
     // HACK: reset ticks if stopped and started within interval
     this.clear();
     this.timeout = setTimeout( function() {
       _this.parent.next( true );
       _this.tick();
     }, time );
   };
   
   Player.prototype.stop = function() {
     this.state = 'stopped';
     this.clear();
     // remove visibility change event
     document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
   };
   
   Player.prototype.clear = function() {
     clearTimeout( this.timeout );
   };
   
   Player.prototype.pause = function() {
     if ( this.state == 'playing' ) {
       this.state = 'paused';
       this.clear();
     }
   };
   
   Player.prototype.unpause = function() {
     // re-start play if paused
     if ( this.state == 'paused' ) {
       this.play();
     }
   };
   
   // pause if page visibility is hidden, unpause if visible
   Player.prototype.visibilityChange = function() {
     var isPageHidden = document.hidden;
     this[ isPageHidden ? 'pause' : 'unpause' ]();
   };
   
   Player.prototype.visibilityPlay = function() {
     this.play();
     document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
   };
   
   // -------------------------- Flickity -------------------------- //
   
   utils.extend( Flickity.defaults, {
     pauseAutoPlayOnHover: true
   });
   
   Flickity.createMethods.push('_createPlayer');
   var proto = Flickity.prototype;
   
   proto._createPlayer = function() {
     this.player = new Player( this );
   
     this.on( 'activate', this.activatePlayer );
     this.on( 'uiChange', this.stopPlayer );
     this.on( 'pointerDown', this.stopPlayer );
     this.on( 'deactivate', this.deactivatePlayer );
   };
   
   proto.activatePlayer = function() {
     if ( !this.options.autoPlay ) {
       return;
     }
     this.player.play();
     this.element.addEventListener( 'mouseenter', this );
   };
   
   // Player API, don't hate the ... thanks I know where the door is
   
   proto.playPlayer = function() {
     this.player.play();
   };
   
   proto.stopPlayer = function() {
     this.player.stop();
   };
   
   proto.pausePlayer = function() {
     this.player.pause();
   };
   
   proto.unpausePlayer = function() {
     this.player.unpause();
   };
   
   proto.deactivatePlayer = function() {
     this.player.stop();
     this.element.removeEventListener( 'mouseenter', this );
   };
   
   // ----- mouseenter/leave ----- //
   
   // pause auto-play on hover
   proto.onmouseenter = function() {
     if ( !this.options.pauseAutoPlayOnHover ) {
       return;
     }
     this.player.pause();
     this.element.addEventListener( 'mouseleave', this );
   };
   
   // resume auto-play on hover off
   proto.onmouseleave = function() {
     this.player.unpause();
     this.element.removeEventListener( 'mouseleave', this );
   };
   
   // -----  ----- //
   
   Flickity.Player = Player;
   
   return Flickity;
   
   }));
   
   
   /***/ }),
   /* 26 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(6),
         __webpack_require__(5)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, utils ) {
         return factory( window, Flickity, utils );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, Flickity, utils ) {
   
   'use strict';
   
   // append cells to a document fragment
   function getCellsFragment( cells ) {
     var fragment = document.createDocumentFragment();
     cells.forEach( function( cell ) {
       fragment.appendChild( cell.element );
     });
     return fragment;
   }
   
   // -------------------------- add/remove cell prototype -------------------------- //
   
   var proto = Flickity.prototype;
   
   /**
    * Insert, prepend, or append cells
    * @param {Element, Array, NodeList} elems
    * @param {Integer} index
    */
   proto.insert = function( elems, index ) {
     var cells = this._makeCells( elems );
     if ( !cells || !cells.length ) {
       return;
     }
     var len = this.cells.length;
     // default to append
     index = index === undefined ? len : index;
     // add cells with document fragment
     var fragment = getCellsFragment( cells );
     // append to slider
     var isAppend = index == len;
     if ( isAppend ) {
       this.slider.appendChild( fragment );
     } else {
       var insertCellElement = this.cells[ index ].element;
       this.slider.insertBefore( fragment, insertCellElement );
     }
     // add to this.cells
     if ( index === 0 ) {
       // prepend, add to start
       this.cells = cells.concat( this.cells );
     } else if ( isAppend ) {
       // append, add to end
       this.cells = this.cells.concat( cells );
     } else {
       // insert in this.cells
       var endCells = this.cells.splice( index, len - index );
       this.cells = this.cells.concat( cells ).concat( endCells );
     }
   
     this._sizeCells( cells );
     this.cellChange( index, true );
   };
   
   proto.append = function( elems ) {
     this.insert( elems, this.cells.length );
   };
   
   proto.prepend = function( elems ) {
     this.insert( elems, 0 );
   };
   
   /**
    * Remove cells
    * @param {Element, Array, NodeList} elems
    */
   proto.remove = function( elems ) {
     var cells = this.getCells( elems );
     if ( !cells || !cells.length ) {
       return;
     }
   
     var minCellIndex = this.cells.length - 1;
     // remove cells from collection & DOM
     cells.forEach( function( cell ) {
       cell.remove();
       var index = this.cells.indexOf( cell );
       minCellIndex = Math.min( index, minCellIndex );
       utils.removeFrom( this.cells, cell );
     }, this );
   
     this.cellChange( minCellIndex, true );
   };
   
   /**
    * logic to be run after a cell's size changes
    * @param {Element} elem - cell's element
    */
   proto.cellSizeChange = function( elem ) {
     var cell = this.getCell( elem );
     if ( !cell ) {
       return;
     }
     cell.getSize();
   
     var index = this.cells.indexOf( cell );
     this.cellChange( index );
   };
   
   /**
    * logic any time a cell is changed: added, removed, or size changed
    * @param {Integer} changedCellIndex - index of the changed cell, optional
    */
   proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
     var prevSelectedElem = this.selectedElement;
     this._positionCells( changedCellIndex );
     this._getWrapShiftCells();
     this.setGallerySize();
     // update selectedIndex
     // try to maintain position & select previous selected element
     var cell = this.getCell( prevSelectedElem );
     if ( cell ) {
       this.selectedIndex = this.getCellSlideIndex( cell );
     }
     this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );
   
     this.emitEvent( 'cellChange', [ changedCellIndex ] );
     // position slider
     this.select( this.selectedIndex );
     // do not position slider after lazy load
     if ( isPositioningSlider ) {
       this.positionSliderAtSelected();
     }
   };
   
   // -----  ----- //
   
   return Flickity;
   
   }));
   
   
   /***/ }),
   /* 27 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
   ( function( window, factory ) {
     // universal module definition
     /* jshint strict: false */
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(6),
         __webpack_require__(5)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, utils ) {
         return factory( window, Flickity, utils );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( window, function factory( window, Flickity, utils ) {
   'use strict';
   
   Flickity.createMethods.push('_createLazyload');
   var proto = Flickity.prototype;
   
   proto._createLazyload = function() {
     this.on( 'select', this.lazyLoad );
   };
   
   proto.lazyLoad = function() {
     var lazyLoad = this.options.lazyLoad;
     if ( !lazyLoad ) {
       return;
     }
     // get adjacent cells, use lazyLoad option for adjacent count
     var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
     var cellElems = this.getAdjacentCellElements( adjCount );
     // get lazy images in those cells
     var lazyImages = [];
     cellElems.forEach( function( cellElem ) {
       var lazyCellImages = getCellLazyImages( cellElem );
       lazyImages = lazyImages.concat( lazyCellImages );
     });
     // load lazy images
     lazyImages.forEach( function( img ) {
       new LazyLoader( img, this );
     }, this );
   };
   
   function getCellLazyImages( cellElem ) {
     // check if cell element is lazy image
     if ( cellElem.nodeName == 'IMG' ) {
       var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
       var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
       var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
       if ( lazyloadAttr || srcAttr || srcsetAttr ) {
         return [ cellElem ];
       }
     }
     // select lazy images in cell
     var lazySelector = 'img[data-flickity-lazyload], ' +
       'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
     var imgs = cellElem.querySelectorAll( lazySelector );
     return utils.makeArray( imgs );
   }
   
   // -------------------------- LazyLoader -------------------------- //
   
   /**
    * class to handle loading images
    */
   function LazyLoader( img, flickity ) {
     this.img = img;
     this.flickity = flickity;
     this.load();
   }
   
   LazyLoader.prototype.handleEvent = utils.handleEvent;
   
   LazyLoader.prototype.load = function() {
     this.img.addEventListener( 'load', this );
     this.img.addEventListener( 'error', this );
     // get src & srcset
     var src = this.img.getAttribute('data-flickity-lazyload') ||
       this.img.getAttribute('data-flickity-lazyload-src');
     var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
     // set src & serset
     this.img.src = src;
     if ( srcset ) {
       this.img.setAttribute( 'srcset', srcset );
     }
     // remove attr
     this.img.removeAttribute('data-flickity-lazyload');
     this.img.removeAttribute('data-flickity-lazyload-src');
     this.img.removeAttribute('data-flickity-lazyload-srcset');
   };
   
   LazyLoader.prototype.onload = function( event ) {
     this.complete( event, 'flickity-lazyloaded' );
   };
   
   LazyLoader.prototype.onerror = function( event ) {
     this.complete( event, 'flickity-lazyerror' );
   };
   
   LazyLoader.prototype.complete = function( event, className ) {
     // unbind events
     this.img.removeEventListener( 'load', this );
     this.img.removeEventListener( 'error', this );
   
     var cell = this.flickity.getParentCell( this.img );
     var cellElem = cell && cell.element;
     this.flickity.cellSizeChange( cellElem );
   
     this.img.classList.add( className );
     this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
   };
   
   // -----  ----- //
   
   Flickity.LazyLoader = LazyLoader;
   
   return Flickity;
   
   }));
   
   
   /***/ }),
   /* 28 */
   /***/ (function(module, exports) {
   
   if (window.NodeList && !NodeList.prototype.forEach) {
     NodeList.prototype.forEach = Array.prototype.forEach;
   }
   
   /***/ }),
   /* 29 */
   /***/ (function(module, exports) {
   
   /**
    * Copyright 2016 Google Inc. All Rights Reserved.
    *
    * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
    *
    *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
    *
    */
   
   (function(window, document) {
   'use strict';
   
   
   // Exits early if all IntersectionObserver and IntersectionObserverEntry
   // features are natively supported.
   if ('IntersectionObserver' in window &&
       'IntersectionObserverEntry' in window &&
       'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
   
     // Minimal polyfill for Edge 15's lack of `isIntersecting`
     // See: https://github.com/w3c/IntersectionObserver/issues/211
     if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
       Object.defineProperty(window.IntersectionObserverEntry.prototype,
         'isIntersecting', {
         get: function () {
           return this.intersectionRatio > 0;
         }
       });
     }
     return;
   }
   
   
   /**
    * An IntersectionObserver registry. This registry exists to hold a strong
    * reference to IntersectionObserver instances currently observing a target
    * element. Without this registry, instances without another reference may be
    * garbage collected.
    */
   var registry = [];
   
   
   /**
    * Creates the global IntersectionObserverEntry constructor.
    * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
    * @param {Object} entry A dictionary of instance properties.
    * @constructor
    */
   function IntersectionObserverEntry(entry) {
     this.time = entry.time;
     this.target = entry.target;
     this.rootBounds = entry.rootBounds;
     this.boundingClientRect = entry.boundingClientRect;
     this.intersectionRect = entry.intersectionRect || getEmptyRect();
     this.isIntersecting = !!entry.intersectionRect;
   
     // Calculates the intersection ratio.
     var targetRect = this.boundingClientRect;
     var targetArea = targetRect.width * targetRect.height;
     var intersectionRect = this.intersectionRect;
     var intersectionArea = intersectionRect.width * intersectionRect.height;
   
     // Sets intersection ratio.
     if (targetArea) {
       // Round the intersection ratio to avoid floating point math issues:
       // https://github.com/w3c/IntersectionObserver/issues/324
       this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
     } else {
       // If area is zero and is intersecting, sets to 1, otherwise to 0
       this.intersectionRatio = this.isIntersecting ? 1 : 0;
     }
   }
   
   
   /**
    * Creates the global IntersectionObserver constructor.
    * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
    * @param {Function} callback The function to be invoked after intersection
    *     changes have queued. The function is not invoked if the queue has
    *     been emptied by calling the `takeRecords` method.
    * @param {Object=} opt_options Optional configuration options.
    * @constructor
    */
   function IntersectionObserver(callback, opt_options) {
   
     var options = opt_options || {};
   
     if (typeof callback != 'function') {
       throw new Error('callback must be a function');
     }
   
     if (options.root && options.root.nodeType != 1) {
       throw new Error('root must be an Element');
     }
   
     // Binds and throttles `this._checkForIntersections`.
     this._checkForIntersections = throttle(
         this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
   
     // Private properties.
     this._callback = callback;
     this._observationTargets = [];
     this._queuedEntries = [];
     this._rootMarginValues = this._parseRootMargin(options.rootMargin);
   
     // Public properties.
     this.thresholds = this._initThresholds(options.threshold);
     this.root = options.root || null;
     this.rootMargin = this._rootMarginValues.map(function(margin) {
       return margin.value + margin.unit;
     }).join(' ');
   }
   
   
   /**
    * The minimum interval within which the document will be checked for
    * intersection changes.
    */
   IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
   
   
   /**
    * The frequency in which the polyfill polls for intersection changes.
    * this can be updated on a per instance basis and must be set prior to
    * calling `observe` on the first target.
    */
   IntersectionObserver.prototype.POLL_INTERVAL = null;
   
   /**
    * Use a mutation observer on the root element
    * to detect intersection changes.
    */
   IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
   
   
   /**
    * Starts observing a target element for intersection changes based on
    * the thresholds values.
    * @param {Element} target The DOM element to observe.
    */
   IntersectionObserver.prototype.observe = function(target) {
     var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
       return item.element == target;
     });
   
     if (isTargetAlreadyObserved) {
       return;
     }
   
     if (!(target && target.nodeType == 1)) {
       throw new Error('target must be an Element');
     }
   
     this._registerInstance();
     this._observationTargets.push({element: target, entry: null});
     this._monitorIntersections();
     this._checkForIntersections();
   };
   
   
   /**
    * Stops observing a target element for intersection changes.
    * @param {Element} target The DOM element to observe.
    */
   IntersectionObserver.prototype.unobserve = function(target) {
     this._observationTargets =
         this._observationTargets.filter(function(item) {
   
       return item.element != target;
     });
     if (!this._observationTargets.length) {
       this._unmonitorIntersections();
       this._unregisterInstance();
     }
   };
   
   
   /**
    * Stops observing all target elements for intersection changes.
    */
   IntersectionObserver.prototype.disconnect = function() {
     this._observationTargets = [];
     this._unmonitorIntersections();
     this._unregisterInstance();
   };
   
   
   /**
    * Returns any queue entries that have not yet been reported to the
    * callback and clears the queue. This can be used in conjunction with the
    * callback to obtain the absolute most up-to-date intersection information.
    * @return {Array} The currently queued entries.
    */
   IntersectionObserver.prototype.takeRecords = function() {
     var records = this._queuedEntries.slice();
     this._queuedEntries = [];
     return records;
   };
   
   
   /**
    * Accepts the threshold value from the user configuration object and
    * returns a sorted array of unique threshold values. If a value is not
    * between 0 and 1 and error is thrown.
    * @private
    * @param {Array|number=} opt_threshold An optional threshold value or
    *     a list of threshold values, defaulting to [0].
    * @return {Array} A sorted list of unique and valid threshold values.
    */
   IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
     var threshold = opt_threshold || [0];
     if (!Array.isArray(threshold)) threshold = [threshold];
   
     return threshold.sort().filter(function(t, i, a) {
       if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
         throw new Error('threshold must be a number between 0 and 1 inclusively');
       }
       return t !== a[i - 1];
     });
   };
   
   
   /**
    * Accepts the rootMargin value from the user configuration object
    * and returns an array of the four margin values as an object containing
    * the value and unit properties. If any of the values are not properly
    * formatted or use a unit other than px or %, and error is thrown.
    * @private
    * @param {string=} opt_rootMargin An optional rootMargin value,
    *     defaulting to '0px'.
    * @return {Array<Object>} An array of margin objects with the keys
    *     value and unit.
    */
   IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
     var marginString = opt_rootMargin || '0px';
     var margins = marginString.split(/\s+/).map(function(margin) {
       var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
       if (!parts) {
         throw new Error('rootMargin must be specified in pixels or percent');
       }
       return {value: parseFloat(parts[1]), unit: parts[2]};
     });
   
     // Handles shorthand.
     margins[1] = margins[1] || margins[0];
     margins[2] = margins[2] || margins[0];
     margins[3] = margins[3] || margins[1];
   
     return margins;
   };
   
   
   /**
    * Starts polling for intersection changes if the polling is not already
    * happening, and if the page's visibility state is visible.
    * @private
    */
   IntersectionObserver.prototype._monitorIntersections = function() {
     if (!this._monitoringIntersections) {
       this._monitoringIntersections = true;
   
       // If a poll interval is set, use polling instead of listening to
       // resize and scroll events or DOM mutations.
       if (this.POLL_INTERVAL) {
         this._monitoringInterval = setInterval(
             this._checkForIntersections, this.POLL_INTERVAL);
       }
       else {
         addEvent(window, 'resize', this._checkForIntersections, true);
         addEvent(document, 'scroll', this._checkForIntersections, true);
   
         if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
           this._domObserver = new MutationObserver(this._checkForIntersections);
           this._domObserver.observe(document, {
             attributes: true,
             childList: true,
             characterData: true,
             subtree: true
           });
         }
       }
     }
   };
   
   
   /**
    * Stops polling for intersection changes.
    * @private
    */
   IntersectionObserver.prototype._unmonitorIntersections = function() {
     if (this._monitoringIntersections) {
       this._monitoringIntersections = false;
   
       clearInterval(this._monitoringInterval);
       this._monitoringInterval = null;
   
       removeEvent(window, 'resize', this._checkForIntersections, true);
       removeEvent(document, 'scroll', this._checkForIntersections, true);
   
       if (this._domObserver) {
         this._domObserver.disconnect();
         this._domObserver = null;
       }
     }
   };
   
   
   /**
    * Scans each observation target for intersection changes and adds them
    * to the internal entries queue. If new entries are found, it
    * schedules the callback to be invoked.
    * @private
    */
   IntersectionObserver.prototype._checkForIntersections = function() {
     var rootIsInDom = this._rootIsInDom();
     var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
   
     this._observationTargets.forEach(function(item) {
       var target = item.element;
       var targetRect = getBoundingClientRect(target);
       var rootContainsTarget = this._rootContainsTarget(target);
       var oldEntry = item.entry;
       var intersectionRect = rootIsInDom && rootContainsTarget &&
           this._computeTargetAndRootIntersection(target, rootRect);
   
       var newEntry = item.entry = new IntersectionObserverEntry({
         time: now(),
         target: target,
         boundingClientRect: targetRect,
         rootBounds: rootRect,
         intersectionRect: intersectionRect
       });
   
       if (!oldEntry) {
         this._queuedEntries.push(newEntry);
       } else if (rootIsInDom && rootContainsTarget) {
         // If the new entry intersection ratio has crossed any of the
         // thresholds, add a new entry.
         if (this._hasCrossedThreshold(oldEntry, newEntry)) {
           this._queuedEntries.push(newEntry);
         }
       } else {
         // If the root is not in the DOM or target is not contained within
         // root but the previous entry for this target had an intersection,
         // add a new record indicating removal.
         if (oldEntry && oldEntry.isIntersecting) {
           this._queuedEntries.push(newEntry);
         }
       }
     }, this);
   
     if (this._queuedEntries.length) {
       this._callback(this.takeRecords(), this);
     }
   };
   
   
   /**
    * Accepts a target and root rect computes the intersection between then
    * following the algorithm in the spec.
    * TODO(philipwalton): at this time clip-path is not considered.
    * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
    * @param {Element} target The target DOM element
    * @param {Object} rootRect The bounding rect of the root after being
    *     expanded by the rootMargin value.
    * @return {?Object} The final intersection rect object or undefined if no
    *     intersection is found.
    * @private
    */
   IntersectionObserver.prototype._computeTargetAndRootIntersection =
       function(target, rootRect) {
   
     // If the element isn't displayed, an intersection can't happen.
     if (window.getComputedStyle(target).display == 'none') return;
   
     var targetRect = getBoundingClientRect(target);
     var intersectionRect = targetRect;
     var parent = getParentNode(target);
     var atRoot = false;
   
     while (!atRoot) {
       var parentRect = null;
       var parentComputedStyle = parent.nodeType == 1 ?
           window.getComputedStyle(parent) : {};
   
       // If the parent isn't displayed, an intersection can't happen.
       if (parentComputedStyle.display == 'none') return;
   
       if (parent == this.root || parent == document) {
         atRoot = true;
         parentRect = rootRect;
       } else {
         // If the element has a non-visible overflow, and it's not the <body>
         // or <html> element, update the intersection rect.
         // Note: <body> and <html> cannot be clipped to a rect that's not also
         // the document rect, so no need to compute a new intersection.
         if (parent != document.body &&
             parent != document.documentElement &&
             parentComputedStyle.overflow != 'visible') {
           parentRect = getBoundingClientRect(parent);
         }
       }
   
       // If either of the above conditionals set a new parentRect,
       // calculate new intersection data.
       if (parentRect) {
         intersectionRect = computeRectIntersection(parentRect, intersectionRect);
   
         if (!intersectionRect) break;
       }
       parent = getParentNode(parent);
     }
     return intersectionRect;
   };
   
   
   /**
    * Returns the root rect after being expanded by the rootMargin value.
    * @return {Object} The expanded root rect.
    * @private
    */
   IntersectionObserver.prototype._getRootRect = function() {
     var rootRect;
     if (this.root) {
       rootRect = getBoundingClientRect(this.root);
     } else {
       // Use <html>/<body> instead of window since scroll bars affect size.
       var html = document.documentElement;
       var body = document.body;
       rootRect = {
         top: 0,
         left: 0,
         right: html.clientWidth || body.clientWidth,
         width: html.clientWidth || body.clientWidth,
         bottom: html.clientHeight || body.clientHeight,
         height: html.clientHeight || body.clientHeight
       };
     }
     return this._expandRectByRootMargin(rootRect);
   };
   
   
   /**
    * Accepts a rect and expands it by the rootMargin value.
    * @param {Object} rect The rect object to expand.
    * @return {Object} The expanded rect.
    * @private
    */
   IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
     var margins = this._rootMarginValues.map(function(margin, i) {
       return margin.unit == 'px' ? margin.value :
           margin.value * (i % 2 ? rect.width : rect.height) / 100;
     });
     var newRect = {
       top: rect.top - margins[0],
       right: rect.right + margins[1],
       bottom: rect.bottom + margins[2],
       left: rect.left - margins[3]
     };
     newRect.width = newRect.right - newRect.left;
     newRect.height = newRect.bottom - newRect.top;
   
     return newRect;
   };
   
   
   /**
    * Accepts an old and new entry and returns true if at least one of the
    * threshold values has been crossed.
    * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
    *    particular target element or null if no previous entry exists.
    * @param {IntersectionObserverEntry} newEntry The current entry for a
    *    particular target element.
    * @return {boolean} Returns true if a any threshold has been crossed.
    * @private
    */
   IntersectionObserver.prototype._hasCrossedThreshold =
       function(oldEntry, newEntry) {
   
     // To make comparing easier, an entry that has a ratio of 0
     // but does not actually intersect is given a value of -1
     var oldRatio = oldEntry && oldEntry.isIntersecting ?
         oldEntry.intersectionRatio || 0 : -1;
     var newRatio = newEntry.isIntersecting ?
         newEntry.intersectionRatio || 0 : -1;
   
     // Ignore unchanged ratios
     if (oldRatio === newRatio) return;
   
     for (var i = 0; i < this.thresholds.length; i++) {
       var threshold = this.thresholds[i];
   
       // Return true if an entry matches a threshold or if the new ratio
       // and the old ratio are on the opposite sides of a threshold.
       if (threshold == oldRatio || threshold == newRatio ||
           threshold < oldRatio !== threshold < newRatio) {
         return true;
       }
     }
   };
   
   
   /**
    * Returns whether or not the root element is an element and is in the DOM.
    * @return {boolean} True if the root element is an element and is in the DOM.
    * @private
    */
   IntersectionObserver.prototype._rootIsInDom = function() {
     return !this.root || containsDeep(document, this.root);
   };
   
   
   /**
    * Returns whether or not the target element is a child of root.
    * @param {Element} target The target element to check.
    * @return {boolean} True if the target element is a child of root.
    * @private
    */
   IntersectionObserver.prototype._rootContainsTarget = function(target) {
     return containsDeep(this.root || document, target);
   };
   
   
   /**
    * Adds the instance to the global IntersectionObserver registry if it isn't
    * already present.
    * @private
    */
   IntersectionObserver.prototype._registerInstance = function() {
     if (registry.indexOf(this) < 0) {
       registry.push(this);
     }
   };
   
   
   /**
    * Removes the instance from the global IntersectionObserver registry.
    * @private
    */
   IntersectionObserver.prototype._unregisterInstance = function() {
     var index = registry.indexOf(this);
     if (index != -1) registry.splice(index, 1);
   };
   
   
   /**
    * Returns the result of the performance.now() method or null in browsers
    * that don't support the API.
    * @return {number} The elapsed time since the page was requested.
    */
   function now() {
     return window.performance && performance.now && performance.now();
   }
   
   
   /**
    * Throttles a function and delays its execution, so it's only called at most
    * once within a given time period.
    * @param {Function} fn The function to throttle.
    * @param {number} timeout The amount of time that must pass before the
    *     function can be called again.
    * @return {Function} The throttled function.
    */
   function throttle(fn, timeout) {
     var timer = null;
     return function () {
       if (!timer) {
         timer = setTimeout(function() {
           fn();
           timer = null;
         }, timeout);
       }
     };
   }
   
   
   /**
    * Adds an event handler to a DOM node ensuring cross-browser compatibility.
    * @param {Node} node The DOM node to add the event handler to.
    * @param {string} event The event name.
    * @param {Function} fn The event handler to add.
    * @param {boolean} opt_useCapture Optionally adds the even to the capture
    *     phase. Note: this only works in modern browsers.
    */
   function addEvent(node, event, fn, opt_useCapture) {
     if (typeof node.addEventListener == 'function') {
       node.addEventListener(event, fn, opt_useCapture || false);
     }
     else if (typeof node.attachEvent == 'function') {
       node.attachEvent('on' + event, fn);
     }
   }
   
   
   /**
    * Removes a previously added event handler from a DOM node.
    * @param {Node} node The DOM node to remove the event handler from.
    * @param {string} event The event name.
    * @param {Function} fn The event handler to remove.
    * @param {boolean} opt_useCapture If the event handler was added with this
    *     flag set to true, it should be set to true here in order to remove it.
    */
   function removeEvent(node, event, fn, opt_useCapture) {
     if (typeof node.removeEventListener == 'function') {
       node.removeEventListener(event, fn, opt_useCapture || false);
     }
     else if (typeof node.detatchEvent == 'function') {
       node.detatchEvent('on' + event, fn);
     }
   }
   
   
   /**
    * Returns the intersection between two rect objects.
    * @param {Object} rect1 The first rect.
    * @param {Object} rect2 The second rect.
    * @return {?Object} The intersection rect or undefined if no intersection
    *     is found.
    */
   function computeRectIntersection(rect1, rect2) {
     var top = Math.max(rect1.top, rect2.top);
     var bottom = Math.min(rect1.bottom, rect2.bottom);
     var left = Math.max(rect1.left, rect2.left);
     var right = Math.min(rect1.right, rect2.right);
     var width = right - left;
     var height = bottom - top;
   
     return (width >= 0 && height >= 0) && {
       top: top,
       bottom: bottom,
       left: left,
       right: right,
       width: width,
       height: height
     };
   }
   
   
   /**
    * Shims the native getBoundingClientRect for compatibility with older IE.
    * @param {Element} el The element whose bounding rect to get.
    * @return {Object} The (possibly shimmed) rect of the element.
    */
   function getBoundingClientRect(el) {
     var rect;
   
     try {
       rect = el.getBoundingClientRect();
     } catch (err) {
       // Ignore Windows 7 IE11 "Unspecified error"
       // https://github.com/w3c/IntersectionObserver/pull/205
     }
   
     if (!rect) return getEmptyRect();
   
     // Older IE
     if (!(rect.width && rect.height)) {
       rect = {
         top: rect.top,
         right: rect.right,
         bottom: rect.bottom,
         left: rect.left,
         width: rect.right - rect.left,
         height: rect.bottom - rect.top
       };
     }
     return rect;
   }
   
   
   /**
    * Returns an empty rect object. An empty rect is returned when an element
    * is not in the DOM.
    * @return {Object} The empty rect.
    */
   function getEmptyRect() {
     return {
       top: 0,
       bottom: 0,
       left: 0,
       right: 0,
       width: 0,
       height: 0
     };
   }
   
   /**
    * Checks to see if a parent element contains a child element (including inside
    * shadow DOM).
    * @param {Node} parent The parent element.
    * @param {Node} child The child element.
    * @return {boolean} True if the parent node contains the child node.
    */
   function containsDeep(parent, child) {
     var node = child;
     while (node) {
       if (node == parent) return true;
   
       node = getParentNode(node);
     }
     return false;
   }
   
   
   /**
    * Gets the parent node of an element or its host element if the parent node
    * is a shadow root.
    * @param {Node} node The node whose parent to get.
    * @return {Node|null} The parent node or null if no parent exists.
    */
   function getParentNode(node) {
     var parent = node.parentNode;
   
     if (parent && parent.nodeType == 11 && parent.host) {
       // If the parent is a shadow root, return the host element.
       return parent.host;
     }
     return parent;
   }
   
   
   // Exposes the constructors globally.
   window.IntersectionObserver = IntersectionObserver;
   window.IntersectionObserverEntry = IntersectionObserverEntry;
   
   }(window, document));
   
   
   /***/ }),
   /* 30 */
   /***/ (function(module, __webpack_exports__, __webpack_require__) {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   
   // EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
   var jquery = __webpack_require__(0);
   var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
   
   // CONCATENATED MODULE: ./source/scripts/globals/jquery.js
   // jQuery plugins expect to find a global `jQuery` object, so we
   // need to attach it to the window.
   //
   // This is in its own file because we have to attach it before any
   // other imports happen, but with ES6 modules, all `import`s have
   // to be at the top.
   
   window.jQuery = jquery_default.a;
   window.$ = jquery_default.a;
   // EXTERNAL MODULE: ./node_modules/jquery-trend/jquery.trend.js
   var jquery_trend = __webpack_require__(15);
   
   // EXTERNAL MODULE: ./node_modules/jquery-revealer/jquery.revealer.js
   var jquery_revealer = __webpack_require__(16);
   
   // EXTERNAL MODULE: ./node_modules/flickity/js/index.js
   var js = __webpack_require__(4);
   var js_default = /*#__PURE__*/__webpack_require__.n(js);
   
   // CONCATENATED MODULE: ./source/scripts/globals/flickity-ios-fix.js
   
    // This is required to fix an iOS10 bug for Flickity.
   // It is our own implementation of the Flickity 2.0 fix found here: http://bit.ly/2kU4mKW
   
   jquery_default()(window).on('dragStart', function (event) {
     var $target = jquery_default()(event.target);
     var $flickityEnabledEl = $target.closest('.flickity-enabled');
   
     if ($flickityEnabledEl.length) {
       var flickity = js_default.a.data($flickityEnabledEl[0]);
       window.removeEventListener('scroll', flickity);
     }
   });
   // EXTERNAL MODULE: ./source/scripts/Polyfills.js
   var Polyfills = __webpack_require__(28);
   
   // EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
   var intersection_observer = __webpack_require__(29);
   
   // CONCATENATED MODULE: ./node_modules/rimg/dist/index.es.js
   /*!
    * rimg v2.1.7
    * (c) 2018 Pixel Union
    */
   /**
    * The default template render function. Turns a template string into an image
    * URL.
    *
    * @param {String} template
    * @param {Size} size
    * @returns {String}
    */
   function defaultTemplateRender(template, size) {
     return template.replace('{size}', size.width + 'x' + size.height);
   }
   
   /**
    * @type Settings
    */
   var defaults = {
     scale: 1,
     template: false,
     templateRender: defaultTemplateRender,
     max: { width: Infinity, height: Infinity },
     round: 32,
     placeholder: false,
     crop: null
   };
   
   /**
    * Get a data attribute value from an element, with a default fallback and
    * sanitization step.
    *
    * @param {Element} el
    *
    * @param {String} name
    *        The data attribute name.
    *
    * @param {Object} options
    *        An object holding fallback values if the data attribute does not
    *        exist. If this object doesn't have the property, we further fallback
    *        to our defaults.
    *
    * @param {Function} [sanitize]
    *        A function to sanitize the data attribute value with.
    *
    * @returns {String|*}
    */
   function getData(el, name, options, sanitize) {
     var attr = 'data-rimg-' + name;
     if (!el.hasAttribute(attr)) return options[name] || defaults[name];
   
     var value = el.getAttribute(attr);
   
     return sanitize ? sanitize(value) : value;
   }
   
   /**
    * Sanitize data attributes that represent a size (in the form of `10x10`).
    *
    * @param {String} value
    * @returns {Object} An object with `width` and `height` properties.
    */
   function parseSize(value) {
     value = value.split('x');
     return { width: parseInt(value[0], 10), height: parseInt(value[1], 10) };
   }
   
   /**
    * Loads information about an element.
    *
    * Options can be set on the element itself using data attributes, or through
    * the `options` parameter. Data attributes take priority.
    *
    * @param {HTMLElement} el
    * @param {Settings} options
    * @returns {Item}
    */
   function parseItem(el) {
     var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
     var isImage = el.hasAttribute('data-rimg-template');
   
     /**
      * @typedef {Settings} Item
      */
     return {
       el: el,
   
       // Type of element
       isImage: isImage,
       isBackgroundImage: isImage && el.tagName !== 'IMG',
   
       // Image scale
       scale: getData(el, 'scale', options),
   
       // Device density
       density: window.devicePixelRatio || 1,
   
       // Image template URL
       template: getData(el, 'template', options),
       templateRender: options.templateRender || defaults.templateRender,
   
       // Maximum image dimensions
       max: getData(el, 'max', options, parseSize),
   
       // Round image dimensions to the nearest multiple
       round: getData(el, 'round', options),
   
       // Placeholder image dimensions
       placeholder: getData(el, 'placeholder', options, parseSize),
   
       // Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
       crop: getData(el, 'crop', options, function (value) {
         return value === '' ? null : value;
       })
     };
   }
   
   /**
    * Round to the nearest multiple.
    *
    * This is so we don't tax the image server too much.
    *
    * @param {Number} size The size, in pixels.
    * @param {Number} [multiple] The multiple to round to the nearest.
    * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
    * @returns {Number}
    */
   function roundSize(size) {
     var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
     var maxLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
   
     return size === 0 ? multiple : Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
   }
   
   /**
    * Get the size of an element.
    *
    * If it is too small, it's parent element is checked, and so on. This helps
    * avoid the situation where an element doesn't have a size yet or is positioned
    * out of the layout.
    *
    * @param {HTMLElement} el
    * @return {Object} size
    * @return {Number} size.width The width, in pixels.
    * @return {Number} size.height The height, in pixels.
    */
   function getElementSize(el) {
     var size = { width: 0, height: 0 };
   
     while (el) {
       size.width = el.offsetWidth;
       size.height = el.offsetHeight;
       if (size.width > 20 && size.height > 20) break;
       el = el.parentNode;
     }
   
     return size;
   }
   
   /**
    * Trigger a custom event.
    *
    * Note: this approach is deprecated, but still required to support older
    * browsers such as IE 10.
    *
    * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
    *
    * @param {HTMLElement} el
    *        The element to trigger the event on.
    *
    * @param {String} name
    *        The event name.
    *
    * @returns {Boolean}
    *          True if the event was canceled.
    */
   function index_es_trigger(el, name) {
     var event = document.createEvent('Event');
     event.initEvent(name, true, true);
     return !el.dispatchEvent(event);
   }
   
   /**
    * Return the maximum supported density of the image, given the container.
    *
    * @param {Item} item
    * @param {Size} size
    */
   function supportedDensity(item, size) {
     return Math.min(Math.min(Math.max(item.max.width / size.width, 1), item.density), Math.min(Math.max(item.max.height / size.height, 1), item.density)).toFixed(2);
   }
   
   /**
    * Set the image URL on the element. Supports background images and `srcset`.
    *
    * @param {Item} item
    * @param {Size} size
    * @param {Boolean} isPlaceholder
    */
   function setImage(item, size, isPlaceholder, onLoad) {
     var render = item.templateRender;
     var density = isPlaceholder ? 1 : supportedDensity(item, size);
     var round = isPlaceholder ? 1 : item.round;
   
     // Calculate the final display size, taking into account the image's
     // maximum dimensions.
     var targetWidth = size.width * density;
     var targetHeight = size.height * density;
   
     var displaySize = void 0;
   
     if (item.crop) {
       displaySize = {
         width: roundSize(targetWidth, round, item.max.width),
         height: roundSize(targetHeight, round, item.max.height)
       };
     } else {
       // Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
       // To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
       // This isn't a problem with cropped images which are served at the exact dimension requested.
       var containerAspectRatio = size.width / size.height;
       var imageAspectRatio = item.max.width / item.max.height;
   
       if (containerAspectRatio > imageAspectRatio) {
         // fit width
         displaySize = {
           width: roundSize(targetWidth, round, item.max.width),
           height: roundSize(targetWidth / imageAspectRatio, round, item.max.height)
         };
       } else {
         // fit height
         displaySize = {
           width: roundSize(targetHeight * imageAspectRatio, round, item.max.width),
           height: roundSize(targetHeight, round, item.max.height)
         };
       }
     }
   
     var url = render(item.template, displaySize);
   
     // On load callback
     var image = new Image();
     image.onload = onLoad;
     image.src = url;
   
     // Set image
     if (item.isBackgroundImage) {
       item.el.style.backgroundImage = 'url(\'' + url + '\')';
     } else {
       item.el.setAttribute('srcset', url + ' ' + density + 'x');
     }
   }
   
   /**
    * Load the image, set loaded status, and trigger the load event.
    *
    * @fires rimg:load
    * @fires rimg:error
    * @param {Item} item
    * @param {Size} size
    */
   function loadFullImage(item, size) {
     var el = item.el;
   
     setImage(item, size, false, function (event) {
       if (event.type === 'load') {
         el.setAttribute('data-rimg', 'loaded');
       } else {
         el.setAttribute('data-rimg', 'error');
         index_es_trigger(el, 'rimg:error');
       }
   
       index_es_trigger(el, 'rimg:load');
     });
   }
   
   /**
    * Load in a responsive image.
    *
    * Sets the image's `srcset` attribute to the final image URLs, calculated based
    * on the actual size the image is being shown at.
    *
    * @fires rimg:loading
    *        The image URLs have been set and we are waiting for them to load.
    *
    * @fires rimg:loaded
    *        The final image has loaded.
    *
    * @fires rimg:error
    *        The final image failed loading.
    *
    * @param {Item} item
    */
   function loadImage(item) {
     var el = item.el;
   
     // Already loaded?
     var status = el.getAttribute('data-rimg');
     if (status === 'loading' || status === 'loaded') return;
   
     // Is the SVG loaded?
     if (!el.complete && !item.isBackgroundImage) {
       // Wait for the load event, then call load image
       el.addEventListener('load', function cb() {
         el.removeEventListener('load', cb);
         loadImage(item);
       });
   
       return;
     }
   
     // Trigger loading event, and stop if cancelled
     if (index_es_trigger(el, 'rimg:loading')) return;
   
     // Mark as loading
     el.setAttribute('data-rimg', 'loading');
   
     // Get element size. This is used as the ideal display size.
     var size = getElementSize(item.el);
   
     size.width *= item.scale;
     size.height *= item.scale;
   
     if (item.placeholder) {
       // Load a placeholder image first, followed by the full image. Force the
       // element to keep its dimensions while it loads. If the image is smaller
       // than the element size, use the image's size. Density is taken into account
       // for HiDPI devices to avoid blurry images.
       if (!item.isBackgroundImage) {
         el.setAttribute('width', Math.min(Math.floor(item.max.width / item.density), size.width));
         el.setAttribute('height', Math.min(Math.floor(item.max.height / item.density), size.height));
       }
   
       setImage(item, item.placeholder, true, function () {
         return loadFullImage(item, size);
       });
     } else {
       loadFullImage(item, size);
     }
   }
   
   /**
    * Prepare an element to be displayed on the screen.
    *
    * Images have special logic applied to them to swap out the different sources.
    *
    * @fires rimg:enter
    *        The element is entering the viewport.
    *
    * @param {HTMLElement} el
    * @param {Settings} options
    */
   function load(el, options) {
     if (!el) return;
     index_es_trigger(el, 'rimg:enter');
   
     var item = parseItem(el, options);
   
     if (item.isImage) {
       if (!item.isBackgroundImage) {
         el.setAttribute('data-rimg-template-svg', el.getAttribute('srcset'));
       }
   
       loadImage(item);
     }
   }
   
   /**
    * Reset an element's state so that its image can be recalculated.
    *
    * @fires rimg:update
    *        The element is being updated.
    *
    * @param {HTMLElement} el
    * @param {Settings} options
    */
   function update(el, options) {
     if (!el) return;
     index_es_trigger(el, 'rimg:update');
   
     var item = parseItem(el, options);
   
     if (item.isImage) {
       if (!item.isBackgroundImage) {
         el.setAttribute('data-rimg', 'lazy');
         el.setAttribute('srcset', el.getAttribute('data-rimg-template-svg'));
       }
   
       loadImage(item);
     }
   }
   
   /**
    * Returns true if the element is within the viewport.
    * @param {HTMLElement} el
    * @returns {Boolean}
    */
   function inViewport(el) {
     if (!el.offsetWidth || !el.offsetHeight || !el.getClientRects().length) {
       return false;
     }
   
     var root = document.documentElement;
     var width = Math.min(root.clientWidth, window.innerWidth);
     var height = Math.min(root.clientHeight, window.innerHeight);
     var rect = el.getBoundingClientRect();
   
     return rect.bottom >= 0 && rect.right >= 0 && rect.top <= height && rect.left <= width;
   }
   
   /**
    * @typedef {Object} Size
    * @property {Number} width
    * @property {Number} height
    */
   
   /**
    * A function to turn a template string into a URL.
    *
    * @callback TemplateRenderer
    * @param {String} template
    * @param {Size} size
    * @returns {String}
    */
   
   /**
    * @typedef {Object} Settings
    *
    * @property {String} [template]
    *           A template string used to generate URLs for an image. This allows us to
    *           dynamically load images with sizes to match the container's size.
    *
    * @property {TemplateRenderer} [templateRender]
    *           A function to turn a template string into a URL.
    *
    * @property {Size} [max]
    *           The maximum available size for the image. This ensures we don't
    *           try to load an image larger than is possible.
    *
    * @property {Number} [scale]
    *           A number to scale the final image dimensions by.
    *           Only applies to lazy-loaded images. Defaults to 1.
    *
    * @property {Number} [round]
    *           Round image dimensions to the nearest multiple. This is intended to
    *           tax the image server less by lowering the number of possible image
    *           sizes requested.
    *
    * @property {Size} [placeholder]
    *           The size of the lo-fi image to load before the full image.
    *
    * @property {String} [crop]
    *           Crop value; null if image is uncropped, otherwise equal
    *           to the Shopify crop parameter ('center', 'top', etc.).
    */
   
   /**
    * Initialize the responsive image handler.
    *
    * @param {String|HTMLElement|NodeList} selector
    *        The CSS selector, element, or elements to track for lazy-loading.
    *
    * @param {Settings} options
    *
    * @returns {PublicApi}
    */
   function rimg() {
     var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
     var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
     // Intersections
     var io = new IntersectionObserver(function (entries) {
       entries.forEach(function (entry) {
         if (entry.isIntersecting || entry.intersectionRatio > 0) {
           io.unobserve(entry.target);
           load(entry.target, options);
         }
       });
     }, {
       // Watch the viewport, with 20% vertical margins
       rootMargin: '20% 0px'
     });
   
     /**
      * @typedef {Object} PublicApi
      */
     var api = {
       /**
        * Track a new selector, element, or nodelist for lazy-loading.
        * @type Function
        * @param {String|HTMLElement|NodeList} selector
        */
       track: function track() {
         var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
   
         var els = querySelector(selector);
   
         for (var i = 0; i < els.length; i++) {
           // If an element is already in the viewport, load it right away. This
           // fixes a race-condition with dynamically added elements.
           if (inViewport(els[i])) {
             load(els[i], options);
           } else {
             io.observe(els[i]);
           }
         }
       },
   
   
       /**
        * Update element(s) that have already been loaded to force their images
        * to be recalculated.
        * @type Function
        * @param {String|HTMLElement|NodeList} selector
        */
       update: function update$$1() {
         var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="loaded"]';
   
         var els = querySelector(selector);
         for (var i = 0; i < els.length; i++) {
           update(els[i], options);
         }
       },
   
   
       /**
        * Stop tracking element(s) for lazy-loading.
        * @type Function
        * @param {String|HTMLElement|NodeList} selector
        */
       untrack: function untrack() {
         var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';
   
         var els = querySelector(selector);
         for (var i = 0; i < els.length; i++) {
           io.unobserve(els[i]);
         }
       },
   
   
       /**
        * Unload all event handlers and observers.
        * @type Function
        */
       unload: function unload() {
         io.disconnect();
       }
     };
   
     // Add initial elements
     api.track(selector);
   
     return api;
   }
   
   /**
    * Finds a group of elements on the page.
    *
    * @param {String|HTMLElement|NodeList} selector
    * @returns {Object} An array-like object.
    */
   function querySelector(selector) {
     if (typeof selector === 'string') {
       return document.querySelectorAll(selector);
     }
   
     if (selector instanceof HTMLElement) {
       return [selector];
     }
   
     if (selector instanceof NodeList) {
       return selector;
     }
   
     return [];
   }
   
   /* harmony default export */ var index_es = (rimg);
   
   // CONCATENATED MODULE: ./node_modules/rimg-shopify/dist/index.es.js
   /*!
    * rimg-shopify v2.3.0
    * (c) 2018 Pixel Union
    */
   
   
   /**
    * Polyfill for Element.matches().
    *
    * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
    */
   if (!Element.prototype.matches) {
     Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
       var matches = (this.document || this.ownerDocument).querySelectorAll(s),
           i = matches.length;
       while (--i >= 0 && matches.item(i) !== this) {}
       return i > -1;
     };
   }
   
   var state = {
     init: index_es_init,
     watch: watch,
     unwatch: unwatch
   };
   
   function index_es_init() {
     var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
     var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
     state.selector = selector;
     state.instance = index_es(selector, options);
     state.loadedWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
   
     // Listen for Shopify theme editor events
     document.addEventListener('shopify:section:load', function (event) {
       return watch(event.target);
     });
   
     window.addEventListener('resize', function () {
       return _update();
     });
   
     document.addEventListener('shopify:section:unload', function (event) {
       return unwatch(event.target);
     });
   
     // Listen for custom events to allow themes to hook into rimg
     document.addEventListener('theme:rimg:watch', function (event) {
       return watch(event.target);
     });
   
     document.addEventListener('theme:rimg:unwatch', function (event) {
       return unwatch(event.target);
     });
   
     // Support custom events triggered through jQuery
     // See: https://github.com/jquery/jquery/issues/3347
     if (window.jQuery) {
       jQuery(document).on({
         'theme:rimg:watch': function themeRimgWatch(event) {
           return watch(event.target);
         },
         'theme:rimg:unwatch': function themeRimgUnwatch(event) {
           return unwatch(event.target);
         }
       });
     }
   }
   
   /**
    * Track an element, and its children.
    *
    * @param {HTMLElement} el
    */
   function watch(el) {
     // Track element
     if (typeof el.matches === 'function' && el.matches(state.selector)) {
       state.instance.track(el);
     }
   
     // Track element's children
     state.instance.track(el.querySelectorAll(state.selector));
   }
   
   /**
    * Untrack an element, and its children
    *
    * @param {HTMLElement} el
    * @private
    */
   function unwatch(el) {
     // Untrack element's children
     state.instance.untrack(el.querySelectorAll(state.selector));
   
     // Untrack element
     if (typeof el.matches === 'function' && el.matches(state.selector)) {
       state.instance.untrack(el);
     }
   }
   
   /**
    * Update an element, and its children.
    *
    * @param {HTMLElement} el
    */
   function _update() {
     var currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
   
     // Return if we're not 2x smaller, or larger than the existing loading size
     if (currentWidth / state.loadedWidth > 0.5 && currentWidth / state.loadedWidth < 2) {
       return;
     }
   
     state.loadedWidth = currentWidth;
     state.instance.update();
   }
   
   /* harmony default export */ var dist_index_es = (state);
   
   // CONCATENATED MODULE: ./source/scripts/helpers/Quantity.js
   function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
   
   var Quantity =
   /*#__PURE__*/
   function () {
     function Quantity(el) {
       _classCallCheck(this, Quantity);
   
       this.$el = $(el);
       this.$inputParent = this.$el.find('.form-field--qty-input');
       this.$input = this.$el.find('[data-quantity-input]');
       this.$selectParent = this.$el.find('.form-field--qty-select');
       this.$select = this.$el.find('[data-quantity-select]');
       this._watchSelect = this._watchSelect.bind(this);
       this._watchInput = this._watchInput.bind(this);
       this.$select.on('change.quantity', this._watchSelect);
       this.$input.on('change.quantity', this._watchInput);
     }
   
     _createClass(Quantity, [{
       key: "unload",
       value: function unload() {
         this.$el.off('.quantity');
       }
     }, {
       key: "_validateValue",
       value: function _validateValue(event) {
         var baseValue = parseInt(event.currentTarget.value, 10);
         return isNaN(baseValue) ? 1 : baseValue;
       }
     }, {
       key: "_watchSelect",
       value: function _watchSelect(event) {
         var value = this._validateValue(event); // Update input to match select
   
   
         this.$input.val(value).trigger('change'); // Switch to quantity input when 10 or more
   
         if (value >= 10) {
           this.$inputParent.removeClass('hidden').addClass('visible');
           this.$input.focus().removeAttr('tabindex').select();
           this.$selectParent.removeClass('visible').addClass('hidden');
           this.$select.attr('tabindex', '-1');
         }
       }
     }, {
       key: "_watchInput",
       value: function _watchInput(event) {
         this.$input.val(this._validateValue(event));
       }
     }]);
   
     return Quantity;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/Forms.js
   function Forms_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Forms_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Forms_createClass(Constructor, protoProps, staticProps) { if (protoProps) Forms_defineProperties(Constructor.prototype, protoProps); if (staticProps) Forms_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var Forms_Forms =
   /*#__PURE__*/
   function () {
     function Forms($el) {
       var _this = this;
   
       var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.form-field-input';
   
       Forms_classCallCheck(this, Forms);
   
       this.$el = $el;
       this.filledClass = 'form-field-filled';
       this.fieldSelector = selector;
       this.quantityItems = [];
       this.$quantityWrapper = this.$el.find('[data-quantity-wrapper]');
       this._toggleFilled = this._toggleFilled.bind(this);
       this.$el.on('focus.forms', this.fieldSelector, this._toggleFilled);
       this.$el.on('blur.forms', this.fieldSelector, this._toggleFilled);
   
       this._checkFilled();
   
       if (this.$quantityWrapper.length) {
         this.$quantityWrapper.each(function (i, el) {
           _this.quantityItems.push(new Quantity(el));
         });
       }
     }
   
     Forms_createClass(Forms, [{
       key: "unload",
       value: function unload() {
         this.$el.off('.forms');
         this.quantityItems.forEach(function (quantityItem) {
           quantityItem.unload();
         });
       }
     }, {
       key: "_checkFilled",
       value: function _checkFilled() {
         var _this2 = this;
   
         this.$el.find(this.fieldSelector).each(function (i, el) {
           if (jquery_default()(el).hasClass(_this2.filledClass)) return;
   
           _this2._toggleFilled(null, el);
         });
       }
     }, {
       key: "_toggleFilled",
       value: function _toggleFilled() {
         var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
         var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
         var target = event ? event.currentTarget : el;
         var $target = jquery_default()(target);
         var value = target.value;
         var isFilled = value.length > 0;
   
         try {
           isFilled = isFilled || $target.is(':-webkit-autofill');
           $target.toggleClass(this.filledClass, isFilled);
         } catch (e) {
           $target.toggleClass(this.filledClass, isFilled);
         }
       }
     }]);
   
     return Forms;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/templates/Account.js
   function Account_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Account_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Account_createClass(Constructor, protoProps, staticProps) { if (protoProps) Account_defineProperties(Constructor.prototype, protoProps); if (staticProps) Account_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var Account_Account =
   /*#__PURE__*/
   function () {
     function Account() {
       Account_classCallCheck(this, Account);
   
       this.$accountContents = jquery_default()('[data-template-account]');
       this.$loginContent = jquery_default()('[data-template-account-login]');
       this.$addressesContent = jquery_default()('[data-template-account-addresses]');
       this.$addressButtonFocus = null;
       this._loginToggle = this._loginToggle.bind(this);
   
       if (this.$loginContent.length) {
         this._initLoginPage();
       }
   
       if (this.$addressesContent.length) {
         this._initAddressPage();
       }
   
       if (this.$accountContents.length) {
         this._init();
       }
     }
   
     Account_createClass(Account, [{
       key: "_init",
       value: function _init() {
         new Forms_Forms(this.$accountContents);
       }
     }, {
       key: "_initLoginPage",
       value: function _initLoginPage() {
         this.$loginToggle = this.$loginContent.find('[data-login-toggle]');
         this.$login = this.$loginContent.find('[data-account-login-main]');
         this.$recovery = this.$loginContent.find('[data-account-login-recovery]');
         this.$recoveryHasMessage = this.$recovery.find('[data-recovery-has-message]');
         this.$loginToggle.on('click', this._loginToggle);
   
         if (this.$recoveryHasMessage.length) {
           this._loginToggle();
         }
       }
     }, {
       key: "_loginToggle",
       value: function _loginToggle() {
         var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
   
         if (event) {
           event.preventDefault();
         }
   
         this.$login.toggleClass('visible');
         this.$recovery.toggleClass('visible');
       }
     }, {
       key: "_initAddressPage",
       value: function _initAddressPage() {
         var _this = this;
   
         var $customerAddresses = this.$addressesContent.find('[data-address-id]');
         this.$addressesContent.on('click', '[data-edit-address]', function (event) {
           var $target = jquery_default()(event.currentTarget);
           var itemId = $target.attr('data-edit-address');
           $customerAddresses.removeClass('visible');
           _this.$addressButtonFocus = $target;
           jquery_default()("[data-address-id=\"".concat(itemId, "\"]")).addClass('visible').find('.form-field-input').eq(0).focus();
         });
         this.$addressesContent.on('click', '[data-edit-address-cancel]', function () {
           $customerAddresses.removeClass('visible');
           jquery_default()('[data-address-id="new"]').addClass('visible'); // Return focus to last used button
   
           _this.$addressButtonFocus.focus();
   
           _this.$addressButtonFocus = null;
         });
         this.$addressesContent.on('click', '[data-delete-address]', function (event) {
           var itemId = jquery_default()(event.target).attr('data-delete-address');
           Shopify.CustomerAddress.destroy(itemId, '');
         });
         $customerAddresses.each(function (i, el) {
           var id = jquery_default()(el).attr('data-address-id');
           var countryEl = "customer_addr_".concat(id, "_country");
           var provinceEl = "customer_addr_".concat(id, "_province");
           var options = {
             hideElement: "address_province_container_".concat(id)
           }; // Initiate provinces for address forms
   
           new Shopify.CountryProvinceSelector(countryEl, provinceEl, options);
         });
       }
     }]);
   
     return Account;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/templates/Contact.js
   function Contact_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   
   
   
   var Contact_Contact = function Contact() {
     Contact_classCallCheck(this, Contact);
   
     this.$contactContents = jquery_default()('[data-template-contact]');
   
     if (this.$contactContents.length) {
       new Forms_Forms(this.$contactContents);
     }
   };
   
   
   // EXTERNAL MODULE: ./node_modules/fitvids/index.js
   var fitvids = __webpack_require__(10);
   var fitvids_default = /*#__PURE__*/__webpack_require__.n(fitvids);
   
   // EXTERNAL MODULE: ./node_modules/grouped-content/dist/index.js
   var dist = __webpack_require__(11);
   var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
   
   // CONCATENATED MODULE: ./source/scripts/components/RichText.js
   function RichText_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function RichText_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function RichText_createClass(Constructor, protoProps, staticProps) { if (protoProps) RichText_defineProperties(Constructor.prototype, protoProps); if (staticProps) RichText_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var RichText_RichText =
   /*#__PURE__*/
   function () {
     function RichText($el) {
       RichText_classCallCheck(this, RichText);
   
       this.$el = $el;
   
       this._initExternalLinks();
   
       this.groupedContent = null;
   
       if (this.$el.length) {
         this.groupedContent = new dist_default.a($el.get(0), {
           layout: 'tabs',
           intelliparse: false
         });
         fitvids_default()('.rte');
       }
     }
   
     RichText_createClass(RichText, [{
       key: "unload",
       value: function unload() {
         if (this.groupedContent) {
           this.groupedContent.unload();
         }
       }
       /**
        * Open links within an RTE field in a new window if they point to external domains
        *
        * @private
        */
   
     }, {
       key: "_initExternalLinks",
       value: function _initExternalLinks() {
         var anchors = this.$el.find('a[href^="http"]').filter(function (i, el) {
           return el.href.indexOf(location.hostname) === -1;
         });
         anchors.attr('target', '_blank');
       }
     }]);
   
     return RichText;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/templates/Page.js
   function Page_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   
   
   
   var Page_Page = function Page() {
     Page_classCallCheck(this, Page);
   
     this.$pageContent = jquery_default()('[data-template-page]');
   
     if (this.$pageContent.length) {
       new RichText_RichText(this.$pageContent);
     }
   };
   
   
   // EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
   var script = __webpack_require__(2);
   var script_default = /*#__PURE__*/__webpack_require__.n(script);
   
   // CONCATENATED MODULE: ./source/scripts/templates/GiftCard.js
   function GiftCard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function GiftCard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function GiftCard_createClass(Constructor, protoProps, staticProps) { if (protoProps) GiftCard_defineProperties(Constructor.prototype, protoProps); if (staticProps) GiftCard_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var GiftCard_GiftCard =
   /*#__PURE__*/
   function () {
     function GiftCard() {
       GiftCard_classCallCheck(this, GiftCard);
   
       this.el = document.querySelector('.giftcard');
       this.$el = jquery_default()(this.el);
       this.qrCode = this.el.querySelector('[data-giftcard-qr]');
       this.giftCardCode = this.el.querySelector('[data-giftcard-code]');
   
       this._bindEvents();
   
       this.addQrCode();
     }
   
     GiftCard_createClass(GiftCard, [{
       key: "addQrCode",
       value: function addQrCode() {
         return new QRCode(this.qrCode, {
           text: jquery_default()(this.qrCode).data('giftcard-qr'),
           width: 120,
           height: 120
         });
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this = this;
   
         this.$el.on('click', '[data-giftcard-print]', function () {
           window.print();
         }); // Auto-select gift card code on click, based on ID passed to the function
   
         this.$el.on('click', '[data-giftcard-code]', function () {
           _this._selectText();
         });
       }
     }, {
       key: "_selectText",
       value: function _selectText() {
         var range = '';
   
         if (document.body.createTextRange) {
           // ms method
           range = document.body.createTextRange();
           range.moveToElementText(this.giftCardCode);
           range.select();
         } else if (window.getSelection) {
           // moz, opera, webkit method
           var selection = window.getSelection();
           range = document.createRange();
           range.selectNodeContents(this.giftCardCode);
           selection.removeAllRanges();
           selection.addRange(range);
         }
       }
     }]);
   
     return GiftCard;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/Sections.js
   function Sections_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Sections_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Sections_createClass(Constructor, protoProps, staticProps) { if (protoProps) Sections_defineProperties(Constructor.prototype, protoProps); if (staticProps) Sections_defineProperties(Constructor, staticProps); return Constructor; }
   
   var Sections =
   /*#__PURE__*/
   function () {
     function Sections() {
       Sections_classCallCheck(this, Sections);
   
       this.handlers = {};
       this.instances = {};
       this._onSectionEvent = this._onSectionEvent.bind(this);
       document.addEventListener('shopify:section:load', this._onSectionEvent);
       document.addEventListener('shopify:section:unload', this._onSectionEvent);
       document.addEventListener('shopify:section:select', this._onSectionEvent);
       document.addEventListener('shopify:section:deselect', this._onSectionEvent);
       document.addEventListener('shopify:block:select', this._onSectionEvent);
       document.addEventListener('shopify:block:deselect', this._onSectionEvent);
     }
     /**
      * Stop listening for section events, and unbind all handlers.
      */
   
   
     Sections_createClass(Sections, [{
       key: "unbind",
       value: function unbind() {
         document.removeEventListener('shopify:section:load', this._onSectionEvent);
         document.removeEventListener('shopify:section:unload', this._onSectionEvent);
         document.removeEventListener('shopify:section:select', this._onSectionEvent);
         document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
         document.removeEventListener('shopify:block:select', this._onSectionEvent);
         document.removeEventListener('shopify:block:deselect', this._onSectionEvent); // Unload all instances
   
         for (var i = 0; i < this.instances.length; i++) {
           this._triggerInstanceEvent(this.instances[i], 'onSectionUnload');
         }
   
         this.handlers = {};
         this.instances = {};
       }
       /**
        * Register a section handler.
        *
        * @param {string} type
        *        The section type to handle. The handler will be called for all
        *        sections with this type.
        *
        * @param {function} handler
        *        The handler function is passed information about a specific section
        *        instance. The handler is expected to return an object that will be
        *        associated with the section instance.
        *
        *        Section handlers are passed an object with the following parameters:
        *          {string} id
        *          An ID that maps to a specific section instance. Typically the
        *          section's filename for static sections, or a generated ID for
        *          dynamic sections.
        *
        *          {string} type
        *          The section type, as supplied when registered.
        *
        *          {Element} el
        *          The root DOM element for the section instance.
        *
        *          {Object} data
        *          Data loaded from the section script element. Defaults to an
        *          empty object.
        *
        *          {Function} postMessage
        *          A function that can be called to pass messages between sections.
        *          The function should be called with a message "name", and
        *          optionally some data.
        */
   
     }, {
       key: "register",
       value: function register(type, handler) {
         if (this.handlers[type]) {
           console.warn("Sections: section handler already exists of type '".concat(type, "'."));
         } // Store the section handler
   
   
         this.handlers[type] = handler; // Init sections for this type
   
         this._initSections(type);
       }
       /**
        * Initialize sections already on the page.
        */
   
     }, {
       key: "_initSections",
       value: function _initSections(type) {
         // Fetch all existing sections of our type on the page
         var dataEls = document.querySelectorAll("[data-section-type=\"".concat(type, "\"]"));
         if (!dataEls) return; // Create an instance for each section
   
         for (var i = 0; i < dataEls.length; i++) {
           var dataEl = dataEls[i];
           var el = dataEl.parentNode; // Get instance ID
   
           var idEl = el.querySelector('[data-section-id]');
   
           if (!idEl) {
             console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
             continue;
           }
   
           var sectionId = idEl.getAttribute('data-section-id');
   
           if (!sectionId) {
             console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
             continue;
           }
   
           this._createInstance(sectionId, el);
         }
       }
     }, {
       key: "_onSectionEvent",
       value: function _onSectionEvent(event) {
         var el = event.target;
         var sectionId = event.detail.sectionId;
         var blockId = event.detail.blockId;
         var instance = this.instances[sectionId];
   
         switch (event.type) {
           case 'shopify:section:load':
             this._createInstance(sectionId, el);
   
             break;
   
           case 'shopify:section:unload':
             this._triggerInstanceEvent(instance, 'onSectionUnload', {
               el: el,
               id: sectionId
             });
   
             delete this.instances[sectionId];
             break;
   
           case 'shopify:section:select':
             this._triggerInstanceEvent(instance, 'onSectionSelect', {
               el: el,
               id: sectionId
             });
   
             break;
   
           case 'shopify:section:deselect':
             this._triggerInstanceEvent(instance, 'onSectionDeselect', {
               el: el,
               id: sectionId
             });
   
             break;
   
           case 'shopify:block:select':
             this._triggerInstanceEvent(instance, 'onSectionBlockSelect', {
               el: el,
               id: blockId
             });
   
             break;
   
           case 'shopify:block:deselect':
             this._triggerInstanceEvent(instance, 'onSectionBlockDeselect', {
               el: el,
               id: blockId
             });
   
             break;
         }
       }
     }, {
       key: "_triggerInstanceEvent",
       value: function _triggerInstanceEvent(instance, eventName) {
         if (instance && instance[eventName]) {
           for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
             args[_key - 2] = arguments[_key];
           }
   
           instance[eventName].apply(instance, args);
         }
       }
     }, {
       key: "_postMessage",
       value: function _postMessage(name, data) {
         var _this = this;
   
         Object.keys(this.instances).forEach(function (id) {
           _this._triggerInstanceEvent(_this.instances[id], 'onSectionMessage', name, data);
         });
       }
     }, {
       key: "_createInstance",
       value: function _createInstance(id, el) {
         var typeEl = el.querySelector('[data-section-type]');
         if (!typeEl) return;
         var type = typeEl.getAttribute('data-section-type');
         if (!type) return;
         var handler = this.handlers[type];
         if (!handler) return console.warn("Sections: unable to find section handler for type '".concat(type, "'."));
   
         var data = this._loadData(el);
   
         var postMessage = this._postMessage.bind(this);
   
         this.instances[id] = handler({
           id: id,
           type: type,
           el: el,
           data: data,
           postMessage: postMessage
         });
       }
     }, {
       key: "_loadData",
       value: function _loadData(el) {
         var dataEl = el.querySelector('[data-section-data]');
         if (!dataEl) return {}; // Load data from attribute, or innerHTML
   
         var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;
   
         try {
           return JSON.parse(data);
         } catch (error) {
           console.warn("Sections: invalid section data found. ".concat(error.message));
           return {};
         }
       }
     }]);
   
     return Sections;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticAnnouncement.js
   function StaticAnnouncement_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   var StaticAnnouncement = function StaticAnnouncement(section) {
     StaticAnnouncement_classCallCheck(this, StaticAnnouncement);
   
     // Since the announcement bar positioning is actually handled by the
     // StaticSectionHeader and StickyHeader classes, we need to let them know
     // when the announcement element is refreshed within the editor.
     if (window.Shopify && window.Shopify.designMode) {
       section.postMessage('announcement:load');
     }
   };
   
   
   // EXTERNAL MODULE: ./node_modules/shopify-currency-converter/dist/index.js
   var shopify_currency_converter_dist = __webpack_require__(1);
   var shopify_currency_converter_dist_default = /*#__PURE__*/__webpack_require__.n(shopify_currency_converter_dist);
   
   // CONCATENATED MODULE: ./source/scripts/Layout.js
   
   var eventHandlers = [];
   var previousBreakpoint = null;
   jquery_default()(window).on('resize', function (event) {
     var currentBreakpoint = getBreakpoint();
   
     if (previousBreakpoint !== currentBreakpoint) {
       eventHandlers.forEach(function (eventHandler) {
         eventHandler(event, {
           previous: previousBreakpoint,
           current: currentBreakpoint
         });
       });
     }
   
     previousBreakpoint = currentBreakpoint;
   });
   
   function getBreakpoint() {
     return window.getComputedStyle(document.documentElement, ':after').getPropertyValue('content').replace(/"/g, '');
   }
   
   function isBreakpoint(breakpoint) {
     return getBreakpoint() === breakpoint;
   }
   
   function Layout_onBreakpointChange(eventHandler) {
     if (eventHandlers.indexOf(eventHandler) === -1) {
       eventHandlers.push(eventHandler);
     }
   }
   
   function offBreakpointChange(eventHandler) {
     var index = eventHandlers.indexOf(eventHandler);
   
     if (index !== -1) {
       eventHandlers.splice(index, 1);
     }
   }
   
   /* harmony default export */ var Layout = ({
     isBreakpoint: isBreakpoint,
     onBreakpointChange: Layout_onBreakpointChange,
     offBreakpointChange: offBreakpointChange
   });
   // CONCATENATED MODULE: ./source/scripts/components/StickyHeader.js
   function StickyHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StickyHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StickyHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) StickyHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) StickyHeader_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var StickyHeader_StickyHeader =
   /*#__PURE__*/
   function () {
     function StickyHeader(options, settings) {
       var _this = this;
   
       StickyHeader_classCallCheck(this, StickyHeader);
   
       this.body = document.querySelector('body');
       this.header = document.querySelector('[data-site-header]');
       this.menu = this.header.querySelector('[data-site-navigation]');
       this.menuToggle = options.menuToggle;
       this.postMessage = options.postMessage;
       this.settings = settings;
       this.transitioning = false;
       this.lastToggle = Date.now() - 1000;
       this.stickyClass = 'site-header-sticky';
       this.scrolledClass = 'site-header-sticky--scrolled';
       this.navOpenClass = 'site-header-nav--open';
       this._toggleStickyHeader = this._toggleStickyHeader.bind(this);
       this._toggleMenu = this._toggleMenu.bind(this);
   
       if (this.settings.sticky_header) {
         this.body.classList.add(this.stickyClass);
         window.requestAnimationFrame(function () {
           // If browser doesn't support sticky, we don't want any of the sticky functionality.
           if (window.getComputedStyle(_this.header).position.indexOf('sticky') > -1) {
             _this.observer = new IntersectionObserver(function (entries) {
               return _this._toggleStickyHeader(entries);
             });
   
             _this.observer.observe(document.querySelector('[data-header-intersection-target]'));
   
             _this.toggleClick = function (event) {
               event.preventDefault();
               if (Layout.isBreakpoint('L')) _this._toggleMenu();
             };
   
             _this.menuToggle.addEventListener('click', _this.toggleClick);
           }
         });
       }
     }
   
     StickyHeader_createClass(StickyHeader, [{
       key: "closeNavigation",
       value: function closeNavigation() {
         var _this2 = this;
   
         if (this.transitioning) {
           return;
         }
   
         this.menuToggle.classList.remove('active');
   
         this.navTransitionOutEvent = function () {
           _this2.header.classList.remove(_this2.navOpenClass);
   
           _this2.transitioning = false;
   
           _this2.menu.removeEventListener('transitionend', _this2.navTransitionOutEvent);
         };
   
         this.menu.addEventListener('transitionend', this.navTransitionOutEvent);
         this.transitioning = true;
         this.menu.setAttribute('style', "margin-top: -".concat(this.menu.getBoundingClientRect().height, "px;"));
         this.postMessage('nav:close-all');
       }
     }, {
       key: "openNavigation",
       value: function openNavigation() {
         var _this3 = this;
   
         if (this.transitioning || this.header.classList.contains(this.navOpenClass)) {
           return;
         }
   
         this.menuToggle.classList.add('active');
   
         this.navTransitionInEvent = function () {
           _this3.transitioning = false;
   
           _this3.menu.removeEventListener('transitionend', _this3.navTransitionInEvent);
         };
   
         this.menu.addEventListener('transitionend', this.navTransitionInEvent);
         this.transitioning = true; // We need to wait for the browser to set the display to 'block' before we set the margin
         // This will help with ensuring the different animations/transitions happen in sequence
         // and not at the same time.
   
         window.requestAnimationFrame(function () {
           _this3.header.classList.add(_this3.navOpenClass);
   
           window.requestAnimationFrame(function () {
             _this3.menu.setAttribute('style', 'margin-top: 0;');
           });
         });
       }
     }, {
       key: "_toggleMenu",
       value: function _toggleMenu() {
         if (this.header.classList.contains(this.navOpenClass)) {
           this.closeNavigation();
         } else {
           this.openNavigation();
         }
       }
       /**
        * Sticky header only shows as sticky after scroll
        *
        * @private
        */
   
     }, {
       key: "_toggleStickyHeader",
       value: function _toggleStickyHeader(entries) {
         if (this.body.classList.contains('scroll-lock') || !Layout.isBreakpoint('L')) {
           return;
         }
   
         var shouldShrink = !entries[0].isIntersecting; // Sticky header is scrolled, is and is visible -- nothing more to do!
   
         if (shouldShrink && this.header.classList.contains(this.scrolledClass)) {
           return;
         } // We also check to make sure the toggle hasnt activated recently to stop jerky transitions
   
   
         if (this.lastToggle + 500 > Date.now()) {
           return;
         }
   
         this.lastToggle = Date.now();
   
         if (shouldShrink) {
           this._shrink();
         } else {
           this._expand();
         }
       }
     }, {
       key: "_shrink",
       value: function _shrink() {
         this.closeNavigation();
         this.header.classList.add(this.scrolledClass);
       }
     }, {
       key: "_expand",
       value: function _expand() {
         this.openNavigation();
         this.header.classList.remove(this.scrolledClass);
         this.menuToggle.classList.remove('active');
       }
     }, {
       key: "unload",
       value: function unload() {
         this.body.classList.remove(this.stickyClass);
         this.body.classList.remove(this.scrolledClass);
   
         if (this.observer) {
           this.observer.disconnect();
         }
   
         this.menuToggle.removeEventListener('click', this.toggleClick);
       }
     }]);
   
     return StickyHeader;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/Accordion.js
   function Accordion_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Accordion_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Accordion_createClass(Constructor, protoProps, staticProps) { if (protoProps) Accordion_defineProperties(Constructor.prototype, protoProps); if (staticProps) Accordion_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var Accordion_Accordion =
   /*#__PURE__*/
   function () {
     function Accordion($el) {
       var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
       Accordion_classCallCheck(this, Accordion);
   
       this.$el = $el;
       this.options = jquery_default.a.extend({}, {
         activeClass: 'accordion--active',
         autoCollapse: false,
         content: '[data-accordion-content]',
         eligibleClass: 'has-accordion'
       }, options);
     }
   
     Accordion_createClass(Accordion, [{
       key: "toggle",
       value: function toggle($block) {
         var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
   
         if (open || !$block.hasClass(this.options.activeClass)) {
           if (this.options.autoCollapse) this.closeOpen();
   
           this._open($block);
         } else {
           this._close($block);
         }
       }
     }, {
       key: "closeOpen",
       value: function closeOpen() {
         var _this = this;
   
         jquery_default()(this.$el.find(".".concat(this.options.activeClass))).each(function (i, block) {
           var $block = jquery_default()(block);
   
           if ($block.hasClass(_this.options.activeClass)) {
             _this._close($block);
           }
         });
       }
     }, {
       key: "openAll",
       value: function openAll() {
         var _this2 = this;
   
         jquery_default()(this.$el.find(".".concat(this.options.eligibleClass))).each(function (i, block) {
           _this2._open(jquery_default()(block), 0);
         });
       }
     }, {
       key: "_open",
       value: function _open($block) {
         $block.addClass(this.options.activeClass);
       }
     }, {
       key: "_close",
       value: function _close($block) {
         $block.removeClass(this.options.activeClass);
       }
     }]);
   
     return Accordion;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/navigation/NavMobileSubMenus.js
   function NavMobileSubMenus_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function NavMobileSubMenus_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function NavMobileSubMenus_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavMobileSubMenus_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavMobileSubMenus_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var NavMobileSubMenus_NavMobileSubMenus =
   /*#__PURE__*/
   function () {
     function NavMobileSubMenus($el) {
       NavMobileSubMenus_classCallCheck(this, NavMobileSubMenus);
   
       this.$el = $el;
       this.Accordion = new Accordion_Accordion(this.$el, {
         activeClass: 'visible',
         content: '[data-accordion-content]'
       }); // Sub menu selectors
   
       this.activeMenuClass = 'navmenu-link-parent-active';
       this.activeMenu = ".".concat(this.activeMenuClass);
       this.linkClass = 'navmenu-link-parent';
       this.linkSelector = ".".concat(this.linkClass);
       this.navTrigger = '[data-navmenu-parent]';
       this.subMenu = '[data-navmenu-submenu]';
       this.buttonClass = 'navmenu-button';
       this.buttonSelector = ".".concat(this.buttonClass);
   
       this._bindEvents();
     }
   
     NavMobileSubMenus_createClass(NavMobileSubMenus, [{
       key: "unload",
       value: function unload() {
         this.$el.off('.mobile-nav');
         delete this.Accordion;
       }
     }, {
       key: "closeSubMenus",
       value: function closeSubMenus($current) {
         var _this = this;
   
         $current.find(this.activeMenu).each(function (index, el) {
           _this._closeSubmenu(jquery_default()(el));
         });
       }
     }, {
       key: "closeAllSubmenus",
       value: function closeAllSubmenus() {
         this.Accordion.closeOpen();
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this2 = this;
   
         // Prevent focus state from applying on mouse click
         this.$el.on('mousedown.mobile-nav', '.navmenu-link', function (event) {
           event.preventDefault();
         });
         this.$el.on('click.mobile-nav', "".concat(this.navTrigger, " > .navmenu-link-parent"), this._linkClicked.bind(this));
         this.$el.on('click.mobile-nav', "".concat(this.navTrigger, " > .navmenu-button"), function (event) {
           event.preventDefault();
   
           _this2._toggleSubmenu(event);
         });
       }
     }, {
       key: "_linkClicked",
       value: function _linkClicked(event) {
         var $target = jquery_default()(event.currentTarget);
   
         if (!$target.hasClass(this.activeMenuClass)) {
           event.preventDefault();
   
           this._openSubmenu($target);
         }
       }
     }, {
       key: "_toggleSubmenu",
       value: function _toggleSubmenu(event) {
         var $target = jquery_default()(event.currentTarget);
         var $link = $target.hasClass(this.linkClass) ? $target : $target.siblings(this.linkSelector).first();
   
         if ($link.hasClass(this.activeMenuClass)) {
           this._closeSubmenu($target);
         } else {
           this._openSubmenu($target);
         }
       }
     }, {
       key: "_openSubmenu",
       value: function _openSubmenu($target) {
         var $menu = $target.siblings(this.subMenu).first();
         var $link = $target.hasClass(this.linkClass) ? $target : $target.siblings(this.linkSelector).first();
         var $button = $target.hasClass(this.buttonClass) ? $target : $target.siblings(this.buttonSelector).first();
         $menu.css('display', 'flex');
         $link.addClass(this.activeMenuClass).attr('aria-expanded', true);
         $button.attr('aria-expanded', true);
         this.Accordion.toggle($menu);
       }
     }, {
       key: "_closeSubmenu",
       value: function _closeSubmenu($target) {
         var $menu = $target.siblings(this.subMenu).first();
         var $link = $target.hasClass(this.linkClass) ? $target : $target.siblings(this.linkSelector).first();
         var $button = $target.hasClass(this.buttonClass) ? $target : $target.siblings(this.buttonSelector).first();
         $menu.one('transitionend', function () {
           return $menu.css('display', '');
         });
         $link.removeClass(this.activeMenuClass).attr('aria-expanded', false);
         $button.attr('aria-expanded', false);
         this.Accordion.toggle($menu);
         this.closeSubMenus($menu);
       }
     }]);
   
     return NavMobileSubMenus;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/navigation/NavMobile.js
   function NavMobile_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function NavMobile_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function NavMobile_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavMobile_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavMobile_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var NavMobile_NavMobile =
   /*#__PURE__*/
   function () {
     function NavMobile(elements) {
       NavMobile_classCallCheck(this, NavMobile);
   
       this.$body = jquery_default()(document.body);
       this.$window = jquery_default()(window);
       this.$el = elements.$el;
       this.$toggleOpen = elements.$toggleOpen;
       this.isOpen = false;
       this.subMenus = null;
       this.$mobileNav = this.$el.find('[data-mobile-nav]');
       this.$panel = this.$el.find('[data-mobile-nav-panel]');
       this.$overlay = this.$el.find('[data-mobile-nav-overlay]');
       this.$toggleClose = this.$el.find('[data-mobile-nav-close]'); // Revert navigation to original state on breakpoint change
   
       this.layoutHandler = this.onBreakpointChange.bind(this);
       Layout.onBreakpointChange(this.layoutHandler);
   
       this._bindEvents();
     }
   
     NavMobile_createClass(NavMobile, [{
       key: "unload",
       value: function unload() {
         this._close();
   
         this.$window.off('resize.mobile-nav');
         Layout.offBreakpointChange(this.layoutHandler);
       }
     }, {
       key: "onBreakpointChange",
       value: function onBreakpointChange() {
         if (Layout.isBreakpoint('L') && this.isOpen) {
           this._close();
         }
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this = this;
   
         this.$toggleOpen.on('click.mobile-nav', function (event) {
           event.preventDefault();
           if (!Layout.isBreakpoint('L')) _this._open();
         });
         this.$window.on('resize.mobile-nav', function () {
           _this.$el.find('[data-menu-toggle]').removeClass('active');
   
           if (_this.isOpen) {
             _this._setPanelHeight();
           }
         });
       }
     }, {
       key: "_setPanelHeight",
       value: function _setPanelHeight() {
         this.$panel.height(window.innerHeight);
       }
     }, {
       key: "_open",
       value: function _open() {
         var _this2 = this;
   
         this.$body.addClass('scroll-lock');
         this.isOpen = true; // Activate Submenu handler
   
         this.subMenus = new NavMobileSubMenus_NavMobileSubMenus(this.$panel);
   
         this._setPanelHeight(); // Animate in elements
   
   
         this.$mobileNav.addClass('animating animating-in').one('trend', function () {
           _this2.$mobileNav.removeClass('animating animating-in').addClass('visible').off('trend');
         });
         this.$mobileNav.focus(); // Event handlers
   
         this.events = [// Close menu when clicking on the overlay
         this.$overlay.on('click.mobile-nav', function (event) {
           return _this2._close(event);
         }), this.$toggleClose.on('click.mobile-nav', function (event) {
           return _this2._close(event);
         }), // Disable scrolling on overlay and contactbar
         this.$overlay.on('touchmove.mobile-nav', function (event) {
           return event.preventDefault();
         })];
       }
     }, {
       key: "_close",
       value: function _close() {
         var _this3 = this;
   
         var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
         if (event) event.preventDefault();
         this.$mobileNav.addClass('animating animating-out').one('trend', function () {
           _this3.$mobileNav.removeClass('animating animating-out').removeClass('visible').off('trend');
         });
         this.$body.removeClass('scroll-lock');
         this.isOpen = false; // Close any open drop down menus
   
         if (this.subMenus) {
           this.subMenus.closeSubMenus(this.$el);
           this.subMenus.closeAllSubmenus(); // Unbind Mobile sub menus
   
           this.subMenus.unload();
         } // Unbind events
   
   
         if (this.events) {
           this.events.forEach(function ($el) {
             return $el.off('.mobile-nav');
           });
           this.events = [];
         }
       }
     }]);
   
     return NavMobile;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/helpers/scrollLeft.js
   
   function scrollLeft($el) {
     var $container = $el.parent();
     $container.animate({
       scrollLeft: $el.offset().left - $el.width() / 2 - $container.width() / 2
     });
   }
   // CONCATENATED MODULE: ./source/scripts/components/navigation/MegaNavScroller.js
   function MegaNavScroller_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function MegaNavScroller_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function MegaNavScroller_createClass(Constructor, protoProps, staticProps) { if (protoProps) MegaNavScroller_defineProperties(Constructor.prototype, protoProps); if (staticProps) MegaNavScroller_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var MegaNavScroller_MegaNavScroller =
   /*#__PURE__*/
   function () {
     function MegaNavScroller($el) {
       var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
   
       MegaNavScroller_classCallCheck(this, MegaNavScroller);
   
       this.$el = $el;
       this.$menuList = this.$el.find('.navmenu-meganav-items');
   
       this._bindEvents();
   
       this._addScrollClasses();
   
       if (block) {
         scrollLeft(jquery_default()(block.el));
       }
     }
   
     MegaNavScroller_createClass(MegaNavScroller, [{
       key: "unload",
       value: function unload() {
         this.$menuList.off('.meganav');
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this = this;
   
         this.$menuList.on('scroll.meganav', function () {
           return _this._addScrollClasses();
         });
       }
     }, {
       key: "_addScrollClasses",
       value: function _addScrollClasses() {
         var scrollLeftPosition = this.$menuList.scrollLeft();
         var scrollWidth = this.$menuList[0].scrollWidth;
         var width = this.$menuList.width();
         this.$el.toggleClass('meganav--overflows-left', scrollLeftPosition > 0);
         this.$el.toggleClass('meganav--overflows-right', scrollLeftPosition < scrollWidth - width);
       }
     }]);
   
     return MegaNavScroller;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/navigation/NavDesktopParent.js
   function NavDesktopParent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function NavDesktopParent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function NavDesktopParent_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavDesktopParent_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavDesktopParent_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var NavDesktopParent_NavDesktopParent =
   /*#__PURE__*/
   function () {
     function NavDesktopParent(el, options) {
       var _this = this;
   
       NavDesktopParent_classCallCheck(this, NavDesktopParent);
   
       this.listitem = el;
       this.link = null;
       this.submenu = null;
       this.isOpen = false;
       this.menu = null;
       this.closeSiblings = options.closeSiblings;
       var children = this.listitem.children;
   
       for (var i = 0; i < children.length; i++) {
         if (children[i].classList.contains('navmenu-link')) {
           this.link = children[i];
         } else if (children[i].classList.contains('navmenu-submenu')) {
           this.submenu = children[i];
         }
       }
   
       this.open = function () {
         _this._open();
       };
   
       this.close = function () {
         _this._close();
       };
   
       this.closeEsc = function (e) {
         if (e.key === 'Escape') {
           _this.link.focus();
   
           _this.close();
         }
       };
   
       this.timer = null;
   
       this.mouseover = function () {
         _this.open();
   
         clearTimeout(_this.timer);
       };
   
       this.mouseout = function () {
         _this.timer = setTimeout(_this.close, 400);
       };
   
       this.click = function (e) {
         e.stopPropagation(); // if already open, continue to link destination
   
         if (!e.target.classList.contains('navmenu-link-parent') || _this.isOpen) {
           return;
         }
   
         e.preventDefault();
   
         _this.open();
       };
   
       this.focusin = function (e) {
         e.stopPropagation();
   
         if (e.target.classList.contains('navmenu-link-parent')) {
           _this.closeSiblings(_this);
         }
       };
   
       this.listitem.addEventListener('mouseover', this.mouseover);
       this.listitem.addEventListener('mouseout', this.mouseout);
       this.listitem.addEventListener('touchend', this.click);
       this.listitem.addEventListener('click', this.click);
       this.listitem.addEventListener('focusin', this.focusin);
       document.body.addEventListener('click', this.close);
       document.body.addEventListener('focusin', this.close);
     }
   
     NavDesktopParent_createClass(NavDesktopParent, [{
       key: "_open",
       value: function _open() {
         var _this2 = this;
   
         this.closeSiblings(this);
         window.addEventListener('keydown', this.closeEsc);
   
         if (!this.listitem.classList.contains('open')) {
           this.listitem.classList.add('open');
           this.link.setAttribute('aria-expanded', true);
   
           this.submenuEndInAnimation = function () {
             _this2.submenu.classList.remove('animating-in');
   
             _this2.submenu.removeEventListener('animationend', _this2.submenuEndInAnimation);
           };
   
           this.submenu.addEventListener('animationend', this.submenuEndInAnimation);
           this.submenu.classList.add('animating-in');
         }
   
         if (!this.menu) {
           this.menu = new NavDesktopMenu_NavDesktopMenu(this.submenu);
         } // Determine if submenu needs to use alternate side for dropdown
         // Only applicable for regular drop down menus, not meganav
   
   
         if (!this.submenu.classList.contains('navmenu-meganav')) {
           var bounds = this.submenu.getBoundingClientRect();
   
           if (bounds.right > document.documentElement.clientWidth) {
             this.listitem.classList.add('alternate-drop');
           }
         }
   
         this.isOpen = true;
       }
     }, {
       key: "_close",
       value: function _close() {
         var _this3 = this;
   
         if (this.listitem.classList.contains('open') && !this.submenu.classList.contains('animating-out')) {
           this.submenuEndOutAnimation = function () {
             _this3.listitem.classList.remove('open');
   
             _this3.listitem.classList.remove('alternate-drop');
   
             _this3.link.setAttribute('aria-expanded', false);
   
             _this3.submenu.classList.remove('animating-out');
   
             _this3.submenu.removeEventListener('animationend', _this3.submenuEndOutAnimation);
           };
   
           this.submenu.addEventListener('animationend', this.submenuEndOutAnimation);
           this.submenu.classList.add('animating-out');
         }
   
         if (this.menu) {
           this.menu.unload();
           this.menu = null;
         }
   
         window.removeEventListener('keydown', this.closeEsc);
         this.isOpen = false;
       }
     }, {
       key: "unload",
       value: function unload() {
         this.close();
         this.listitem.removeEventListener('mouseover', this.mouseover);
         this.listitem.removeEventListener('mouseout', this.mouseout);
         this.listitem.removeEventListener('touchend', this.click);
         this.listitem.removeEventListener('click', this.click);
         this.listitem.removeEventListener('focusin', this.focusin);
         window.removeEventListener('keydown', this.closeEsc);
         document.body.removeEventListener('click', this.bodyClose);
         document.body.removeEventListener('focusin', this.focusInClose);
       }
     }]);
   
     return NavDesktopParent;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/navigation/NavDesktopMenu.js
   function NavDesktopMenu_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function NavDesktopMenu_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function NavDesktopMenu_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavDesktopMenu_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavDesktopMenu_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var NavDesktopMenu_NavDesktopMenu =
   /*#__PURE__*/
   function () {
     function NavDesktopMenu(_ref) {
       var _this = this;
   
       var children = _ref.children;
   
       NavDesktopMenu_classCallCheck(this, NavDesktopMenu);
   
       this.parents = [];
       this.children = children;
   
       this.closeSiblings = function (current) {
         _this.parents.forEach(function (parent) {
           if (parent !== current) {
             parent.close();
           }
         });
       };
   
       for (var i = 0; i < this.children.length; i++) {
         if (this.children[i].dataset.navmenuParent !== undefined) {
           this.parents.push(new NavDesktopParent_NavDesktopParent(this.children[i], {
             closeSiblings: this.closeSiblings
           }));
         } else if (children[i].classList.contains('navmenu-item')) {
           this.children[i].addEventListener('focusin', this.closeSiblings);
         }
       }
     }
   
     NavDesktopMenu_createClass(NavDesktopMenu, [{
       key: "unload",
       value: function unload() {
         this.parents.forEach(function (parent) {
           parent.unload();
         });
   
         for (var i = 0; i < this.children.length; i++) {
           this.children[i].removeEventListener('focusin', this.closeSiblings);
         }
       }
     }]);
   
     return NavDesktopMenu;
   }();
   
   
   // EXTERNAL MODULE: ./node_modules/just-debounce/index.js
   var just_debounce = __webpack_require__(3);
   var just_debounce_default = /*#__PURE__*/__webpack_require__.n(just_debounce);
   
   // EXTERNAL MODULE: ./node_modules/eventemitter2/lib/eventemitter2.js
   var eventemitter2 = __webpack_require__(12);
   var eventemitter2_default = /*#__PURE__*/__webpack_require__.n(eventemitter2);
   
   // CONCATENATED MODULE: ./source/scripts/Search.js
   function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
   
   function Search_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Search_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Search_createClass(Constructor, protoProps, staticProps) { if (protoProps) Search_defineProperties(Constructor.prototype, protoProps); if (staticProps) Search_defineProperties(Constructor, staticProps); return Constructor; }
   
   function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
   
   function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
   
   function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
   
   function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
   
   function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
   
   
   /**
    * Search API Class
    */
   
   var Search =
   /*#__PURE__*/
   function (_EventEmitter) {
     _inherits(Search, _EventEmitter);
   
     /**
      * Create a new Search instance, and override defaults
      *
      * @param options
      * @property {string} options.type - Search restriction. Use 'article', 'page', 'product', or ''
      * @property {string} options.view - Search template suffix. Specify different templates as needed
      */
     function Search() {
       var _this;
   
       var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
   
       Search_classCallCheck(this, Search);
   
       _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this));
       _this.searchType = options.type || '';
       _this.view = options.view || 'json';
       _this.inProgress = false;
       _this.xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
       _this._xhrLoad = _this._xhrLoad.bind(_assertThisInitialized(_this));
       _this._xhrError = _this._xhrError.bind(_assertThisInitialized(_this));
       _this._xhrAbort = _this._xhrAbort.bind(_assertThisInitialized(_this));
   
       _this._bindEvents();
   
       return _this;
     }
   
     Search_createClass(Search, [{
       key: "_bindEvents",
       value: function _bindEvents() {
         this.xhr.addEventListener('load', this._xhrLoad);
         this.xhr.addEventListener('error', this._xhrError);
         this.xhr.addEventListener('abort', this._xhrAbort);
       }
       /**
        * XHR was successfull
        *
        * @description XHR completed successfully
        * @param {object} event
        * @fires Search#complete
        * @private
        */
   
     }, {
       key: "_xhrLoad",
       value: function _xhrLoad(event) {
         var response = {};
         var readyState = event.target.readyState;
         var status = event.target.status;
   
         try {
           if (readyState > 3 && status == 200) {
             response = JSON.parse(event.target.responseText);
             this.emit('complete', response);
           } else {
             var message = "Invalid readyState: ".concat(readyState, ", or status: ").concat(status, ".");
             return this._xhrError(event, message);
           }
         } catch (error) {
           return this._xhrError(event, 'Invalid JSON', error);
         }
   
         this.inProgress = false;
       }
       /**
        * XHR contains an error
        *
        * @description XHR has contained an error, and was unable to complete
        * @param {object} event
        * @param {object|string} message
        * @param {object} error
        * @fires Search#error
        * @private
        */
   
     }, {
       key: "_xhrError",
       value: function _xhrError(event) {
         var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
         var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
         this.inProgress = false;
         this.emit('error', {
           event: event,
           message: message,
           error: error
         });
       }
       /**
        * XHR has been aborted
        *
        * @description This event only fires if there is an active XHR request that has been terminated
        * @fires Search#aborted
        * @private
        */
   
     }, {
       key: "_xhrAbort",
       value: function _xhrAbort() {
         this.emit('aborted');
       }
       /**
        * Perform the search
        *
        * @param {string} term - Search term(s)
        * @fires Search#initialized
        * @fires Search#cancelled
        */
   
     }, {
       key: "execute",
       value: function execute(term) {
         this.emit('initialized', {
           term: term
         });
   
         if (this.inProgress) {
           this.emit('cancelled');
           this.xhr.abort();
         }
   
         this.inProgress = true;
         var url = '/search';
         var params = {
           q: term,
           type: this.searchType,
           view: this.view
         };
         var searchParams = Object.keys(params).map(function (key) {
           var value = params[key];
           return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
         }).join('&');
         this.xhr.open('get', "".concat(url, "?").concat(searchParams));
         this.xhr.setRequestHeader('Accept', 'application/json');
         this.xhr.send();
       }
     }]);
   
     return Search;
   }(eventemitter2_default.a);
   /**
    * @description XHR initialized
    * @event Search#initialized
    * @type {object}
    */
   
   /**
    * @description XHR completed
    * @event Search#complete
    * @property {object} response - JSON response from end point
    */
   
   /**
    * @description XHR had an error
    * @event Search#error
    */
   
   /**
    * @description XHR cancelled due to user interaction. If an XHR is being processed, this does not terminate it
    * @event Search#cancelled
    */
   
   /**
    * @description XHR aborted due to user interaction, terminating previously executed XHR.
    * @event Search#aborted
    */
   
   
   
   // CONCATENATED MODULE: ./source/scripts/components/search/SearchForm.js
   function SearchForm_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function SearchForm_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function SearchForm_createClass(Constructor, protoProps, staticProps) { if (protoProps) SearchForm_defineProperties(Constructor.prototype, protoProps); if (staticProps) SearchForm_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var SearchForm_SearchForm =
   /*#__PURE__*/
   function () {
     function SearchForm($container) {
       var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
       SearchForm_classCallCheck(this, SearchForm);
   
       this.$body = jquery_default()('body');
       this.$container = $container;
       this.$form = this.$container.find('[data-live-search-form]');
       this.isLiveSearch = options.liveSearch ? options.liveSearch : false;
       this.submitHandler = this.submitHandler.bind(this);
       this.events = [this.$form.on('submit.search-form', this.submitHandler)];
     }
   
     SearchForm_createClass(SearchForm, [{
       key: "unload",
       value: function unload() {
         this.events.forEach(function ($el) {
           return $el.off('.search-form');
         });
       }
     }, {
       key: "submitHandler",
       value: function submitHandler(event) {
         event.preventDefault();
         var $form = jquery_default()(event.currentTarget).clone();
         var $terms = $form.find('[name=q]');
         $form.css({
           position: 'absolute',
           left: -1000,
           bottom: -1000,
           visibility: 'hidden'
         });
         var terms = $terms.val();
   
         if (this.isLiveSearch && !terms) {
           return;
         } // Adds `*` after each word in search terms, doesn't add to last word
   
   
         if (terms.indexOf(' ') > 0) {
           terms = terms.split(' ').join('* ').trim();
         } // Adds `*` at the end of the search terms
   
   
         terms = "".concat(terms, "*"); // Update value
   
         $terms.val(terms); // Forms must be in the browser context in order to submit
   
         this.$body.append($form);
         $form.submit();
       }
     }]);
   
     return SearchForm;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/search/LiveSearchTemplates.js
   /**
    * Shows a list item component when result is an article, or a page
    *
    * @param contentItem
    * @returns {string}
    * @constructor
    */
   function ContentItem(contentItem) {
     return "\n  <li class=\"search-flydown--content-item\">\n    <a href=\"".concat(contentItem.url, "\">").concat(contentItem.title, "</a>\n  </li>\n  ");
   }
   /**
    * Shows a header for the article and page results
    *
    * @param context
    * @returns {string}
    * @constructor
    */
   
   
   function ContentResultsHeader(context) {
     return "\n    <h5 class=\"search-flydown--content-title\">\n      ".concat(context.content_results.title, "\n    </h5>  \n  ");
   }
   /**
    * Shows a list of results from articles, or pages
    *
    * @param props
    * @returns {jQuery|HTMLElement}
    * @constructor
    */
   
   
   function ContentResults(props) {
     var content = props.content,
         context = props.context;
     var $title = ContentResultsHeader(context);
     var contentItems = content.map(function (contentItem) {
       return ContentItem(contentItem);
     });
     return $("\n    <div class=\"search-flydown--content-items\">\n      ".concat($title, "\n      \n      <ul class=\"search-flydown--content-items-list\">\n        ").concat(contentItems.join(''), "\n      </ul>\n    </div>\n  "));
   }
   /**
    * Shows a message when there are no article or page results
    *
    * @param props
    * @returns {jQuery|HTMLElement}
    * @constructor
    */
   
   
   function ContentNoResults(props) {
     var context = props.context;
     var $title = ContentResultsHeader(context);
     return $("\n    <div class=\"search-flydown--content-items\">\n      ".concat($title, "\n      \n      <p class=\"search-flydown--content-items-none\">\n        ").concat(context.content_results.no_results, "\n      </p>\n    </div>\n  "));
   }
   /**
    * Shows the product's compare_at_price, with connection for CurrencyConverter
    *
    * @param price
    * @returns {string}
    * @constructor
    */
   
   
   function ProductPriceCompareAt(price) {
     return "\n  <span class=\"search-flydown--product-price--compare-at\">\n    <span class=\"money\">".concat(price.compare_at_price, "</span>\n  </span>\n  ");
   }
   /**
    * Shows the product's price, with connection for CurrencyConverter
    *
    * @param price
    * @returns {string}
    * @constructor
    */
   
   
   function ProductPriceMain(price) {
     return "\n  <span class=\"search-flydown--product-price--main\">\n    <span class=\"money\">".concat(price.price, "</span>\n  </span>\n  ");
   }
   /**
    * Shows the product's prices
    *
    * @param props
    * @returns {string}
    * @constructor
    */
   
   
   function ProductPrice(props) {
     var price = props.price,
         onSale = props.onSale,
         consistentSaved = props.consistentSaved;
     var $compareAt = onSale && consistentSaved ? ProductPriceCompareAt(price) : '';
     var $price = ProductPriceMain(price);
     return "\n    <span class=\"search-flydown--product-price ".concat(onSale ? 'search-flydown--product-price-has-sale' : '', "\">\n      ").concat($price, "\n      ").concat($compareAt, "\n    </span>\n  ");
   }
   /**
    * Shows a product's main content
    *
    * @param product
    * @returns {string}
    * @constructor
    */
   
   
   function ProductContent(product) {
     var $price = ProductPrice({
       price: product.price,
       onSale: product.on_sale,
       consistentSaved: product.consistent_saved
     });
     return "\n    <div class=\"search-flydown--product-text\">\n      <span class=\"search-flydown--product-title\">\n        ".concat(product.title, "\n      </span>\n      ").concat($price, "\n    </div>\n  ");
   }
   /**
    * Shows a product's image
    *
    * @param image
    * @returns {string}
    * @constructor
    */
   
   
   function ProductImage(image) {
     return "\n    <div class=\"search-flydown--product-image\">\n      ".concat(image, "\n    </div>\n  ");
   }
   /**
    * Shows a product list item component when result is a product
    *
    * @param product
    * @param enableImages
    * @returns {string}
    * @constructor
    */
   
   
   function ProductItem(product, enableImages) {
     var $image = enableImages ? ProductImage(product.image) : '';
     var $content = ProductContent(product);
     return "\n    <a class=\"search-flydown--product search-flydown--product\" href=\"".concat(product.url, "\">\n      ").concat($image, "\n      ").concat($content, "\n    </a>\n  ");
   }
   /**
    * Shows a list of product results
    *
    * @param props
    * @returns {jQuery|HTMLElement}
    * @constructor
    */
   
   
   function ProductResults(props) {
     var products = props.products,
         enableImages = props.enableImages;
     var productItems = products.map(function (product) {
       return ProductItem(product, enableImages);
     });
     return $("\n    <div class=\"search-flydown--product-items\">\n      ".concat(productItems.join(''), "\n    </div>\n  "));
   }
   /**
    * Show a message when no product results are found
    *
    * @param props
    * @returns {jQuery|HTMLElement}
    * @constructor
    */
   
   
   function ProductNoResults(props) {
     var context = props.context,
         terms = props.terms;
     return $("\n    <div class=\"search-flydown--product-items--none\" data-live-search-no-products>\n      <h5>\n        ".concat(context.no_results_products.title.replace('*terms*', terms), "\n      </h5>\n      <p>\n        ").concat(context.no_results_products.message, "\n      </p>\n      <p>\n        <a class=\"search-flydown--continue\" href=\"/collections/all\">\n          ").concat(context.view_all_products, "\n        </a>\n      </p>\n    </div>\n  "));
   }
   /**
    * Show's the Results footer, directing customers to all products
    *
    * @param props
    * @returns {jQuery|HTMLElement}
    * @constructor
    */
   
   
   function ResultsFooter(props) {
     var context = props.context,
         terms = props.terms,
         type = props.type;
     return $("\n    <div class=\"search-flydown--footer\">\n      <a class=\"search-flydown--continue\" href=\"/search?q=".concat(terms, "&type=").concat(type, "\">\n        ").concat(context.view_all_results, "\n      </a>\n    </div>\n  "));
   }
   
   
   // CONCATENATED MODULE: ./source/scripts/components/search/LiveSearch.js
   function LiveSearch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function LiveSearch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function LiveSearch_createClass(Constructor, protoProps, staticProps) { if (protoProps) LiveSearch_defineProperties(Constructor.prototype, protoProps); if (staticProps) LiveSearch_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   var MAX_RESULTS = 7;
   
   var LiveSearch_LiveSearch =
   /*#__PURE__*/
   function () {
     function LiveSearch($els, settings) {
       var _this = this;
   
       LiveSearch_classCallCheck(this, LiveSearch);
   
       this.$el = $els.$el;
       this.$body = jquery_default()('body');
       this.$header = $els.$header;
       this.$document = jquery_default()(document);
       this.settings = settings;
       this.formOptions = {
         liveSearch: true
       };
       this.enableContent = this.settings.enable_content;
       this.enableImages = this.settings.enable_images;
       this.flyDownActive = false;
       this.takeOverActive = false;
       this.showFlyDown = false;
       this.searchType = this.enableContent ? 'article,page,product' : 'product';
       this.$form = this.$el.find('[data-live-search-form]');
       this.$input = this.$form.find('[data-live-search-input]');
       this.$button = this.$form.find('[data-live-search-submit]');
       this.$takeOverButton = this.$form.find('[data-live-search-takeover-cancel]');
       this.$flyDown = this.$el.find('[data-live-search-flydown]');
       this.$searchResults = this.$flyDown.find('[data-live-search-results]');
       this.$searchPlaceholder = this.$flyDown.find('[data-live-search-placeholder]');
       this.$quickLinks = this.$flyDown.find('[data-live-search-quick-links]');
       this.staticSearch = new SearchForm_SearchForm(this.$el, this.formOptions);
       this.search = new Search({
         view: 'header',
         type: this.searchType
       });
       this._search = this._search.bind(this);
       this._toggleTakeOver = this._toggleTakeOver.bind(this);
       this._searchFocused = this._searchFocused.bind(this);
       this._documentFocus = this._documentFocus.bind(this);
       this._searchCancelled = this._searchCancelled.bind(this);
       this._searchComplete = this._searchComplete.bind(this);
       this._searchError = this._searchError.bind(this);
       this.search.on('cancelled', this._searchCancelled);
       this.search.on('complete', this._searchComplete);
       this.search.on('error', this._searchError);
   
       this._closeEsc = function (e) {
         if (e.key === 'Escape') {
           e.stopPropagation();
   
           _this.$input.focus();
   
           _this._closeFlyDown(true);
         }
       };
   
       
       this.events = [this.$button.on('click.live-search', function (event) {
           event.preventDefault();
           _this.$form.submit();
       }), this.$input.on('keyup.live-search', just_debounce_default()(this._search, 250)), this.$input.on('focus.live-search', this._searchFocused), this.$takeOverButton.on('click.live-search', this._toggleTakeOver)];
       
     }
   
     LiveSearch_createClass(LiveSearch, [{
       key: "unload",
       value: function unload() {
         this.events.forEach(function ($el) {
           return $el.off('.live-search');
         });
         this.search.off('cancelled', this._searchCancelled);
         this.search.off('complete', this._searchComplete);
         this.search.off('error', this._searchError);
         this.staticSearch.unload();
       }
       /**
        * If is searching, only show placeholder
        *
        * @private
        */
   
     }, {
       key: "_flyDownSearching",
       value: function _flyDownSearching() {
         this.$searchResults.removeClass('visible');
         this.$quickLinks.removeClass('visible');
         this.$searchPlaceholder.addClass('visible');
       }
       /**
        * Search field has been focused, or has been cleared of contents
        *   - If previous search contents, show
        *   - If no previous search contents, show quicklinks if exists
        *
        * @param hasTerms
        * @private
        */
   
     }, {
       key: "_flyDownInitial",
       value: function _flyDownInitial(hasTerms) {
         this.showFlyDown = false;
         var hasNoResults = this.$searchResults.find('[data-live-search-no-products]').length === 0;
         var hasPreviousResults = this.$searchResults.children().length > 0;
   
         if (hasTerms && hasNoResults && hasPreviousResults) {
           this.$searchResults.addClass('visible');
           this.$quickLinks.removeClass('visible');
           this.showFlyDown = true;
         } else if (this.$quickLinks.length) {
           this.$searchResults.removeClass('visible');
           this.$quickLinks.addClass('visible');
           this.showFlyDown = true;
         }
       }
     }, {
       key: "_search",
       value: function _search(event) {
         // Ignore non character key strokes
         var invalidKeyStrokes = ['Alt', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Capslock', 'Control', 'Escape', 'Meta', 'Shift', 'Tab', 'Enter'];
   
         if(event.key == 'Enter'){
           $(event.target).closest("[data-live-search-form]").submit();
         }
   
         if (event.key && invalidKeyStrokes.indexOf(event.key) !== -1) { 
           return;
         }
   
         var terms = this.$input.val();
         var hasTerms = terms.length > 0; // If is XS, pop the search out into a Takeover screen
   
         if (Layout.isBreakpoint('XS')) {
           this._toggleTakeOver(null, true);
         }
   
         if (!hasTerms) {
           this._flyDownInitial(true);
   
           if (!this.showFlyDown) {
             this._closeFlyDown(true);
           }
   
           return;
         }
   
         this._flyDownSearching(); // Clear previous results
   
   
         this.$searchResults.html(''); // If terms has length, this will be true
   
         this._toggleButton(hasTerms); // Show the flyout if it isn't open
   
   
         if (!this.$flyDown.data('is-open')) {
           this.showFlyDown = true;
   
           this._openFlyDown();
         } // Adds `*` after each word in search terms, doesn't add to last word
   
   
         if (terms.indexOf(' ') > 0) {
           terms = terms.split(' ').join('* ').trim();
         } // Adds `*` at the end of the search terms
   
   
         terms = "".concat(terms, "*");
         this.search.execute(terms);
       }
     }, {
       key: "_searchError",
       value: function _searchError(response) {
         console.warn('Search had error');
         console.log(response.message, response.error, response.event);
   
         this._toggleButton(false);
       }
       /**
        * Search has been cancelled due to new search being performed
        *
        * @private
        */
   
     }, {
       key: "_searchCancelled",
       value: function _searchCancelled() {// Searches are canceled on user interaction, UI should remain unchanged
       }
     }, {
       key: "_searchComplete",
       value: function _searchComplete(response) {
         var _this2 = this;
   
         var content = response.content,
             products = response.products,
             terms = response.terms,
             sanitizedTerms = response.sanitizedTerms;
         content = content.slice(0, MAX_RESULTS), products = products.slice(0, MAX_RESULTS);
         var settings = {
           products: {
             results: {
               products: products,
               enableImages: this.enableImages
             },
             noResults: {
               context: this.settings.context,
               terms: sanitizedTerms
             }
           },
           content: {
             results: {
               context: this.settings.context,
               content: content
             },
             noResults: {
               context: this.settings.context
             }
           },
           footer: {
             context: this.settings.context,
             terms: terms,
             type: this.searchType
           }
         };
         var $productResults = products.length ? ProductResults(settings.products.results) : ProductNoResults(settings.products.noResults);
         var $contentResults = content.length ? ContentResults(settings.content.results) : ContentNoResults(settings.content.noResults);
         $productResults.find('.money').each(function (i, el) {
           el.innerHTML = Shopify.formatMoney(el.innerHTML, _this2.settings.money_format);
           shopify_currency_converter_dist_default.a.update(el);
         }); // Hide placeholder
         // TODO: Lock minimum height?
   
         this.$searchPlaceholder.removeClass('visible'); // Show results
   
         this.$searchResults.html($productResults).addClass('visible');
   
         if (this.enableContent) {
           this.$searchResults.append($contentResults);
         }
   
         this.$searchResults.append(ResultsFooter(settings.footer));
   
         this._toggleButton(false);
       }
       /**
        * Toggles search button while processing
        *
        * @param disable
        * @private
        */
   
     }, {
       key: "_toggleButton",
       value: function _toggleButton(disable) {
         if (disable) {
           this.$button.addClass('search-icon--processing').attr('disabled');
         } else {
           this.$button.removeClass('search-icon--processing').removeAttr('disabled');
         }
       }
     }, {
       key: "_searchFocused",
       value: function _searchFocused(e) {
         e.stopPropagation();
   
         if (this.flyDownActive) {
           return;
         }
   
         var hasTerms = this.$input.val().length > 0; // Only listen for events outside of the search flydown when its open
   
         this.closeEvents = [this.$document.on('focusin.live-search', this._documentFocus), this.$document.on('touchstart.live-search', this._documentFocus), this.$document.on('click.live-search', this._documentFocus)];
         this.$el.addClass('live-search--focused'); // If is XS, pop the search out into a Takeover screen
   
         if (Layout.isBreakpoint('XS')) {
           this._toggleTakeOver(null, true);
         }
   
         this._flyDownInitial(hasTerms);
   
         this._openFlyDown();
       }
     }, {
       key: "_openFlyDown",
       value: function _openFlyDown() {
         if (!this.showFlyDown) {
           return;
         }
   
         window.addEventListener('keydown', this._closeEsc);
         this.$el.addClass('live-search--active');
         this.$flyDown.data('is-open', true);
         this.flyDownActive = true;
       }
       /**
        * Close the FlyDown when no longer needed
        *  - Keep focus styling if input is still being interacted with
        *
        * @param retainFocus
        * @private
        */
   
     }, {
       key: "_closeFlyDown",
       value: function _closeFlyDown() {
         var retainFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
   
         if (!this.flyDownActive) {
           if (!retainFocus) {
             this.$el.removeClass('live-search--focused');
           }
   
           return;
         }
   
         if (this.takeOverActive) {
           this._toggleTakeOver(null, false);
         }
   
         this.$flyDown.data('is-open', false);
         this.$el.removeClass('live-search--active');
   
         if (!retainFocus) {
           this.$el.removeClass('live-search--focused');
         }
   
         this.flyDownActive = false;
   
         if (this.closeEvents && this.closeEvents.length) {
           this.closeEvents.forEach(function ($el) {
             $el.off('.live-search');
           });
         }
   
         window.removeEventListener('keydown', this._closeEsc);
         this.closeEvents = [];
       }
       /**
        * Open or close the Take over for mobile
        *
        *
        * @param event
        * @param enable
        * @private
        */
   
     }, {
       key: "_toggleTakeOver",
       value: function _toggleTakeOver() {
         var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
         var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
         this.takeOverActive = enable;
   
         if (event) {
           event.preventDefault();
         }
   
         if (!enable) {
           this._closeFlyDown(false);
         }
   
         if (this.$header.hasClass('search--section')) {
           this.$body.toggleClass('search-takeover-active', enable);
         }
   
         this.$el.toggleClass('live-search--takeover', enable);
         this.$body.toggleClass('scroll-lock', enable);
       }
       /**
        * When the focus element has changed, either by clicking, touching, or tabbing
        * check to see if it is within the flydown
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_documentFocus",
       value: function _documentFocus(event) {
         var $parent = jquery_default()(event.target).parents('[data-live-search]');
   
         if ($parent.length) {
           return;
         }
   
         this._closeFlyDown();
       }
     }]);
   
     return LiveSearch;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticSectionHeader.js
   function StaticSectionHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticSectionHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticSectionHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticSectionHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticSectionHeader_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   
   
   
   
   
   var StaticSectionHeader_StaticSectionHeader =
   /*#__PURE__*/
   function () {
     function StaticSectionHeader(section) {
       var _this = this;
   
       StaticSectionHeader_classCallCheck(this, StaticSectionHeader);
   
       this.$el = jquery_default()(section.el);
       this.settings = section.data.settings;
       this.currency = section.data.currency;
       this.postMessage = section.postMessage;
       this.headerSearch = null;
       this.$scripts = jquery_default()('[data-scripts]');
       this.$menuToggle = this.$el.find('[data-menu-toggle]');
       this.$cartCount = this.$el.find('[data-header-cart-count]');
       this.$searchField = this.$el.find('[data-live-search]');
       this.$siteNavigation = this.$el.find('[data-site-navigation]');
       this.$desktopNavigation = this.$siteNavigation.find('ul.navmenu-depth-1');
       this.$headerTools = this.$siteNavigation.find('[data-header-actions]');
       this.converter = '[data-currency-converter]';
       this.$converter = jquery_default()(this.converter);
       this.stickyHeader = new StickyHeader_StickyHeader({
         header: this.$el[0],
         menuToggle: this.$menuToggle[0],
         postMessage: this.postMessage
       }, this.settings);
       this.megaNavs = {};
       var meganavMenus = document.querySelectorAll('[data-meganav-menu]');
   
       for (var i = 0; i < meganavMenus.length; i++) {
         var el = meganavMenus[i];
         var id = el.getAttribute('data-meganav-id');
         this.megaNavs[id] = new MegaNavScroller_MegaNavScroller(jquery_default()(el));
       }
   
       this.navMobile = new NavMobile_NavMobile({
         $el: this.$el,
         $toggleOpen: this.$menuToggle
       });
       this.navDesktop = new NavDesktopMenu_NavDesktopMenu(document.querySelector('.site-navigation > [data-navmenu]'));
       this.forms = new Forms_Forms(this.$el);
   
       if (this.settings.live_search.enable) {
         script_default()(this.$scripts.data('shopify-api-url'), function () {
           _this.headerSearch = new LiveSearch_LiveSearch({
             $el: _this.$searchField,
             $header: _this.$el
           }, _this.settings.live_search);
         });
       } else {
         this.headerSearch = new SearchForm_SearchForm(this.$searchField);
       }
   
       if (this.currency.enable) {
         script_default()(this.$scripts.data('shopify-currencies'), function () {
           _this._converter();
         });
       }
   
       this.$el.on('cartcount:update', function (event, data) {
         _this.$cartCount.attr('data-header-cart-count', data.response.item_count).toggleClass('visible', data.response.item_count > 0);
       });
     }
   
     StaticSectionHeader_createClass(StaticSectionHeader, [{
       key: "onSectionSelect",
       value: function onSectionSelect() {
         this.stickyHeader.openNavigation();
       }
     }, {
       key: "onSectionDeselect",
       value: function onSectionDeselect() {
         this._closeAllMeganavs();
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.stickyHeader.unload();
         this.navMobile.unload();
         this.navDesktop.unload();
         this.forms.unload();
         this.$el.off('cartcount:update');
         this.headerSearch.unload();
   
         if (this.currency.enable) {
           this.$converter.off('change.converter');
         }
       }
     }, {
       key: "onSectionMessage",
       value: function onSectionMessage(name, data) {
         if (name === 'nav:close-all' && Layout.isBreakpoint('L')) {
           this._closeAllMeganavs();
         }
       }
     }, {
       key: "onSectionBlockSelect",
       value: function onSectionBlockSelect(block) {
         if (!Layout.isBreakpoint('L')) {
           return;
         }
   
         if (this.megaNavs[block.id]) {
           this.megaNavs[block.id].$el.addClass('meganav-editing-block');
           this.stickyHeader.openNavigation();
         }
       }
     }, {
       key: "onSectionBlockDeselect",
       value: function onSectionBlockDeselect(block) {
         if (this.megaNavs[block.id]) {
           this.megaNavs[block.id].$el.removeClass('meganav-editing-block');
         }
       }
     }, {
       key: "_converter",
       value: function _converter() {
         var _this2 = this;
   
         shopify_currency_converter_dist_default.a.init({
           switcherSelector: this.converter,
           priceSelector: '.money',
           shopCurrency: this.currency.shop_currency,
           defaultCurrency: this.currency.default_currency,
           displayFormat: this.currency.display_format,
           moneyFormat: this.currency.money_format,
           moneyFormatNoCurrency: this.currency.money_format_no_currency,
           moneyFormatCurrency: this.currency.money_format_currency
         });
         this.$converter.on('change.converter', function (event) {
           _this2.$converter.each(function (index, converter) {
             if (converter.value !== event.currentTarget.value) {
               converter.value = event.currentTarget.value;
             }
           });
   
           shopify_currency_converter_dist_default.a.setCurrency(event.currentTarget.value);
         });
       }
     }, {
       key: "_closeAllMeganavs",
       value: function _closeAllMeganavs() {
         var keys = Object.keys(this.megaNavs);
   
         for (var i = 0; keys.length < i; i++) {
           this.megaNavs[keys[i]].$el.removeClass('meganav-editing-block');
         }
       }
     }]);
   
     return StaticSectionHeader;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticSectionFooter.js
   function StaticSectionFooter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticSectionFooter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticSectionFooter_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticSectionFooter_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticSectionFooter_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var StaticSectionFooter_StaticSectionFooter =
   /*#__PURE__*/
   function () {
     function StaticSectionFooter(section) {
       StaticSectionFooter_classCallCheck(this, StaticSectionFooter);
   
       this.$el = jquery_default()(section.el);
       this.Accordion = new Accordion_Accordion(this.$el);
       this.forms = new Forms_Forms(this.$el); // Handle Accordion interaction when window size changes
   
       this.layoutHandler = this.onBreakpointChange.bind(this);
       Layout.onBreakpointChange(this.layoutHandler);
   
       this._bindEvents();
     }
   
     StaticSectionFooter_createClass(StaticSectionFooter, [{
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this = this;
   
         this.$el.on('click.footer', '[data-accordion-trigger]', function (event) {
           event.preventDefault();
   
           _this._toggleAccordion(jquery_default()(event.currentTarget).parent());
         });
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.$el.off('.footer');
         this.forms.unload();
         delete this.Accordion;
       }
     }, {
       key: "onSectionBlockSelect",
       value: function onSectionBlockSelect(block) {
         var $block = jquery_default()(block.el);
         if ($block.hasClass('has-accordion')) this._toggleAccordion($block, true);
       }
     }, {
       key: "onSectionBlockDeselect",
       value: function onSectionBlockDeselect(block) {
         var $block = jquery_default()(block.el);
         if ($block.hasClass('has-accordion')) this._toggleAccordion($block, false);
       }
     }, {
       key: "_toggleAccordion",
       value: function _toggleAccordion($block) {
         if (Layout.isBreakpoint('L')) return;
         this.Accordion.toggle($block);
       }
     }, {
       key: "onBreakpointChange",
       value: function onBreakpointChange(event, breakpoints) {
         if (Layout.isBreakpoint('L')) {
           this.Accordion.openAll();
         } else if (breakpoints.previous === 'L' && !Layout.isBreakpoint('L')) {
           this.Accordion.closeOpen();
         }
       }
     }]);
   
     return StaticSectionFooter;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticArticle.js
   function StaticArticle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticArticle_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticArticle_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticArticle_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticArticle_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var StaticArticle_StaticArticle =
   /*#__PURE__*/
   function () {
     function StaticArticle(section) {
       StaticArticle_classCallCheck(this, StaticArticle);
   
       this.$el = jquery_default()(section.el);
       this.$commentForm = this.$el.find('[data-articlecomments-form]');
       this.richText = new RichText_RichText(this.$el);
   
       if (this.$commentForm.length) {
         this.commentForm = new Forms_Forms(this.$commentForm);
       }
     }
   
     StaticArticle_createClass(StaticArticle, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.richText.unload();
   
         if (this.commentForm) {
           this.commentForm.unload();
         }
       }
     }]);
   
     return StaticArticle;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticBlog.js
   function StaticBlog_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticBlog_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticBlog_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticBlog_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticBlog_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var StaticBlog_StaticBlog =
   /*#__PURE__*/
   function () {
     function StaticBlog(section) {
       StaticBlog_classCallCheck(this, StaticBlog);
   
       this.$el = jquery_default()(section.el);
       this.richText = new RichText_RichText(this.$el);
     }
   
     StaticBlog_createClass(StaticBlog, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.richText.unload();
       }
     }]);
   
     return StaticBlog;
   }();
   
   
   // CONCATENATED MODULE: ./node_modules/morphdom/dist/morphdom-esm.js
   function morphAttrs(fromNode, toNode) {
       var attrs = toNode.attributes;
       var i;
       var attr;
       var attrName;
       var attrNamespaceURI;
       var attrValue;
       var fromValue;
   
       // update attributes on original DOM element
       for (i = attrs.length - 1; i >= 0; --i) {
           attr = attrs[i];
           attrName = attr.name;
           attrNamespaceURI = attr.namespaceURI;
           attrValue = attr.value;
   
           if (attrNamespaceURI) {
               attrName = attr.localName || attrName;
               fromValue = fromNode.getAttributeNS(attrNamespaceURI, attrName);
   
               if (fromValue !== attrValue) {
                   fromNode.setAttributeNS(attrNamespaceURI, attrName, attrValue);
               }
           } else {
               fromValue = fromNode.getAttribute(attrName);
   
               if (fromValue !== attrValue) {
                   fromNode.setAttribute(attrName, attrValue);
               }
           }
       }
   
       // Remove any extra attributes found on the original DOM element that
       // weren't found on the target element.
       attrs = fromNode.attributes;
   
       for (i = attrs.length - 1; i >= 0; --i) {
           attr = attrs[i];
           if (attr.specified !== false) {
               attrName = attr.name;
               attrNamespaceURI = attr.namespaceURI;
   
               if (attrNamespaceURI) {
                   attrName = attr.localName || attrName;
   
                   if (!toNode.hasAttributeNS(attrNamespaceURI, attrName)) {
                       fromNode.removeAttributeNS(attrNamespaceURI, attrName);
                   }
               } else {
                   if (!toNode.hasAttribute(attrName)) {
                       fromNode.removeAttribute(attrName);
                   }
               }
           }
       }
   }
   
   var range; // Create a range object for efficently rendering strings to elements.
   var NS_XHTML = 'http://www.w3.org/1999/xhtml';
   
   var doc = typeof document === 'undefined' ? undefined : document;
   
   /**
    * This is about the same
    * var html = new DOMParser().parseFromString(str, 'text/html');
    * return html.body.firstChild;
    *
    * @method toElement
    * @param {String} str
    */
   function toElement(str) {
       if (!range && doc.createRange) {
           range = doc.createRange();
           range.selectNode(doc.body);
       }
   
       var fragment;
       if (range && range.createContextualFragment) {
           fragment = range.createContextualFragment(str);
       } else {
           fragment = doc.createElement('body');
           fragment.innerHTML = str;
       }
       return fragment.childNodes[0];
   }
   
   /**
    * Returns true if two node's names are the same.
    *
    * NOTE: We don't bother checking `namespaceURI` because you will never find two HTML elements with the same
    *       nodeName and different namespace URIs.
    *
    * @param {Element} a
    * @param {Element} b The target element
    * @return {boolean}
    */
   function compareNodeNames(fromEl, toEl) {
       var fromNodeName = fromEl.nodeName;
       var toNodeName = toEl.nodeName;
   
       if (fromNodeName === toNodeName) {
           return true;
       }
   
       if (toEl.actualize &&
           fromNodeName.charCodeAt(0) < 91 && /* from tag name is upper case */
           toNodeName.charCodeAt(0) > 90 /* target tag name is lower case */) {
           // If the target element is a virtual DOM node then we may need to normalize the tag name
           // before comparing. Normal HTML elements that are in the "http://www.w3.org/1999/xhtml"
           // are converted to upper case
           return fromNodeName === toNodeName.toUpperCase();
       } else {
           return false;
       }
   }
   
   /**
    * Create an element, optionally with a known namespace URI.
    *
    * @param {string} name the element name, e.g. 'div' or 'svg'
    * @param {string} [namespaceURI] the element's namespace URI, i.e. the value of
    * its `xmlns` attribute or its inferred namespace.
    *
    * @return {Element}
    */
   function createElementNS(name, namespaceURI) {
       return !namespaceURI || namespaceURI === NS_XHTML ?
           doc.createElement(name) :
           doc.createElementNS(namespaceURI, name);
   }
   
   /**
    * Copies the children of one DOM element to another DOM element
    */
   function moveChildren(fromEl, toEl) {
       var curChild = fromEl.firstChild;
       while (curChild) {
           var nextChild = curChild.nextSibling;
           toEl.appendChild(curChild);
           curChild = nextChild;
       }
       return toEl;
   }
   
   function syncBooleanAttrProp(fromEl, toEl, name) {
       if (fromEl[name] !== toEl[name]) {
           fromEl[name] = toEl[name];
           if (fromEl[name]) {
               fromEl.setAttribute(name, '');
           } else {
               fromEl.removeAttribute(name);
           }
       }
   }
   
   var specialElHandlers = {
       OPTION: function(fromEl, toEl) {
           var parentNode = fromEl.parentNode;
           if (parentNode) {
               var parentName = parentNode.nodeName.toUpperCase();
               if (parentName === 'OPTGROUP') {
                   parentNode = parentNode.parentNode;
                   parentName = parentNode && parentNode.nodeName.toUpperCase();
               }
               if (parentName === 'SELECT' && !parentNode.hasAttribute('multiple')) {
                   if (fromEl.hasAttribute('selected') && !toEl.selected) {
                       // Workaround for MS Edge bug where the 'selected' attribute can only be
                       // removed if set to a non-empty value:
                       // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12087679/
                       fromEl.setAttribute('selected', 'selected');
                       fromEl.removeAttribute('selected');
                   }
                   // We have to reset select element's selectedIndex to -1, otherwise setting
                   // fromEl.selected using the syncBooleanAttrProp below has no effect.
                   // The correct selectedIndex will be set in the SELECT special handler below.
                   parentNode.selectedIndex = -1;
               }
           }
           syncBooleanAttrProp(fromEl, toEl, 'selected');
       },
       /**
        * The "value" attribute is special for the <input> element since it sets
        * the initial value. Changing the "value" attribute without changing the
        * "value" property will have no effect since it is only used to the set the
        * initial value.  Similar for the "checked" attribute, and "disabled".
        */
       INPUT: function(fromEl, toEl) {
           syncBooleanAttrProp(fromEl, toEl, 'checked');
           syncBooleanAttrProp(fromEl, toEl, 'disabled');
   
           if (fromEl.value !== toEl.value) {
               fromEl.value = toEl.value;
           }
   
           if (!toEl.hasAttribute('value')) {
               fromEl.removeAttribute('value');
           }
       },
   
       TEXTAREA: function(fromEl, toEl) {
           var newValue = toEl.value;
           if (fromEl.value !== newValue) {
               fromEl.value = newValue;
           }
   
           var firstChild = fromEl.firstChild;
           if (firstChild) {
               // Needed for IE. Apparently IE sets the placeholder as the
               // node value and vise versa. This ignores an empty update.
               var oldValue = firstChild.nodeValue;
   
               if (oldValue == newValue || (!newValue && oldValue == fromEl.placeholder)) {
                   return;
               }
   
               firstChild.nodeValue = newValue;
           }
       },
       SELECT: function(fromEl, toEl) {
           if (!toEl.hasAttribute('multiple')) {
               var selectedIndex = -1;
               var i = 0;
               // We have to loop through children of fromEl, not toEl since nodes can be moved
               // from toEl to fromEl directly when morphing.
               // At the time this special handler is invoked, all children have already been morphed
               // and appended to / removed from fromEl, so using fromEl here is safe and correct.
               var curChild = fromEl.firstChild;
               var optgroup;
               var nodeName;
               while(curChild) {
                   nodeName = curChild.nodeName && curChild.nodeName.toUpperCase();
                   if (nodeName === 'OPTGROUP') {
                       optgroup = curChild;
                       curChild = optgroup.firstChild;
                   } else {
                       if (nodeName === 'OPTION') {
                           if (curChild.hasAttribute('selected')) {
                               selectedIndex = i;
                               break;
                           }
                           i++;
                       }
                       curChild = curChild.nextSibling;
                       if (!curChild && optgroup) {
                           curChild = optgroup.nextSibling;
                           optgroup = null;
                       }
                   }
               }
   
               fromEl.selectedIndex = selectedIndex;
           }
       }
   };
   
   var ELEMENT_NODE = 1;
   var DOCUMENT_FRAGMENT_NODE = 11;
   var TEXT_NODE = 3;
   var COMMENT_NODE = 8;
   
   function noop() {}
   
   function defaultGetNodeKey(node) {
       return node.id;
   }
   
   function morphdomFactory(morphAttrs) {
   
       return function morphdom(fromNode, toNode, options) {
           if (!options) {
               options = {};
           }
   
           if (typeof toNode === 'string') {
               if (fromNode.nodeName === '#document' || fromNode.nodeName === 'HTML') {
                   var toNodeHtml = toNode;
                   toNode = doc.createElement('html');
                   toNode.innerHTML = toNodeHtml;
               } else {
                   toNode = toElement(toNode);
               }
           }
   
           var getNodeKey = options.getNodeKey || defaultGetNodeKey;
           var onBeforeNodeAdded = options.onBeforeNodeAdded || noop;
           var onNodeAdded = options.onNodeAdded || noop;
           var onBeforeElUpdated = options.onBeforeElUpdated || noop;
           var onElUpdated = options.onElUpdated || noop;
           var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;
           var onNodeDiscarded = options.onNodeDiscarded || noop;
           var onBeforeElChildrenUpdated = options.onBeforeElChildrenUpdated || noop;
           var childrenOnly = options.childrenOnly === true;
   
           // This object is used as a lookup to quickly find all keyed elements in the original DOM tree.
           var fromNodesLookup = {};
           var keyedRemovalList;
   
           function addKeyedRemoval(key) {
               if (keyedRemovalList) {
                   keyedRemovalList.push(key);
               } else {
                   keyedRemovalList = [key];
               }
           }
   
           function walkDiscardedChildNodes(node, skipKeyedNodes) {
               if (node.nodeType === ELEMENT_NODE) {
                   var curChild = node.firstChild;
                   while (curChild) {
   
                       var key = undefined;
   
                       if (skipKeyedNodes && (key = getNodeKey(curChild))) {
                           // If we are skipping keyed nodes then we add the key
                           // to a list so that it can be handled at the very end.
                           addKeyedRemoval(key);
                       } else {
                           // Only report the node as discarded if it is not keyed. We do this because
                           // at the end we loop through all keyed elements that were unmatched
                           // and then discard them in one final pass.
                           onNodeDiscarded(curChild);
                           if (curChild.firstChild) {
                               walkDiscardedChildNodes(curChild, skipKeyedNodes);
                           }
                       }
   
                       curChild = curChild.nextSibling;
                   }
               }
           }
   
           /**
            * Removes a DOM node out of the original DOM
            *
            * @param  {Node} node The node to remove
            * @param  {Node} parentNode The nodes parent
            * @param  {Boolean} skipKeyedNodes If true then elements with keys will be skipped and not discarded.
            * @return {undefined}
            */
           function removeNode(node, parentNode, skipKeyedNodes) {
               if (onBeforeNodeDiscarded(node) === false) {
                   return;
               }
   
               if (parentNode) {
                   parentNode.removeChild(node);
               }
   
               onNodeDiscarded(node);
               walkDiscardedChildNodes(node, skipKeyedNodes);
           }
   
           // // TreeWalker implementation is no faster, but keeping this around in case this changes in the future
           // function indexTree(root) {
           //     var treeWalker = document.createTreeWalker(
           //         root,
           //         NodeFilter.SHOW_ELEMENT);
           //
           //     var el;
           //     while((el = treeWalker.nextNode())) {
           //         var key = getNodeKey(el);
           //         if (key) {
           //             fromNodesLookup[key] = el;
           //         }
           //     }
           // }
   
           // // NodeIterator implementation is no faster, but keeping this around in case this changes in the future
           //
           // function indexTree(node) {
           //     var nodeIterator = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT);
           //     var el;
           //     while((el = nodeIterator.nextNode())) {
           //         var key = getNodeKey(el);
           //         if (key) {
           //             fromNodesLookup[key] = el;
           //         }
           //     }
           // }
   
           function indexTree(node) {
               if (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE) {
                   var curChild = node.firstChild;
                   while (curChild) {
                       var key = getNodeKey(curChild);
                       if (key) {
                           fromNodesLookup[key] = curChild;
                       }
   
                       // Walk recursively
                       indexTree(curChild);
   
                       curChild = curChild.nextSibling;
                   }
               }
           }
   
           indexTree(fromNode);
   
           function handleNodeAdded(el) {
               onNodeAdded(el);
   
               var curChild = el.firstChild;
               while (curChild) {
                   var nextSibling = curChild.nextSibling;
   
                   var key = getNodeKey(curChild);
                   if (key) {
                       var unmatchedFromEl = fromNodesLookup[key];
                       if (unmatchedFromEl && compareNodeNames(curChild, unmatchedFromEl)) {
                           curChild.parentNode.replaceChild(unmatchedFromEl, curChild);
                           morphEl(unmatchedFromEl, curChild);
                       }
                   }
   
                   handleNodeAdded(curChild);
                   curChild = nextSibling;
               }
           }
   
           function cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey) {
               // We have processed all of the "to nodes". If curFromNodeChild is
               // non-null then we still have some from nodes left over that need
               // to be removed
               while (curFromNodeChild) {
                   var fromNextSibling = curFromNodeChild.nextSibling;
                   if ((curFromNodeKey = getNodeKey(curFromNodeChild))) {
                       // Since the node is keyed it might be matched up later so we defer
                       // the actual removal to later
                       addKeyedRemoval(curFromNodeKey);
                   } else {
                       // NOTE: we skip nested keyed nodes from being removed since there is
                       //       still a chance they will be matched up later
                       removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
                   }
                   curFromNodeChild = fromNextSibling;
               }
           }
   
           function morphEl(fromEl, toEl, childrenOnly) {
               var toElKey = getNodeKey(toEl);
   
               if (toElKey) {
                   // If an element with an ID is being morphed then it will be in the final
                   // DOM so clear it out of the saved elements collection
                   delete fromNodesLookup[toElKey];
               }
   
               if (toNode.isSameNode && toNode.isSameNode(fromNode)) {
                   return;
               }
   
               if (!childrenOnly) {
                   // optional
                   if (onBeforeElUpdated(fromEl, toEl) === false) {
                       return;
                   }
   
                   // update attributes on original DOM element first
                   morphAttrs(fromEl, toEl);
                   // optional
                   onElUpdated(fromEl);
   
                   if (onBeforeElChildrenUpdated(fromEl, toEl) === false) {
                       return;
                   }
               }
               if (fromEl.nodeName !== 'TEXTAREA') {
                 morphChildren(fromEl, toEl);
               } else {
                 specialElHandlers.TEXTAREA(fromEl, toEl);
               }
           }
   
           function morphChildren(fromEl, toEl) {
               var curToNodeChild = toEl.firstChild;
               var curFromNodeChild = fromEl.firstChild;
               var curToNodeKey;
               var curFromNodeKey;
   
               var fromNextSibling;
               var toNextSibling;
               var matchingFromEl;
   
               // walk the children
               outer: while (curToNodeChild) {
                   toNextSibling = curToNodeChild.nextSibling;
                   curToNodeKey = getNodeKey(curToNodeChild);
   
                   // walk the fromNode children all the way through
                   while (curFromNodeChild) {
                       fromNextSibling = curFromNodeChild.nextSibling;
   
                       if (curToNodeChild.isSameNode && curToNodeChild.isSameNode(curFromNodeChild)) {
                           curToNodeChild = toNextSibling;
                           curFromNodeChild = fromNextSibling;
                           continue outer;
                       }
   
                       curFromNodeKey = getNodeKey(curFromNodeChild);
   
                       var curFromNodeType = curFromNodeChild.nodeType;
   
                       // this means if the curFromNodeChild doesnt have a match with the curToNodeChild
                       var isCompatible = undefined;
   
                       if (curFromNodeType === curToNodeChild.nodeType) {
                           if (curFromNodeType === ELEMENT_NODE) {
                               // Both nodes being compared are Element nodes
   
                               if (curToNodeKey) {
                                   // The target node has a key so we want to match it up with the correct element
                                   // in the original DOM tree
                                   if (curToNodeKey !== curFromNodeKey) {
                                       // The current element in the original DOM tree does not have a matching key so
                                       // let's check our lookup to see if there is a matching element in the original
                                       // DOM tree
                                       if ((matchingFromEl = fromNodesLookup[curToNodeKey])) {
                                           if (fromNextSibling === matchingFromEl) {
                                               // Special case for single element removals. To avoid removing the original
                                               // DOM node out of the tree (since that can break CSS transitions, etc.),
                                               // we will instead discard the current node and wait until the next
                                               // iteration to properly match up the keyed target element with its matching
                                               // element in the original tree
                                               isCompatible = false;
                                           } else {
                                               // We found a matching keyed element somewhere in the original DOM tree.
                                               // Let's move the original DOM node into the current position and morph
                                               // it.
   
                                               // NOTE: We use insertBefore instead of replaceChild because we want to go through
                                               // the `removeNode()` function for the node that is being discarded so that
                                               // all lifecycle hooks are correctly invoked
                                               fromEl.insertBefore(matchingFromEl, curFromNodeChild);
   
                                               // fromNextSibling = curFromNodeChild.nextSibling;
   
                                               if (curFromNodeKey) {
                                                   // Since the node is keyed it might be matched up later so we defer
                                                   // the actual removal to later
                                                   addKeyedRemoval(curFromNodeKey);
                                               } else {
                                                   // NOTE: we skip nested keyed nodes from being removed since there is
                                                   //       still a chance they will be matched up later
                                                   removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
                                               }
   
                                               curFromNodeChild = matchingFromEl;
                                           }
                                       } else {
                                           // The nodes are not compatible since the "to" node has a key and there
                                           // is no matching keyed node in the source tree
                                           isCompatible = false;
                                       }
                                   }
                               } else if (curFromNodeKey) {
                                   // The original has a key
                                   isCompatible = false;
                               }
   
                               isCompatible = isCompatible !== false && compareNodeNames(curFromNodeChild, curToNodeChild);
                               if (isCompatible) {
                                   // We found compatible DOM elements so transform
                                   // the current "from" node to match the current
                                   // target DOM node.
                                   // MORPH
                                   morphEl(curFromNodeChild, curToNodeChild);
                               }
   
                           } else if (curFromNodeType === TEXT_NODE || curFromNodeType == COMMENT_NODE) {
                               // Both nodes being compared are Text or Comment nodes
                               isCompatible = true;
                               // Simply update nodeValue on the original node to
                               // change the text value
                               if (curFromNodeChild.nodeValue !== curToNodeChild.nodeValue) {
                                   curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
                               }
   
                           }
                       }
   
                       if (isCompatible) {
                           // Advance both the "to" child and the "from" child since we found a match
                           // Nothing else to do as we already recursively called morphChildren above
                           curToNodeChild = toNextSibling;
                           curFromNodeChild = fromNextSibling;
                           continue outer;
                       }
   
                       // No compatible match so remove the old node from the DOM and continue trying to find a
                       // match in the original DOM. However, we only do this if the from node is not keyed
                       // since it is possible that a keyed node might match up with a node somewhere else in the
                       // target tree and we don't want to discard it just yet since it still might find a
                       // home in the final DOM tree. After everything is done we will remove any keyed nodes
                       // that didn't find a home
                       if (curFromNodeKey) {
                           // Since the node is keyed it might be matched up later so we defer
                           // the actual removal to later
                           addKeyedRemoval(curFromNodeKey);
                       } else {
                           // NOTE: we skip nested keyed nodes from being removed since there is
                           //       still a chance they will be matched up later
                           removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
                       }
   
                       curFromNodeChild = fromNextSibling;
                   } // END: while(curFromNodeChild) {}
   
                   // If we got this far then we did not find a candidate match for
                   // our "to node" and we exhausted all of the children "from"
                   // nodes. Therefore, we will just append the current "to" node
                   // to the end
                   if (curToNodeKey && (matchingFromEl = fromNodesLookup[curToNodeKey]) && compareNodeNames(matchingFromEl, curToNodeChild)) {
                       fromEl.appendChild(matchingFromEl);
                       // MORPH
                       morphEl(matchingFromEl, curToNodeChild);
                   } else {
                       var onBeforeNodeAddedResult = onBeforeNodeAdded(curToNodeChild);
                       if (onBeforeNodeAddedResult !== false) {
                           if (onBeforeNodeAddedResult) {
                               curToNodeChild = onBeforeNodeAddedResult;
                           }
   
                           if (curToNodeChild.actualize) {
                               curToNodeChild = curToNodeChild.actualize(fromEl.ownerDocument || doc);
                           }
                           fromEl.appendChild(curToNodeChild);
                           handleNodeAdded(curToNodeChild);
                       }
                   }
   
                   curToNodeChild = toNextSibling;
                   curFromNodeChild = fromNextSibling;
               }
   
               cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey);
   
               var specialElHandler = specialElHandlers[fromEl.nodeName];
               if (specialElHandler) {
                   specialElHandler(fromEl, toEl);
               }
           } // END: morphChildren(...)
   
           var morphedNode = fromNode;
           var morphedNodeType = morphedNode.nodeType;
           var toNodeType = toNode.nodeType;
   
           if (!childrenOnly) {
               // Handle the case where we are given two DOM nodes that are not
               // compatible (e.g. <div> --> <span> or <div> --> TEXT)
               if (morphedNodeType === ELEMENT_NODE) {
                   if (toNodeType === ELEMENT_NODE) {
                       if (!compareNodeNames(fromNode, toNode)) {
                           onNodeDiscarded(fromNode);
                           morphedNode = moveChildren(fromNode, createElementNS(toNode.nodeName, toNode.namespaceURI));
                       }
                   } else {
                       // Going from an element node to a text node
                       morphedNode = toNode;
                   }
               } else if (morphedNodeType === TEXT_NODE || morphedNodeType === COMMENT_NODE) { // Text or comment node
                   if (toNodeType === morphedNodeType) {
                       if (morphedNode.nodeValue !== toNode.nodeValue) {
                           morphedNode.nodeValue = toNode.nodeValue;
                       }
   
                       return morphedNode;
                   } else {
                       // Text node to something else
                       morphedNode = toNode;
                   }
               }
           }
   
           if (morphedNode === toNode) {
               // The "to node" was not compatible with the "from node" so we had to
               // toss out the "from node" and use the "to node"
               onNodeDiscarded(fromNode);
           } else {
               morphEl(morphedNode, toNode, childrenOnly);
   
               // We now need to loop over any keyed nodes that might need to be
               // removed. We only do the removal if we know that the keyed node
               // never found a match. When a keyed node is matched up we remove
               // it out of fromNodesLookup and we use fromNodesLookup to determine
               // if a keyed node has been matched up or not
               if (keyedRemovalList) {
                   for (var i=0, len=keyedRemovalList.length; i<len; i++) {
                       var elToRemove = fromNodesLookup[keyedRemovalList[i]];
                       if (elToRemove) {
                           removeNode(elToRemove, elToRemove.parentNode, false);
                       }
                   }
               }
           }
   
           if (!childrenOnly && morphedNode !== fromNode && fromNode.parentNode) {
               if (morphedNode.actualize) {
                   morphedNode = morphedNode.actualize(fromNode.ownerDocument || doc);
               }
               // If we had to swap out the from node with a new node because the old
               // node was not compatible with the target node then we need to
               // replace the old DOM node in the original DOM tree. This is only
               // possible if the original DOM node was part of a DOM tree which
               // we know is the case if it has a parent node.
               fromNode.parentNode.replaceChild(morphedNode, fromNode);
           }
   
           return morphedNode;
       };
   }
   
   var morphdom = morphdomFactory(morphAttrs);
   
   /* harmony default export */ var morphdom_esm = (morphdom);
   
   // CONCATENATED MODULE: ./node_modules/shopify-asyncview/dist/index.es.js
   
     /*!
      * shopify-asyncview v1.0.2
      * (c) 2019 Pixel Union
     */
   
   var classCallCheck = function (instance, Constructor) {
     if (!(instance instanceof Constructor)) {
       throw new TypeError("Cannot call a class as a function");
     }
   };
   
   var createClass = function () {
     function defineProperties(target, props) {
       for (var i = 0; i < props.length; i++) {
         var descriptor = props[i];
         descriptor.enumerable = descriptor.enumerable || false;
         descriptor.configurable = true;
         if ("value" in descriptor) descriptor.writable = true;
         Object.defineProperty(target, descriptor.key, descriptor);
       }
     }
   
     return function (Constructor, protoProps, staticProps) {
       if (protoProps) defineProperties(Constructor.prototype, protoProps);
       if (staticProps) defineProperties(Constructor, staticProps);
       return Constructor;
     };
   }();
   
   var index_es_deferred = {};
   
   var AsyncView = function () {
     function AsyncView() {
       classCallCheck(this, AsyncView);
     }
   
     createClass(AsyncView, null, [{
       key: 'load',
   
       /**
        * Load the template given by the provided URL into the provided
        * view
        *
        * @param {string} url - The url to load.
        * @param {string} view - The view to load into.
        * @param {object} options - Config options.
        * @param {string} options.hash - A hash of the current page content.
        */
       value: function load(url, view) {
         var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
   
         var data = void 0;
         if (url in index_es_deferred) {
           return index_es_deferred[url];
         }
   
         var $deferred = $.Deferred();
   
         index_es_deferred[url] = $deferred;
   
         if (options.hash) {
           data = sessionStorage.getItem(url);
   
           if (data) {
             var deserialized = JSON.parse(data);
   
             if (options.hash === deserialized.options.hash) {
               delete index_es_deferred[url];
               return $deferred.resolve(deserialized).promise();
             }
           }
         }
   
         // NOTE The $.ajax request has the cache option set to false.
         // This is to prevent certain browsers from returning cached
         // versions of the url we are requesting.
         // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
         $.ajax({
           url: url,
           cache: false,
           data: 'view=' + view,
           dataType: 'html',
           headers: {
             'cache-control': 'no-cache'
           },
           success: function success(response) {
             var el = document.createElement('div');
             el.innerHTML = response;
   
             var responseOptions = {};
             var optionsEl = el.querySelector('[data-options]');
   
             if (optionsEl && optionsEl.innerHTML) {
               responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
             }
   
             var htmls = el.querySelectorAll('[data-html]');
   
             var html = {};
   
             if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
               html = htmls[0].innerHTML;
             } else {
               for (var i = 0; i < htmls.length; i++) {
                 html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
               }
             }
   
             if (options.hash) {
               try {
                 sessionStorage.setItem(url, JSON.stringify({ options: responseOptions, html: html }));
               } catch (error) {
                 console.error(error);
               }
             }
   
             delete index_es_deferred[url];
             return $deferred.resolve({ options: responseOptions, html: html });
           },
           error: function error() {
             delete index_es_deferred[url];
             return $deferred.reject();
           }
   
         });
   
         return $deferred.promise();
       }
     }]);
     return AsyncView;
   }();
   
   /* harmony default export */ var shopify_asyncview_dist_index_es = (AsyncView);
   
   // CONCATENATED MODULE: ./node_modules/@shopify/theme-addresses/theme-addresses.js
   /**
    * CountryProvinceSelector Constructor
    * @param {String} countryOptions the country options in html string
    */
   function CountryProvinceSelector(countryOptions) {
     if (typeof countryOptions !== 'string') {
       throw new TypeError(countryOptions + ' is not a string.');
     }
     this.countryOptions = countryOptions;
   }
   
   /**
    * Builds the country and province selector with the given node element
    * @param {Node} countryNodeElement The <select> element for country
    * @param {Node} provinceNodeElement The <select> element for province
    * @param {Object} options Additional settings available
    * @param {CountryProvinceSelector~onCountryChange} options.onCountryChange callback after a country `change` event
    * @param {CountryProvinceSelector~onProvinceChange} options.onProvinceChange callback after a province `change` event
    */
   CountryProvinceSelector.prototype.build = function (countryNodeElement, provinceNodeElement, options) {
     if (typeof countryNodeElement !== 'object') {
       throw new TypeError(countryNodeElement + ' is not a object.');
     }
   
     if (typeof provinceNodeElement !== 'object') {
       throw new TypeError(provinceNodeElement + ' is not a object.');
     }
   
     var defaultValue = countryNodeElement.getAttribute('data-default');
     options = options || {}
   
     countryNodeElement.innerHTML = this.countryOptions;
     countryNodeElement.value = defaultValue;
   
     if (defaultValue && getOption(countryNodeElement, defaultValue)) {
       var provinces = buildProvince(countryNodeElement, provinceNodeElement, defaultValue);
       options.onCountryChange && options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
     }
   
     // Listen for value change on the country select
     countryNodeElement.addEventListener('change', function (event) {
       var target = event.target;
       var selectedValue = target.value;
       
       var provinces = buildProvince(target, provinceNodeElement, selectedValue);
       options.onCountryChange && options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
     });
   
     options.onProvinceChange && provinceNodeElement.addEventListener('change', options.onProvinceChange);
   }
   
   /**
    * This callback is called after a user interacted with a country `<select>`
    * @callback CountryProvinceSelector~onCountryChange
    * @param {array} provinces the parsed provinces
    * @param {Node} provinceNodeElement province `<select>` element
    * @param {Node} countryNodeElement country `<select>` element
    */
   
    /**
    * This callback is called after a user interacted with a province `<select>`
    * @callback CountryProvinceSelector~onProvinceChange
    * @param {Event} event the province selector `change` event object
    */
   
   /**
    * Returns the <option> with the specified value from the
    * given node element
    * A null is returned if no such <option> is found
    */
   function getOption(nodeElement, value) {
     return nodeElement.querySelector('option[value="' + value +'"]')
   }
   
   /**
    * Builds the options for province selector
    */
   function buildOptions (provinceNodeElement, provinces) {
     var defaultValue = provinceNodeElement.getAttribute('data-default');
   
     provinces.forEach(function (option) {
       var optionElement = document.createElement('option');
       optionElement.value = option[0];
       optionElement.textContent = option[1];
   
       provinceNodeElement.appendChild(optionElement);
     })
   
     if (defaultValue && getOption(provinceNodeElement, defaultValue)) {
       provinceNodeElement.value = defaultValue;
     }
   }
   
   /**
    * Builds the province selector
    */
   function buildProvince (countryNodeElement, provinceNodeElement, selectedValue) {
     var selectedOption = getOption(countryNodeElement, selectedValue);
     var provinces = JSON.parse(selectedOption.getAttribute('data-provinces'));
   
     provinceNodeElement.options.length = 0;
   
     if (provinces.length) {
       buildOptions(provinceNodeElement, provinces)
     }
   
     return provinces;
   }
   
   // CONCATENATED MODULE: ./source/scripts/components/MessageBanner.js
   function MessageBanner_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function MessageBanner_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function MessageBanner_createClass(Constructor, protoProps, staticProps) { if (protoProps) MessageBanner_defineProperties(Constructor.prototype, protoProps); if (staticProps) MessageBanner_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var MessageBanner_MessageBanner =
   /*#__PURE__*/
   function () {
     function MessageBanner() {
       var _this = this;
   
       MessageBanner_classCallCheck(this, MessageBanner);
   
       this.$window = jquery_default()(window);
       this.$document = jquery_default()(document);
       this.$body = jquery_default()(document.body);
       this.$bannerTemplate = jquery_default()('[data-templates] [data-message-banner]');
       this.$banners = [];
       this.header = document.querySelector('[data-site-header]');
       this.events = [];
       this.$document.on('touchstart.message-banner, click.message-banner', function (event) {
         _this._handleDocumentClick(event.target);
       });
       this.$window.on('keydown.message-banner', function (event) {
         return _this._closeEsc(event);
       });
     }
   
     MessageBanner_createClass(MessageBanner, [{
       key: "unload",
       value: function unload() {
         this.$document.off('touchstart.message-banner, click.message-banner');
         this.$window.off('keydown.message-banner');
       }
     }, {
       key: "message",
       value: function message(_message, type) {
         var $banner = this.$bannerTemplate.clone();
         $banner.addClass("message--".concat(type)).find('[data-message-banner-content]').html(_message);
         jquery_default()(this.header).append($banner);
   
         this._bindEvents($banner);
   
         this._show($banner);
       }
     }, {
       key: "dismissBanners",
       value: function dismissBanners() {
         var _this2 = this;
   
         var $visibleBanners = jquery_default()('[data-message-banner]:visible');
         $visibleBanners.each(function (index, banner) {
           _this2._hide(jquery_default()(banner), index);
         });
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents($banner) {
         var _this3 = this;
   
         this.events.push([$banner.on('click.message-banner', '[data-message-banner-close]', function (event) {
           event.preventDefault();
   
           _this3._hide($banner);
         }), this.$window.on('keydown.message-banner', function (e) {
           if (e.key === 'Escape') {
             _this3._hide($banner);
           }
         })]);
       }
     }, {
       key: "_closeEsc",
       value: function _closeEsc(e) {
         if (e.key === 'Escape') {
           this.dismissBanners();
         }
       }
     }, {
       key: "_show",
       value: function _show($banner) {
         this.$banners.push($banner);
         $banner.addClass('animating animating-in').one('trend', function () {
           $banner.removeClass('animating animating-in').addClass('visible').off('trend');
         });
       }
     }, {
       key: "_hide",
       value: function _hide($banner) {
         var _this4 = this;
   
         var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
         $banner.addClass('animating animating-out').one('trend', function () {
           $banner.removeClass('animating animating-out visible').off('trend');
   
           _this4._removeBanner($banner, index);
         });
       }
     }, {
       key: "_removeBanner",
       value: function _removeBanner($banner, index) {
         if (this.events[index]) {
           this.events[index].forEach(function ($el) {
             return $el.off('.message-banner');
           });
           this.events.splice(index, 1);
         }
   
         this.$banners.splice(index, 1);
         $banner.remove();
       }
     }, {
       key: "_handleDocumentClick",
       value: function _handleDocumentClick(target) {
         var $parent = jquery_default()(target).parents('[data-message-banner]');
         if ($parent.length) return;
         this.dismissBanners();
       }
     }]);
   
     return MessageBanner;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticCart.js
   function StaticCart_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticCart_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticCart_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticCart_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticCart_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   
   
   
   
   var StaticCart_StaticCart =
   /*#__PURE__*/
   function () {
     function StaticCart(section) {
       var _this = this;
   
       StaticCart_classCallCheck(this, StaticCart);
   
       this.settings = section.data.settings;
       this.shipping = section.data.shipping;
       this.messageBanner = new MessageBanner_MessageBanner();
       this.$window = jquery_default()(window);
       this.$el = jquery_default()(section.el);
       this.el = section.el;
       this.$header = jquery_default()('[data-site-header-main]');
       this.$total = this.$el.find('[data-cart-total]');
       this.$shipping = this.$el.find('[data-cartshipping]'); // Product form containers
   
       this.$titleTotalSmall = this.$el.find('.cart-title-total--small');
       this.$titleTotalLarge = this.$el.find('.cart-title-total--large');
       this.$titleTotalContents = this.$el.find('[data-cart-title-total]'); // Cart list
   
       this.cartItemList = this.$el[0].querySelector('[data-cart-item-list]');
       this.cartDiscounts = this.$el[0].querySelector('[data-cart-discounts]'); // Shipping calculator elements
   
       this.$shippingToggle = this.$el.find('[data-cartshipping-toggle]');
       this.$shippingResponse = this.$shipping.find('[data-cartshipping-response]');
       this.$shippingResponseMessage = this.$shippingResponse.find('[data-cartshipping-message]');
       this.$shippingResponseRates = this.$shippingResponse.find('[data-cartshipping-rates]');
       this.$shippingSubmit = this.$shipping.find('[data-cartshipping-submit]');
   
       this._moveTitleTotal();
   
       var $scripts = jquery_default()('[data-scripts]');
       this._editItemQuantity = this._editItemQuantity.bind(this);
       script_default()($scripts.data('shopify-api-url'), function () {
         _this._bindEvents();
   
         Shopify.onError = _this._handleErrors.bind(_this);
       });
       this.forms = new Forms_Forms(this.$el); // Update the section when onSectionLoad fires to restore prices to local currency
   
       this.$el.find('.money').each(function (index, el) {
         return shopify_currency_converter_dist_default.a.update(el);
       });
   
       if (this.settings.shipping && this.$shipping.length) {
         script_default()($scripts.data('shopify-countries'), function () {
           script_default()($scripts.data('shopify-common'), function () {
             _this._initShippingCalc();
           });
         });
       }
     }
   
     StaticCart_createClass(StaticCart, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.$el.off('.cart-page');
         this.$window.off('.cart-page');
         this.forms.unload();
         this.messageBanner.unload();
         this.messageBanner.dismissBanners();
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this2 = this;
   
         this.$el.on('keyup.cart-page', '[data-cartitem-quantity]', just_debounce_default()(function (event) {
           return _this2._quantityKeyUp(event);
         }, 200));
         /*
          * There are two [data-cartitem-quantity] selectors.
          * Use the input as the source of truth rather than the select
          * because the input has an infinite value range whereas the select
          * has a finite range.
          */
   
         this.$el.on('change.cart-page', '[data-cartitem-quantity][data-quantity-input]', this._editItemQuantity);
         this.$el.on('click.cart-page', '[data-cartitem-remove]', function (event) {
           event.preventDefault();

            _this2._editItemQuantity(event, true);
         });
         this.$window.on('resize.cart-page', just_debounce_default()(function () {
           return _this2._moveTitleTotal();
         }, 20));
       }
     }, {
       key: "_moveTitleTotal",
       value: function _moveTitleTotal() {
         if (!this.$titleTotalContents.length) {
           return;
         }
   
         if (this.$window.outerWidth() >= 480) {
           if (!jquery_default.a.contains(this.$titleTotalLarge[0], this.$titleTotalContents[0])) {
             var $form = this.$titleTotalContents.detach();
             this.$titleTotalLarge.append($form);
           }
         } else {
           if (!jquery_default.a.contains(this.$titleTotalSmall[0], this.$titleTotalContents[0])) {
             var _$form = this.$titleTotalContents.detach();
   
             this.$titleTotalSmall.append(_$form);
           }
         }
       }
       /**
        * Prevent form submission when pressing `enter` within a quantity selector
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_quantityKeyUp",
       value: function _quantityKeyUp(event) {
         // Only block enter keys
         if (event.keyCode === 13) {
           return;
         } // Block form submission, but update field
   
   
         jquery_default()(event.currentTarget).trigger('change');
         event.preventDefault();
       }
       /**
        * Handle an item quantity change
        *
        * @param event
        * @param {Boolean} remove - Set as true to remove cart item
        * @private
        */
   
     }, {
       key: "_editItemQuantity",
       value: function _editItemQuantity(event) {
         var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
         this.messageBanner.dismissBanners();
         var $target = jquery_default()(event.currentTarget);
         var cartItemRow = $target.closest('[data-cartitem-id]')[0];
         var quantity = remove ? 0 : cartItemRow.querySelector('.form-field.visible [data-cartitem-quantity]').value;
         var key = cartItemRow.getAttribute('data-cartitem-key');

         var line_item = jQuery('.cart-item[data-cartitem-key="'+ key +'"]');
         var id = line_item.data('cartitem-id');

         var $this = this;
         
         if (quantity > 0 && !line_item.hasClass('has_dpo')) {
            var new_properties = [];
            jQuery.ajax({
                url: '/cart.js',
                type: 'get',
                dataType: 'json',
                success: function(response){ 
                    
                    var items = response.items;
    
                    jQuery.each(items, function(index,item){

                        if(item.id == id){
    
                            var properties_size = Object.keys(item.properties).length;
    
                            if(properties_size == quantity){
                                new_properties = item.properties;
                            }else{
    
                                var temp_properties = item.properties;
                                var keys = Object.keys(temp_properties);
    
                                if(properties_size > quantity){                             
    
                                    // remove
                                    for(var i = 1; i <= (properties_size - quantity); i++){
                                        delete temp_properties[keys[keys.length - i]];
                                    }
                                                                    
                                }else{
    
                                    // add
                                    
                                    for(var i = 1; i <= ( (quantity > 10 ? 10 : quantity) - properties_size); i++){
                                        temp_properties['Bag ' + (keys.length + i)] = temp_properties[keys[0]];
                                    }
            
                                }
    
                                new_properties = temp_properties;
                                
                            }

                            $this._updateCart(key, quantity, new_properties);
                            return false;
    
                        }
                    
                    });
    
                }
            });
         } else {
            $this._updateCart(key, quantity);
         }
       }
       
       /**
        * Update cart with a valid quantity
        *
        * @param $cartItem
        * @param quantity
        * @private
        */

    }, {
       key: "_updateCart",
       value: function _updateCart(key, quantity, properties) {          

            var _this3 = this;

            var data = {
                id: key,
                quantity: quantity
            }

            if (typeof(properties) != 'undefined') {
                data.properties = properties;
            }

            jQuery.ajax({
                url: '/cart/change.js',
                type: 'post',
                dataType: 'json',
                data: data,
                success: function(response){ 
                    location.reload();
                    //_this3._didUpdate(key, quantity, response);
                }
            });
            
            /*
            // Notify Shopify updated item
            Shopify.changeItem(key, quantity, function (response) {
                _this3._didUpdate(key, quantity, response);
            });
            */
       }
     }, {
       
       key: "_quantityError",
       value: function _quantityError(limit, title) {
         var errorMessage = this.settings.stock_limit.replace('** quantity **', limit).replace('** title **', title);
         this.messageBanner.message(errorMessage, 'error');
       }
       /**
        * Update cart content based on information from Shopify
        *
        * @param id
        * @param quantity
        * @param response
        * @returns {*}
        * @private
        */
   
     }, {
       key: "_didUpdate",
       value: function _didUpdate(id, quantity, response) {
         var _this4 = this;
   
         // Reload page if all items are removed from cart
         if (!response.items.length) {
           return window.location = '/cart';
         }
   
         this.$header.trigger('cartcount:update', {
           response: response
         });
         this.$total.each(function (i, el) {
           el.innerHTML = Shopify.formatMoney(response.total_price, _this4.settings.money_format);
           shopify_currency_converter_dist_default.a.update(el);
         }); // Reload the cart-item-list and the discounts snippets
   
         shopify_asyncview_dist_index_es.load('/cart', '_ajax').done(function (_ref) {
           var options = _ref.options,
               html = _ref.html;
           // Inject new cart list contents
           var newListContainer = document.createElement('div');
           newListContainer.innerHTML = html.list;
           morphdom_esm(_this4.cartItemList, newListContainer.querySelector('ul'), {
             onBeforeElUpdated: function onBeforeElUpdated(fromEl, toEl) {
               // Skip images if src matches
               // - we don't want to reload lazy loaded images
               if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                 return false;
               }
   
               return true;
             }
           });
   
           _this4.cartItemList.querySelectorAll('.money').forEach(function (money) {
             return shopify_currency_converter_dist_default.a.update(money);
           });
   
           dist_index_es.watch(_this4.cartItemList);
   
           _this4.forms.unload();
   
           _this4.forms = new Forms_Forms(_this4.$el);
   
           _this4.$el.off('keyup.cart-page', '[data-cartitem-quantity]');
   
           _this4.$el.on('keyup.cart-page', '[data-cartitem-quantity]', just_debounce_default()(function (event) {
             return _this4._quantityKeyUp(event);
           }, 200));
   
           _this4.$el.off('change.cart-page', '[data-cartitem-quantity][data-quantity-input]');
   
           _this4.$el.on('change.cart-page', '[data-cartitem-quantity][data-quantity-input]', _this4._editItemQuantity);
   
           _this4.$el.off('click.cart-page', '[data-cartitem-remove]');
   
           _this4.$el.on('click.cart-page', '[data-cartitem-remove]', function (event) {
             event.preventDefault();
   
             _this4._editItemQuantity(event, true);
           }); // Inject new cart level discounts
   
   
           _this4.cartDiscounts.innerHTML = html.discounts;
   
           _this4.cartDiscounts.querySelectorAll('.money').forEach(function (money) {
             return shopify_currency_converter_dist_default.a.update(money);
           });
         }).fail(function () {
           return window.location.reload();
         });
       }
       /**
        * Handle Errors returned from Shopify
        *
        * @param errors
        * @private
        */
   
     }, {
       key: "_handleErrors",
       value: function _handleErrors() {
         var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
   
         if (!errors) {
           return;
         }
   
         var shippingResponse = {
           message: this.shipping.error_general
         };
   
         if (errors.zip && errors.zip.length > 0) {
           if (errors.zip[0].indexOf('is not valid') !== -1 || errors.zip[0].indexOf('can\'t be blank') !== -1) {
             shippingResponse.message = "".concat(this.shipping.zip, " ").concat(errors.zip);
           }
         }
   
         if (errors.error && errors.error.length > 0) {
           if (errors.error[0].indexOf('shipment_too_heavy') !== -1) {
             shippingResponse.message = this.shipping.shipment_too_heavy;
           }
         }
   
         this._handleShippingResponse(shippingResponse);
       }
     }, {
       key: "_initShippingCalc",
       value: function _initShippingCalc() {
         var _this5 = this;
   
         this._bindShippingCalcEvents();
   
         var countrySelect = document.getElementById('address_country');
         var provinceSelect = document.getElementById('address_province');
         var provinceContainer = document.getElementById('address_province_container');
         this.shippingCountryProvinceSelector = new CountryProvinceSelector(countrySelect.innerHTML);
         this.shippingCountryProvinceSelector.build(countrySelect, provinceSelect, {
           onCountryChange: function onCountryChange(provinces) {
             if (provinces.length) {
               provinceContainer.style.display = 'block';
             } else {
               provinceContainer.style.display = 'none';
             } // "Province", "State", "Region", etc. and "Postal Code", "ZIP Code", etc.
             // Even countries without provinces include a label.
   
   
             var _window$Countries$cou = window.Countries[countrySelect.value],
                 label = _window$Countries$cou.label,
                 zip_label = _window$Countries$cou.zip_label;
             provinceContainer.querySelector('label[for="address_province"]').innerHTML = label;
             _this5.el.querySelector('#address_zip ~ label[for="address_zip"]').innerHTML = zip_label;
           }
         });
       }
     }, {
       key: "_bindShippingCalcEvents",
       value: function _bindShippingCalcEvents() {
         var _this6 = this;
   
         this.$el.on('click.cart-page', '[data-cartshipping-toggle]', function () {
           _this6._toggleShippingCalc();
         });
         this.$el.on('click.cart-page', '[data-cartshipping-submit]', function () {
           _this6._getShippingRates();
         });
         this.$el.on('keypress.cart-page', '#address_zip', function (event) {
           if (event.keyCode === 10 || event.keyCode === 13) {
             event.preventDefault();
   
             _this6.$shippingSubmit.trigger('click');
           }
         });
       }
     }, {
       key: "_toggleShippingCalc",
       value: function _toggleShippingCalc() {
         var oldText = this.$shippingToggle.text();
         var newText = this.$shippingToggle.data('cartshipping-toggle');
         this.$shippingToggle.text(newText).data('cartshipping-toggle', oldText);
         this.$shipping.toggleClass('open');
       }
     }, {
       key: "_getShippingRates",
       value: function _getShippingRates() {
         var _this7 = this;
   
         this._disableShippingButton();
   
         var shippingAddress = {};
         shippingAddress.country = jquery_default()('#address_country').val() || '';
         shippingAddress.province = jquery_default()('#address_province').val() || '';
         shippingAddress.zip = jquery_default()('#address_zip').val() || '';
         var queryString = Object.keys(shippingAddress).map(function (key) {
           return "".concat(encodeURIComponent("shipping_address[".concat(key, "]")), "=").concat(encodeURIComponent(shippingAddress[key]));
         }).join('&');
         jquery_default.a.ajax("/cart/shipping_rates.json?".concat(queryString), {
           dataType: 'json'
         }).fail(function (error) {
           return _this7._handleErrors(error.responseJSON || {});
         }).done(function (response) {
           var rates = response.shipping_rates;
           var addressBase = [];
   
           if (shippingAddress.zip.length) {
             addressBase.push(shippingAddress.zip.trim());
           }
   
           if (shippingAddress.province.length) {
             addressBase.push(shippingAddress.province);
           }
   
           if (shippingAddress.country.length) {
             addressBase.push(shippingAddress.country);
           }
   
           var address = addressBase.join(', ');
           var message = '';
   
           if (rates.length > 1) {
             var firstRate = window.Shopify.formatMoney(rates[0].price, _this7.settings.moneyFormat);
             message = _this7.shipping.multiple_rates.replace('*address*', address).replace('*number_of_rates*', rates.length).replace('*rate*', "<span class=\"money\">".concat(firstRate, "</span>"));
           } else if (rates.length === 1) {
             message = _this7.shipping.one_rate.replace('*address*', address);
           } else {
             message = _this7.shipping.no_rates;
           }
   
           var ratesList = rates.map(function (rate) {
             var price = window.Shopify.formatMoney(rate.price, _this7.settings.moneyFormat);
   
             var rateValue = _this7.shipping.rate_value.replace('*rate_title*', rate.name).replace('*rate*', "<span class=\"money\">".concat(price, "</span>"));
   
             return "<li>".concat(rateValue, "</li>");
           });
   
           _this7._handleShippingResponse({
             message: message,
             rates: ratesList
           });
         });
       }
     }, {
       key: "_enableShippingButton",
       value: function _enableShippingButton() {
         this.$shippingSubmit.text(this.shipping.calculate_shipping).attr('disabled', false);
       }
     }, {
       key: "_disableShippingButton",
       value: function _disableShippingButton() {
         this.$shippingSubmit.text(this.shipping.calculating).attr('disabled', true);
       }
     }, {
       key: "_showShippingResponse",
       value: function _showShippingResponse() {
         this.$shippingResponse.addClass('visible');
       }
     }, {
       key: "_hideShippingResponse",
       value: function _hideShippingResponse() {
         this.$shippingResponse.removeClass('visible');
       }
       /**
        * Handle shipping responses
        *
        * @param {object} shippingResponse
        * @property {String} shippingResponse.messages - Error / Success message
        * @property {Array|String} shippingResponse.rates - Shipping rates
        * @private
        */
   
     }, {
       key: "_handleShippingResponse",
       value: function _handleShippingResponse() {
         var shippingResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
   
         // Hide the response so that it can be populated smoothly
         this._hideShippingResponse();
   
         var message = shippingResponse.message || null;
         var rates = shippingResponse.rates || null; // Empty out contents
   
         this.$shippingResponseMessage.empty();
         this.$shippingResponseRates.empty();
   
         if (message) {
           this.$shippingResponseMessage.html(message).find('.money').each(function (index, money) {
             return shopify_currency_converter_dist_default.a.update(money);
           });
         }
   
         if (rates) {
           this.$shippingResponseRates.html(rates).find('.money').each(function (index, money) {
             return shopify_currency_converter_dist_default.a.update(money);
           });
         } // Reset the calculating button so it can be used again
   
   
         this._enableShippingButton(); // No error provided
   
   
         if (!message && !rates) {
           return;
         } // Show the response
   
   
         this._showShippingResponse();
       }
     }]);
   
     return StaticCart;
   }();
   
   
   // EXTERNAL MODULE: ./node_modules/vanilla-modal/dist/index.js
   var vanilla_modal_dist = __webpack_require__(13);
   var vanilla_modal_dist_default = /*#__PURE__*/__webpack_require__.n(vanilla_modal_dist);
   
   // CONCATENATED MODULE: ./node_modules/@shopify/theme-a11y/theme-a11y.js
   /**
    * A11y Helpers
    * -----------------------------------------------------------------------------
    * A collection of useful functions that help make your theme more accessible
    */
   
   /**
    * Moves focus to an HTML element
    * eg for In-page links, after scroll, focus shifts to content area so that
    * next `tab` is where user expects. Used in bindInPageLinks()
    * eg move focus to a modal that is opened. Used in trapFocus()
    *
    * @param {Element} container - Container DOM element to trap focus inside of
    * @param {Object} options - Settings unique to your theme
    * @param {string} options.className - Class name to apply to element on focus.
    */
   function forceFocus(element, options) {
     options = options || {};
   
     var savedTabIndex = element.tabIndex;
   
     element.tabIndex = -1;
     element.dataset.tabIndex = savedTabIndex;
     element.focus();
     if (typeof options.className !== 'undefined') {
       element.classList.add(options.className);
     }
     element.addEventListener('blur', callback);
   
     function callback(event) {
       event.target.removeEventListener(event.type, callback);
   
       element.tabIndex = savedTabIndex;
       delete element.dataset.tabIndex;
       if (typeof options.className !== 'undefined') {
         element.classList.remove(options.className);
       }
     }
   }
   
   /**
    * If there's a hash in the url, focus the appropriate element
    * This compensates for older browsers that do not move keyboard focus to anchor links.
    * Recommendation: To be called once the page in loaded.
    *
    * @param {Object} options - Settings unique to your theme
    * @param {string} options.className - Class name to apply to element on focus.
    * @param {string} options.ignore - Selector for elements to not include.
    */
   
   function focusHash(options) {
     options = options || {};
     var hash = window.location.hash;
     var element = document.getElementById(hash.slice(1));
   
     // if we are to ignore this element, early return
     if (element && options.ignore && element.matches(options.ignore)) {
       return false;
     }
   
     if (hash && element) {
       forceFocus(element, options);
     }
   }
   
   /**
    * When an in-page (url w/hash) link is clicked, focus the appropriate element
    * This compensates for older browsers that do not move keyboard focus to anchor links.
    * Recommendation: To be called once the page in loaded.
    *
    * @param {Object} options - Settings unique to your theme
    * @param {string} options.className - Class name to apply to element on focus.
    * @param {string} options.ignore - CSS selector for elements to not include.
    */
   
   function bindInPageLinks(options) {
     options = options || {};
     var links = Array.prototype.slice.call(
       document.querySelectorAll('a[href^="#"]')
     );
   
     return links.filter(function(link) {
       if (link.hash === '#' || link.hash === '') {
         return false;
       }
   
       if (options.ignore && link.matches(options.ignore)) {
         return false;
       }
   
       var element = document.querySelector(link.hash);
   
       if (!element) {
         return false;
       }
   
       link.addEventListener('click', function() {
         forceFocus(element, options);
       });
   
       return true;
     });
   }
   
   function focusable(container) {
     var elements = Array.prototype.slice.call(
       container.querySelectorAll(
         '[tabindex],' +
           '[draggable],' +
           'a[href],' +
           'area,' +
           'button:enabled,' +
           'input:not([type=hidden]):enabled,' +
           'object,' +
           'select:enabled,' +
           'textarea:enabled'
       )
     );
   
     // Filter out elements that are not visible.
     // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
     return elements.filter(function(element) {
       return !!(
         element.offsetWidth ||
         element.offsetHeight ||
         element.getClientRects().length
       );
     });
   }
   
   /**
    * Traps the focus in a particular container
    *
    * @param {Element} container - Container DOM element to trap focus inside of
    * @param {Element} elementToFocus - Element to be focused on first
    * @param {Object} options - Settings unique to your theme
    * @param {string} options.className - Class name to apply to element on focus.
    */
   
   var trapFocusHandlers = {};
   
   function trapFocus(container, options) {
     options = options || {};
     var elements = focusable(container);
     var elementToFocus = options.elementToFocus || container;
     var first = elements[0];
     var last = elements[elements.length - 1];
   
     removeTrapFocus();
   
     trapFocusHandlers.focusin = function(event) {
       if (container !== event.target && !container.contains(event.target)) {
         first.focus();
       }
   
       if (
         event.target !== container &&
         event.target !== last &&
         event.target !== first
       )
         return;
       document.addEventListener('keydown', trapFocusHandlers.keydown);
     };
   
     trapFocusHandlers.focusout = function() {
       document.removeEventListener('keydown', trapFocusHandlers.keydown);
     };
   
     trapFocusHandlers.keydown = function(event) {
       if (event.keyCode !== 9) return; // If not TAB key
   
       // On the last focusable element and tab forward, focus the first element.
       if (event.target === last && !event.shiftKey) {
         event.preventDefault();
         first.focus();
       }
   
       //  On the first focusable element and tab backward, focus the last element.
       if (
         (event.target === container || event.target === first) &&
         event.shiftKey
       ) {
         event.preventDefault();
         last.focus();
       }
     };
   
     document.addEventListener('focusout', trapFocusHandlers.focusout);
     document.addEventListener('focusin', trapFocusHandlers.focusin);
   
     forceFocus(elementToFocus, options);
   }
   
   /**
    * Removes the trap of focus from the page
    */
   function removeTrapFocus() {
     document.removeEventListener('focusin', trapFocusHandlers.focusin);
     document.removeEventListener('focusout', trapFocusHandlers.focusout);
     document.removeEventListener('keydown', trapFocusHandlers.keydown);
   }
   
   /**
    * Add a preventive message to external links and links that open to a new window.
    * @param {string} elements - Specific elements to be targeted
    * @param {object} options.messages - Custom messages to overwrite with keys: newWindow, external, newWindowExternal
    * @param {string} options.messages.newWindow - When the link opens in a new window (e.g. target="_blank")
    * @param {string} options.messages.external - When the link is to a different host domain.
    * @param {string} options.messages.newWindowExternal - When the link is to a different host domain and opens in a new window.
    * @param {object} options.prefix - Prefix to namespace "id" of the messages
    */
   function accessibleLinks(elements, options) {
     if (typeof elements !== 'string') {
       throw new TypeError(elements + ' is not a String.');
     }
   
     elements = document.querySelectorAll(elements);
   
     if (elements.length === 0) {
       return;
     }
   
     options = options || {};
     options.messages = options.messages || {};
   
     var messages = {
       newWindow: options.messages.newWindow || 'Opens in a new window.',
       external: options.messages.external || 'Opens external website.',
       newWindowExternal:
         options.messages.newWindowExternal ||
         'Opens external website in a new window.'
     };
   
     var prefix = options.prefix || 'a11y';
   
     var messageSelectors = {
       newWindow: prefix + '-new-window-message',
       external: prefix + '-external-message',
       newWindowExternal: prefix + '-new-window-external-message'
     };
   
     function generateHTML(messages) {
       var container = document.createElement('ul');
       var htmlMessages = Object.keys(messages).reduce(function(html, key) {
         return (html +=
           '<li id=' + messageSelectors[key] + '>' + messages[key] + '</li>');
       }, '');
   
       container.setAttribute('hidden', true);
       container.innerHTML = htmlMessages;
   
       document.body.appendChild(container);
     }
   
     function externalSite(link) {
       return link.hostname !== window.location.hostname;
     }
   
     elements.forEach(function(link) {
       var target = link.getAttribute('target');
       var rel = link.getAttribute('rel');
       var isExternal = externalSite(link);
       var isTargetBlank = target === '_blank';
       var isRelNoopenerEmpty = rel === null || rel.indexOf('noopener') === -1;
   
       if (isTargetBlank && isRelNoopenerEmpty) {
         link.setAttribute('rel', 'noopener');
       }
   
       if (isExternal && isTargetBlank) {
         link.setAttribute('aria-describedby', messageSelectors.newWindowExternal);
       } else if (isExternal) {
         link.setAttribute('aria-describedby', messageSelectors.external);
       } else if (isTargetBlank) {
         link.setAttribute('aria-describedby', messageSelectors.newWindow);
       }
     });
   
     generateHTML(messages);
   }
   // CONCATENATED MODULE: ./source/scripts/components/Modal.js
   function Modal_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Modal_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Modal_createClass(Constructor, protoProps, staticProps) { if (protoProps) Modal_defineProperties(Constructor.prototype, protoProps); if (staticProps) Modal_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var Modal_Modal =
   /*#__PURE__*/
   function () {
     function Modal() {
       var callbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
   
       Modal_classCallCheck(this, Modal);
   
       this.$body = jquery_default()(document.body);
       this.$window = jquery_default()(window);
       this.modal = null;
       this.$modal = jquery_default()('[data-modal-container]');
       this.$modalInner = this.$modal.find('[data-modal-inner]');
       this.trigger = null; // Extend default vanilla-modal callbacks back to instantiator of Modal
   
       this.defaultCallbacks = {
         onOpen: function onOpen() {},
         onClose: function onClose() {},
         onBeforeOpen: function onBeforeOpen() {},
         onBeforeClose: function onBeforeClose() {}
       };
       this.callbacks = jquery_default.a.extend({}, this.defaultCallbacks, callbacks);
       this._onOpen = this._onOpen.bind(this);
       this._onBeforeOpen = this._onBeforeOpen.bind(this);
       this._onClose = this._onClose.bind(this);
       this._onBeforeClose = this._onBeforeClose.bind(this);
       this._closeEsc = this._closeEsc.bind(this);
       this.position = this.position.bind(this);
       this.modalOptions = {
         loadClass: '',
         "class": 'modal-loaded',
         onOpen: this._onOpen,
         onClose: this._onClose,
         onBeforeOpen: this._onBeforeOpen,
         onBeforeClose: this._onBeforeClose,
         transitions: false
       };
     }
   
     Modal_createClass(Modal, [{
       key: "unload",
       value: function unload() {
         if (!this.modal || !this.modal.isOpen) return;
         this.modal.destroy();
       }
       /**
        * Open a modal with contents from selector
        *
        * @param selector
        * @param handle
        */
   
     }, {
       key: "open",
       value: function open(selector) {
         var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'general';
         var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
   
         this._addModalClass(handle);
   
         this.modal = new vanilla_modal_dist_default.a(this.modalOptions);
         this.modal.open(selector);
         this.trigger = trigger;
         window.addEventListener('keydown', this.closeEsc);
       }
     }, {
       key: "close",
       value: function close() {
         this.modal.close();
         window.removeEventListener('keydown', this.closeEsc);
       }
     }, {
       key: "_closeEsc",
       value: function _closeEsc(e) {
         if (e.key === 'Escape') {
           this.close();
         }
       }
     }, {
       key: "isOpen",
       value: function isOpen() {
         return this.modal && this.modal.isOpen;
       }
       /**
        * Update the vertical positioning of modal
        */
   
     }, {
       key: "position",
       value: function position() {
         var windowHeight = window.innerHeight;
         var modalHeight = this.$modalInner.outerHeight();
         var modalPadding = parseInt(this.$modal.css('padding-top'), 10) * 2;
         var offset = (windowHeight - modalPadding - modalHeight) / 2;
         var marginTop = offset > 0 ? offset : 0;
         this.$modalInner.css({
           marginTop: marginTop
         });
       }
       /**
        * Add a class to the modal for individual styling
        * @param handle
        * @private
        */
   
     }, {
       key: "_addModalClass",
       value: function _addModalClass(handle) {
         this.$modal.addClass("modal--".concat(handle));
       }
       /**
        * Remove modal class based on the handle
        * @private
        */
   
     }, {
       key: "_removeModalClass",
       value: function _removeModalClass() {
         var modalClass = this.$modal.attr('class').match(/modal--[\w-]*\b/);
   
         if (!modalClass) {
           return;
         }
   
         this.$modal.removeClass(modalClass[0]);
       }
     }, {
       key: "_onClose",
       value: function _onClose() {
         this._removeModalClass();
   
         this.$body.removeClass('scroll-lock').removeClass('modal-visible');
         this.$window.off('resize.modal');
         this.$modalInner.css({
           marginTop: ''
         });
         this.callbacks.onClose();
         removeTrapFocus(this.$modal[0]);
   
         if (this.activeElement) {
           this.activeElement.focus();
         }
       }
     }, {
       key: "_onOpen",
       value: function _onOpen() {
         var _this = this;
   
         this.activeElement = document.activeElement;
         this.position();
         this.$body.addClass('scroll-lock').addClass('modal-visible');
         this.$window.on('resize.modal', just_debounce_default()(function () {
           return _this.position();
         }, 16, true, true));
         this.callbacks.onOpen();
         trapFocus(this.$modal[0]);
       }
     }, {
       key: "_onBeforeClose",
       value: function _onBeforeClose() {
         this.callbacks.onBeforeClose();
       }
     }, {
       key: "_onBeforeOpen",
       value: function _onBeforeOpen() {
         this.callbacks.onBeforeOpen();
       }
     }]);
   
     return Modal;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/ProductOptions.js
   function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
   
   function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
   
   function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
   
   function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
   
   function ProductOptions_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ProductOptions_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ProductOptions_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductOptions_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductOptions_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var Node =
   /*#__PURE__*/
   function () {
     function Node(variant) {
       ProductOptions_classCallCheck(this, Node);
   
       this.variant = variant;
       this.optionsCount = this.variant.options.length;
       this.neighbors = [];
   
       for (var i = 0; i < this.optionsCount; i++) {
         this.neighbors.push([]);
       }
     }
   
     ProductOptions_createClass(Node, [{
       key: "addNeighbor",
       value: function addNeighbor(variant) {
         for (var i = 0; i < this.optionsCount; i++) {
           if (this.variant.options[i] !== variant.options[i]) {
             this.neighbors[i].push(variant);
             break;
           }
         }
       }
     }, {
       key: "getValidOptions",
       value: function getValidOptions() {
         var _this = this;
   
         var options = [];
   
         var _loop = function _loop(i) {
           var variants = [_this.variant].concat(_toConsumableArray(_this.neighbors[i]));
           options[i] = {};
           variants.forEach(function (item) {
             var variant = item;
             var option = variant.options[i];
             options[i][option] = {
               available: options[i][option] && options[i][option].available || variant.available
             };
           });
         };
   
         for (var i = 0; i < this.optionsCount; i++) {
           _loop(i);
         }
   
         return options;
       }
     }]);
   
     return Node;
   }();
   
   var ProductOptions =
   /*#__PURE__*/
   function () {
     function ProductOptions(product) {
       ProductOptions_classCallCheck(this, ProductOptions);
   
       this.productHandle = product.handle;
       this.optionsCount = product.options.length;
       this.variants = product.variants;
       this.nodeMap = {};
   
       this._generateNodeMap(product);
     }
   
     ProductOptions_createClass(ProductOptions, [{
       key: "_generateNodeMap",
       value: function _generateNodeMap() {
         var _this2 = this;
   
         this.variants.forEach(function (variant) {
           _this2.nodeMap[variant.id] = new Node(variant);
   
           _this2.variants.forEach(function (variant2) {
             _this2.nodeMap[variant.id].addNeighbor(variant2);
           });
         });
       }
     }, {
       key: "getVariantFromOptions",
       value: function getVariantFromOptions(options) {
         var foundVariant = null;
         this.variants.forEach(function (variant) {
           var found = true;
   
           for (var i = 0; i < variant.options.length; i++) {
             if (options[i] !== variant.options[i]) {
               found = false;
             }
           }
   
           if (found) {
             foundVariant = variant;
           }
         });
         return foundVariant ? foundVariant : false;
       }
     }, {
       key: "getClosestVariantFromOptions",
       value: function getClosestVariantFromOptions(options) {
         var closestVariant = null;
         var matchingValues = 0;
         this.variants.forEach(function (variant) {
           var tempMatchingValues = 0;
   
           for (var i = 0; i < variant.options.length; i++) {
             if (options[i] === variant.options[i]) {
               tempMatchingValues++;
             } else {
               break;
             }
           }
   
           if (tempMatchingValues >= matchingValues) {
             closestVariant = variant;
             matchingValues = tempMatchingValues;
           }
         });
         return closestVariant ? closestVariant : false;
       }
     }, {
       key: "getVariantOrClosestFromOptions",
       value: function getVariantOrClosestFromOptions(options) {
         return this.getVariantFromOptions(options) || this.getClosestVariantFromOptions(options);
       }
     }, {
       key: "getAvailableOptionsFromVariant",
       value: function getAvailableOptionsFromVariant(variant) {
         return this.nodeMap[variant.id].getValidOptions();
       }
     }]);
   
     return ProductOptions;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/VariantHelper.js
   function VariantHelper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function VariantHelper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function VariantHelper_createClass(Constructor, protoProps, staticProps) { if (protoProps) VariantHelper_defineProperties(Constructor.prototype, protoProps); if (staticProps) VariantHelper_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var VariantHelper_VariantHelper =
   /*#__PURE__*/
   function () {
     function VariantHelper(product, $variants, $options) {
       VariantHelper_classCallCheck(this, VariantHelper);
   
       this.product = product;
       this.optionsCount = this.product.options.length;
       this.$variants = $variants;
       this.$options = $options;
       this.productOptions = new ProductOptions(this.product);
       this.optionsTypes = {
         select: 'select',
         radio: 'input[type="radio"]'
       };
   
       this._bindEvents();
   
       if (this.$options.is(this.optionsTypes.select)) {
         this.optionsType = this.optionsTypes.select;
       } else if (this.$options.is(this.optionsTypes.radio)) {
         this.optionsType = this.optionsTypes.radio;
       } else {
         console.warn('Variant helper: Option set is not a valid type');
   
         this._unbindEvents();
       }
   
       this._switchVariant(null, true);
     }
   
     VariantHelper_createClass(VariantHelper, [{
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this = this;
   
         this.$options.on('change.variant-helper', function (event) {
           return _this._switchVariant(event);
         });
       }
     }, {
       key: "_unbindEvents",
       value: function _unbindEvents() {
         this.$options.off('change.variant-helper');
       }
     }, {
       key: "_switchVariant",
       value: function _switchVariant(event) {
         var firstLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
         var options = [];
         var product = this.product;
         var $selected = event ? jquery_default()(event.target) : null;
         var variant = null;
         var availableOptions = null;
   
         if (this.optionsType === this.optionsTypes.select) {
           this.$options.each(function (i, option) {
             options.push(option.value);
           });
         } else if (this.optionsType === this.optionsTypes.radio) {
           this.$options.filter(':checked').each(function (i, option) {
             options.push(option.value);
           });
         } else {
           return;
         }
   
         if (this.optionsType === this.optionsTypes.radio) {
         variant = this.productOptions.getVariantFromOptions(options);
         } else {
         variant = this.productOptions.getVariantOrClosestFromOptions(options);
         }
   
         if (variant) {
           availableOptions = this.productOptions.getAvailableOptionsFromVariant(variant);
         } else {
           return;
         }
   
         if (this.optionsType === this.optionsTypes.select) {
           this._switchVariantSelect(variant, availableOptions);
         } else if (this.optionsType === this.optionsTypes.radio) {
             //test all options to be selected
           if (window.selected_variant === false){
               //check if we have all the choices filled in
                if (jquery_default()('div[data-product-options-container=""]:not(:has(:radio:checked))').length) {
                    alert("Please, fill in all the options");
                } else {
                    window.selected_variant = true;
                }
           } else {
             this._switchVariantRadio(variant, availableOptions);

             if ($selected) {
               $selected.focus();
             }
           }
         } else {
           return;
         }
   
         this.$variants.val(variant.id);
         jquery_default()(window).trigger('product-variant-switch', {
           product: product,
           variant: variant,
           firstLoad: firstLoad
         });
       }
     }, {
       key: "_switchVariantSelect",
       value: function _switchVariantSelect(variant, availableOptions) {
         var _this2 = this;
   
         var _loop = function _loop(i) {
           // Corresponding select dropdown
           var $select = jquery_default()(_this2.$options[i]);
           var $optionEls = $select.find('option'); // Iterate over each option on dropdown
   
           $optionEls.each(function (index, option) {
             var $option = jquery_default()(option);
             var value = option.value; // Not an available option
   
             $option.prop('disabled', !availableOptions[i][value] || !availableOptions[i][value].available).prop('selected', false); // Dropdown option matches variant option
   
             if (variant.options[i] === value) {
               $option.prop('disabled', false).prop('selected', true);
             }
           });
         };
   
         // Iterate over each option type
         for (var i = 0; i < this.product.options.length; i++) {
           _loop(i);
         }
       }
     }, {
       key: "_switchVariantRadio",
       value: function _switchVariantRadio(variant, availableOptions) {
         var _this3 = this;
   
         this.$options.attr('disabled', true).prop('checked', false).attr('data-soldout', false);
   
         var _loop2 = function _loop2(i) {
           var selector = encodeURIComponent(_this3.product.options[i]).replace(/%20/g, '+').replace(/[!'()*]/g, function (_char) {
             return '%' + _char.charCodeAt(0).toString(16).toUpperCase();
           });
   
           var $options = _this3.$options.filter("[name=\"".concat(selector, "\"]"));
   
           $options.each(function (index, option) {
             var $option = jquery_default()(option);
   
             if (variant.options[i] === $option.val()) {
               $option.prop('checked', true);
             }
   
             if (availableOptions[i][$option.val()]) {
               $option.attr('disabled', false);
   
               if (!availableOptions[i][$option.val()].available) {
                 $option.attr('disabled', true);
                 $option.attr('data-soldout', true);
               }
             }
           });
         };
   
         for (var i = 0; i < this.product.options.length; i++) {
           _loop2(i);
         }
       }
     }, {
       key: "isDefault",
       value: function isDefault() {
         if (this.product.variants[0].title === 'Default Title' && this.product.variants[0].option1 === 'Default Title') {
           return true;
         }
       }
     }, {
       key: "hasSingleOption",
       value: function hasSingleOption() {
         return this.optionsCount === 1;
       }
     }, {
       key: "getSelectedVariant",
       value: function getSelectedVariant() {
         var options = [];
   
         if (this.optionsType === this.optionsTypes.select) {
           this.$options.each(function (i, option) {
             options.push(option.value);
           });
         } else if (this.optionsType === this.optionsTypes.radio) {
           this.$options.filter(':checked').each(function (i, option) {
             options.push(option.value);
           });
         } else {
           return;
         }
   
         return this.productOptions.getVariantFromOptions(options);
       }
     }, {
       key: "unload",
       value: function unload() {
         this._unbindEvents();
       }
     }]);
   
     return VariantHelper;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/helpers/Images.js
   function Images_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Images_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Images_createClass(Constructor, protoProps, staticProps) { if (protoProps) Images_defineProperties(Constructor.prototype, protoProps); if (staticProps) Images_defineProperties(Constructor, staticProps); return Constructor; }
   
   var Images =
   /*#__PURE__*/
   function () {
     function Images() {
       Images_classCallCheck(this, Images);
     }
   
     Images_createClass(Images, [{
       key: "preload",
   
       /**
        * Preloads an image in memory and uses the browsers cache to store it until needed.
        *
        * @param {Array} images - A list of image urls
        * @param {String} size - A shopify image size attribute
        */
       value: function preload(images, size) {
         if (typeof images === 'string') {
           images = [images];
         }
   
         for (var i = 0; i < images.length; i++) {
           this.loadImage(this.getSizedImageUrl(images[i], size));
         }
       }
       /**
        * Loads and caches an image in the browsers cache.
        *
        * @param {string} path - An image url
        */
   
     }, {
       key: "loadImage",
       value: function loadImage(path) {
         return new Image().src = path;
       }
       /**
        * Adds a Shopify size attribute to a URL
        *
        * @param src
        * @param size
        * @returns {*}
        */
   
     }, {
       key: "getSizedImageUrl",
       value: function getSizedImageUrl() {
         var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
         var size = arguments.length > 1 ? arguments[1] : undefined;
   
         if (!size) {
           return null;
         }
   
         if (size === 'master') {
           return this.removeProtocol(src);
         }
   
         var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
   
         if (match) {
           var prefix = src.split(match[0]);
           var suffix = match[0];
           return this.removeProtocol("".concat(prefix[0], "_").concat(size).concat(suffix));
         } else {
           console.warn("No ".concat(size, " found for '").concat(src));
           return null;
         }
       }
     }, {
       key: "removeProtocol",
       value: function removeProtocol(path) {
         return path.replace(/http(s)?:/, '');
       }
     }]);
   
     return Images;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/AddToCartFlyout.js
   function AddToCartFlyout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function AddToCartFlyout_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function AddToCartFlyout_createClass(Constructor, protoProps, staticProps) { if (protoProps) AddToCartFlyout_defineProperties(Constructor.prototype, protoProps); if (staticProps) AddToCartFlyout_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   var AddToCartFlyout_AddToCartFlyout =
   /*#__PURE__*/
   function () {
     function AddToCartFlyout() {
       AddToCartFlyout_classCallCheck(this, AddToCartFlyout);
   
       this.formData = {};
       this.settings = {};
       this.events = [];
       this.Images = new Images();
       this.flyOutSelector = '[data-atc-banner]';
       this.$atcTemplate = jquery_default()("[data-templates] ".concat(this.flyOutSelector));
       this.activeElement = null;
       this.itemId = null;
       this.atcFlyOut = document.querySelector(this.flyOutSelector);
       this._onInit = this._onInit.bind(this);
       this._onError = this._onError.bind(this);
       this._onSuccess = this._onSuccess.bind(this);
       this._onCloseAll = this._onCloseAll.bind(this);
       this._handleDocumentClick = this._handleDocumentClick.bind(this);
       this._closeEsc = this._closeEsc.bind(this);
       this.messageBanner = new MessageBanner_MessageBanner();
       this.header = document.querySelector('[data-site-header]');
       this.headerAnnouncement = document.querySelector('[data-site-header-announcement]');
       this.$header = jquery_default()(this.header);
       this.$body = jquery_default()(document.body);
     }
   
     AddToCartFlyout_createClass(AddToCartFlyout, [{
       key: "init",
       value: function init(formData, options) {
         var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
         this.formData = formData; // Allows ATC Flow to be overridden
   
         this.callbacks = jquery_default.a.extend({
           onInit: this._onInit,
           onError: this._onError,
           onSuccess: this._onSuccess,
           onClose: this._onCloseAll
         }, callbacks);
         var $atcButton = options.$atcButton;
         this.settings = jquery_default.a.extend({
           moneyFormat: null,
           cartRedirection: false
         }, options.settings); // If any FlyOuts are fully open, close them
   
         this._closeFlyOuts();
   
         this.callbacks.onInit();
         this.activeElement = document.activeElement;
   
         this._disableButton($atcButton);
   
         this._updateCart($atcButton);
       }
     }, {
       key: "unload",
       value: function unload() {
         this.messageBanner.dismissBanners();
   
         this._removeFlyOuts();
   
         delete this.Images;
       }
     }, {
       key: "_updateCart",
       value: function _updateCart($atcButton) {
         var _this = this;
   
         var $flyOut = this.$atcTemplate.clone();
         var quantityField = this.formData.filter(function (data) {
           return data.name === 'quantity';
         });
         var quantity = quantityField[0].value;
         jquery_default.a.ajax({
           type: 'POST',
           url: '/cart/add.js',
           data: jquery_default.a.param(this.formData),
           dataType: 'json'
         }).done(function (response) {
           _this.itemId = response.id;
   
           if (response.image) {
             var imageUrl = _this.Images.getSizedImageUrl(response.image, '200x');
   
             var image = _this.Images.loadImage(imageUrl);
   
             $flyOut.find('[data-atc-banner-product-image]').html("<img src=\"".concat(image, "\" alt=\"").concat(response.product_title, "\">"));
           }
   
           $flyOut.find('[data-atc-banner-product-title]').text(response.product_title);
           /*
             TODO: Bring in `variant.options`, iterate through to get option
               name for: <strong>Option name:</strong> Option
           */
   
           if (response.variant_options[0] !== 'Title' && response.variant_options[0] !== 'Default Title') {
             $flyOut.find('[data-atc-banner-product-options]').text(response.variant_options.join(', '));
           }
           /*
             TODO: Bring in variant, and use that to check compare_at_price
               to see if the item is on sale
           */
   
   
           var $productPriceQuantity = $flyOut.find('[data-atc-banner-product-price-quantity]');
           $productPriceQuantity.text("".concat(quantity, " \xD7 "));
           jquery_default.a.ajax({
             type: 'GET',
             url: '/cart.js',
             dataType: 'json'
           }).done(function (response) {
             if (_this.settings.cartRedirection) {
               return location.href = '/cart';
             }
   
             _this.callbacks.onSuccess(); // Reset formData in case instance is never cleared
   
   
             _this.formData = {};
             var lineItem = null;
             response.items.forEach(function (item) {
               if (item.id === _this.itemId) {
                 if (!lineItem) {
                   lineItem = item;
                 } else {
                   // If there are 2 lineItems with the same id, it means that there is likely a BOGO offer
                   // on the product. We need to grab the highest discounted price (BOGO will be 0)
                   // while also combining with the different discounts on the product in the discounts array
                   lineItem.line_level_discount_allocations = lineItem.line_level_discount_allocations.concat(item.line_level_discount_allocations);
                   lineItem.final_price = lineItem.final_price > item.final_price ? lineItem.final_price : item.final_price;
                   lineItem.quantity += item.quantity;
                 }
               }
             });
             var $productPriceValue = $flyOut.find('[data-atc-banner-product-price-value]');
             $productPriceValue.text(Shopify.formatMoney(lineItem.original_price, _this.settings.moneyFormat)); // Update price to local currency
   
             shopify_currency_converter_dist_default.a.update($productPriceValue[0]);
             var $productPriceDiscounted = $flyOut.find('[data-atc-banner-product-price-discounted]');
   
             if (lineItem.final_price < lineItem.original_price) {
               $productPriceDiscounted.text(Shopify.formatMoney(lineItem.final_price, _this.settings.moneyFormat)); // Update price to local currency
   
               shopify_currency_converter_dist_default.a.update($productPriceDiscounted[0]);
               $productPriceDiscounted.show();
               $productPriceValue.addClass('original-price');
             } else {
               $productPriceDiscounted.hide();
               $productPriceValue.removeClass('original-price');
             }
   
             var $productDiscounts = $flyOut.find('[data-atc-banner-product-discounts]');
   
             if (lineItem.line_level_discount_allocations.length > 0) {
               var discountItemTemplate = $productDiscounts.children().first();
               $productDiscounts.empty();
               lineItem.line_level_discount_allocations.forEach(function (discount) {
                 var $listItem = discountItemTemplate.clone();
                 $listItem.find('.discount-title').html(discount.discount_application.title);
                 var $amount = $listItem.find('.discount-amount');
                 $amount.html(discount.amount);
                 $productDiscounts.append($listItem);
                 shopify_currency_converter_dist_default.a.update($amount[0]);
               });
               $productDiscounts.show();
             } else {
               $productDiscounts.hide();
             }
   
             var $subTotal = $flyOut.find('[data-atc-banner-cart-subtotal]');
             $subTotal.text(Shopify.formatMoney(response.total_price, _this.settings.moneyFormat));
             shopify_currency_converter_dist_default.a.update($subTotal[0]);
             $flyOut.find('[data-atc-banner-cart-button]').find('span').text(response.item_count);
   
             _this.$header.append($flyOut); // Notifiy Header of new cart count
   
   
             _this.$header.trigger('cartcount:update', {
               response: response
             });
   
             _this._bindEvents($flyOut);
   
             _this._openFlyOut($flyOut, $atcButton);
           });
         }).fail(function (response) {
           var errorText;
   
           try {
             var responseText = JSON.parse(response.responseText);
             errorText = responseText.description;
           } catch (error) {
             errorText = "".concat(response.status, " ").concat(response.statusText);
   
             if (response.status === 401) {
               errorText = "".concat(errorText, ". Try refreshing and logging in.");
             }
           }
   
           _this._enableButton($atcButton);
   
           _this.callbacks.onError(errorText);
         });
       }
     }, {
       key: "_onError",
       value: function _onError(error) {
         this.messageBanner.message(error, 'error');
       }
     }, {
       key: "_onInit",
       value: function _onInit() {
         this.messageBanner.dismissBanners();
       }
     }, {
       key: "_onSuccess",
       value: function _onSuccess() {
         /*
           By default, the ATC Flyout doesn't need any additional success callbacks
            The `this.callbacks.onSuccess` is used to allow other views to initiate
           behaviour when a product has been added to the cart
          */
       }
     }, {
       key: "_onCloseAll",
       value: function _onCloseAll() {
         /*
           By default, the ATC Flyout doesn't need any additional close callbacks
            The `this.callbacks.onClose` is used to allow other views to initiate
           behaviour when the atc banner has been closed
          */
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents($flyOut) {
         var _this2 = this;
   
         this.events.push([$flyOut.on('click.atc-banner', '[data-atc-banner-close]', function (event) {
           event.preventDefault();
   
           _this2._closeFlyOut($flyOut);
         }), jquery_default()(document).on('touchstart.atc-banner, click.atc-banner', this._handleDocumentClick)]);
       }
       /**
        * Trigger any existing open FlyOuts to close
        *
        * @private
        */
   
     }, {
       key: "_closeFlyOuts",
       value: function _closeFlyOuts() {
         var _this3 = this;
   
         var $excludeFlyOut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
         jquery_default()(this.flyOutSelector).filter('[data-flyout-active]').each(function (index, el) {
           var $flyOut = jquery_default()(el);
   
           if ($excludeFlyOut && $flyOut.is($excludeFlyOut)) {
             return;
           }
   
           _this3._closeFlyOut($flyOut, index);
         });
   
         if (!$excludeFlyOut) {
           this.callbacks.onClose();
         }
   
         window.removeEventListener('keydown', this._closeEsc);
       }
     }, {
       key: "_openFlyOut",
       value: function _openFlyOut($flyOut, $atcButton) {
         var _this4 = this;
   
         /*
          If user has initiated a new ATC Flow before the first has finished,
          the first FlyOut could have opened after the first attempt to close open flyouts
         */
         this._closeFlyOuts($flyOut);
   
         $flyOut.addClass('animating animating-in').one('trend', function () {
           $flyOut.removeClass('animating animating-in').addClass('visible').off('trend');
           $flyOut.attr('data-flyout-active', true);
           trapFocus($flyOut[0]);
           window.addEventListener('keydown', _this4._closeEsc);
   
           _this4._enableButton($atcButton);
         });
       }
     }, {
       key: "_closeEsc",
       value: function _closeEsc(e) {
         if (e.key === 'Escape') {
           this._closeFlyOuts();
         }
       }
       /**
        * Close an open FlyOut
        *
        * @param $flyOut
        * @param index
        * @private
        */
   
     }, {
       key: "_closeFlyOut",
       value: function _closeFlyOut() {
         var _this5 = this;
   
         var $flyOut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
         var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
   
         if (!$flyOut) {
           return;
         }
   
         $flyOut.addClass('animating animating-out').one('trend', function () {
           $flyOut.removeClass('animating animating-out visible').one('trend', function () {
             $flyOut.off('trend');
   
             _this5._removeFlyOut($flyOut, index); // if the user clicked onto the search box, close the atc flyout and move focus
             // to the search instead of going to the previous active element.
   
   
             if (_this5.documentClickEventTarget && 'liveSearchInput' in _this5.documentClickEventTarget.dataset) {
               _this5.documentClickEventTarget.focus();
             } else if (_this5.activeElement) {
               _this5.activeElement.focus();
             }
   
             removeTrapFocus($flyOut[0]);
   
             _this5.callbacks.onClose();
           });
         });
       }
     }, {
       key: "_removeFlyOuts",
       value: function _removeFlyOuts() {
         var _this6 = this;
   
         jquery_default()(this.flyOutSelector).filter('[data-flyout-active]').each(function (index, el) {
           _this6._removeFlyOut(jquery_default()(el), index);
         });
       }
       /**
        * Remove the Flyout from the DOM, and clean up listeners
        *
        * @param $flyOut
        * @param index
        * @private
        */
   
     }, {
       key: "_removeFlyOut",
       value: function _removeFlyOut($flyOut, index) {
         if (this.events[index]) {
           this.events[index].forEach(function ($el) {
             return $el.off('.atc-banner');
           });
           this.events.splice(index, 1);
         }
   
         if ($flyOut) {
           $flyOut.remove();
         }
       }
     }, {
       key: "_disableButton",
       value: function _disableButton($atcButton) {
         $atcButton.addClass('processing').prop('disabled', true);
       }
     }, {
       key: "_enableButton",
       value: function _enableButton($atcButton) {
         $atcButton.prop('disabled', false).removeClass('processing');
       }
     }, {
       key: "_handleDocumentClick",
       value: function _handleDocumentClick(event) {
         var target = event.target;
         var $parent = jquery_default()(target).parents('[data-atc-banner]');
   
         if ($parent.length) {
           return;
         }
   
         this.documentClickEventTarget = target;
   
         this._closeFlyOuts();
       }
     }]);
   
     return AddToCartFlyout;
   }();
   
   /* harmony default export */ var components_AddToCartFlyout = (new AddToCartFlyout_AddToCartFlyout());
   // CONCATENATED MODULE: ./source/scripts/helpers/flickityHelper.js
   /**
    * Determines if flickity needs to be resized based on the selected image height
    *
    * @param {object} flickity - the flickity instance
    */
   function resizeFlickityIfNeeded(flickity) {
     if (!flickity) {
       return;
     }
   
     var activeHeight = flickity.selectedElement.offsetHeight;
     var flickityHeight = flickity.viewport.offsetHeight; // If flickity height is greater than slide height, ignore
   
     if (activeHeight < flickityHeight) {
       return;
     }
   
     flickity.resize();
   }
   // CONCATENATED MODULE: ./source/scripts/components/Youtube.js
   function Youtube_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Youtube_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Youtube_createClass(Constructor, protoProps, staticProps) { if (protoProps) Youtube_defineProperties(Constructor.prototype, protoProps); if (staticProps) Youtube_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   var api = 'https://www.youtube.com/iframe_api';
   var apiLoadedCallbacks = [];
   var apiLoaded = false;
   
   window.onYouTubeIframeAPIReady = function () {
     apiLoadedCallbacks.forEach(function (apiLoadedCallback) {
       return apiLoadedCallback();
     });
     apiLoadedCallbacks = [];
     apiLoaded = true;
   };
   
   var Youtube_Youtube =
   /*#__PURE__*/
   function () {
     function Youtube(_ref) {
       var el = _ref.el,
           videoUrl = _ref.videoUrl;
   
       Youtube_classCallCheck(this, Youtube);
   
       var regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
       this.el = el;
       this.id = videoUrl.match(regex)[1] || null;
       this.onApiLoaded = this._onApiLoaded.bind(this);
       this.isReady = false;
       this.onReady = this._onReady.bind(this);
       this.onReadyCallback = null;
       this.onStateChange = this._onStateChange.bind(this);
       this.onPlayCallback = null;
   
       if (apiLoaded) {
         this._onApiLoaded();
       } else {
         apiLoadedCallbacks.push(this.onApiLoaded);
         script_default()(api);
       }
     }
   
     Youtube_createClass(Youtube, [{
       key: "play",
       value: function play() {
         var _this = this;
   
         return new Promise(function (resolve) {
           _this.onPlayCallback = resolve;
   
           if (_this.isReady) {
             _this.player.playVideo();
           } else {
             _this.onReadyCallback = function () {
               _this.player.playVideo();
             };
           }
         });
       }
     }, {
       key: "pause",
       value: function pause() {
         var _this2 = this;
   
         return new Promise(function (resolve) {
           _this2.onPlayCallback = resolve;
   
           if (_this2.isReady) {
             _this2.player.pauseVideo();
           } else {
             _this2.onReadyCallback = function () {
               _this2.player.pauseVideo();
             };
           }
         });
       }
     }, {
       key: "autoplay",
       value: function autoplay() {
         var _this3 = this;
   
         return new Promise(function (resolve) {
           _this3.onPlayCallback = resolve;
   
           if (_this3.isReady) {
             _this3.player.playVideo();
   
             _this3.player.mute();
           } else {
             _this3.onReadyCallback = function () {
               _this3.player.playVideo();
   
               _this3.player.mute();
             };
           }
         });
       }
     }, {
       key: "unload",
       value: function unload() {
         this.player.destroy();
       }
     }, {
       key: "_onApiLoaded",
       value: function _onApiLoaded() {
         this.player = new YT.Player(this.el, {
           videoId: this.id,
           playerVars: {
             modestbranding: true,
             showinfo: false,
             controls: false,
             rel: 0
           },
           events: {
             onReady: this.onReady,
             onStateChange: this.onStateChange
           }
         });
       }
     }, {
       key: "_onReady",
       value: function _onReady() {
         this.isReady = true;
   
         if (this.onReadyCallback) {
           this.onReadyCallback();
         }
       }
     }, {
       key: "_onStateChange",
       value: function _onStateChange(event) {
         var state = event.data;
   
         if (this.onPlayCallback && state === YT.PlayerState.BUFFERING) {
           this.onPlayCallback();
           this.onPlayCallback = null;
         }
       }
     }]);
   
     return Youtube;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/Vimeo.js
   function Vimeo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Vimeo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Vimeo_createClass(Constructor, protoProps, staticProps) { if (protoProps) Vimeo_defineProperties(Constructor.prototype, protoProps); if (staticProps) Vimeo_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   var Vimeo_api = 'https://player.vimeo.com/api/player.js';
   var Vimeo_apiLoaded = false;
   
   var Vimeo_VimeoPlayer =
   /*#__PURE__*/
   function () {
     function VimeoPlayer(_ref) {
       var el = _ref.el,
           videoUrl = _ref.videoUrl;
   
       Vimeo_classCallCheck(this, VimeoPlayer);
   
       this.el = el;
       var urlParts = videoUrl.split('/');
       this.id = urlParts[urlParts.length - 1];
       this.onReadyCallback = null;
       this.onApiLoaded = this._onApiLoaded.bind(this);
       this.onProgress = this._onProgress.bind(this);
       this.onProgressCallback = null;
   
       if (Vimeo_apiLoaded) {
         this._onApiLoaded();
       } else {
         script_default()(Vimeo_api, this.onApiLoaded);
       }
     }
   
     Vimeo_createClass(VimeoPlayer, [{
       key: "play",
       value: function play() {
         var _this = this;
   
         return new Promise(function (resolve) {
           _this.onProgressCallback = resolve;
   
           if (Vimeo_apiLoaded) {
             _this.player.on('play', _this.onProgress);
   
             _this.player.play();
           } else {
             _this.onReadyCallback = function () {
               _this.player.on('play', _this.onProgress);
   
               _this.player.play();
             };
           }
         });
       }
     }, {
       key: "pause",
       value: function pause() {
         var _this2 = this;
   
         return new Promise(function (resolve) {
           _this2.onProgressCallback = resolve;
   
           if (Vimeo_apiLoaded) {
             _this2.player.on('pause', _this2.onProgress);
   
             _this2.player.pause();
           } else {
             _this2.onReadyCallback = function () {
               _this2.player.on('pause', _this2.onProgress);
   
               _this2.player.pause();
             };
           }
         });
       }
     }, {
       key: "autoplay",
       value: function autoplay() {
         var _this3 = this;
   
         return new Promise(function (resolve) {
           _this3.onProgressCallback = resolve;
   
           if (Vimeo_apiLoaded) {
             _this3.player.on('play', _this3.onProgress);
   
             _this3.player.setVolume(0);
   
             _this3.player.play();
           } else {
             _this3.onReadyCallback = function () {
               _this3.player.on('play', _this3.onProgress);
   
               _this3.player.setVolume(0);
   
               _this3.player.play();
             };
           }
         });
       }
     }, {
       key: "unload",
       value: function unload() {
         this.player.unload()["catch"]();
       }
     }, {
       key: "_onApiLoaded",
       value: function _onApiLoaded() {
         this.player = new window.Vimeo.Player(this.el, {
           id: this.id
         });
         this.player.ready().then()["catch"]();
         Vimeo_apiLoaded = true;
   
         if (this.onReadyCallback) {
           this.onReadyCallback();
         }
       }
     }, {
       key: "_onProgress",
       value: function _onProgress() {
         this.player.off('play', this.onProgress);
         this.player.off('pause', this.onProgress);
   
         if (this.onProgressCallback) {
           this.onProgressCallback();
           this.onProgressCallback = null;
         }
       }
     }]);
   
     return VimeoPlayer;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/Video.js
   function Video_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Video_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Video_createClass(Constructor, protoProps, staticProps) { if (protoProps) Video_defineProperties(Constructor.prototype, protoProps); if (staticProps) Video_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var Video_Video =
   /*#__PURE__*/
   function () {
     function Video(el, options) {
       Video_classCallCheck(this, Video);
   
       this.el = el;
       this.options = options;
       this.platform = el.getAttribute('data-video').trim();
       this.playButton = el.querySelector('[data-video-play-button]');
       this.videoEl = el.querySelector('[data-video-element]');
       this.onPlayClick = this._onPlayClick.bind(this);
       this.onPauseClick = this._onPauseClick.bind(this);
       this.autoplay = this._autoplay.bind(this);
       this.video = null;
       this.videoData = {
         el: this.videoEl.childNodes[0],
         videoUrl: this.videoEl.getAttribute('data-video-url')
       };
   
       switch (this.platform) {
         case 'youtube':
           this.video = new Youtube_Youtube(this.videoData);
           break;
   
         case 'vimeo':
           this.video = new Vimeo_VimeoPlayer(this.videoData);
           break;
   
         default:
           this.video = null;
           break;
       }
   
       if (this.playButton) {
         if (this.options && this.options.autoplay) {
           this.autoplay();
         }
   
         this.playButton.addEventListener('click', this.onPlayClick);
       }
     }
   
     Video_createClass(Video, [{
       key: "_onPlayClick",
       value: function _onPlayClick() {
         var _this = this;
   
         this.el.classList.add('video-loading');
         this.video.play().then(function () {
           _this.el.classList.add('video-transitioning');
   
           setTimeout(function () {
             _this.el.classList.remove('video-loading');
   
             _this.el.classList.remove('video-transitioning');
   
             _this.el.classList.add('video-playing');
           }, 200);
         });
       }
     }, {
       key: "_onPauseClick",
       value: function _onPauseClick() {
         this.video.pause();
       }
     }, {
       key: "_autoplay",
       value: function _autoplay() {
         var _this2 = this;
   
         this.el.classList.add('video-loading');
         this.video.autoplay().then(function () {
           _this2.el.classList.add('video-transitioning');
   
           setTimeout(function () {
             _this2.el.classList.remove('video-loading');
   
             _this2.el.classList.remove('video-transitioning');
   
             _this2.el.classList.add('video-playing');
           }, 200);
         });
       }
     }, {
       key: "unload",
       value: function unload() {
         if (this.playButton) {
           this.playButton.removeEventListener('click', this.onPlayClick);
         }
   
         if (this.video) {
           this.video.unload();
         }
       }
     }]);
   
     return Video;
   }();
   
   
   // CONCATENATED MODULE: ./node_modules/pixelzoom/dist/index.es.js
   
   /*!
    * pixelzoom v1.0.1
    * (c) 2018 Pixel Union
    */
   
   // Polyfill for creating CustomEvents on IE9/10/11
   
   // code pulled from:
   // https://github.com/d4tocchini/customevent-polyfill
   // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill
   
   (function () {
     if (typeof window === 'undefined') {
       return;
     }
   
     try {
       var ce = new window.CustomEvent('test', { cancelable: true });
       ce.preventDefault();
       if (ce.defaultPrevented !== true) {
         // IE has problems with .preventDefault() on custom events
         // http://stackoverflow.com/questions/23349191
         throw new Error('Could not prevent default');
       }
     } catch (e) {
       var CustomEvent = function CustomEvent(event, params) {
         var evt, origPrevent;
         params = params || {
           bubbles: false,
           cancelable: false,
           detail: undefined
         };
   
         evt = document.createEvent('CustomEvent');
         evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
         origPrevent = evt.preventDefault;
         evt.preventDefault = function () {
           origPrevent.call(this);
           try {
             Object.defineProperty(this, 'defaultPrevented', {
               get: function get() {
                 return true;
               }
             });
           } catch (e) {
             this.defaultPrevented = true;
           }
         };
         return evt;
       };
   
       CustomEvent.prototype = window.Event.prototype;
       window.CustomEvent = CustomEvent; // expose definition to window
     }
   })();
   
   var index_es_classCallCheck = function (instance, Constructor) {
     if (!(instance instanceof Constructor)) {
       throw new TypeError("Cannot call a class as a function");
     }
   };
   
   var index_es_createClass = function () {
     function defineProperties(target, props) {
       for (var i = 0; i < props.length; i++) {
         var descriptor = props[i];
         descriptor.enumerable = descriptor.enumerable || false;
         descriptor.configurable = true;
         if ("value" in descriptor) descriptor.writable = true;
         Object.defineProperty(target, descriptor.key, descriptor);
       }
     }
   
     return function (Constructor, protoProps, staticProps) {
       if (protoProps) defineProperties(Constructor.prototype, protoProps);
       if (staticProps) defineProperties(Constructor, staticProps);
       return Constructor;
     };
   }();
   
   
   
   
   
   
   
   var _extends = Object.assign || function (target) {
     for (var i = 1; i < arguments.length; i++) {
       var source = arguments[i];
   
       for (var key in source) {
         if (Object.prototype.hasOwnProperty.call(source, key)) {
           target[key] = source[key];
         }
       }
     }
   
     return target;
   };
   
   var Pixelzoom = function () {
     function Pixelzoom(container, options) {
       index_es_classCallCheck(this, Pixelzoom);
   
       this.options = _extends({
         imageClass: 'pixelzoom--image',
         imageSource: options.imageSource || container.querySelector('img').src,
         initialZoom: 1,
         dragPan: false,
         naturalPan: false,
         maxZoom: 9999,
         zoomSensitivity: 1,
         zoomSteps: 1,
         overflowContainer: null
       }, options);
   
       // Overflow container
       this.overflowContainer = this.options.overflowContainer;
   
       // Image container
       this.container = container;
       this.container.style.cursor = this.options.maxZoom > this.options.initialZoom ? 'zoom-in' : 'zoom-out';
       this.containerWidth = null;
       this.containerHeight = null;
   
       // Image
       this.image = new Image();
       this.imageSrc = this.options.imageSource;
       this.imageWidth = null;
       this.imageHeight = null;
   
       // State
       this.x = 0;
       this.y = 0;
       this.lastX = 0;
       this.lastY = 0;
       this.dragX = null;
       this.dragY = null;
       this.lastDragX = null;
       this.lastDragY = null;
       this.zoom = Math.min(this.options.maxZoom, this.options.initialZoom);
       this.zoomMax = this.options.maxZoom;
       this.zoomMin = 1;
       this.zoomSensitivity = this.options.zoomSensitivity;
       this.zoomSteps = Math.min(this.options.maxZoom, this.options.zoomSteps);
       this.distance = 0;
       this.cursor = this.container.style.cursor;
       this.panning = false;
       this.mouseDown = false;
       this.dragging = false;
       this.touched = false;
   
       this._triggerEvent('loading');
       this._loadImage();
     }
   
     /**
       * Load image
       *
       * @private
       */
   
   
     index_es_createClass(Pixelzoom, [{
       key: '_loadImage',
       value: function _loadImage() {
         var _this = this;
   
         this.image.addEventListener('load', function () {
           _this._appendImage();
         });
   
         this.image.classList.add(this.options.imageClass);
         this.image.src = this.imageSrc;
   
         this.image.style.position = 'absolute';
         this.image.style.top = '100%';
         this.image.style.left = '100%';
         this.image.style.maxWidth = '100%';
         this.image.style.maxHeight = '100%';
         this.image.style.transformOrigin = 'top left';
       }
   
       /**
         * Append image to the DOM
         *
         * @private
         */
   
     }, {
       key: '_appendImage',
       value: function _appendImage() {
         this._triggerEvent('loaded');
         this.container.appendChild(this.image);
   
         this.refresh();
         this._bindEvents();
   
         if (this.zoom > this.zoomMin) {
           this.x = -(this.imageWidth * this.zoom) + (this.imageWidth * this.zoom - this.imageWidth) / 2;
           this.y = -(this.imageHeight * this.zoom) + (this.imageHeight * this.zoom - this.imageHeight) / 2;
   
           if (this.lastDragX === null && this.lastDragY == null) {
             var offset = this.container.getBoundingClientRect();
             var dragX = this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageWidth * this.zoom ? this.overflowContainer.offsetWidth : this.containerWidth;
             var dragY = this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageHeight * this.zoom ? this.overflowContainer.offsetHeight : this.containerHeight;
   
             var scrollLeft = window.pageXOffset ? window.pageXOffset : document.body.scrollLeft;
             var scrollTop = window.pageYOffset ? window.pageYOffset : document.body.scrollTop;
   
             this.lastDragX = dragX / 2 + offset.left + scrollLeft;
             this.lastDragY = dragY / 2 + offset.top + scrollTop;
           }
         } else {
           this.x = -this.imageWidth;
           this.y = -this.imageHeight;
         }
   
         this.lastX = this.x;
         this.lastY = this.y;
   
         this._update();
       }
   
       /**
         * Bind mouse and touch events
         *
         * @private
         */
   
     }, {
       key: '_bindEvents',
       value: function _bindEvents() {
         var _this2 = this;
   
         this.container.addEventListener('mousedown', function (event) {
           event.stopPropagation();
   
           var pointer = _this2._getPointerBounds(event);
   
           _this2._initializeDrag(pointer[0]);
         });
   
         this.container.addEventListener('mouseenter', function () {
           event.stopPropagation();
   
           _this2._initializeMouse();
         });
   
         this.container.addEventListener('touchstart', function (event) {
           event.stopPropagation();
   
           var pointers = _this2._getPointerBounds(event);
   
           _this2._initializeTouch(pointers[0], pointers[1]);
         });
   
         this.container.addEventListener('dragstart', function (event) {
           event.stopPropagation();
   
           _this2._preventDrag(event);
         });
   
         ['mousemove', 'touchmove'].forEach(function (eventType) {
           _this2.container.addEventListener(eventType, function (event) {
             var pointers = _this2._getPointerBounds(event);
   
             _this2._pan(eventType, pointers[0], pointers[1]);
           });
         });
   
         this.container.addEventListener('mouseup', function (event) {
           event.stopPropagation();
   
           _this2._tap({
             x: event.pageX,
             y: event.pageY
           });
         });
   
         ['mouseleave', 'touchend'].forEach(function (eventType) {
           _this2.container.addEventListener(eventType, function (event) {
             event.stopPropagation();
   
             _this2._release();
           });
         });
   
         this.container.addEventListener('wheel', function (event) {
           event.stopPropagation();
   
           _this2._scroll(event.deltaY, {
             x: event.pageX,
             y: event.pageY
           });
         });
   
         document.body.addEventListener('touchmove', function (event) {
           _this2._preventScroll(event);
         });
       }
   
       /**
         * Increment or decrement zoom
         *
         * @param {number} adjustment
         * @private
         */
   
     }, {
       key: '_setZoom',
       value: function _setZoom(adjustment) {
         this._triggerEvent('zoom');
   
         var zoom = this.zoom + adjustment;
   
         zoom = Math.min(this.zoomMax, zoom);
         zoom = Math.max(this.zoomMin, zoom);
         this.zoom = zoom;
   
         if (this.zoom === this.zoomMax) {
           this.container.style.cursor = 'zoom-out';
           this.cursor = 'zoom-out';
   
           this._triggerEvent('zoomMax');
         } else {
           this.container.style.cursor = 'zoom-in';
           this.cursor = 'zoom-in';
         }
   
         if (this.zoom === this.zoomMin) {
           this.lastDragX = null;
           this.lastDragY = null;
   
           this._triggerEvent('zoomMin');
         }
       }
   
       /**
         * Set image center position
         *
         * @param {object} pointer
         * @private
         */
   
     }, {
       key: '_setCenter',
       value: function _setCenter(pointer, event) {
         if (this.zoom !== this.zoomMin) {
           var offset = this.container.getBoundingClientRect();
           var zoomWidth = this.imageWidth * this.zoom - this.containerWidth;
           var zoomHeight = this.imageHeight * this.zoom - this.containerHeight;
   
           var scrollLeft = window.pageXOffset ? window.pageXOffset : document.body.scrollLeft;
           var scrollTop = window.pageYOffset ? window.pageYOffset : document.body.scrollTop;
   
           if (!(this.zoom - 1 > this.zoomMin && event === 'tap') || event === 'tap' && this.zoomSteps >= this.zoomMax) {
             this.lastX = pointer.x;
             this.lastY = pointer.y;
           }
   
           var currentX = (offset.left - this.lastX) * (zoomWidth / this.containerWidth) - this.containerWidth + scrollLeft * this.zoom - scrollLeft;
           var currentY = (offset.top - this.lastY) * (zoomHeight / this.containerHeight) - this.containerHeight + scrollTop * this.zoom - scrollTop;
   
           currentX = Math.max(-this.imageWidth * this.zoom, currentX);
           currentY = Math.max(-this.imageHeight * this.zoom, currentY);
   
           if (this.overflowContainer) {
             currentX = Math.max(-this.imageWidth * this.zoom + offset.left, currentX);
             currentY = Math.max(-this.imageHeight * this.zoom + offset.top, currentY);
   
             currentX = Math.min(-this.imageWidth - offset.left, currentX);
             currentY = Math.min(-this.imageHeight - offset.top, currentY);
           }
   
           if (this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageWidth * this.zoom) {
             this.x = -(this.imageWidth * this.zoom) + (this.imageWidth * this.zoom - this.imageWidth) / 2;
           } else {
             this.x = Math.min(-this.imageWidth, currentX);
           }
   
           if (this.overflowContainer && this.overflowContainer.offsetHeight >= this.imageHeight * this.zoom) {
             this.y = -(this.imageHeight * this.zoom) + (this.imageHeight * this.zoom - this.imageHeight) / 2;
           } else {
             this.y = Math.min(-this.imageHeight, currentY);
           }
         } else {
           this.x = -this.imageWidth;
           this.y = -this.imageHeight;
           this.lastX = 0;
           this.lastY = 0;
           this.lastDragX = null;
           this.lastDragY = null;
         }
       }
   
       /**
         * Initialize zoom for non-touch devices
         *
         * @private
         */
   
     }, {
       key: '_initializeMouse',
       value: function _initializeMouse() {
         this._triggerEvent('touch');
         this.refresh();
       }
   
       /**
         * Initialize drag
         *
         * @private
         */
   
     }, {
       key: '_initializeDrag',
       value: function _initializeDrag(pointer) {
         if (this.options.dragPan) {
           this.mouseDown = true;
   
           if (this.lastDragX === null && this.lastDragY === null) {
             this.lastDragX = pointer.x;
             this.lastDragY = pointer.y;
           }
         }
       }
   
       /**
         * Initialize zoom for touch devices
         *
         * @param {object} touches
         * @param {object} pointerOne
         * @param {object} pointerTwo
         * @private
         */
   
     }, {
       key: '_initializeTouch',
       value: function _initializeTouch(pointerOne, pointerTwo) {
         this._triggerEvent('touch');
   
         this.touched = true;
   
         if (this.lastDragX === null && this.lastDragY == null) {
           this.lastDragX = pointerOne.x;
           this.lastDragY = pointerOne.y;
         }
   
         if (pointerTwo && pointerTwo.x && pointerTwo.y) {
           this.distance = Math.hypot(pointerOne.x - pointerTwo.x, pointerOne.y - pointerTwo.y);
         }
       }
   
       /**
         * Pan image
         *
         * @param {string} eventType
         * @param {object} touches
         * @param {object} pointerOne
         * @param {object} pointerTwo
         * @private
         */
   
     }, {
       key: '_pan',
       value: function _pan(eventType, pointerOne, pointerTwo) {
         if (pointerTwo && pointerTwo.x && pointerTwo.y) {
           if (this.panning || !this.touched) {
             this._pinch({
               x: pointerOne.x,
               y: pointerOne.y
             }, {
               x: pointerTwo.x,
               y: pointerTwo.y
             });
           }
         } else {
           if (this.options.dragPan && this.mouseDown === false && eventType !== 'touchmove') {
             return;
           } else if (this.options.dragPan && this.mouseDown || eventType === 'touchmove') {
             this.dragging = true;
             this.container.style.cursor = 'move';
           }
   
           if (this.panning || !this.touched) {
             if (this.dragging) {
               this._drag({
                 x: pointerOne.x,
                 y: pointerOne.y
               });
             } else {
               this._setCenter({
                 x: pointerOne.x,
                 y: pointerOne.y
               });
   
               this._update();
             }
           } else {
             if (!this.dragging) {
               this._setCenter({
                 x: this.lastX,
                 y: this.lastY
               });
   
               this._update();
             }
           }
         }
   
         if (eventType === 'touchmove' && !this.panning) {
           this.panning = true;
           this._triggerEvent('pan');
         }
       }
   
       /**
         * Zoom into the image on pinch
         *
         * @param {object} touchOne
         * @param {object} touchTwo
         * @private
         */
   
     }, {
       key: '_pinch',
       value: function _pinch(touchOne, touchTwo) {
         this._triggerEvent('pinch');
   
         var distance = Math.hypot(touchOne.x - touchTwo.x, touchOne.y - touchTwo.y);
   
         var zoomAdjustment = this.zoom / (this.zoomSensitivity * 2);
         var difference = Math.abs(distance) - Math.abs(this.distance);
   
         if (difference > 0.5 || difference < -0.5) {
           this._setZoom(distance > this.distance ? +zoomAdjustment : -zoomAdjustment);
         }
   
         this.refresh();
   
         if (this.zoom < this.zoomMax) {
           if (distance > this.distance) {
             touchOne.x -= (touchOne.x - touchTwo.x) / 2;
             touchOne.y -= (touchOne.y - touchTwo.y) / 2;
           } else {
             touchOne.x = this.lastDragX;
             touchOne.y = this.lastDragY;
           }
   
           this.lastDragX = touchOne.x;
           this.lastDragY = touchOne.y;
           this.dragX = 0;
           this.dragY = 0;
   
           this._setCenter({
             x: touchOne.x,
             y: touchOne.y
           });
   
           this.distance = distance;
   
           this._update();
         }
       }
   
       /**
         * Drag image
         *
         * @param {object} pointer
         * @private
         */
   
     }, {
       key: '_drag',
       value: function _drag(pointer) {
         if (this.dragX && this.dragY && this.lastDragX !== null && this.lastDragY !== null) {
           var differenceX = (this.dragX - pointer.x) / (this.zoom / 2);
           var differenceY = (this.dragY - pointer.y) / (this.zoom / 2);
           var dragX = this.lastDragX;
           var dragY = this.lastDragY;
   
           if (this.options.naturalPan) {
             dragX += differenceX;
             dragY += differenceY;
           } else {
             dragX -= differenceX;
             dragY -= differenceY;
           }
   
           dragX = Math.min(this.imageWidth * this.zoom, dragX);
           this.lastDragX = Math.max(0, dragX);
   
           dragY = Math.min(this.imageHeight * this.zoom, dragY);
           this.lastDragY = Math.max(0, dragY);
   
           this.lastX = this.lastDragX;
           this.lastY = this.lastDragY;
   
           this._setCenter({
             x: this.lastDragX,
             y: this.lastDragY
           });
   
           this._update();
         }
   
         this.dragX = pointer.x;
         this.dragY = pointer.y;
       }
   
       /**
         * Zoom into the image on tap/click
         *
         * @param {object} pointer
         * @private
         */
   
     }, {
       key: '_tap',
       value: function _tap(pointer) {
         this._triggerEvent('tap');
   
         if (!this.panning && !this.dragging) {
           this._setZoom(this.zoomMax > this.zoom ? +this.zoomSteps : -this.zoomMax);
   
           this.refresh();
   
           this._setCenter(pointer, 'tap');
   
           this.lastDragX = this.lastX;
           this.lastDragY = this.lastY;
   
           this._update();
         }
   
         this.panning = false;
         this.mouseDown = false;
         this.dragging = false;
         this.touched = false;
         this.distance = 0;
         this.dragX = 0;
         this.dragY = 0;
   
         this.container.style.cursor = this.cursor;
       }
   
       /**
         * Zoom into the image on scroll
         *
         * @param {int} scale
         * @param {object} pointer
         * @private
         */
   
     }, {
       key: '_scroll',
       value: function _scroll(scale, pointer) {
         if (!this.dragging) {
           this._triggerEvent('scroll');
   
           var zoomAdjustment = this.zoom / this.zoomSensitivity;
   
           if (this.options.dragPan && this.zoom > this.zoomMin) {
             pointer.x = this.lastDragX;
             pointer.y = this.lastDragY;
           }
   
           this.lastDragX = pointer.x;
           this.lastDragY = pointer.y;
           this.dragX = 0;
           this.dragY = 0;
   
           this._setZoom(scale < 0 ? +zoomAdjustment : -zoomAdjustment);
   
           this.refresh();
   
           this._setCenter(pointer);
           this._update();
         }
       }
   
       /**
         * Set panning to false
         *
         * @private
         */
   
     }, {
       key: '_release',
       value: function _release() {
         this._triggerEvent('release');
         this.panning = false;
         this.mouseDown = false;
         this.dragging = false;
         this.dragX = 0;
         this.dragY = 0;
   
         this.container.style.cursor = this.cursor;
       }
   
       /**
         * Prevent images from being dragged
         *
         * @param {object} event
         * @private
         */
   
     }, {
       key: '_preventDrag',
       value: function _preventDrag(event) {
         event.preventDefault();
       }
   
       /**
         * Prevent body from scrolling when image is being panned
         *
         * @param {object} event
         * @private
         */
   
     }, {
       key: '_preventScroll',
       value: function _preventScroll(event) {
         if (this.panning) {
           event.preventDefault();
         }
       }
   
       /**
         * Get the pointer bounds from the event
         *
         * @param {object} event
         * @private
         */
   
     }, {
       key: '_getPointerBounds',
       value: function _getPointerBounds(event) {
         var pointers = [{
           x: event.pageX ? event.pageX : event.touches[0].clientX,
           y: event.pageY ? event.pageY : event.touches[0].clientY
         }, {
           x: event.targetTouches && event.targetTouches.length > 1 ? event.touches[1].clientX : null,
           y: event.targetTouches && event.targetTouches.length > 1 ? event.touches[1].clientY : null
         }];
   
         return pointers;
       }
   
       /**
         * Create an event and trigger it
         *
         * @param {string} name
         * @private
         */
   
     }, {
       key: '_triggerEvent',
       value: function _triggerEvent(name) {
         var event = new CustomEvent('pixelzoom:' + name, { 'bubbles': true, 'cancelable': false });
         this.container.dispatchEvent(event);
       }
   
       /**
         * Update the image position by adjustng the CSS
         *
         * @private
         */
   
     }, {
       key: '_update',
       value: function _update() {
         var _this3 = this;
   
         requestAnimationFrame(function () {
           _this3.image.style.transform = 'translate(' + _this3.x + 'px, ' + _this3.y + 'px) scale(' + _this3.zoom + ')';
         });
       }
   
       /**
         * Refresh variables
         *
         * @public
         */
   
     }, {
       key: 'refresh',
       value: function refresh() {
         this.containerWidth = this.container.offsetWidth;
         this.containerHeight = this.container.offsetHeight;
         this.imageWidth = Math.min(this.containerWidth, this.image.naturalWidth);
         this.imageHeight = Math.min(this.containerHeight, this.image.naturalHeight);
   
         var maxZoom = Math.floor(this.image.naturalWidth / this.containerWidth);
         this.zoomMax = this.options.maxZoom < maxZoom ? this.options.maxZoom : maxZoom;
         this.zoom = Math.min(this.zoomMax, this.zoom);
         this.zoomSteps = Math.min(this.zoomMax, this.zoomSteps);
   
         if (this.zoomMax <= 1) {
           this.container.style.cursor = 'default';
           this.cursor = 'default';
         }
       }
   
       /**
         * Update the image position by adjustng the CSS
         *
         * @public
         */
   
     }, {
       key: 'unload',
       value: function unload() {
         var _this4 = this;
   
         this.image.removeEventListener('load', this._appendImage);
         document.body.removeEventListener('touchmove', this._preventScroll);
   
         [['mouseenter', this._initializeMouse], ['touchstart', this._initializeTouch], ['mousedown', this._initializeDrag], ['dragstart', this._preventDrag], ['mousemove', this._pan], ['touchmove', this._pan], ['mouseup', this._tap], ['touchend', this._release], ['mouseleave', this._release], ['wheel', this._scroll]].forEach(function (eventType) {
           _this4.container.removeEventListener(eventType[0], eventType[1]);
         });
   
         if (this.image.parentNode) {
           this.image.parentNode.removeChild(this.image);
         }
       }
     }]);
     return Pixelzoom;
   }();
   
   /* harmony default export */ var pixelzoom_dist_index_es = (Pixelzoom);
   
   // CONCATENATED MODULE: ./source/scripts/components/ProductZoom.js
   function ProductZoom_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ProductZoom_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ProductZoom_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductZoom_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductZoom_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var ProductZoom_ProductZoom =
   /*#__PURE__*/
   function () {
     function ProductZoom(options) {
       ProductZoom_classCallCheck(this, ProductZoom);
   
       this.$gallery = options.$gallery;
       this.settings = options.settings;
       this.$slider = this.$gallery.find('[data-product-slider]');
       this.$pixelzoomOverlay = this.$gallery.find('[data-pixelzoom-overlay]');
       this.$pixelzoomOverlayContainer = this.$pixelzoomOverlay.find('[data-pixelzoom-overlay-container]');
       this.imageZoom = {};
       this.zoomOverlay = null;
       this.index = 0;
       this._beforeOpen = this._beforeOpen.bind(this);
       this._onOpen = this._onOpen.bind(this);
       this._onClose = this._onClose.bind(this);
       this._showZoomInstructions = this._showZoomInstructions.bind(this);
       this.modalOpen = false;
       this.swipping = false;
       this.touched = false;
   
       this._bindEvents();
   
       this.enableZoom();
     }
   
     ProductZoom_createClass(ProductZoom, [{
       key: "unload",
       value: function unload() {
         var _this = this;
   
         if (Object.keys(this.imageZoom).length !== 0) {
           Object.keys(this.imageZoom).forEach(function (image) {
             _this.imageZoom[image].unload();
           });
           this.imageZoom = {};
         }
   
         if (this.zoomOverlay) {
           this.zoomOverlay.unload();
           this.zoomOverlay = null;
         }
   
         document.body.removeEventListener('touchmove', function (event) {
           event.preventDefault();
         }, {
           passive: false
         });
         this.$pixelzoomOverlayContainer.off('pixelzoom:pan');
         this.$pixelzoomOverlayContainer.off('pixelzoom:release');
         this.$slider.off('.product-zoom');
       }
     }, {
       key: "enableZoom",
       value: function enableZoom(index) {
         var _this2 = this;
   
         if (Layout.isBreakpoint('XS')) {
           this.unload();
           return;
         }
   
         if (index !== -1 && index || index === 0) {
           this.index = index;
         }
   
         var $newSlide = this.$slider.find("[data-product-image-index=".concat(this.index, "] .product-galley--image-background"));
         var inObject = !this.imageZoom[this.index];
         var slideExists = this.$gallery.find("[data-product-image-index=".concat(this.index, "][data-product-image-zoom]")).length;
   
         if (inObject && slideExists) {
           this.imageZoom[this.index] = //layout.isBreakpoint('XS') ? true :
           new pixelzoom_dist_index_es($newSlide[0], {
             imageSource: $newSlide[0].dataset.image,
             initialZoom: this.settings.image_zoom_level === 'min' ? 1 : 9999,
             zoomSensitivity: 10,
             maxZoom: 9999,
             zoomSteps: 9999,
             naturalPan: true
           });
           $newSlide.on('pixelzoom:loaded', function () {
             _this2._showZoomInstructions($newSlide);
   
             jquery_default()(window).on('resize', function () {
               _this2._showZoomInstructions($newSlide);
             });
           });
           $newSlide.on('pixelzoom:touch', function () {
             var imageWidth = $newSlide.find('.pixelzoom--image').get(0).naturalWidth;
             var imageHeight = $newSlide.find('.pixelzoom--image').get(0).naturalHeight;
   
             if (!Layout.isBreakpoint('XS') && (imageWidth / $newSlide.width() >= 2 || imageHeight / $newSlide.height() >= 2)) {
               _this2._toggleClass(jquery_default()('body'), 'pixelzoom--active');
             }
   
             _this2.touched = true;
           });
           $newSlide.on('pixelzoom:release', function () {
             _this2._toggleClass(jquery_default()('body'), 'pixelzoom--active', true);
   
             _this2.touched = false;
           });
         }
       }
     }, {
       key: "_showZoomInstructions",
       value: function _showZoomInstructions($newSlide) {
         setTimeout(function () {
           if ($newSlide.css('cursor') !== 'default') {
             $newSlide.find('.product-galley--zoom-instructions').css('display', 'block');
           }
         }, 200);
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this3 = this;
   
         this.$slider.on('dragStart.flickity', function (event) {
           _this3._preventClick();
         });
         this.$slider.on('settle.flickity', function (event) {
           _this3._resolveClick();
         });
         document.body.addEventListener('touchmove', function (event) {
           _this3._preventScroll(event);
         }, {
           passive: false
         });
       }
     }, {
       key: "_toggleClass",
       value: function _toggleClass(element, className, remove) {
         if (remove) {
           element.removeClass(className);
         } else {
           element.addClass(className);
         }
       }
     }, {
       key: "_beforeOpen",
       value: function _beforeOpen() {
         var $newSlide = this.$slider.find("[data-product-image-index=".concat(this.index, "] .product-galley--image-background"));
         this.$pixelzoomOverlayContainer.find('[data-rimg]').replaceWith($newSlide.find('[data-rimg]').clone());
       }
     }, {
       key: "_onOpen",
       value: function _onOpen() {
         var _this4 = this;
   
         var $newSlide = this.$slider.find("[data-product-image-index=".concat(this.index, "] .product-galley--image-background"));
         this.modalOpen = true;
         setTimeout(function () {
           _this4.zoomOverlay = new pixelzoom_dist_index_es(document.querySelector('[data-modal-content]'), {
             imageSource: $newSlide[0].dataset.image,
             naturalPan: true,
             dragPan: true,
             initialZoom: _this4.settings.image_zoom_level === 'min' ? 1 : 9999,
             maxZoom: 9999,
             zoomSensitivity: 10,
             zoomSteps: 9999,
             overflowContainer: document.querySelector('.modal--pixelzoom')
           });
           jquery_default()('[data-modal-content]').on('pixelzoom:loaded', function () {
             jquery_default()('[data-modal-content]').addClass('loaded');
           });
           jquery_default()('[data-modal-content]').on('pixelzoom:touch', function () {
             _this4._toggleClass(jquery_default()('body'), 'pixelzoom--active');
           });
           jquery_default()('[data-modal-content]').on('pixelzoom:release', function () {
             _this4._toggleClass(jquery_default()('body'), 'pixelzoom--active', true);
           });
         }, 500);
       }
     }, {
       key: "_onClose",
       value: function _onClose() {
         jquery_default()('[data-modal-content]').removeClass('loaded');
         this.zoomOverlay.unload();
         this.zoomOverlay = null;
         this.modalOpen = false;
       }
     }, {
       key: "_preventScroll",
       value: function _preventScroll(event) {
         if (this.modalOpen || this.touched && !Layout.isBreakpoint('XS')) {
           event.preventDefault();
         }
       }
     }, {
       key: "_preventClick",
       value: function _preventClick() {
         this.swipping = true;
       }
     }, {
       key: "_resolveClick",
       value: function _resolveClick() {
         this.swipping = false;
       }
     }]);
   
     return ProductZoom;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/ProductGallery.js
   function ProductGallery_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ProductGallery_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ProductGallery_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductGallery_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductGallery_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   
   var ProductGallery_ProductGallery =
   /*#__PURE__*/
   function () {
     function ProductGallery(options) {
       ProductGallery_classCallCheck(this, ProductGallery);
   
       this.$gallery = options.$gallery;
       this.settings = options.settings;
       this.isQuickshop = options.isQuickshop || false; // Gallery
   
       this.flickity = null;
       this.slider = '[data-product-slider]';
       this.$slider = this.$gallery.find(this.slider);
       this.slides = '[data-product-image]';
       this.$slides = this.$gallery.find(this.slides);
       this.$sliderPagination = this.$gallery.find('[data-product-slider-pagination]');
       this.$paginationTrigger = this.$gallery.find('[data-product-thumbnail]');
       this.productZoom = null;
   
       if (this.settings.enable_image_zoom) {
         this.productZoom = new ProductZoom_ProductZoom(options);
       }
   
       this.videos = {};
       this.videoSlides = this.$slider[0].querySelectorAll('[data-product-image-video]'); // Re-initialise gallery when crossing breakpoints if needed
   
       this._onUpdateGallery = this._onUpdateGallery.bind(this);
       Layout.onBreakpointChange(this._onUpdateGallery);
       this.slideImageLoaded = this._onSlideImageLoaded.bind(this);
       this.variantChange = this._onVariantChange.bind(this);
   
       if (this.isQuickshop) {
         this.$gallery.trigger('theme:rimg:watch');
       }
   
       this._init();
     }
   
     ProductGallery_createClass(ProductGallery, [{
       key: "unload",
       value: function unload() {
         this.$slider[0].removeEventListener('rimg:load', this.slideImageLoaded);
   
         if (this.productZoom) {
           this.productZoom.unload();
         }
   
         if (this.isQuickshop) {
           this.$gallery.trigger('theme:rimg:unwatch');
         }
   
         if (this.isQuickshop) {
           this._onUpdateGallery();
         }
   
         Layout.offBreakpointChange(this._onUpdateGallery);
   
         this._unloadGallery();
       }
     }, {
       key: "_init",
       value: function _init() {
         this.$slider[0].addEventListener('rimg:load', this.slideImageLoaded);
   
         if (this.videoSlides.length) {
           for (var i = 0; i < this.videoSlides.length; i += 1) {
             var videoSlide = this.videoSlides[i];
             var slideId = videoSlide.getAttribute('data-product-image');
             var videoEl = videoSlide.querySelector('[data-video]');
             this.videos[slideId] = new Video_Video(videoEl);
           }
         }
   
         if (this.$slides.length) {
           this._initGallery();
         }
       }
       /**
        * Make sure Flickity updates viewport height when images load in
        * @private
        */
   
     }, {
       key: "_onSlideImageLoaded",
       value: function _onSlideImageLoaded() {
         resizeFlickityIfNeeded(this.flickity);
       }
     }, {
       key: "_unloadGallery",
       value: function _unloadGallery() {
         if (this.flickity) {
           for (var i = 0; i < this.videos.length; i += 1) {
             this.videos[i].unload();
           }
   
           this.$paginationTrigger.off('.gallery');
           this.flickity.destroy();
           this.flickity = null;
           this.$slider.find(this.slides).attr('style', '');
         }
       }
     }, {
       key: "_onUpdateGallery",
       value: function _onUpdateGallery() {
         /**
           Do not reset the gallery if we are taking an element full-screen.
           This function is called by layout.onBreakpointChange, a side effect 
           of going full-screen with a video. If there is a full-screen element 
           just return out of this function. 
         */
         if (document.fullscreenElement !== null) {
           return;
         }
   
         this._unloadGallery();
   
         this._initGallery();
       }
       /**
        * Update gallery on variant change
        *
        * @param variant
        * @property {Object} options.featured_image - Featured image information
        * @private
        */
   
     }, {
       key: "_onVariantChange",
       value: function _onVariantChange(variant) {
         if (!variant.featured_image || !this.flickity) {
           return;
         }
   
         var index = this.$slider.find("[data-product-image=".concat(variant.featured_image.id, "]")).attr('data-product-image-index');
         this.flickity.select(index, false, false);
       }
     }, {
       key: "_initGallery",
       value: function _initGallery() {
         var $selectedImage = this.$slider.find('.image--selected'); // Options shared on Desktop and Mobile
   
         var flickityOptions = {
           autoPlay: 0,
           accessibility: true,
           adaptiveHeight: true,
           cellAlign: 'left',
           cellSelector: this.slides,
           pageDots: false,
           prevNextButtons: false,
           wrapAround: true
         }; // Mobile only options
   
         var optionsMobile = {
           draggable: true,
           friction: 0.8,
           selectedAttraction: 0.2
         }; // Desktop only options
   
         var optionsDesktop = {
           draggable: false
         };
   
         if (Layout.isBreakpoint('XS')) {
           flickityOptions = jquery_default.a.extend({}, optionsMobile, flickityOptions);
         } else {
           flickityOptions = jquery_default.a.extend({}, optionsDesktop, flickityOptions);
         } // If a variant has an image pre-selected, start the slideshow at that image
         // If the slideshow has been re-initalised across a break point, slideshow
         // restarts at same slide
   
   
         if ($selectedImage.length) {
           var initialIndex = parseInt($selectedImage.attr('data-product-image-index'), 10);
           flickityOptions = jquery_default.a.extend({}, {
             initialIndex: initialIndex
           }, flickityOptions);
         }
   
         this.flickity = new js_default.a(this.$slider[0], flickityOptions);
   
         this._bindGallery();
   
         this._handleGalleryVideos();
       }
     }, {
       key: "_bindGallery",
       value: function _bindGallery() {
         var _this = this;
   
         this.flickity.on('select', function () {
           _this._updateActiveSlide(_this.flickity.selectedIndex);
   
           _this._handleGalleryVideos();
         });
         this.$paginationTrigger.on('click.gallery', function (event) {
           event.preventDefault();
           var $target = jquery_default()(event.currentTarget);
   
           _this.flickity.select($target.attr('data-product-thumbnail'), false, false);
         });
       }
       /**
        * Handle gallery videos
        * - Pause video if is not active slide
        * - Play video if is active slide, and is autoplay
        *
        * @private
        */
   
     }, {
       key: "_handleGalleryVideos",
       value: function _handleGalleryVideos() {
         var _this2 = this;
   
         var slideId = parseInt(this.flickity.selectedElement.getAttribute('data-product-image'), 10);
         Object.keys(this.videos).forEach(function (key) {
           var videoKey = parseInt(key, 10); // Pause inactive slide videos
   
           if (slideId !== videoKey) {
             _this2.videos[videoKey].onPauseClick();
           } // Play video if is selected, and auto play enabled
   
   
           if (slideId === videoKey && _this2.settings.enable_video_autoplay) {
             _this2.videos[videoKey].autoplay();
           }
         });
       }
       /**
        * Adds a non-flickity active class to thumbnails, and main slideshow
        *  - Is used on re-init across breakpoints
        *  - Is used to show the active thumbnail in the pagination
        *
        * @param index
        * @private
        */
   
     }, {
       key: "_updateActiveSlide",
       value: function _updateActiveSlide(index) {
         var $newSlide = this.$slider.find("[data-product-image-index=".concat(index, "]"));
         var $newThumbnail = this.$sliderPagination.find("[data-product-thumbnail=".concat(index, "]"));
         $newSlide.addClass('image--selected').attr('aria-hidden', 'false').siblings('.image--selected').removeClass('image--selected').attr('aria-hidden', 'true');
         $newThumbnail.addClass('thumbnail--selected').siblings('.thumbnail--selected').removeClass('thumbnail--selected');
   
         if (Layout.isBreakpoint('XS')) {
           scrollLeft($newThumbnail);
         }
   
         if (this.settings.enable_image_zoom) {
           this.productZoom.enableZoom(index);
         }
       }
     }]);
   
     return ProductGallery;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/ProductDetails.js
   function ProductDetails_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ProductDetails_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ProductDetails_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductDetails_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductDetails_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   
   var ProductDetails_ProductDetails =
   /*#__PURE__*/
   function () {
     function ProductDetails(options) {
       ProductDetails_classCallCheck(this, ProductDetails);
   
       this.$window = jquery_default()(window);
       this.$formArea = options.$formArea;
       this.$gallery = options.$gallery;
       this.$details = options.$details;
       this.context = options.context;
       this.settings = options.settings;
       this.product = options.product;
       this.useHistory = options.useHistory;
       this.variantHelper = null;
       this.atcCallbacks = options.atcCallbacks; // Form
   
       this.$form = this.$formArea.find('[data-product-form]');
       this.$productAtcButton = this.$formArea.find('[data-product-atc]');
       this.$productVariants = this.$form.find('[data-variants]');
       this.$productOptions = this.$form.find('[data-product-option]');
       this.variantFields = {
         $price: this.$details.find('[data-price]'),
         $priceMoney: this.$details.find('[data-price] .money'),
         $compareAtPrice: this.$details.find('[data-price-compare-at]'),
         $compareAtPriceMoney: this.$details.find('[data-price-compare-at] .money'),
         $badge: this.$details.find('[data-badge-sales]'),
         $badgeMoneySaved: this.$details.find('[data-price-money-saved]'),
         $badgePercentSaved: this.$details.find('[data-price-percent-saved]'),
         $sku: this.$details.find('[data-product-sku]'),
         $upc: this.$details.find('[data-product-upc]')
       };
       this.forms = new Forms_Forms(this.$form);
       this.gallery = new ProductGallery_ProductGallery(options);
   
       this._bindEvents();
   
       this._initOptions();
     }
   
     ProductDetails_createClass(ProductDetails, [{
       key: "unload",
       value: function unload() {
         this.$form.off('.product-details');
         this.forms.unload();
   
         if (this.variantHelper) {
           this.variantHelper.unload();
         }
   
         this.gallery.unload();
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this = this;
   
         this.$window.on('product-variant-switch.product-details', function (event, data) {
           return _this._switchVariant(event, data);
         });
         this.$form.on('submit.product-details', function (event) {
           if($('input[name="recharge_options"]:checked').val() != 'subscription') {
             // DBNY - Stopping automatic adding to cart if subscription
             return _this._AddToCartFlyout(event);
           }
         });
       }
     }, {
       key: "_initOptions",
       value: function _initOptions() {
         if (!this.$productVariants.length) return;
         this.variantHelper = new VariantHelper_VariantHelper(this.product, this.$productVariants, this.$productOptions);
       }
     }, {
       key: "_switchVariant",
       value: function _switchVariant(event, data) {
         if (data.product !== this.product) return;
         var variant = data.variant;
         var firstLoad = data.firstLoad;
   
         if (firstLoad) {
           return;
         } // Update main select
   
   
         this.$productVariants.val(data.variant.id);
         this.gallery.variantChange(variant); // Update Variant information
   
         this._updatePrice(variant);
   
         this._updateSKU(variant);
         
         this._updateUPC(variant);
   
         this._updateBadge(variant);
   
         this._updateButton(variant);
   
         if (this.useHistory) {
           var url = "".concat(this.product.handle, "?").concat(jquery_default.a.param({
             variant: variant.id
           }));
           history.replaceState({}, 'variant', url);
         }
       }
     }, {
       key: "_updatePrice",
       value: function _updatePrice(variant) {
         // Update compare at price
         var hasComparePrice = !!variant.compare_at_price && variant.compare_at_price > variant.price;
         this.variantFields.$compareAtPrice.toggleClass('visible', hasComparePrice);
         this.variantFields.$compareAtPriceMoney.text(Shopify.formatMoney(variant.compare_at_price, this.settings.money_format));
         shopify_currency_converter_dist_default.a.update(this.variantFields.$compareAtPriceMoney[0]); // Update price
   
         this.variantFields.$priceMoney.text(Shopify.formatMoney(variant.price, this.settings.money_format));
         shopify_currency_converter_dist_default.a.update(this.variantFields.$priceMoney[0]);
       }
     }, {
       key: "_updateUPC",
       value: function _updateUPC(variant) {
         if (variant.barcode === null || variant.barcode === 'None') {
           this.variantFields.$upc.parent().addClass('product-upc--empty');
         } else {
           this.variantFields.$upc.parent().removeClass('product-upc--empty');
         }
             this.variantFields.$upc.text(variant.barcode);
       }
     }, {
       key: "_updateSKU",
       value: function _updateSKU(variant) {
         if (variant.sku === '') {
           this.variantFields.$sku.parent().addClass('product-sku--empty');
         } else {
           this.variantFields.$sku.parent().removeClass('product-sku--empty');
         }
   
         this.variantFields.$sku.text(variant.sku);
       }
     }, {
       key: "_updateBadge",
       value: function _updateBadge(variant) {
         var priceSaved = variant.compare_at_price ? variant.compare_at_price - variant.price : 0;
         this.variantFields.$badge.toggle(!!priceSaved);
   
         if (this.variantFields.$badgeMoneySaved.length) {
           // Update badge if it shows money saved
           this.variantFields.$badgeMoneySaved.text(Shopify.formatMoney(priceSaved, this.settings.money_format));
           shopify_currency_converter_dist_default.a.update(this.variantFields.$badgeMoneySaved[0]);
         }
   
         if (this.variantFields.$badgePercentSaved.length) {
           // Update badge if it shows percentiles
           var percentileSaved = Math.round(priceSaved * 100 / variant.compare_at_price);
           this.variantFields.$badgePercentSaved.text(percentileSaved);
         }
       }
     }, {
       key: "_updateButton",
       value: function _updateButton(variant) {
         if (variant.available) {
           this.$productAtcButton.text(this.context.product_available);
           this.$productAtcButton.removeClass('disabled').prop('disabled', false);
         } else {
           this.$productAtcButton.text(this.context.product_unavailable);
           this.$productAtcButton.addClass('disabled').prop('disabled', true);
         }
       }
     }, {
       key: "_AddToCartFlyout",
       value: function _AddToCartFlyout(event) {
         event.preventDefault();
         var formData = this.$form.serializeArray();
         var options = {
           $atcButton: this.$productAtcButton,
           settings: {
             moneyFormat: this.settings.money_format,
             cartRedirection: this.settings.cart_redirection
           }
         };
         components_AddToCartFlyout.init(formData, options, this.atcCallbacks);
       }
     }]);
   
     return ProductDetails;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/helpers/ProductReviews.js
   var initShopifyProductReviews = function initShopifyProductReviews() {
     if (!window.SPR) {
       return;
     }
   
     window.SPR.registerCallbacks();
     window.SPR.initRatingHandler();
     window.SPR.initDomEls();
     window.SPR.loadProducts();
     window.SPR.loadBadges();
   };
   /* harmony default export */ var ProductReviews = ({
     initShopifyProductReviews: initShopifyProductReviews
   });
   // CONCATENATED MODULE: ./source/scripts/components/ProductQuickshop.js
   function ProductQuickshop_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ProductQuickshop_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ProductQuickshop_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductQuickshop_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductQuickshop_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   var ProductQuickshop_ProductQuickshop =
   /*#__PURE__*/
   function () {
     function ProductQuickshop(options) {
       ProductQuickshop_classCallCheck(this, ProductQuickshop);
   
       this.$el = options.$el;
       this.$quickShop = this.$el.find('[data-product-quickshop]');
       this.id = options.id;
       this.modalClass = options.modalClass;
       this.loaded = false;
       this.richText = null;
       this.productDetails = null;
       this.quickShopHTML = null;
       this.trigger = options.trigger;
       this.openingAddToCart = false;
   
       try {
         this.data = JSON.parse(this.$el.find('[data-product-quickshop-data]').text());
       } catch (error) {
         return console.warn("Quickshop: invalid quickshop data found. ".concat(error.message));
       }
   
       try {
         this.quickShopHTML = JSON.parse(this.$el.find('[data-product-quickshop-html]').text());
       } catch (error) {
         return console.warn("Quickshop: invalid quickshop html found. ".concat(error.message));
       }
   
       if (!this.$quickShop[0].hasAttribute('data-loaded')) {
         this.$quickShop.append(this.quickShopHTML);
         this.$quickShop.attr('data-loaded', true);
         this.$quickShop.find('.money').each(function (index, el) {
           return shopify_currency_converter_dist_default.a.update(el);
         });
         initShopifyProductReviews();
       }
   
       this._initialize();
   
       if (window.Shopify && Shopify.PaymentButton) {
         Shopify.PaymentButton.init();
       }
     }
   
     ProductQuickshop_createClass(ProductQuickshop, [{
       key: "_initialize",
       value: function _initialize() {
         this.$message = this.$el.find('[data-product-quickshop-message]');
         this.$formArea = this.$el.find('[data-product-form-area]');
         this.$gallery = this.$el.find('[data-product-gallery]');
         this.$details = this.$el.find('[data-product-details]');
         this.$description = this.$el.find('[data-product-description]');
         this.context = this.data.context;
         this.settings = this.data.settings;
         this.product = this.data.product;
         this._open = this._open.bind(this);
         this._close = this._close.bind(this);
         this._onATCInit = this._onATCInit.bind(this);
         this._onATCError = this._onATCError.bind(this);
         this._onATCSuccess = this._onATCSuccess.bind(this);
         this._onATCClose = this._onATCClose.bind(this);
         var modalCallbacks = {
           onOpen: this._open,
           onClose: this._close
         };
         this.atcCallbacks = {
           onInit: this._onATCInit,
           onError: this._onATCError,
           onSuccess: this._onATCSuccess,
           onClose: this._onATCClose
         };
         this.modal = new Modal_Modal(modalCallbacks);
         this.modal.open("#shopify-section-".concat(this.id, " [data-product-quickshop=\"").concat(this.product.id, "\"]"), this.modalClass, this.trigger);
       }
     }, {
       key: "_open",
       value: function _open() {
         if (this.loaded) {
           return;
         }
   
         if (this.$description.length) {
           this.richText = new RichText_RichText(this.$description);
         }
   
         var options = {
           $formArea: this.$formArea,
           $gallery: this.$gallery,
           $details: this.$details,
           atcCallbacks: this.atcCallbacks,
           context: this.context,
           settings: this.settings,
           product: this.product,
           useHistory: false,
           isQuickshop: true
         };
         this.productDetails = new ProductDetails_ProductDetails(options);
       }
     }, {
       key: "_close",
       value: function _close() {
         if (this.productDetails) {
           this.productDetails.unload();
         }
   
         if (this.richText) {
           this.richText.unload();
         }
   
         if (!this.openingAddToCart) {
           this.trigger.focus();
         }
   
         this._toggleMessage('', false);
   
         this.modal.unload();
       }
     }, {
       key: "_toggleMessage",
       value: function _toggleMessage(message, isVisible) {
         this.$message.html(message).toggleClass('visible', isVisible);
       }
     }, {
       key: "_onATCInit",
       value: function _onATCInit() {
         this.openingAddToCart = true;
         this.$message.removeClass('visible');
       }
     }, {
       key: "_onATCError",
       value: function _onATCError(error) {
         var $content = jquery_default()("<div class=\"product-message--error\" tabindex=\"-1\">".concat(error, "</div>"));
   
         this._toggleMessage($content, true);
   
         $content.focus();
       }
     }, {
       key: "_onATCSuccess",
       value: function _onATCSuccess() {
         this._close();
       }
     }, {
       key: "_onATCClose",
       value: function _onATCClose() {
         this.trigger.focus();
       }
     }, {
       key: "unload",
       value: function unload() {
         this._close();
       }
     }]);
   
     return ProductQuickshop;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/ProductGridItem.js
   function ProductGridItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ProductGridItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ProductGridItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductGridItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductGridItem_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   var ProductGridItem_ProductGridItem =
   /*#__PURE__*/
   function () {
     function ProductGridItem(options) {
       var _this = this;
   
       ProductGridItem_classCallCheck(this, ProductGridItem);
   
       this.$el = jquery_default()(options.el);
       this.id = options.id;
       this.productQuickshop = null;
       this.quickBuySettings = null;
       this.events = [];
       this.actionsOpen = false;
       this.$window = jquery_default()(window);
       this.$html = jquery_default()('html');
       this.$content = this.$el.find('[data-product-item-content]');
       this.$actions = this.$el.find('[data-product-actions]');
       this.hasProductActions = this.$actions.length;
       this._addToCart = this._addToCart.bind(this);
       this._actionsToggle = this._actionsToggle.bind(this);
       this._openQuickShop = this._openQuickShop.bind(this);
   
       if (this.hasProductActions) {
         this._setSortByQueryParameters();
   
         if (this.$html.hasClass('no-touch') && Shopify.queryParams.grid_list !== 'list-view') {
           this.events.push(this.$el.on('mouseenter.product-item', this._actionsToggle));
           this.events.push(this.$el.on('mouseleave.product-item', this._actionsToggle));
           this.events.push(this.$el.on('focusin.product-item', this._actionsToggle));
         } // $scripts checks existence of script in header before attempting to inject
   
   
         script_default()(jquery_default()('[data-scripts]').data('shopify-api-url'), function () {
           _this.events.push(_this.$el.on('click.product-item', '[data-quick-buy]', _this._addToCart));
   
           _this.events.push(_this.$el.on('click.product-item', '[data-quickshop-slim]', _this._openQuickShop));
   
           _this.events.push(_this.$el.on('click.product-item', '[data-quickshop-full]', _this._openQuickShop));
         });
       }
   
       if (this.$el.find('[data-quick-buy]').length) {
         this._initQuickBuy();
       }
   
       this._objectFitPolyfill();
     }
     /**
      * Make Shopify aware of releavent collection search info
      *  - tag
      *  - vendor
      *  - pagination
      *  - sorting criteria
      *
      * @private
      */
   
   
     ProductGridItem_createClass(ProductGridItem, [{
       key: "_setSortByQueryParameters",
       value: function _setSortByQueryParameters() {
         Shopify.queryParams = {};
   
         if (location.search.length) {
           for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
             var aKeyValue = aCouples[i].split('='); // Reset the page number when we apply (i.e. don't add it to params)
   
             if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
               Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
             }
           }
         }
       }
     }, {
       key: "_initQuickBuy",
       value: function _initQuickBuy() {
         try {
           this.quickBuySettings = JSON.parse(this.$el.find('[data-quick-buy-settings]').text());
         } catch (error) {
           return console.warn("Quick buy: invalid QuickBuy data found. ".concat(error.message));
         }
       }
     }, {
       key: "_openQuickShop",
       value: function _openQuickShop(event) {
         event.preventDefault();
         var modalClass = event.currentTarget.hasAttribute('data-quickshop-full') ? 'quickshop-full' : 'quickshop-slim';
   
         if (this.productQuickshop) {
           this.productQuickshop.unload();
         }
   
         this.productQuickshop = new ProductQuickshop_ProductQuickshop({
           $el: this.$el,
           id: this.id,
           modalClass: modalClass,
           trigger: this.$el.find('.productitem--title a')
         });
       }
     }, {
       key: "_isObjectFitAvailable",
       value: function _isObjectFitAvailable() {
         return 'objectFit' in document.documentElement.style;
       }
     }, {
       key: "_objectFitPolyfill",
       value: function _objectFitPolyfill() {
         if (this._isObjectFitAvailable()) {
           return;
         }
   
         var $figure = jquery_default()('[data-product-item-image]', this.$el);
         var featuredSrc = jquery_default()('img:not(.productitem--image-alternate)', $figure).attr('src');
         var alternateSrc = jquery_default()('.productitem--image-alternate', $figure).attr('src');
         $figure.addClass('product-item-image-no-objectfit');
         $figure.css('background-image', "url(\"".concat(featuredSrc, "\")"));
   
         if (alternateSrc) {
           this.$el.on("mouseover", function () {
             $figure.css('background-image', "url(\"".concat(alternateSrc, "\")"));
           });
           this.$el.on("mouseleave", function () {
             $figure.css('background-image', "url(\"".concat(featuredSrc, "\")"));
           });
         }
       }
       /**
        * Get height of element, and combined height of element + actions
        *
        * @returns {{heightBase, heightExpanded: *}}
        * @private
        */
   
     }, {
       key: "_getHeights",
       value: function _getHeights() {
         var height = this.$el.height();
         var actionsHeight = this.$el.find('[data-product-actions]').outerHeight(true);
         return {
           heightBase: height,
           heightExpanded: height + actionsHeight
         };
       }
     }, {
       key: "_actionsToggle",
       value: function _actionsToggle(event) {
         if (!Layout.isBreakpoint('L')) return;
         var $currentTarget = jquery_default()(event.currentTarget);
         var $target = jquery_default()(event.target);
         var openProductItem = false; // This function gets called on the element as well as the document focusin, so we want to
         // be extra careful that we are inside the product card in question. We want the product card
         // to close if another product card has received focus.
   
         var productHasFocus = this.$el.is($currentTarget) || this.$el.is($target) || this.$el.is($target.parents('.productgrid--item').first());
   
         if (event.type === 'mouseenter' || event.type === 'mouseleave') {
           openProductItem = event.type === 'mouseenter';
         } else if (productHasFocus) {
           openProductItem = true;
         }
   
         if (openProductItem) {
           this._showActions();
         } else {
           this._hideActions();
         }
       }
     }, {
       key: "_showActions",
       value: function _showActions() {
         var _this2 = this;
   
         if (this.actionsOpen) {
           return;
         }
   
         var _this$_getHeights = this._getHeights(),
             heightBase = _this$_getHeights.heightBase,
             heightExpanded = _this$_getHeights.heightExpanded; // Lock heights to prevent jumping
   
   
         this.$el.css('height', heightBase);
         this.$content.css('height', heightBase); // Store height for when hovering out
   
         this.$el.data('base-height', heightBase); // Start animation, and transition height to expanded height
   
         this.$el.revealer('show').one('revealer-animating.product-item', function () {
           _this2.$content.css('height', heightExpanded);
         });
         document.addEventListener('focusin', this._actionsToggle);
         this.actionsOpen = true;
       }
     }, {
       key: "_hideActions",
       value: function _hideActions() {
         var _this3 = this;
   
         var height = this.$el.data('base-height');
         /*
           - Transition buttons up, using base height for animation
           - Remove heights after animation is complete in case of resize
          */
   
         this.$el.revealer('hide').one('revealer-animating', function () {
           _this3.$el.off('revealer-animating.product-item');
   
           _this3.$el.css({
             height: height
           });
   
           _this3.$content.css({
             height: height
           });
         }).one('revealer-hide', function () {
           _this3.$el.off('revealer-hide.product-item').css('height', '');
   
           _this3.$content.css('height', '');
         });
         document.removeEventListener('focusin', this._actionsToggle);
         this.actionsOpen = false;
       }
     }, {
       key: "_addToCart",
       value: function _addToCart(event) {
         event.preventDefault();
         var $atcButton = jquery_default()(event.currentTarget);
         var variantID = $atcButton.attr('data-variant-id');
         var formData = [{
           'name': 'id',
           'value': variantID
         }, {
           'name': 'quantity',
           'value': 1
         }];
         var options = {
           $atcButton: $atcButton,
           settings: {
             moneyFormat: this.quickBuySettings.money_format,
             cartRedirection: this.quickBuySettings.cart_redirection
           }
         };
         components_AddToCartFlyout.init(formData, options);
       }
     }, {
       key: "unload",
       value: function unload() {
         this.events.forEach(function ($el) {
           return $el.off('.product-item');
         });
   
         if (this.productQuickshop) {
           this.productQuickshop.unload();
         }
   
         document.removeEventListener('focusin', this._actionsToggle);
       }
     }]);
   
     return ProductGridItem;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticCollection.js
   function StaticCollection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticCollection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticCollection_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticCollection_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticCollection_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var StaticCollection_StaticCollection =
   /*#__PURE__*/
   function () {
     function StaticCollection(section) {
       var _this = this;
   
       StaticCollection_classCallCheck(this, StaticCollection);
   
       this.section = section;
       this.$el = jquery_default()(section.el);
       this.context = section.data.context;
       this.collectionUrl = this.context.collectionUrl;
       this.$focusItem = null;
       this.filtersContentSelector = '[data-productgrid-filters-content]';
       this.sortContent = '[data-productgrid-sort-content]';
       this.$sortTrigger = this.$el.find('[data-productgrid-trigger-sort]');
       this.$sortTriggerButton = this.$el.find('[data-productgrid-trigger-sort-button]');
       this.$sortTriggerModal = this.$el.find('[data-productgrid-modal-sort]');
       this.$filtersTrigger = this.$el.find('[data-productgrid-trigger-filters]');
       this.$filtersContent = this.$el.find(this.filtersContentSelector);
       this.$allTags = this.$filtersContent.find('.filter-item a:not([data-filter-toggle])');
       this.$advandedTags = this.$el.find('[data-tag-advanced] a');
       this.$additionalTags = this.$el.find('[data-filter-toggle]');
       this.$viewToggle = this.$el.find('[data-collection-view]');
       this.$gridContainer = this.$el.find('.productgrid--outer');
       this._changeSorting = this._changeSorting.bind(this);
       this._changeSortingButton = this._changeSortingButton.bind(this);
       this._showSortModal = this._showSortModal.bind(this);
       this._showFiltersModal = this._showFiltersModal.bind(this);
       this._activateTag = this._activateTag.bind(this);
       this._advancedTags = this._advancedTags.bind(this);
       this._toggleTags = this._toggleTags.bind(this);
       this._toggleView = this._toggleView.bind(this);
       this._checkListView = this._checkListView.bind(this);
       this.events = [this.$sortTrigger.on('change.collection', this._changeSorting), this.$sortTriggerButton.on('click.collection', this._changeSortingButton), this.$sortTriggerModal.on('click.collection', this._showSortModal), this.$filtersTrigger.on('click.collection', this._showFiltersModal), this.$advandedTags.on('click.collection', this._advancedTags), this.$allTags.on('click.collection', this._activateTag), this.$additionalTags.on('click.collection', this._toggleTags), this.$viewToggle.on('click.collection', this._toggleView)]; // Product items
   
       this.productItems = [];
       var $productItems = this.$el.find('[data-product-item]');
       $productItems.each(function (i, productItem) {
         _this.productItems.push(new ProductGridItem_ProductGridItem({
           el: productItem,
           id: _this.section.id
         }));
       });
   
       this._setSortByQueryParameters();
   
       this._checkListView();
   
       this._updatePrices();
   
       this.modal = new Modal_Modal();
     }
   
     StaticCollection_createClass(StaticCollection, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.events.forEach(function ($el) {
           return $el.off('.collection');
         });
         this.modal.unload();
         this.productItems.forEach(function (productItem) {
           productItem.unload();
         });
       }
       /**
        * Set product grid prices to match CurrencyConverter settings on page load, section re-load
        *
        * @private
        */
   
     }, {
       key: "_updatePrices",
       value: function _updatePrices() {
         this.$el.find('.money').each(function (index, el) {
           return shopify_currency_converter_dist_default.a.update(el);
         });
       }
       /**
        * Open Tags/Filters modal (on mobile)
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_showFiltersModal",
       value: function _showFiltersModal(event) {
         event.preventDefault();
         this.$focusItem = jquery_default()(event.currentTarget);
         this.modal.open(this.filtersContentSelector, 'productgrid-filters');
       }
       /**
        * Open Sort by modal (on mobile)
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_showSortModal",
       value: function _showSortModal(event) {
         event.preventDefault();
         this.$focusItem = jquery_default()(event.currentTarget);
         this.modal.open(this.sortContent, 'productgrid-sort');
       }
       /**
        * Style a tag as active after click, before page transition
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_activateTag",
       value: function _activateTag(event) {
         jquery_default()(event.target).closest('.filter-item').toggleClass('filter-item--active').toggleClass('filter-item--inactive');
       }
       /**
        * Used by advanced tags to concatenate tag searches
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_advancedTags",
       value: function _advancedTags(event) {
         event.preventDefault();
         var $target = jquery_default()(event.currentTarget).parent();
         var targetGroup = $target.attr('data-group');
         var $filtersContent = $target.closest('nav');
         var filterGroups = $filtersContent.find('[data-filter-group]');
         var filterHandles = []; // Build the filter for the url based on what is in the dom
   
         filterGroups.each(function (index, filterGroup) {
           if (filterGroup.getAttribute('data-filter-group') === targetGroup) {
             if (!$target.hasClass('filter-item--active')) {
               $target.siblings().removeClass('filter-item--active').addClass('filter-item--inactive');
               filterHandles.push($target.data('handle'));
             } // The active class is removed from the target in _activateTag
   
           } else {
             var selectedItems = filterGroup.querySelectorAll('.filter-item--active');
   
             if (selectedItems.length) {
               filterHandles.push(jquery_default()(selectedItems).data('handle'));
             }
           }
         });
         location.href = "".concat(this.collectionUrl, "/").concat(filterHandles.join('+'));
       }
       /**
        * Expand / Collapse additional tags in the sidebar
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_toggleTags",
       value: function _toggleTags(event) {
         event.preventDefault();
         var $trigger = jquery_default()(event.currentTarget);
         var $items = $trigger.parent().siblings('[data-hidden-default]');
         var siblingsVisible = $trigger.data('filter-toggle');
         $items.toggleClass('filter-item--hidden', siblingsVisible);
         $trigger.data('filter-toggle', !siblingsVisible).text(!siblingsVisible ? this.context.see_less : this.context.see_more);
   
         if (this.modal.isOpen()) {
           this.modal.position();
         }
       }
       /**
        * Make Shopify aware of releavent collection search info
        *  - tag
        *  - vendor
        *  - pagination
        *  - sorting criteria
        *
        * @private
        */
   
     }, {
       key: "_setSortByQueryParameters",
       value: function _setSortByQueryParameters() {
         Shopify.queryParams = {};
   
         if (location.search.length) {
           for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
             var aKeyValue = aCouples[i].split('='); // Reset the page number when we apply (i.e. don't add it to params)
   
             if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
               Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
             }
           }
         }
       }
       /**
        * Sort by opens a modal on mobile, this handles button events
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_changeSortingButton",
       value: function _changeSortingButton(event) {
         var activeClass = 'utils-sortby--modal-button--active';
         jquery_default()(event.currentTarget).addClass(activeClass).parent().siblings().find(".".concat(activeClass)).removeClass(activeClass);
   
         this._changeSorting(event);
       }
       /**
        * Change sorting of collection
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_changeSorting",
       value: function _changeSorting(event) {
         event.preventDefault();
         var $target = jquery_default()(event.currentTarget);
         Shopify.queryParams.sort_by = $target.val();
         location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
       }
       /**
        * Toggle grid or list view
        *
        */
   
     }, {
       key: "_toggleView",
       value: function _toggleView(event) {
         var $target = jquery_default()(event.currentTarget);
         Shopify.queryParams.grid_list = $target.data('collection-view');
         location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
       }
       /**
        * Check grid/list view toggle query parameters
        *
        */
   
     }, {
       key: "_checkListView",
       value: function _checkListView() {
         var view = Shopify.queryParams.grid_list ? Shopify.queryParams.grid_list : 'grid-view';
         this.$el.find('[href*="&grid_list"]').attr('href', function (i, href) {
           if (href.indexOf('?') < 0) {
             var replaceIndex = href.indexOf('&');
             var firstHalf = href.substr(0, replaceIndex);
             var secondHalf = href.substr(replaceIndex + 1);
             href = firstHalf.concat('?', secondHalf);
           }
   
           href = href.replace('grid_list', "grid_list=".concat(view));
           return href;
         });
         this.$el.find('.utils-viewtoggle-button').removeClass('active');
         jquery_default()("[data-collection-view=".concat(view, "]")).addClass('active');
         var className = view.replace('-', '');
         this.$gridContainer.addClass("productgrid-".concat(className));
       }
     }]);
   
     return StaticCollection;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticPassword.js
   function StaticPassword_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticPassword_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticPassword_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticPassword_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticPassword_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var StaticPassword_StaticPassword =
   /*#__PURE__*/
   function () {
     function StaticPassword(section) {
       StaticPassword_classCallCheck(this, StaticPassword);
   
       this.$el = jquery_default()(section.el);
       this.modalForms = null;
       this.newsletterForm = null;
       this.modalContents = '[data-passwordentry]';
       this.$newsletterForm = this.$el.find('[data-password-newsletter]');
       this.modalOpen = this.onModalOpen.bind(this);
       this.modalClose = this.onModalClose.bind(this);
       this._openModal = this._openModal.bind(this);
       this.modal = new Modal_Modal({
         onOpen: this.modalOpen,
         onClose: this.modalClose
       });
   
       if (this.$newsletterForm) {
         this.newsletterForm = new Forms_Forms(this.$newsletterForm);
       }
   
       this._checkForPasswordAttempt();
   
       this._bindEvents();
     }
   
     StaticPassword_createClass(StaticPassword, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.$el.off('.static-password');
   
         if (this.newsletterForm) {
           this.newsletterForm.unload();
         }
   
         if (this.modalForms) {
           this.modalForms.unload();
         }
       }
     }, {
       key: "onModalOpen",
       value: function onModalOpen() {
         var $contents = jquery_default()('[data-passwordentry-contents]');
         this.modalForms = new Forms_Forms($contents);
       }
     }, {
       key: "onModalClose",
       value: function onModalClose() {
         this.modalForms.unload();
         this.modalForms = null;
       }
     }, {
       key: "_bindEvents",
       value: function _bindEvents() {
         this.$el.on('click.static-password', '[data-passwordentry-toggle]', this._openModal);
       }
     }, {
       key: "_openModal",
       value: function _openModal() {
         this.modal.open(this.modalContents, 'passwordentry');
       }
     }, {
       key: "_checkForPasswordAttempt",
       value: function _checkForPasswordAttempt() {
         if (!jquery_default()('[data-passwordentry-errors]').length) {
           return;
         }
   
         this._openModal();
       }
     }]);
   
     return StaticPassword;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticProduct.js
   function StaticProduct_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticProduct_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticProduct_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticProduct_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticProduct_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   
   var StaticProduct_StaticProduct =
   /*#__PURE__*/
   function () {
     function StaticProduct(section) {
       var _this = this;
   
       StaticProduct_classCallCheck(this, StaticProduct);
   
       this.section = section;
       this.postMessage = section.postMessage;
       this.context = section.data.context;
       this.settings = section.data.settings;
       this.product = section.data.product;
       this.richText = null;
       this.reviewForm = null;
       this.flickity = null;
       this.flickityOptions = null;
       this.$el = jquery_default()(section.el);
       this.$product = this.$el.find('[data-product-wrapper]');
   
       if (this.settings) {
         this.isThreeColumn = this.settings.layout === 'layout--three-col';
       } // History
   
   
       this.isThemeEditor = window.Shopify && window.Shopify.designMode;
       this.useHistory = !this.isThemeEditor && history.replaceState;
       this.$gallery = this.$product.find('[data-product-gallery]'); // Product details
   
       this.$details = this.$product.find('[data-product-details]'); // Product description
   
       this.$description = this.$product.find('[data-product-description]'); // Product form containers
   
       this.$formRegular = this.$product.find('[data-product-form-regular]');
       this.$formAlt = this.$product.find('[data-product-form-alt]'); // Product form area
   
       this.$formArea = this.$product.find('[data-product-form-area]'); // Move product form and information on breakpoint change
   
       this.layoutHandler = this.onBreakpointChange.bind(this);
       Layout.onBreakpointChange(this.layoutHandler); // Product reviews
   
       this.$productReviews = this.$el.find('[data-product-reviews]');
   
       this._moveForm();
   
       if (this.$description.length) {
         this.richText = new RichText_RichText(this.$description);
       }
   
       if (this.$productReviews.length) {
         this.reviewForm = new Forms_Forms(this.$productReviews, '.spr-form-input');
       } // Instantiate ProductDetails after Shopify API is loaded
   
   
       script_default()(jquery_default()('[data-scripts]').data('shopify-api-url'), function () {
         var options = {
           $formArea: _this.$formArea,
           $gallery: _this.$gallery,
           $details: _this.$details,
           context: _this.context,
           settings: _this.settings,
           product: _this.product,
           useHistory: _this.useHistory
         };
         _this.productDetails = new ProductDetails_ProductDetails(options);
       });
     }
   
     StaticProduct_createClass(StaticProduct, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         Layout.offBreakpointChange(this.layoutHandler);
         this.productDetails.unload();
   
         if (this.richText) {
           this.richText.unload();
         }
   
         if (this.reviewForm) {
           this.reviewForm.unload();
         }
       }
     }, {
       key: "onBreakpointChange",
       value: function onBreakpointChange() {
         this._moveForm();
       }
       /**
        * Move product form if is a three column layout
        * @private
        */
   
     }, {
       key: "_moveForm",
       value: function _moveForm() {
         if (!this.isThreeColumn) return;
   
         if (Layout.isBreakpoint('L')) {
           if (!jquery_default.a.contains(this.$formAlt[0], this.$formArea[0])) {
             var $form = this.$formArea.detach();
             this.$formAlt.append($form);
           }
         } else {
           if (!jquery_default.a.contains(this.$formRegular[0], this.$formArea[0])) {
             var _$form = this.$formArea.detach();
   
             this.$formRegular.append(_$form);
           }
         }
       }
     }]);
   
     return StaticProduct;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/ProductRowScroller.js
   function ProductRowScroller_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ProductRowScroller_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ProductRowScroller_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductRowScroller_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductRowScroller_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var ProductRowScroller_ProductRowScroller =
   /*#__PURE__*/
   function () {
     function ProductRowScroller(productRow) {
       ProductRowScroller_classCallCheck(this, ProductRowScroller);
   
       this.$window = $(window);
       this.flickity = null;
       this.productRow = productRow;
       this.$productRow = $(this.productRow); // Activate flickity on mobile
   
       this._mobileSlider = this._mobileSlider.bind(this);
       Layout.onBreakpointChange(this._mobileSlider);
   
       this._mobileSlider();
     }
   
     ProductRowScroller_createClass(ProductRowScroller, [{
       key: "unload",
       value: function unload() {
         Layout.offBreakpointChange(this._mobileSlider);
   
         this._destroyFlickity();
       }
     }, {
       key: "_initFlickity",
       value: function _initFlickity() {
         this.flickity = new js_default.a(this.productRow, {
           cellSelector: '.productgrid--item',
           contain: true,
           freeScroll: true,
           percentPosition: false,
           prevNextButtons: false,
           pageDots: false,
           setGallerySize: false
         });
   
         this._bindSlider();
       }
     }, {
       key: "_destroyFlickity",
       value: function _destroyFlickity() {
         if (!this.flickity) {
           return;
         }
   
         this.$window.off('.product-row');
         this.$productRow.off('.product-row');
         this.flickity.destroy();
         this.flickity = null;
       }
     }, {
       key: "_mobileSlider",
       value: function _mobileSlider() {
         // If is Large layout, attempt to destroy flickity
         if (Layout.isBreakpoint('L')) {
           this._destroyFlickity();
   
           return;
         } // Is XS/S/M, and flickity is init'd -- do nothing
   
   
         if (this.flickity) {
           return;
         } // Is XS/S/M, and flickity is not init'd
   
   
         this._initFlickity();
       }
     }, {
       key: "_bindSlider",
       value: function _bindSlider() {
         var _this = this;
   
         var $slider = this.$productRow.find('.flickity-slider');
         this.$window.on('resize.product-row', just_debounce_default()(function () {
           _this.$productRow.trigger('heightUpdate.product-row');
         }));
         this.flickity.on('cellSelect', function () {
           _this.$productRow.trigger('heightUpdate.product-row');
         });
         this.$productRow.on('heightUpdate.product-row', function () {
           if (!_this.flickity) {
             return;
           }
   
           $slider.height(Math.ceil(_this.flickity.maxCellHeight));
         }); // Sets the Slider to the height of the first slide
   
         this.$productRow.trigger('heightUpdate.product-row');
       }
     }]);
   
     return ProductRowScroller;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticProductRecommendations.js
   function StaticProductRecommendations_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticProductRecommendations_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticProductRecommendations_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticProductRecommendations_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticProductRecommendations_defineProperties(Constructor, staticProps); return Constructor; }
   
    // eslint-disable-line
   
   
   
   
   
   
   
   var StaticProductRecommendations_StaticProductRecommendations =
   /*#__PURE__*/
   function () {
     function StaticProductRecommendations(section) {
       StaticProductRecommendations_classCallCheck(this, StaticProductRecommendations);
   
       this.section = section;
       this.productId = section.data.productId;
       this.limit = section.data.settings.limit;
       this.recommendedProducts = [];
       this.productsScroller = null;
       this.recommendationContainer = document.querySelector('[data-product-recommendations]');
       this.recommendUrl = "/recommendations/products?section_id=static-product-recommendations&limit=".concat(this.limit, "&product_id=").concat(this.productId);
       this._loadRecommendations = this._loadRecommendations.bind(this);
       this._resizeRowScroller = this._resizeRowScroller.bind(this);
   
       this._loadRecommendations();
     }
   
     StaticProductRecommendations_createClass(StaticProductRecommendations, [{
       key: "_loadRecommendations",
       value: function _loadRecommendations() {
         var _this = this;
   
         shopify_asyncview_dist_index_es.load(this.recommendUrl).done(function (_ref) {
           var html = _ref.html;
           _this.recommendationContainer.innerHTML = html;
           dist_index_es.watch(_this.recommendationContainer);
   
           var productItems = _this.recommendationContainer.querySelectorAll('[data-product-item]');
   
           if (productItems.length) {
             productItems.forEach(function (productItem) {
               _this.recommendedProducts.push(new ProductGridItem_ProductGridItem({
                 el: productItem,
                 id: _this.section.id
               }));
             });
             initShopifyProductReviews();
   
             var moneyItems = _this.recommendationContainer.querySelectorAll('.money');
   
             moneyItems.forEach(function (money) {
               return shopify_currency_converter_dist_default.a.update(money);
             });
   
             if (window.Shopify && Shopify.PaymentButton) {
               Shopify.PaymentButton.init();
             }
   
             _this.recommendationContainer.addEventListener('rimg:load', _this._resizeRowScroller);
   
             _this.productsScroller = new ProductRowScroller_ProductRowScroller(_this.section.el.querySelector('[data-product-row]'));
           }
         });
       }
     }, {
       key: "_resizeRowScroller",
       value: function _resizeRowScroller() {
         if (this.productsScroller && this.productsScroller.flickity) {
           this.productsScroller.flickity.resize();
         }
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         if (this.productsScroller) {
           this.productsScroller.unload();
         }
   
         this.recommendedProducts.forEach(function (productItem) {
           productItem.unload();
         });
         this.recommendationContainer.removeEventListener('rimg:load', this._resizeRowScroller);
       }
     }]);
   
     return StaticProductRecommendations;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticRecentlyViewed.js
   function StaticRecentlyViewed_toConsumableArray(arr) { return StaticRecentlyViewed_arrayWithoutHoles(arr) || StaticRecentlyViewed_iterableToArray(arr) || StaticRecentlyViewed_nonIterableSpread(); }
   
   function StaticRecentlyViewed_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
   
   function StaticRecentlyViewed_iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
   
   function StaticRecentlyViewed_arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
   
   function StaticRecentlyViewed_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticRecentlyViewed_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticRecentlyViewed_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticRecentlyViewed_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticRecentlyViewed_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var StaticRecentlyViewed_StaticRecentlyViewed =
   /*#__PURE__*/
   function () {
     function StaticRecentlyViewed(section) {
       var _this = this;
   
       StaticRecentlyViewed_classCallCheck(this, StaticRecentlyViewed);
   
       this.namespace = 'pxu';
       this.maxRecentlyViewed = 30; // Store a max of 30 items
   
       this.maxStorageTime = 30 * 24 * 3600; // Store items for 30 days only
   
       this.version = 1; // Version key is used to update localstorage when format changes
   
       this.storageKey = "".concat(this.namespace, "-recentlyViewed-").concat(this.version);
       this.$el = jquery_default()(section.el);
       this.time = section.data.time;
       this.flickity = null;
       this.recentlyViewed = section.data.recently_viewed_info;
       this.cardSettings = section.data.product_card_settings;
   
       if (this.recentlyViewed && this.time) {
         this.recentlyViewed.timestamp = Math.round(new Date().getTime() / 1000);
       }
   
       this.slideImageLoaded = this._onSlideImageLoaded.bind(this);
   
       if (this.time) {
         var _recentlyViewed = this._getRecentlyViewed();
   
         if (this.recentlyViewed) {
           this.removeRecentlyViewed(this.recentlyViewed.handle, _recentlyViewed);
   
           _recentlyViewed.push(this.recentlyViewed);
         }
   
         var promises = this._setRecentlyViewed(_recentlyViewed); // Wait until promises are resolved before inserting markup into the DOM
   
   
         jquery_default.a.when.apply(jquery_default.a, StaticRecentlyViewed_toConsumableArray(promises)).done(function () {
           if (_recentlyViewed.length) {
             var cardsMarkup = _this._getRecentlyViewedCards();
   
             var cardsData = _this._getRecentlyViewed();
   
             _this.$el.find('[data-recently-viewed-container]').append(cardsMarkup);
   
             cardsData.map(function (productData) {
               var timestamp = _this.timeSince(productData.timestamp);
   
               jquery_default()("[data-product-handle=".concat(productData.handle, "]")).prepend(timestamp);
             });
             dist_index_es.watch(_this.$el[0]);
             _this.$carousel = _this.$el.find('.product-recently-viewed--content');
             _this.slides = '.product-recently-viewed-card';
   
             if (_this.$carousel.find(_this.slides).length > 1) {
               _this._initSlider();
             }
           } else {
             _this.$el.find('.product-recently-viewed--section').addClass('hide');
           }
         });
       } else {
         if (this.recentlyViewed) {
           recentlyViewed.push(this.recentlyViewed);
   
           this._setRecentlyViewed(recentlyViewed);
         }
   
         this.$el.find('.product-recently-viewed--section').addClass('hide');
       }
   
       this.bindEvents();
     }
   
     StaticRecentlyViewed_createClass(StaticRecentlyViewed, [{
       key: "bindEvents",
       value: function bindEvents() {
         var _this2 = this;
   
         this.$el.on('click', '[data-remove-recently-viewed]', function (event) {
           var $target = jquery_default()(event.currentTarget);
           var handle = $target.closest('[data-product-handle]').data('product-handle');
   
           var recentlyViewed = _this2._getRecentlyViewed();
   
           _this2.removeRecentlyViewed(handle, recentlyViewed);
   
           _this2._setRecentlyViewed(recentlyViewed);
   
           $target.parents('[data-recently-viewed-card]').addClass('hide-card');
           $target.parents('[data-recently-viewed-card]').nextAll().addClass('move-card');
           setTimeout(function () {
             var index = $target.parents('[data-recently-viewed-card]').index();
   
             if (index !== 0) {
               index--;
             }
   
             $target.parents('[data-recently-viewed-card]').nextAll().removeClass('move-card');
   
             if ($target.parents('[data-recently-viewed-card]').length) {
               _this2.flickity.remove($target.parents('[data-recently-viewed-card]'));
             }
   
             _this2.flickity.selectCell(index);
           }, 500);
         });
         this.$el.on('click', '[data-clear-recently-viewed]', function (event) {
           _this2.clearRecentlyViewed();
         });
       }
     }, {
       key: "timeSince",
       value: function timeSince(timestamp) {
         var now = Math.round(new Date().getTime() / 1000);
         var secondsPast = now - timestamp;
   
         if (secondsPast < 60) {
           var secondsAgo = parseInt(secondsPast);
           return secondsAgo === 1 ? "".concat(secondsAgo, " ").concat(this.time.second, " ").concat(this.time.ago) : "".concat(secondsAgo, " ").concat(this.time.seconds, " ").concat(this.time.ago);
         }
   
         if (secondsPast < 3600) {
           var minutesAgo = parseInt(secondsPast / 60);
           return minutesAgo === 1 ? "".concat(minutesAgo, " ").concat(this.time.minute, " ").concat(this.time.ago) : "".concat(minutesAgo, " ").concat(this.time.minutes, " ").concat(this.time.ago);
         }
   
         if (secondsPast <= 86400) {
           var hoursAgo = parseInt(secondsPast / 3600);
           return hoursAgo === 1 ? "".concat(hoursAgo, " ").concat(this.time.hour, " ").concat(this.time.ago) : "".concat(hoursAgo, " ").concat(this.time.hours, " ").concat(this.time.ago);
         }
   
         if (secondsPast > 86400) {
           var date = new Date(timestamp * 1000);
           var currentDate = new Date(now * 1000);
           var day = date.getDate();
           var month = date.toDateString().match(/ [a-zA-Z]*/)[0].replace(' ', '');
           var year = date.getFullYear() === currentDate.getFullYear() ? '' : ", ".concat(date.getFullYear());
           return "".concat(month, " ").concat(day, " ").concat(year);
         }
       }
     }, {
       key: "removeRecentlyViewed",
       value: function removeRecentlyViewed(handle, recentlyViewed) {
         for (var i = 0; i < recentlyViewed.length; i++) {
           if (recentlyViewed[i].handle === handle) {
             recentlyViewed.splice(i, 1);
           }
         }
   
         this._setRecentlyViewed(recentlyViewed);
   
         var cards = sessionStorage.getItem(this.storageKey) ? JSON.parse(sessionStorage.getItem(this.storageKey)) : {};
         delete cards[handle];
         sessionStorage.setItem(this.storageKey, JSON.stringify(cards));
   
         if (recentlyViewed.length === 0) {
           this.$el.find('.product-recently-viewed--section').addClass('hide');
         }
   
         if (this.$carousel) {
           this.$carousel[0].removeEventListener('rimg:load', this.slideImageLoaded);
         }
       }
     }, {
       key: "clearRecentlyViewed",
       value: function clearRecentlyViewed() {
         localStorage.removeItem(this.storageKey);
         sessionStorage.removeItem(this.storageKey);
         this.$el.find('[data-recently-viewed-card]').remove();
         this.$el.find('.product-recently-viewed--section').addClass('hide');
       }
     }, {
       key: "_onSlideImageLoaded",
       value: function _onSlideImageLoaded() {
         this.flickity.resize();
       }
     }, {
       key: "_initSlider",
       value: function _initSlider() {
         this.flickityOptions = {
           autoPlay: 0,
           accessibility: true,
           cellAlign: 'left',
           cellSelector: this.slides,
           groupCells: true,
           pageDots: false,
           contain: true,
           prevNextButtons: false,

           arrowShape: {
             x0: 10,
             x1: 60,
             y1: 50,
             x2: 65,
             y2: 45,
             x3: 20
           }
         };
         this.flickity = new js_default.a(this.$carousel[0], this.flickityOptions);
         this.$carousel[0].addEventListener('rimg:load', this.slideImageLoaded);
       }
       /**
        * Store recently viewed products
        *
        * @param {Object[]} productData - recently viewed products
        * @param {number} productData[].timestamp - Timestamp indicating when product was added to productData
        * @param {string} productData[].handle - Shopify product handle
        * @private
        */
   
     }, {
       key: "_setRecentlyViewed",
       value: function _setRecentlyViewed(productData) {
         var _this3 = this;
   
         var now = Math.floor(Date.now() / 1000); // Unix timestamp for current date
   
         var minStorageTimestamp = now - this.maxStorageTime;
         var filteredData = productData.filter(function (item) {
           return item.timestamp > minStorageTimestamp;
         });
   
         if (filteredData.length > this.maxRecentlyViewed) {
           var removeCount = filteredData.length - this.maxRecentlyViewed;
           filteredData.splice(0, removeCount); // Remove oldest if more than max number have been stored
         }
   
         try {
           localStorage.setItem(this.storageKey, JSON.stringify(filteredData));
         } catch (error) {
           console.warn(error);
         } // Retrieve markup for recently viewed cards and store in session
   
   
         try {
           var handles = filteredData ? filteredData.map(function (x) {
             return x.handle;
           }) : [];
           var storedCards = sessionStorage.getItem(this.storageKey) ? JSON.parse(sessionStorage.getItem(this.storageKey)) : {};
   
           if (storedCards.cardSettings) {
             for (var key in storedCards.cardSettings) {
               if (storedCards.cardSettings[key] !== this.cardSettings[key]) {
                 storedCards = {};
                 sessionStorage.removeItem(this.storageKey);
                 break;
               }
             }
           }
   
           storedCards.cardSettings = this.cardSettings;
           var promises = handles.map(function (handle) {
             if (storedCards[handle]) {
               return;
             }
   
             var fetchUrl = "/products/".concat(handle, "?view=_recently-viewed");
             return jquery_default.a.get(fetchUrl)["catch"](function (error) {
               return console.error('Error:', error);
             }).then(function (response) {
               if (response) {
                 storedCards[handle] = response;
   
                 try {
                   sessionStorage.setItem(_this3.storageKey, JSON.stringify(storedCards));
                 } catch (error) {
                   console.warn(error);
                 }
               }
             });
           });
           return promises;
         } catch (error) {
           console.warn(error);
           return false;
         }
       }
       /**
        * Get stored recently viewed products
        *
        * @returns {Array}
        * @private
        */
   
     }, {
       key: "_getRecentlyViewed",
       value: function _getRecentlyViewed() {
         try {
           var _recentlyViewed2 = localStorage.getItem(this.storageKey) ? JSON.parse(localStorage.getItem(this.storageKey)) : [];
   
           return _recentlyViewed2;
         } catch (error) {
           console.warn(error);
           return [];
         }
       }
     }, {
       key: "_getRecentlyViewedCards",
       value: function _getRecentlyViewedCards() {
         var cards = sessionStorage.getItem(this.storageKey) ? JSON.parse(sessionStorage.getItem(this.storageKey)) : {};
         var orderedItems = localStorage.getItem(this.storageKey) ? JSON.parse(localStorage.getItem(this.storageKey)) : {};
         var markup = [];
   
         for (var i = orderedItems.length - 1; i >= 0; i--) {
           var cardKey = orderedItems[i].handle;
           markup.push(cards[cardKey]);
         }
   
         return markup.join('');
       }
     }]);
   
     return StaticRecentlyViewed;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticSearch.js
   function StaticSearch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticSearch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticSearch_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticSearch_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticSearch_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var StaticSearch_StaticSearch =
   /*#__PURE__*/
   function () {
     function StaticSearch(section) {
       var _this = this;
   
       StaticSearch_classCallCheck(this, StaticSearch);
   
       this.section = section;
       this.$el = jquery_default()(section.el);
       this.$searchField = this.$el.find('[data-live-search]'); // Product items
   
       this.productItems = [];
       var $productItems = this.$el.find('[data-product-item]');
       $productItems.each(function (i, productItem) {
         _this.productItems.push(new ProductGridItem_ProductGridItem({
           el: productItem,
           id: _this.section.id
         }));
       });
   
       this._updatePrices();
   
       this.searchForm = new SearchForm_SearchForm(this.$searchField);
     }
   
     StaticSearch_createClass(StaticSearch, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.searchForm.unload();
         this.productItems.forEach(function (productItem) {
           productItem.unload();
         });
       }
     }, {
       key: "_updatePrices",
       value: function _updatePrices() {
         this.$el.find('.money').each(function (index, el) {
           return shopify_currency_converter_dist_default.a.update(el);
         });
       }
     }]);
   
     return StaticSearch;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicBlogPosts.js
   function DynamicBlogPosts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicBlogPosts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicBlogPosts_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicBlogPosts_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicBlogPosts_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var DynamicBlogPosts_DynamicTwitterFeed =
   /*#__PURE__*/
   function () {
     function DynamicTwitterFeed(section) {
       DynamicBlogPosts_classCallCheck(this, DynamicTwitterFeed);
   
       this.$el = jquery_default()(section.el);
       this.$window = jquery_default()(window);
       this.flickity = null;
       this.$blogPosts = this.$el.find('[data-blog-posts]'); // Activate flickity on mobile
   
       this._mobileSlider = this._mobileSlider.bind(this);
       Layout.onBreakpointChange(this._mobileSlider);
   
       this._mobileSlider();
     }
     /**
      * Unbind events when section is re-drawn
      */
   
   
     DynamicBlogPosts_createClass(DynamicTwitterFeed, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         Layout.offBreakpointChange(this._mobileSlider);
   
         this._destroyFlickity();
       }
     }, {
       key: "_initFlickity",
       value: function _initFlickity() {
         this.flickity = new js_default.a(this.$blogPosts[0], {
           cellSelector: '.article--excerpt-wrapper',
           contain: true,
           freeScroll: true,
           percentPosition: false,
           prevNextButtons: false,
           pageDots: false,
           setGallerySize: false
         });
   
         this._bindSlider();
       }
     }, {
       key: "_destroyFlickity",
       value: function _destroyFlickity() {
         if (!this.flickity) {
           return;
         }
   
         this.$window.off('.blog-posts');
         this.$blogPosts.off('.blog-posts');
         this.flickity.destroy();
         this.flickity = null;
       }
     }, {
       key: "_mobileSlider",
       value: function _mobileSlider() {
         // If is Large layout, attempt to destroy flickity
         if (Layout.isBreakpoint('L')) {
           this._destroyFlickity();
   
           return;
         } // Is XS/S/M, and flickity is init'd -- do nothing
   
   
         if (this.flickity) {
           return;
         } // Is XS/S/M, and flickity is not init'd
   
   
         this._initFlickity();
       }
     }, {
       key: "_bindSlider",
       value: function _bindSlider() {
         var _this = this;
   
         var $slider = this.$blogPosts.find('.flickity-slider');
         this.$window.on('resize.blog-posts', just_debounce_default()(function () {
           _this.$blogPosts.trigger('heightUpdate.blog-posts');
         }));
         this.flickity.on('cellSelect', function () {
           _this.$blogPosts.trigger('heightUpdate.blog-posts');
         });
         this.$blogPosts.on('heightUpdate.blog-posts', function () {
           if (!_this.flickity) {
             return;
           }
   
           $slider.height(Math.ceil(_this.flickity.maxCellHeight));
         }); // Sets the Slider to the height of the first slide
   
         this.$blogPosts.trigger('heightUpdate.blog-posts');
       }
     }]);
   
     return DynamicTwitterFeed;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticHighlightsBanners.js
   function StaticHighlightsBanners_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticHighlightsBanners_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticHighlightsBanners_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticHighlightsBanners_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticHighlightsBanners_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var StaticHighlightsBanners_StaticHighlightsBanners =
   /*#__PURE__*/
   function () {
     function StaticHighlightsBanners(section) {
       StaticHighlightsBanners_classCallCheck(this, StaticHighlightsBanners);
   
       this.$el = jquery_default()(section.el);
       this.$window = jquery_default()(window);
       this.$carousel = this.$el.find('.highlights-banners');
       this.slides = '.highlights-banners-block';
       this.flickity = null;
       this.flickityOptions = null;
   
       if (this.$carousel.find(this.slides).length > 1) {
         this._initSlider();
       }
     }
   
     StaticHighlightsBanners_createClass(StaticHighlightsBanners, [{
       key: "_initSlider",
       value: function _initSlider() {
         this.flickityOptions = {
           autoPlay: 0,
           accessibility: true,
           cellAlign: 'left',
           cellSelector: this.slides,
           pageDots: false,
           prevNextButtons: false,
           contain: true
         };
   
         this._bindFlickity();
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this._destroyFlickity();
   
         this.$window.off('.twitter');
       }
     }, {
       key: "_bindFlickity",
       value: function _bindFlickity() {
         var _this = this;
   
         if (Layout.isBreakpoint('L') === false && this.flickity === null) {
           this.flickity = new js_default.a(this.$carousel[0], this.flickityOptions);
         }
   
         this.$window.on('resize', just_debounce_default()(function () {
           if (Layout.isBreakpoint('L') === false && _this.flickity === null) {
             _this._bindFlickity();
           } else if (Layout.isBreakpoint('L') && _this.flickity) {
             _this._destroyFlickity();
           }
         }));
       }
     }, {
       key: "_destroyFlickity",
       value: function _destroyFlickity() {
         if (!this.flickity) {
           return;
         }
   
         this.flickity.destroy();
         this.flickity = null;
       }
     }]);
   
     return StaticHighlightsBanners;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticSlideshow.js
   function StaticSlideshow_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticSlideshow_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticSlideshow_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticSlideshow_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticSlideshow_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var StaticSlideshow_StaticSlideshow =
   /*#__PURE__*/
   function () {
     function StaticSlideshow(section) {
       StaticSlideshow_classCallCheck(this, StaticSlideshow);
   
       this.el = section.el;
       this.settings = section.data;
       this.$window = jquery_default()(window);
       this.carousel = this.el.querySelector('.slideshow');
       this.slides = '.slideshow-slide';
       this.container = this.el.querySelector('.slideshow-height-fullscreen');
       this.isFullscreen = !!this.container;
       this.selectBlockOnLoad = true;
       this.continueAutoplay = true;
       this.stopAutoplay = false;
       this.autoplayTimeout = 0;
       this.$firstSlideImage = null;
       this.flickity = null;
       this.flickityOptions = null;
       this._initFlickity = this._initFlickity.bind(this);
   
       if (this.carousel && this.carousel.querySelectorAll(this.slides).length > 1) {
         this._initSlider();
       }
     }
   
     StaticSlideshow_createClass(StaticSlideshow, [{
       key: "_initSlider",
       value: function _initSlider() {
         this.flickityOptions = {
           autoPlay: this.settings.enable_autoplay ? this.settings.autoplay_duration * 1000 : false,
           setGallerySize: !this.isFullscreen,
           pauseAutoPlayOnHover: false,
           accessibility: true,
           adaptiveHeight: true,
           cellAlign: 'left',
           cellSelector: this.slides,
           contain: true,
           wrapAround: true,
           arrowShape: {
             x0: 10,
             x1: 60,
             y1: 50,
             x2: 65,
             y2: 45,
             x3: 20
           }
         };
         this.$firstSlideImage = jquery_default()(this.slides, this.carousel).find('img[data-rimg]').first(); // If image isn't lazy loaded, it may load before
         // this JS runs, so we need to check
   
         if (this.$firstSlideImage.length && !this.$firstSlideImage[0].complete) {
           this.$firstSlideImage.one('rimg:load', this._initFlickity);
         } else {
           this._initFlickity();
         }
       }
     }, {
       key: "_initFlickity",
       value: function _initFlickity() {
         var _this = this;
   
         this.flickity = new js_default.a(this.carousel, this.flickityOptions);
   
         this._slideshowHeight();
   
         this._positionDots();
   
         this._changeArrowColors();
   
         this.$window.on('resize.slideshow', just_debounce_default()(function () {
           _this._slideshowHeight();
   
           _this._positionDots();
   
           _this._changeArrowColors();
         }));
         this.flickity.on('select', function () {
           _this._slideshowHeight();
   
           _this._positionDots();
   
           _this._changeArrowColors();
   
           _this.selectBlockOnLoad = false;
   
           if (_this.settings.enable_autoplay && !_this.stopAutoplay) {
             _this.flickity.pausePlayer();
   
             if (_this.continueAutoplay) {
               _this.autoplayTimeout = 0;
             } else {
               _this.autoplayTimeout = 10000;
             }
   
             _this.continueAutoplay = true;
             setTimeout(function () {
               _this.flickity.playPlayer();
             }, _this.autoplayTimeout);
           }
         });
         this.flickity.on('dragStart', function () {
           _this.continueAutoplay = false;
         });
   
         this.stopAutoplaying = function () {
           _this.stopAutoplay = true;
   
           _this.flickity.stopPlayer();
         }; // For users that need to use a keyboard for navigation, we want to pause the player
         // when they are focused on it, and we also want to slide to the slide their focus is on.
   
   
         this.slideElements = this.el.querySelectorAll(this.slides);
         this.slideElements.forEach(function (slide) {
           slide.addEventListener('focusin', function () {
             _this.stopAutoplaying();
   
             var $slides = jquery_default()(_this.slides);
             var $slide = jquery_default()(slide);
             var slideIndex = $slides.index($slide);
   
             _this.flickity.select(slideIndex, false, true);
           });
         }); // For screen readers, we will add a live region that is hidden to users,
         // but is read when clicking the nagivation buttons
   
         this.liveregion = document.createElement('div');
         this.liveregion.setAttribute('aria-live', 'polite');
         this.liveregion.setAttribute('class', 'live-region visually-hidden');
         this.el.appendChild(this.liveregion);
   
         this.handleManualSlideChange = function () {
           _this.stopAutoplaying();
   
           _this.liveregion.textContent = "Slide autoplay stopped.\n        On slide ".concat(_this.flickity.selectedIndex + 1, " of ").concat(_this.flickity.slides.length);
         }; // stop autoplaying if a user has interacted with the slideshow next/previous buttons
   
   
         this.el.querySelector('.flickity-prev-next-button.next').addEventListener('click', this.handleManualSlideChange);
         this.el.querySelector('.flickity-prev-next-button.previous').addEventListener('click', this.handleManualSlideChange);
       }
     }, {
       key: "_positionDots",
       value: function _positionDots() {
         var pageDots = this.el.querySelector('.flickity-page-dots');
         var top = 'auto';
   
         if (Layout.isBreakpoint('XS') && !this.isFullscreen) {
           var content = this.flickity.selectedElement.querySelector('.slideshow-slide-content');
           var height = this.flickity.selectedElement.querySelector('.slideshow-background').offsetHeight;
           var dotGutter = 5;
   
           if (content) {
             top = "".concat(height + dotGutter, "px");
           } else {
             var pageDotsHeight = pageDots.offsetHeight;
             var dotBottomGutter = 20; // If no content, and mobile, offset by height of dots, and the bottom gutter
   
             top = "".concat(height - (pageDotsHeight + dotBottomGutter), "px");
           }
         }
   
         pageDots.style.top = top;
       }
     }, {
       key: "_changeArrowColors",
       value: function _changeArrowColors() {
         var currentColor = this.flickity.selectedElement.querySelector('.slideshow-background').dataset;
         var dots = this.el.querySelectorAll('.flickity-page-dots .dot');
   
         if (Layout.isBreakpoint('XS') && !this.isFullscreen) {
           currentColor = currentColor.themecolor;
         } else {
           currentColor = currentColor.slidecolor;
         }
   
         this.el.querySelector('.flickity-prev-next-button.previous svg').style.fill = currentColor;
         this.el.querySelector('.flickity-prev-next-button.next svg').style.fill = currentColor;
   
         for (var i = 0; i < dots.length; i++) {
           dots[i].style.background = currentColor;
         }
       }
     }, {
       key: "_slideshowHeight",
       value: function _slideshowHeight() {
         if (this.isFullscreen) {
           var offsetHeight = document.querySelector('[data-site-header]').getBoundingClientRect().height;
           var announcement = document.querySelector('.site-announcement');
   
           if (announcement) {
             offsetHeight += announcement.getBoundingClientRect().height;
           }
   
           this.el.querySelector('.flickity-viewport').style.height = "calc(100vh - ".concat(offsetHeight, "px)");
           this.container.style.height = "calc(100vh - ".concat(offsetHeight, "px)");
         }
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this._destroyFlickity();
   
         this.$window.off('.slideshow');
         this.$firstSlideImage.off('rimg:load');
       }
     }, {
       key: "_destroyFlickity",
       value: function _destroyFlickity() {
         if (!this.flickity) {
           return;
         }
   
         this.flickity.destroy();
       }
     }, {
       key: "onSectionBlockSelect",
       value: function onSectionBlockSelect(block) {
         var _this2 = this;
   
         setTimeout(function () {
           _this2.flickity.resize();
         }, 100);
         var $slides = jquery_default()(this.slides);
         var $slide = jquery_default()(block.el);
         var slideIndex = $slides.index($slide);
   
         if (this.settings.enable_autoplay) {
           this.stopAutoplay = true;
           this.flickity.pausePlayer();
         }
   
         if (!$slide.hasClass('is-selected') && !this.selectBlockOnLoad) {
           this.flickity.select(slideIndex, false, false);
         } else if (this.selectBlockOnLoad) {
           this.flickity.select(slideIndex, false, true);
         }
       }
     }, {
       key: "onSectionBlockDeselect",
       value: function onSectionBlockDeselect() {
         if (this.settings.enable_autoplay) {
           this.stopAutoplay = false;
           this.flickity.playPlayer();
         }
       }
     }]);
   
     return StaticSlideshow;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicPromoBlocks.js
   function DynamicPromoBlocks_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicPromoBlocks_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicPromoBlocks_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicPromoBlocks_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicPromoBlocks_defineProperties(Constructor, staticProps); return Constructor; }
   
   
    // Adjusts the height of the block so it can contain the wrapper within it
   
   var DynamicPromoBlocks_adjustHeight = function adjustHeight(block) {
     var $block = jquery_default()(block);
     var $wrapper = $block.find('.promo-block--content-wrapper');
     var padding = window.getComputedStyle($block[0], null).getPropertyValue('padding-top').replace('px', '');
   
     if ($block.innerHeight() - padding * 2 < $wrapper.innerHeight()) {
       $block.css({
         height: "".concat($wrapper.innerHeight() + padding * 2, "px")
       });
       $wrapper.css({
         transform: 'none',
         top: 'auto'
       });
     }
   }; // Removes height settings on the block because they only need to be there for small screens
   
   
   var DynamicPromoBlocks_resetHeight = function resetHeight(block) {
     var $block = jquery_default()(block);
     var $wrapper = $block.find('.promo-block--content-wrapper');
     $block.css({
       height: ''
     });
     $wrapper.css({
       transform: '',
       top: ''
     });
   };
   
   var DynamicPromoBlocks_DynamicPromoBlocks =
   /*#__PURE__*/
   function () {
     function DynamicPromoBlocks(section) {
       var _this = this;
   
       DynamicPromoBlocks_classCallCheck(this, DynamicPromoBlocks);
   
       this.$el = jquery_default()(section.el);
       this.content = '[data-promo-block-content]';
       this.expandedClass = 'promo-block--expanded';
       this.compressBlocks = section.data.compress_blocks; // Revert navigation to original state on breakpoint change
   
       this.layoutHandler = this.onBreakpointChange.bind(this);
       Layout.onBreakpointChange(this.layoutHandler);
       this._blockInteraction = this._blockInteraction.bind(this);
       this.$el.on('click.promo-block', this.content, this._blockInteraction);
   
       if (!this.compressBlocks && Layout.isBreakpoint('XS')) {
         this.$el.find(this.content).each(function (index, block) {
           DynamicPromoBlocks_adjustHeight(block);
         });
       }
   
       if (!this.compressBlocks) {
         jquery_default()(window).on('resize', function () {
           _this.$el.find(_this.content).each(function (index, block) {
             if (Layout.isBreakpoint('XS')) {
               DynamicPromoBlocks_adjustHeight(block);
             } else {
               DynamicPromoBlocks_resetHeight(block);
             }
           });
         });
       }
     }
     /**
      * Remove block's toggled state and attributes when leaving mobile
      */
   
   
     DynamicPromoBlocks_createClass(DynamicPromoBlocks, [{
       key: "onBreakpointChange",
       value: function onBreakpointChange() {
         var _this2 = this;
   
         if (!Layout.isBreakpoint('XS')) {
           this.$el.find(".".concat(this.expandedClass)).each(function (i, content) {
             _this2._collapse(content);
           });
           this.$el.find(this.content).each(function (index, block) {
             DynamicPromoBlocks_resetHeight(block);
           });
         } else if (!this.compressBlocks) {
           this.$el.find(this.content).each(function (index, block) {
             DynamicPromoBlocks_adjustHeight(block);
           });
         }
       }
       /**
        * Unbind events when section is re-drawn
        */
   
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.$el.off('.promo-block');
         Layout.offBreakpointChange(this.layoutHandler);
       }
       /**
        * Callback to open block on mobile from the TE
        *
        * @param block
        */
   
     }, {
       key: "onSectionBlockSelect",
       value: function onSectionBlockSelect(block) {
         if (!Layout.isBreakpoint('XS')) return;
   
         this._expand(block.el.querySelector(this.content));
       }
       /**
        * Callback to close block on mobile from the TE
        *
        * @param block
        */
   
     }, {
       key: "onSectionBlockDeselect",
       value: function onSectionBlockDeselect(block) {
         if (!Layout.isBreakpoint('XS')) return;
   
         this._collapse(block.el.querySelector(this.content));
       }
       /**
        * Expand a block on first click, then allow it to behave as normal
        *
        * @param event
        * @private
        */
   
     }, {
       key: "_blockInteraction",
       value: function _blockInteraction(event) {
         var content = event.currentTarget;
         var clicked = content.getAttribute('data-clicked'); // On second click, or on desktop, don't interfere with block
   
         if (clicked || !Layout.isBreakpoint('XS') || !this.compressBlocks) {
           return;
         }
   
         event.preventDefault();
         content.setAttribute('data-clicked', 'clicked');
   
         this._expand(content);
       }
       /**
        * Expand promo block
        *
        * @param content
        * @private
        */
   
     }, {
       key: "_expand",
       value: function _expand(content) {
         var _this3 = this;
   
         if (!this.compressBlocks) {
           return;
         }
   
         var $content = jquery_default()(content);
         $content.addClass('animating animating-in').one('trend', function () {
           $content.removeClass('animating animating-in').addClass(_this3.expandedClass).off('trend');
           DynamicPromoBlocks_adjustHeight($content);
         });
       }
       /**
        * Collapse a block
        *
        * @param content
        * @private
        */
   
     }, {
       key: "_collapse",
       value: function _collapse(content) {
         var _this4 = this;
   
         if (!this.compressBlocks) {
           return;
         }
   
         var $content = jquery_default()(content);
         $content.addClass('animating animating-out').one('trend', function () {
           $content.removeClass("animating animating-out ".concat(_this4.expandedClass)).off('trend');
           content.removeAttribute('data-clicked');
           DynamicPromoBlocks_resetHeight($content);
         });
       }
     }]);
   
     return DynamicPromoBlocks;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicMenuList.js
   function DynamicMenuList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicMenuList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicMenuList_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicMenuList_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicMenuList_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var DynamicMenuList_DynamicMenuList =
   /*#__PURE__*/
   function () {
     function DynamicMenuList(section) {
       DynamicMenuList_classCallCheck(this, DynamicMenuList);
   
       this.$el = jquery_default()(section.el);
       this.context = section.data.context;
       this.Accordion = new Accordion_Accordion(this.$el); // Handle Accordion interaction when window size changes
   
       this.layoutHandler = this.onBreakpointChange.bind(this);
       Layout.onBreakpointChange(this.layoutHandler);
   
       this._bindEvents();
     }
   
     DynamicMenuList_createClass(DynamicMenuList, [{
       key: "_bindEvents",
       value: function _bindEvents() {
         var _this = this;
   
         this.$el.on('click.menu-list', '[data-accordion-trigger]', function (event) {
           event.preventDefault();
   
           _this._toggleAccordion(jquery_default()(event.currentTarget).parent());
         });
         this.$el.on('click.menu-list', '[data-menulist-toggle]', function (event) {
           event.preventDefault();
   
           _this._toggleList(event.currentTarget);
         });
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.$el.off('.menu-list');
         delete this.Accordion;
       }
     }, {
       key: "onSectionBlockSelect",
       value: function onSectionBlockSelect(block) {
         this._toggleAccordion(jquery_default()(block.el), true);
       }
     }, {
       key: "onSectionBlockDeselect",
       value: function onSectionBlockDeselect(block) {
         this._toggleAccordion(jquery_default()(block.el), false);
       }
     }, {
       key: "_toggleAccordion",
       value: function _toggleAccordion($block) {
         if (Layout.isBreakpoint('L')) return;
         this.Accordion.toggle($block);
       }
     }, {
       key: "_toggleList",
       value: function _toggleList(el) {
         var $trigger = jquery_default()(el);
         var $items = $trigger.parent().siblings('[data-hidden-default]');
         var siblingsVisible = $trigger.data('menulist-toggle');
         $items.toggleClass('menulist--menu-item-hidden', siblingsVisible);
         $trigger.data('menulist-toggle', !siblingsVisible).text(!siblingsVisible ? this.context.see_less : this.context.see_more);
       }
     }, {
       key: "onBreakpointChange",
       value: function onBreakpointChange(event, breakpoints) {
         if (Layout.isBreakpoint('L')) {
           this.Accordion.openAll();
         } else if (breakpoints.previous === 'L' && !Layout.isBreakpoint('L')) {
           this.Accordion.closeOpen();
         }
       }
     }]);
   
     return DynamicMenuList;
   }();
   
   
   // EXTERNAL MODULE: ./node_modules/twitter-fetcher/js/twitterFetcher_min.js
   var twitterFetcher_min = __webpack_require__(14);
   var twitterFetcher_min_default = /*#__PURE__*/__webpack_require__.n(twitterFetcher_min);
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicTwitterFeed.js
   function DynamicTwitterFeed_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicTwitterFeed_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicTwitterFeed_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicTwitterFeed_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicTwitterFeed_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   var DynamicTwitterFeed_DynamicTwitterFeed =
   /*#__PURE__*/
   function () {
     function DynamicTwitterFeed(section) {
       var _this = this;
   
       DynamicTwitterFeed_classCallCheck(this, DynamicTwitterFeed);
   
       this.$el = jquery_default()(section.el);
       this.settings = section.data;
       this.$window = jquery_default()(window);
       this.flickity = null;
       this.$content = this.$el.find('[data-twitter-content]');
       this.$wrapper = this.$el.find('[data-twitter-wrapper]');
       this.$tweets = this.$el.find('[data-tweet-content]');
       this.$wrapper.on('rimg:enter', function (event) {
         _this._load();
       });
       dist_index_es.instance.track(this.$wrapper[0]);
     }
   
     DynamicTwitterFeed_createClass(DynamicTwitterFeed, [{
       key: "_load",
       value: function _load() {
         var _this2 = this;
   
         this.$template = jquery_default()(this.settings.template);
         var onboarding = this.settings.onboarding;
         var username = this.settings.username;
         var retweets = this.settings.retweets;
         var images = this.settings.images;
         var locale = this.settings.locale || 'en'; // Activate flickity on mobile
   
         this._mobileSlider = this._mobileSlider.bind(this);
         Layout.onBreakpointChange(this._mobileSlider);
   
         this._mobileSlider();
   
         if (onboarding || !username) {
           return;
         }
   
         twitterFetcher_min_default.a.fetch({
           'profile': {
             'screenName': username
           },
           'maxTweets': 3,
           'enableLinks': true,
           'showUser': true,
           'showTime': true,
           'dataOnly': false,
           'useEmoji': true,
           'showImages': images,
           'showRetweet': retweets,
           'lang': locale,
           'customCallback': function customCallback(tweets) {
             return _this2._renderTweets(tweets);
           },
           'showInteraction': false
         });
       }
       /**
        * Unbind events when section is re-drawn
        */
   
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         dist_index_es.instance.untrack(this.$wrapper[0]);
         this.$window.off('.twitter');
         this.$content.off('.twitter');
         Layout.offBreakpointChange(this._mobileSlider);
   
         this._destroyFlickity();
       }
     }, {
       key: "_initFlickity",
       value: function _initFlickity() {
         this.flickity = new js_default.a(this.$content[0], {
           cellSelector: '[data-tweet-content]',
           contain: true,
           freeScroll: true,
           percentPosition: false,
           prevNextButtons: false,
           pageDots: false,
           setGallerySize: false
         });
   
         this._bindSlider();
       }
     }, {
       key: "_destroyFlickity",
       value: function _destroyFlickity() {
         if (!this.flickity) {
           return;
         }
   
         this.flickity.destroy();
         this.flickity = null;
       }
     }, {
       key: "_mobileSlider",
       value: function _mobileSlider() {
         // If is Large layout, attempt to destroy flickity
         if (Layout.isBreakpoint('L')) {
           this._destroyFlickity();
   
           return;
         } // Is XS/S/M, and flickity is init'd -- do nothing
   
   
         if (this.flickity) {
           return;
         } // Is XS/S/M, and flickity is not init'd
   
   
         this._initFlickity();
       }
     }, {
       key: "_bindSlider",
       value: function _bindSlider() {
         var _this3 = this;
   
         var $slider = this.$content.find('.flickity-slider');
         this.$window.on('resize.twitter', just_debounce_default()(function () {
           _this3.$content.trigger('heightUpdate.twitter');
         }));
         this.flickity.on('cellSelect', function () {
           _this3.$content.trigger('heightUpdate.twitter');
         });
         this.$content.on('heightUpdate.twitter', function () {
           if (!_this3.flickity) {
             return;
           }
   
           $slider.height(Math.ceil(_this3.flickity.maxCellHeight));
         }); // Sets the Slider to the height of the first slide
   
         this.$content.trigger('heightUpdate.twitter');
       }
       /**
        * Retrieve information about user who tweeted
        *
        * @param el
        * @returns {{$avatar: *, link: *, name, screenName}}
        * @private
        */
   
     }, {
       key: "_extractAuthor",
       value: function _extractAuthor(el) {
         var $el = jquery_default()(el);
         var link = $el.find('a').attr('href');
         var name = $el.find('[data-scribe="element:name"]').text();
         var screenName = $el.find('[data-scribe="element:screen_name"]').text();
         var $avatar = $el.find('img');
         return {
           $avatar: $avatar,
           link: link,
           name: name,
           screenName: screenName
         };
       }
       /**
        * Retrieve link to tweet, and when it was tweeted
        *
        * @param el
        * @returns {{link: *, postedAt: *}}
        * @private
        */
   
     }, {
       key: "_extractMeta",
       value: function _extractMeta(el) {
         var $el = jquery_default()(el);
         var link = $el.find('a').attr('href');
         var postedAt = $el.text();
         return {
           link: link,
           postedAt: postedAt
         };
       }
     }, {
       key: "_extractWrapperClass",
       value: function _extractWrapperClass() {
         var wrapperClass = this.$wrapper.attr('class').match(/tweet--count-\d+$/);
   
         if (wrapperClass) {
           return wrapperClass[0];
         } else {
           return '';
         }
       }
     }, {
       key: "_renderTweets",
       value: function _renderTweets(tweets) {
         var _this4 = this;
   
         var tweetsLength = tweets.length;
         if (!tweets || !tweetsLength) return;
         var tweetsArray = [];
         var wrapperClass = "tweet--count-".concat(tweetsLength);
         tweets.forEach(function (tweet) {
           var $tweet = jquery_default()(tweet);
   
           var $template = _this4.$template.clone();
   
           var authorInfo = _this4._extractAuthor($tweet[0]);
   
           var meta = _this4._extractMeta($tweet[2]);
   
           var content = $tweet[1]; // Render header
   
           $template.find('.tweet--header').attr('href', authorInfo.link);
           $template.find('.tweet--header-image').html(authorInfo.$avatar);
           $template.find('.tweet--header-name').text(authorInfo.name);
           $template.find('.tweet--header-screenname').text(authorInfo.screenName); // Render content
   
           $template.find('.tweet--content').append($tweet[3] ? $tweet[3] : null).append(content); // Render footer
   
           $template.find('.tweet--footer').attr('href', meta.link).find('.tweet--footer--posted').text(meta.postedAt);
           tweetsArray.push($template);
         });
         this.$wrapper.css('min-height', this.$wrapper.height());
         this.$tweets.fadeOut().promise().then(function () {
           _this4._destroyFlickity();
   
           _this4.$tweets.remove();
   
           _this4.$content.append(tweetsArray);
   
           _this4.$wrapper.removeClass(_this4._extractWrapperClass()).addClass(wrapperClass).css('min-height', '');
   
           _this4.$tweets = _this4.$el.find('[data-tweet-content]');
   
           _this4._mobileSlider();
         });
       }
     }]);
   
     return DynamicTwitterFeed;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicInstagramFeed.js
   function DynamicInstagramFeed_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicInstagramFeed_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicInstagramFeed_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicInstagramFeed_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicInstagramFeed_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   var DynamicInstagramFeed_DynamicInstagramFeed =
   /*#__PURE__*/
   function () {
     function DynamicInstagramFeed(section) {
       var _this = this;
   
       DynamicInstagramFeed_classCallCheck(this, DynamicInstagramFeed);
   
       this.settings = section.data;
       this.onboarding = this.settings.onboarding;
       this.photoCount = this.settings.photo_count;
       this.accessToken = this.settings.access_token;
       this.$el = jquery_default()(section.el);
       this.$window = jquery_default()(window);
       this.$photoContainer = this.$el.find('[data-instagram-content]');
       this.$photoContainerPlaceholder = this.$el.find('[data-instagram-photo-placeholder]');
       this.$photoTemplate = jquery_default()('<figure class="instagram--photo" data-instagram-photo />');
       this.$photoContainer.on('rimg:enter', function (event) {
         _this._load();
       });
       dist_index_es.instance.track(this.$photoContainer[0]);
     }
   
     DynamicInstagramFeed_createClass(DynamicInstagramFeed, [{
       key: "_load",
       value: function _load() {
         var _this2 = this;
   
         // Activate flickity on mobile
         this._mobileSlider = this._mobileSlider.bind(this);
         Layout.onBreakpointChange(this._mobileSlider);
   
         this._mobileSlider();
   
         if (this.onboarding || !this.accessToken) {
           return;
         }
   
         this._getPhotos().done(function (photos) {
           return _this2._renderPhotos(photos);
         }).fail(function (error) {
           console.warn("Instagram: ".concat(error));
         });
       }
     }, {
       key: "_getPhotos",
       value: function _getPhotos() {
         var url = "https://api.instagram.com/v1/users/self/media/recent?access_token=".concat(this.accessToken, "&count=").concat(this.photoCount, "&callback=");
         var photoPromise = jquery_default.a.ajax(url, {
           dataType: 'jsonp'
         });
         return photoPromise.then(function (response) {
           if (response.meta.code !== 200) {
             var error = "".concat(response.meta.error_message, " (").concat(response.meta.error_type, ")");
             return jquery_default.a.Deferred().reject(error).promise();
           }
   
           return response.data;
         });
       }
     }, {
       key: "_renderPhotos",
       value: function _renderPhotos(photos) {
         var _this3 = this;
   
         var photoArray = [];
         var photoIndex = 0;
         photos.forEach(function (photo) {
           photoIndex += 1;
   
           var $template = _this3.$photoTemplate.clone();
   
           var lowResolution = photo.images.low_resolution;
           var standardResolution = photo.images.standard_resolution;
           var imageURL = lowResolution.url;
   
           if (window.devicePixelRatio >= 2) {
             imageURL = standardResolution.url;
           }
   
           var $link = jquery_default()("<a aria-label=\"view photo ".concat(photoIndex, " by ").concat(photo.user.username, " on instagram\" target=\"_blank\" href=\"").concat(photo.link, "\"></a>"));
           var $photo = jquery_default()("\n        <div\n          class=\"instagram--photo-img\"\n          role=\"img\"\n          style=\"background-image: url(".concat(imageURL, ");\" \n          aria-label=\"photo ").concat(photoIndex, " by ").concat(photo.user.username, " on instagram\"\n        >\n      "));
           $link.append($photo);
           $template.append($link);
           photoArray.push($template);
         });
         this.$photoContainerPlaceholder.fadeOut(function () {
           _this3._destroyFlickity();
   
           _this3.$photoContainer.append(photoArray);
   
           _this3.$photoContainerPlaceholder.remove();
   
           _this3._mobileSlider();
         });
       }
     }, {
       key: "_initFlickity",
       value: function _initFlickity() {
         this.flickity = new js_default.a(this.$photoContainer[0], {
           cellSelector: '.instagram--photo',
           contain: true,
           freeScroll: true,
           percentPosition: false,
           prevNextButtons: false,
           pageDots: false,
           setGallerySize: false
         });
   
         this._bindSlider();
       }
     }, {
       key: "_destroyFlickity",
       value: function _destroyFlickity() {
         if (!this.flickity) {
           return;
         }
   
         this.$window.off('.instagram-feed');
         this.$photoContainer.off('.instagram-feed');
         this.flickity.destroy();
         this.flickity = null;
       }
     }, {
       key: "_mobileSlider",
       value: function _mobileSlider() {
         // If is Large layout, attempt to destroy flickity
         if (Layout.isBreakpoint('L') || Layout.isBreakpoint('M')) {
           this._destroyFlickity();
   
           return;
         } // Is XS/S/M, and flickity is init'd -- do nothing
   
   
         if (this.flickity) {
           return;
         } // Is XS/S/M, and flickity is not init'd
   
   
         this._initFlickity();
       }
     }, {
       key: "_bindSlider",
       value: function _bindSlider() {
         var _this4 = this;
   
         var $slider = this.$photoContainer.find('.flickity-slider');
         this.$window.on('resize.instagram-feed', just_debounce_default()(function () {
           _this4.$photoContainer.trigger('heightUpdate.instagram-feed');
         }));
         this.flickity.on('cellSelect', function () {
           _this4.$photoContainer.trigger('heightUpdate.instagram-feed');
         });
         this.$photoContainer.on('heightUpdate.instagram-feed', function () {
           if (!_this4.flickity) {
             return;
           }
   
           $slider.height(Math.ceil(_this4.flickity.maxCellHeight));
         }); // Sets the Slider to the height of the first slide
   
         this.$photoContainer.trigger('heightUpdate.instagram-feed');
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         dist_index_es.instance.untrack(this.$photoContainer[0]);
       }
     }]);
   
     return DynamicInstagramFeed;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicFeaturedCollection.js
   function DynamicFeaturedCollection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicFeaturedCollection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicFeaturedCollection_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicFeaturedCollection_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicFeaturedCollection_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var DynamicFeaturedCollection_DynamicFeaturedCollection =
   /*#__PURE__*/
   function () {
     function DynamicFeaturedCollection(section) {
       var _this = this;
   
       DynamicFeaturedCollection_classCallCheck(this, DynamicFeaturedCollection);
   
       this.section = section;
       this.$el = jquery_default()(section.el); // Product items
   
       this.productItems = [];
       var $productItems = this.$el.find('[data-product-item]');
       $productItems.each(function (i, productItem) {
         _this.productItems.push(new ProductGridItem_ProductGridItem({
           el: productItem,
           id: _this.section.id
         }));
       });
       this.ProductRowScroller = new ProductRowScroller_ProductRowScroller(section.el.querySelector('[data-product-row]'));
   
       this._updatePrices();
     }
   
     DynamicFeaturedCollection_createClass(DynamicFeaturedCollection, [{
       key: "_updatePrices",
       value: function _updatePrices() {
         this.$el.find('.money').each(function (index, el) {
           return shopify_currency_converter_dist_default.a.update(el);
         });
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.productItems.forEach(function (productItem) {
           productItem.unload();
         });
         this.ProductRowScroller.unload();
       }
     }]);
   
     return DynamicFeaturedCollection;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicSearch.js
   function DynamicSearch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicSearch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicSearch_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicSearch_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicSearch_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   var DynamicSearch_DynamicSearch =
   /*#__PURE__*/
   function () {
     function DynamicSearch(section) {
       var _this = this;
   
       DynamicSearch_classCallCheck(this, DynamicSearch);
   
       this.$el = jquery_default()(section.el);
       this.settings = section.data.settings;
       this.search = null;
       this.$scripts = jquery_default()('[data-scripts]');
       this.$searchField = this.$el.find('[data-live-search]');
       this.forms = new Forms_Forms(this.$el);
   
       if (this.settings.live_search.enable) {
         script_default()(this.$scripts.data('shopify-api-url'), function () {
           _this.search = new LiveSearch_LiveSearch({
             $el: _this.$searchField,
             $header: _this.$el
           }, _this.settings.live_search);
         });
       } else {
         this.search = new SearchForm_SearchForm(this.$searchField);
       }
     }
   
     DynamicSearch_createClass(DynamicSearch, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.search.unload();
         this.forms.unload();
       }
     }]);
   
     return DynamicSearch;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicRichText.js
   function DynamicRichText_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicRichText_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicRichText_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicRichText_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicRichText_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var DynamicRichText_DynamicTwitterFeed =
   /*#__PURE__*/
   function () {
     function DynamicTwitterFeed(section) {
       var _this = this;
   
       DynamicRichText_classCallCheck(this, DynamicTwitterFeed);
   
       this.$el = jquery_default()(section.el);
       this.rte = [];
       this.$el.find('[data-rte]').each(function (i, el) {
         _this.rte.push(new RichText_RichText(jquery_default()(el)));
       });
     }
     /**
      * Unbind events when section is re-drawn
      */
   
   
     DynamicRichText_createClass(DynamicTwitterFeed, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.rte.forEach(function (richTextArea) {
           richTextArea.unload();
         });
       }
     }]);
   
     return DynamicTwitterFeed;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicVideo.js
   function DynamicVideo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicVideo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicVideo_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicVideo_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicVideo_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var DynamicVideo_DynamicVideo =
   /*#__PURE__*/
   function () {
     function DynamicVideo(section) {
       DynamicVideo_classCallCheck(this, DynamicVideo);
   
       var videoEl = section.el.querySelector('[data-video]');
       this.$el = section.el;
       this.autoplay = section.data.autoplay;
       this.hasPlayed = false;
   
       if (videoEl) {
         this.video = new Video_Video(videoEl);
         this.bindEvents();
       }
     }
   
     DynamicVideo_createClass(DynamicVideo, [{
       key: "bindEvents",
       value: function bindEvents() {
         var _this = this;
   
         window.addEventListener('scroll', function () {
           if (_this.autoplay) {
             var rect = _this.$el.getBoundingClientRect();
   
             if (rect.top >= 0 || rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
               if (!_this.hasPlayed) {
                 _this.video._autoplay();
   
                 _this.hasPlayed = true;
               }
             } else {
               _this.video._onPauseClick();
             }
           }
         });
       }
     }, {
       key: "onSectionUnload",
       value: function onSectionUnload() {
         if (this.video) {
           this.video.unload();
         }
       }
     }]);
   
     return DynamicVideo;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicNewsletter.js
   function DynamicNewsletter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicNewsletter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicNewsletter_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicNewsletter_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicNewsletter_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var DynamicNewsletter_DynamicNewsletter =
   /*#__PURE__*/
   function () {
     function DynamicNewsletter(section) {
       DynamicNewsletter_classCallCheck(this, DynamicNewsletter);
   
       this.$el = jquery_default()(section.el);
       this.forms = new Forms_Forms(this.$el);
     }
   
     DynamicNewsletter_createClass(DynamicNewsletter, [{
       key: "onSectionUnload",
       value: function onSectionUnload() {
         this.forms.unload();
       }
     }]);
   
     return DynamicNewsletter;
   }();
   
   
   // CONCATENATED MODULE: ./node_modules/pxs-map/dist/index.es.js
   
   /*!
    * pxs-map v2.0.3
    * (c) 2018 undefined
    */
   
   
   
   
   var dist_index_es_classCallCheck = function (instance, Constructor) {
     if (!(instance instanceof Constructor)) {
       throw new TypeError("Cannot call a class as a function");
     }
   };
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   var toConsumableArray = function (arr) {
     if (Array.isArray(arr)) {
       for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
   
       return arr2;
     } else {
       return Array.from(arr);
     }
   };
   
   /*
    * Function to convert any given latitude and longitude format to decimal degrees
    */
   function getDecimalDegrees() {
     var firstComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
     var secondComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
     var thirdComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
     var fourthComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
   
     var directions = {
       N: 1,
       E: 1,
       S: -1,
       W: -1
     };
     var decimalDegrees = 0.0;
     var components = [firstComponent, secondComponent, thirdComponent, fourthComponent];
   
     for (var i = 0; i < components.length; i++) {
       var component = components[i];
   
       if (component) {
         if (Number.isNaN(parseFloat(component))) {
           decimalDegrees *= directions[component];
         } else {
           decimalDegrees += parseFloat(component) / Math.pow(60, i);
         }
       }
     }
   
     return decimalDegrees;
   }
   
   /*
    * By providing the ability to use a place name, or latitude and longitude coordinates
    * we give merchants, and our demo stores the option to bypass the Geocoding API.
    * The Geocoding API (https://developers.google.com/maps/documentation/geocoding/usage-and-billing) allows us
    * to take a place name and convert it to latitude and longitude expressed in decimal degrees.
    */
   function getLatitudeLongitude(address) {
     var deferred = jquery_default.a.Deferred();
     // Degrees, Minutes and Seconds: DDD° MM' SS.S"
     var latLongDegreesMinutesSeconds = /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W)$/g;
     // Degrees and Decimal Minutes: DDD° MM.MMM'
     var latLongDegreesMinutes = /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W)$/g;
     // Decimal Degrees: DDD.DDDDD°
     var latLongDegrees = /^([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?,? ?([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?$/g;
     var latLongFormats = [latLongDegreesMinutesSeconds, latLongDegreesMinutes, latLongDegrees];
     var latLongMatches = latLongFormats.map(function (latLongFormat) {
       return address.match(latLongFormat);
     });
   
     /*
      * Select the first latitude and longitude format that is matched.
      * Ordering:
      *   1. Degrees, minutes, and seconds,
      *   2. Degrees, and decimal minutes,
      *   3. Decimal degrees.
      */
     var latLongMatch = latLongMatches.reduce(function (accumulator, value, index) {
       if (!accumulator && value) {
         var latLongResult = latLongFormats[index].exec(address);
         var lat = latLongResult.slice(1, latLongResult.length / 2 + 1);
         var lng = latLongResult.slice(latLongResult.length / 2 + 1, latLongResult.length);
   
         return {
           lat: lat,
           lng: lng
         };
       }
   
       return accumulator;
     }, null);
   
     // If we've got a match on latitude and longitude, use that and avoid geocoding
     if (latLongMatch) {
       var latDecimalDegrees = getDecimalDegrees.apply(undefined, toConsumableArray(latLongMatch.lat));
       var longDecimalDegrees = getDecimalDegrees.apply(undefined, toConsumableArray(latLongMatch.lng));
   
       deferred.resolve({
         lat: latDecimalDegrees,
         lng: longDecimalDegrees
       });
     } else {
       // Otherwise, geocode the assumed address
       var geocoder = new google.maps.Geocoder();
   
       geocoder.geocode({ address: address }, function (results, status) {
         if (status !== google.maps.GeocoderStatus.OK) {
           deferred.reject(status);
         }
   
         deferred.resolve(results[0].geometry.location);
       });
     }
   
     return deferred;
   }
   
   function getMapStyles(colors) {
     if (!colors) {
       return [];
     }
   
     return [{ elementType: 'geometry', stylers: [{ color: colors.e }] }, { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { elementType: 'labels.text.fill', stylers: [{ color: colors.a }] }, { elementType: 'labels.text.stroke', stylers: [{ color: colors.e }] }, { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.country', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.neighborhood', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.locality', stylers: [{ visibility: 'off' }] }, { featureType: 'poi', stylers: [{ visibility: 'off' }] }, { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: colors.d }] }, { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: colors.c }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: colors.b }] }, { featureType: 'road.highway.controlled_access', stylers: [{ visibility: 'off' }] }, { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: colors.b }] }, { featureType: 'road.local', elementType: 'labels.text.stroke', stylers: [{ color: colors.e }] }, { featureType: 'transit', stylers: [{ visibility: 'off' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ color: colors.f }] }];
   }
   
   function createMap(options) {
     var deferred = jquery_default.a.Deferred();
     var container = options.container,
         address = options.address,
         zoom = options.zoom,
         colors = options.colors;
   
   
     getLatitudeLongitude(address).done(function (latLong) {
       var map = new google.maps.Map(container, {
         center: latLong,
         clickableIcons: false,
         disableDefaultUI: true,
         disableDoubleClickZoom: true,
         gestureHandling: 'none',
         keyboardShortcuts: false,
         maxZoom: zoom,
         minZoom: zoom,
         scrollWheel: false,
         styles: getMapStyles(colors),
         zoom: zoom,
         zoomControl: false
       });
   
       new google.maps.Marker({
         clickable: false,
         map: map,
         position: map.getCenter()
       });
   
       map.panBy(0, 0);
       deferred.resolve(map);
     }).fail(function (status) {
       var usageLimits = 'https://developers.google.com/maps/faq#usagelimits';
       var errorMessage = void 0;
   
       switch (status) {
         case 'ZERO_RESULTS':
           errorMessage = '<p>Unable to find the address:</p> ' + address;
           break;
         case 'OVER_QUERY_LIMIT':
           errorMessage = '\n            <p>Unable to load Google Maps, you have reached your usage limit.</p>\n            <p>\n              Please visit\n              <a href="' + usageLimits + '" target="_blank">' + usageLimits + '</a>\n              for more details.\n            </p>\n          ';
           break;
         default:
           errorMessage = 'Unable to load Google Maps.';
           break;
       }
   
       deferred.reject(errorMessage);
     });
   
     return deferred;
   }
   
   function displayErrorInThemeEditor(container, errorMessage) {
     var isThemeEditor = window.Shopify && window.Shopify.designMode;
   
     if (!isThemeEditor) {
       return;
     }
   
     container.innerHTML = '<div class="map-error-message">' + errorMessage + '</div>';
   }
   
   var index_es_PxsMap = function PxsMap(section) {
     var _this = this;
   
     dist_index_es_classCallCheck(this, PxsMap);
   
     this.map = null;
   
     var el = section.el.querySelector('[data-map]');
     var container = el.querySelector('[data-map-container]');
     var settings = section.data;
     var address = settings.address,
         colors = settings.colors;
   
     var apiKey = settings.api_key;
     // Scale so range is 12 ~ 17, rather than 1 to 6
     var zoom = Number.isNaN(settings.zoom) ? 13 : 11 + parseInt(settings.zoom, 10);
   
     if (apiKey) {
       if (window.googleMaps === undefined) {
         script_default()('https://maps.googleapis.com/maps/api/js?key=' + apiKey, function () {
           window.googleMaps = true;
           createMap({
             container: container,
             address: address,
             zoom: zoom,
             colors: colors
           }).done(function (map) {
             _this.map = map;
           }).fail(function (error) {
             return displayErrorInThemeEditor(container, error);
           });
         });
       } else {
         createMap({
           container: container,
           address: address,
           zoom: zoom,
           colors: colors
         }).done(function (map) {
           _this.map = map;
         }).fail(function (error) {
           return displayErrorInThemeEditor(container, error);
         });
       }
     }
   };
   
   /* harmony default export */ var pxs_map_dist_index_es = (index_es_PxsMap);
   
   // CONCATENATED MODULE: ./source/scripts/Empire.js
   // jQuery plugins
   
    // eslint-disable-line
   
    // eslint-disable-line
   // Global imports
   
   
    // Responsive Images
   
    // eslint-disable-line
   
    // eslint-disable-line
   // Template imports
   
   
   
   
    // Section imports
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
    // eslint-disable-line
   
   dist_index_es.init();
   var sections = new Sections();
   sections.register('static-header', function (section) {
     return new StaticSectionHeader_StaticSectionHeader(section);
   });
   sections.register('static-announcement', function (section) {
     return new StaticAnnouncement(section);
   });
   sections.register('static-footer', function (section) {
     return new StaticSectionFooter_StaticSectionFooter(section);
   });
   sections.register('static-article', function (section) {
     return new StaticArticle_StaticArticle(section);
   });
   sections.register('static-blog', function (section) {
     return new StaticBlog_StaticBlog(section);
   });
   sections.register('static-cart', function (section) {
     return new StaticCart_StaticCart(section);
   });
   sections.register('static-collection', function (section) {
     return new StaticCollection_StaticCollection(section);
   });
   sections.register('static-password', function (section) {
     return new StaticPassword_StaticPassword(section);
   });
   sections.register('static-product', function (section) {
     return new StaticProduct_StaticProduct(section);
   });
   sections.register('static-product-recommendations', function (section) {
     return new StaticProductRecommendations_StaticProductRecommendations(section);
   });
   sections.register('static-recently-viewed', function (section) {
     return new StaticRecentlyViewed_StaticRecentlyViewed(section);
   });
   sections.register('static-search', function (section) {
     return new StaticSearch_StaticSearch(section);
   });
   sections.register('dynamic-blog-posts', function (section) {
     return new DynamicBlogPosts_DynamicTwitterFeed(section);
   });
   sections.register('static-highlights-banners', function (section) {
     return new StaticHighlightsBanners_StaticHighlightsBanners(section);
   });
   sections.register('static-slideshow', function (section) {
     return new StaticSlideshow_StaticSlideshow(section);
   });
   sections.register('dynamic-promo-mosaic', function (section) {
     return new DynamicPromoBlocks_DynamicPromoBlocks(section);
   });
   sections.register('dynamic-promo-grid', function (section) {
     return new DynamicPromoBlocks_DynamicPromoBlocks(section);
   });
   sections.register('dynamic-menu-list', function (section) {
     return new DynamicMenuList_DynamicMenuList(section);
   });
   sections.register('dynamic-twitter-feed', function (section) {
     return new DynamicTwitterFeed_DynamicTwitterFeed(section);
   });
   sections.register('dynamic-instagram-feed', function (section) {
     return new DynamicInstagramFeed_DynamicInstagramFeed(section);
   });
   sections.register('dynamic-featured-collection', function (section) {
     return new DynamicFeaturedCollection_DynamicFeaturedCollection(section);
   });
   sections.register('dynamic-featured-product', function (section) {
     return new StaticProduct_StaticProduct(section);
   });
   sections.register('dynamic-rich-text', function (section) {
     return new DynamicRichText_DynamicTwitterFeed(section);
   });
   sections.register('dynamic-search', function (section) {
     return new DynamicSearch_DynamicSearch(section);
   });
   sections.register('dynamic-video', function (section) {
     return new DynamicVideo_DynamicVideo(section);
   });
   sections.register('pxs-newsletter', function (section) {
     return new DynamicNewsletter_DynamicNewsletter(section);
   });
   sections.register('pxs-map', function (section) {
     return new pxs_map_dist_index_es(section);
   });
   
   if ($('body.giftcard').length) {
     new GiftCard_GiftCard();
   }
   
   new Account_Account();
   new Contact_Contact();
   new Page_Page();
   
   /***/ })
   /******/ ]);
   //# sourceMappingURL=empire.js.map?1560813238291
   
   jQuery().ready(function() {
       jQuery(function($) {
       var intRegex = /^\d+$/;
       var floatRegex = /^((\d+(\.\d *)?)|((\d*\.)?\d+))$/;
       var maxBagPersonalizeBox = 10;
       var html = '<div class="BagPersonalizeRow added"><p class="line-item-property__field"><label for="bag_personalization_{{num}}">Bag {{num}}:</label><input id="bag_personalization_{{num}}" class="form-field-input" type="text" name="properties[Bag {{num}}]" value="valueContent" maxlength="25"><small>(25 characters max)</small></p></div>';
       var obj = $(".MoreBags");
   
       $("#product-quantity-select, #product-quantity-input").change(function() {

           // var text = $(".BagPersonalizeRow.first input[type=text]").val();
   
           var qty = $(this).val();
           if (intRegex.test(qty) || floatRegex.test(qty)) {
               if (qty <= 0) {
                   $(".BagPersonalizeRow.first").addClass("disabled");
               } else {
                   $(".BagPersonalizeRow.first").removeClass("disabled");
               }
               if (maxBagPersonalizeBox >= qty && qty > 0) {
                   obj.find('.BagPersonalizeRow').remove();
                   for (var i = 2; i <= qty; i++) {
                        var content = html.replace(/{{num}}/g, i);
                        content = content.replace(/valueContent/g, '');
                        obj.append(content);
                   }
               } else if (maxBagPersonalizeBox < qty) {
                   obj.find('.BagPersonalizeRow').remove();
                   // $('#all_bag_personalization').prop('checked', true);
               } else {
                   obj.find('.BagPersonalizeRow').remove();
               }
               checkAllBagBox();
           }
       });

    //    $(".BagPersonalizeRow.first input[type=text]").keyup(function(event) {
    //         var string = $(this).val();
    //         $(".BagPersonalizeRow.added input[type=text]").val(string);
    //    });
    //    $(document).on('change', "#all_bag_personalization", function() {
    //        checkAllBagBox();
    //    });
       
       function checkAllBagBox() {
           $(".MoreBags .BagPersonalizeRow").removeClass("disabled");
       }
       });
   });
   
   // Solving Mega Menu Hover Issue
   
   $( document ).ready(function() {
       var megaMenu = $('.horizontal-mega-menu li.buddha-menu-item ul.mm-submenu');
   
       $( document ).on( 'scroll', function(){
           jQuery(megaMenu).addClass('mm-submenu--scroll');
       });
   
       $('.horizontal-mega-menu li.buddha-menu-item').hover(function() {
           $(this).find('ul.mm-submenu').removeClass('mm-submenu--scroll');
       });
   });
   
